(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["PleskUiLibrary"] = factory();
	else
		root["PleskUiLibrary"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonpPleskUiLibrary"];
/******/ 	window["webpackJsonpPleskUiLibrary"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		2: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"react-sortable-hoc","1":"codemirror"}[chunkId]||chunkId) + ".plesk-ui-library.min.js?" + {"0":"926f2670036660e0e84d","1":"abf2eeba27306353a43e"}[chunkId] + "";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 48);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(257)();
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactDom = __webpack_require__(22);

Object.defineProperty(exports, 'render', {
    enumerable: true,
    get: function get() {
        return _reactDom.render;
    }
});
Object.defineProperty(exports, 'createPortal', {
    enumerable: true,
    get: function get() {
        return _reactDom.createPortal;
    }
});
Object.defineProperty(exports, 'findDOMNode', {
    enumerable: true,
    get: function get() {
        return _reactDom.findDOMNode;
    }
});
Object.defineProperty(exports, 'unmountComponentAtNode', {
    enumerable: true,
    get: function get() {
        return _reactDom.unmountComponentAtNode;
    }
});

var _react = __webpack_require__(9);

Object.defineProperty(exports, 'Children', {
    enumerable: true,
    get: function get() {
        return _react.Children;
    }
});
Object.defineProperty(exports, 'createClass', {
    enumerable: true,
    get: function get() {
        return _react.createClass;
    }
});
Object.defineProperty(exports, 'createElement', {
    enumerable: true,
    get: function get() {
        return _react.createElement;
    }
});
Object.defineProperty(exports, 'cloneElement', {
    enumerable: true,
    get: function get() {
        return _react.cloneElement;
    }
});
Object.defineProperty(exports, 'isValidElement', {
    enumerable: true,
    get: function get() {
        return _react.isValidElement;
    }
});
Object.defineProperty(exports, 'Component', {
    enumerable: true,
    get: function get() {
        return _react.Component;
    }
});
Object.defineProperty(exports, 'PureComponent', {
    enumerable: true,
    get: function get() {
        return _react.PureComponent;
    }
});
Object.defineProperty(exports, 'Fragment', {
    enumerable: true,
    get: function get() {
        return _react.Fragment;
    }
});

var _classnames = __webpack_require__(3);

Object.defineProperty(exports, 'classNames', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_classnames).default;
    }
});

var _propTypes = __webpack_require__(0);

Object.defineProperty(exports, 'PropTypes', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_propTypes).default;
    }
});

var _reactMeasure = __webpack_require__(8);

Object.defineProperty(exports, 'Measure', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_reactMeasure).default;
    }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isRtl = exports.isRtl = function isRtl() {
    return getComputedStyle(document.documentElement).direction === 'rtl';
};

var disableDocumentScrollCounter = 0;

var disableDocumentScroll = exports.disableDocumentScroll = function disableDocumentScroll() {
    disableDocumentScrollCounter = disableDocumentScrollCounter + 1;
    if (disableDocumentScrollCounter === 1) {
        var top = -window.pageYOffset + 'px';
        document.documentElement.style.position = 'fixed';
        document.body.style.marginTop = top;
    }
};

var enableDocumentScroll = exports.enableDocumentScroll = function enableDocumentScroll() {
    disableDocumentScrollCounter = disableDocumentScrollCounter - 1;
    if (disableDocumentScrollCounter === 0) {
        var scrollTop = Math.abs(parseInt(document.body.style.marginTop)) || 0;
        document.documentElement.style.position = '';
        document.body.style.marginTop = '';
        window.scrollTo(0, scrollTop);
    }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

module.exports = {
    CLS_PREFIX: 'pul-',
    Z_INDEX_POPOVER: 1035,
    Z_INDEX_DROPDOWN: 1035,
    Z_INDEX_TOASTER: 1045,
    Z_INDEX_OVERLAY: 1050
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = __webpack_require__(66);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Button).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = __webpack_require__(111);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Icon).default;
  }
});
Object.keys(_Icon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Icon[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Translate = __webpack_require__(175);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Translate).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withContentRect = exports.default = undefined;

var _Measure = __webpack_require__(260);

var _Measure2 = _interopRequireDefault(_Measure);

var _withContentRect = __webpack_require__(52);

var _withContentRect2 = _interopRequireDefault(_withContentRect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Measure2.default;
exports.withContentRect = _withContentRect2.default;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(266);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Spinner = __webpack_require__(150);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Spinner).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var safeInvoke = exports.safeInvoke = function safeInvoke(fn) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    }

    if (typeof fn === 'function') {
        fn.apply(undefined, args);
    }
};

var wrapFunction = exports.wrapFunction = function wrapFunction(fn, wrapper) {
    return function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        safeInvoke.apply(undefined, [fn].concat(args));
        safeInvoke.apply(undefined, [wrapper].concat(args));
    };
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dropdown = __webpack_require__(89);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Dropdown).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormField = __webpack_require__(104);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormField).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IconButton = __webpack_require__(110);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_IconButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ButtonGroup = __webpack_require__(65);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ButtonGroup).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Menu = __webpack_require__(127);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Menu).default;
  }
});

var _MenuItem = __webpack_require__(30);

Object.defineProperty(exports, 'MenuItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MenuItem).default;
  }
});

var _MenuBaseItem = __webpack_require__(29);

Object.defineProperty(exports, 'MenuBaseItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MenuBaseItem).default;
  }
});

var _MenuSelectableItem = __webpack_require__(42);

Object.defineProperty(exports, 'MenuSelectableItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MenuSelectableItem).default;
  }
});

var _MenuDivider = __webpack_require__(128);

Object.defineProperty(exports, 'MenuDivider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MenuDivider).default;
  }
});

var _MenuHeader = __webpack_require__(129);

Object.defineProperty(exports, 'MenuHeader', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MenuHeader).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkbox = __webpack_require__(74);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Checkbox).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Input = __webpack_require__(112);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Input).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Section = __webpack_require__(147);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Section).default;
  }
});

var _SectionItem = __webpack_require__(148);

Object.defineProperty(exports, 'SectionItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SectionItem).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tooltip = __webpack_require__(174);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tooltip).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(259);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Form = __webpack_require__(105);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Form).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GridCol = __webpack_require__(107);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GridCol).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Grid = __webpack_require__(108);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Grid).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Hint = __webpack_require__(109);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Hint).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Label = __webpack_require__(117);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Label).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Layer = __webpack_require__(118);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Layer).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Icon = __webpack_require__(6);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `MenuBaseItem` component.
 */
var MenuBaseItem = function MenuBaseItem(_ref) {
    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        children = _ref.children,
        icon = _ref.icon,
        label = _ref.label,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'children', 'icon', 'label']);

    return (0, _utils.createElement)(
        'li',
        _extends({
            className: (0, _classnames2.default)(baseClassName, className)
        }, props),
        (0, _utils.createElement)(
            'div',
            { className: baseClassName + '-icon' },
            _Icon2.default.create(icon, { size: _Icon.ICON_SIZE_16 })
        ),
        (0, _utils.createElement)(
            'div',
            { className: baseClassName + '-content' },
            children
        ),
        (0, _utils.createElement)(
            'div',
            { className: baseClassName + '-label' },
            label
        )
    );
};

MenuBaseItem.propTypes = {
    /**
     * Icon
     */
    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.element]),
    /**
     * Right label of item.
     */
    label: _propTypes2.default.node,
    /**
     * Content of the `MenuBaseItem`.
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

MenuBaseItem.defaultProps = {
    icon: null,
    label: null,
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'menu__base-item'
};

exports.default = MenuBaseItem;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _MenuBaseItem = __webpack_require__(29);

var _MenuBaseItem2 = _interopRequireDefault(_MenuBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `MenuItem` component.
 */
var MenuItem = function MenuItem(_ref) {
    var _classNames;

    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        children = _ref.children,
        _onClick = _ref.onClick,
        active = _ref.active,
        disabled = _ref.disabled,
        icon = _ref.icon,
        label = _ref.label,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'children', 'onClick', 'active', 'disabled', 'icon', 'label']);

    return (0, _utils.createElement)(
        _MenuBaseItem2.default,
        _extends({
            className: (0, _classnames2.default)(baseClassName, className, (_classNames = {}, _defineProperty(_classNames, baseClassName + '--active', active), _defineProperty(_classNames, baseClassName + '--disabled', disabled), _classNames)),
            onClick: function onClick(e) {
                if (_onClick && !disabled) {
                    _onClick(e);
                }
            },
            tabIndex: '0',
            icon: icon,
            label: label
        }, props),
        children
    );
};

MenuItem.propTypes = {
    /**
     * Whether item is active.
     */
    active: _propTypes2.default.bool,
    /**
     * Whether item is disabled.
     */
    disabled: _propTypes2.default.bool,
    /**
     * Icon
     */
    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.element]),
    /**
     * Right label of item.
     */
    label: _propTypes2.default.node,
    /**
     * Content of the `MenuItem`.
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string,
    /**
     * @ignore
     */
    onClick: _propTypes2.default.func
};

MenuItem.defaultProps = {
    active: false,
    disabled: false,
    icon: null,
    label: null,
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'menu__item',
    onClick: null
};

exports.default = MenuItem;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Overlay = __webpack_require__(133);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Overlay).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Popover = __webpack_require__(141);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Popover).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SegmentedControl = __webpack_require__(149);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SegmentedControl).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = __webpack_require__(263);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _TransitionGroup = __webpack_require__(264);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _Transition = __webpack_require__(53);

var _Transition2 = _interopRequireDefault(_Transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition2.default,
  TransitionGroup: _TransitionGroup2.default,
  CSSTransition: _CSSTransition2.default
};

/***/ }),
/* 35 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Action = __webpack_require__(58);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Action).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AutoClosable = __webpack_require__(61);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AutoClosable).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Badge = __webpack_require__(64);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Badge).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VIEW_ROW = exports.VIEW_EXTENDED = exports.VIEW_RESPONSIVE = exports.VIEW_TILE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _utils2 = __webpack_require__(11);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactMeasure = __webpack_require__(8);

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _constants = __webpack_require__(2);

var _Pagination = __webpack_require__(43);

var _Pagination2 = _interopRequireDefault(_Pagination);

var _Grid = __webpack_require__(25);

var _Grid2 = _interopRequireDefault(_Grid);

var _GridCol = __webpack_require__(24);

var _GridCol2 = _interopRequireDefault(_GridCol);

var _Button = __webpack_require__(5);

var _Button2 = _interopRequireDefault(_Button);

var _Spinner = __webpack_require__(10);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _Translate = __webpack_require__(7);

var _Translate2 = _interopRequireDefault(_Translate);

var _CardListToolbar = __webpack_require__(67);

var _CardListToolbar2 = _interopRequireDefault(_CardListToolbar);

__webpack_require__(185);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var VIEW_TILE = exports.VIEW_TILE = 'tile';
var VIEW_RESPONSIVE = exports.VIEW_RESPONSIVE = 'responsive';
var VIEW_EXTENDED = exports.VIEW_EXTENDED = 'extended';
var VIEW_ROW = exports.VIEW_ROW = 'row';

/**
 * `CardList` component.
 */

var CardList = function (_Component) {
    _inherits(CardList, _Component);

    function CardList(props) {
        _classCallCheck(this, CardList);

        var _this = _possibleConstructorReturn(this, (CardList.__proto__ || Object.getPrototypeOf(CardList)).call(this, props));

        _this.selectAll = function () {
            var items = _this.state.items;

            _this.select(items.map(_this.getItemKey));
        };

        _this.selectNone = function () {
            _this.select([]);
        };

        _this.getItemKey = function (item) {
            var itemKey = _this.props.itemKey;

            return item[itemKey];
        };

        _this.renderItem = function (item) {
            var _this$props = _this.props,
                baseClassName = _this$props.baseClassName,
                itemRender = _this$props.itemRender,
                onSelectionChange = _this$props.onSelectionChange;
            var view = _this.state.view;


            return (0, _utils.cloneElement)(itemRender(item), {
                key: _this.getItemKey(item),
                view: _this.isTile() ? VIEW_TILE : view,
                className: (0, _classnames2.default)(baseClassName + '__list-item'),
                selection: onSelectionChange ? _this.itemSelection(item) : null
            });
        };

        _this.previousView = null;

        _this.handleResize = function (_ref) {
            var width = _ref.entry.width;

            var view = width > 584 ? _this.previousView : VIEW_RESPONSIVE;

            if (view === VIEW_RESPONSIVE && !_this.previousView) {
                _this.previousView = _this.state.view;
            } else if (view !== VIEW_RESPONSIVE) {
                _this.previousView = null;
            }

            if (view && view !== _this.state.view) {
                _this.changeView(view);
            }
        };

        _this.state = {
            page: props.defaultPage,
            totalItems: props.totalItems || props.items.length,
            pageSize: 10,
            items: props.items,
            view: props.view
        };
        return _this;
    }

    _createClass(CardList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetchItems();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var view = nextProps.view,
                items = nextProps.items,
                totalItems = nextProps.totalItems;


            this.setState({
                items: items,
                totalItems: totalItems || items.length
            });

            if (nextProps.view !== this.props.view && this.state.view !== VIEW_RESPONSIVE) {
                this.fetchItems({ page: 1, view: view });
            }
        }
    }, {
        key: 'totalPages',
        value: function totalPages() {
            var _state = this.state,
                totalItems = _state.totalItems,
                pageSize = _state.pageSize;

            return Math.ceil(totalItems / pageSize);
        }
    }, {
        key: 'fetchItems',
        value: function fetchItems() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref2$page = _ref2.page,
                page = _ref2$page === undefined ? this.state.page : _ref2$page,
                _ref2$view = _ref2.view,
                view = _ref2$view === undefined ? this.state.view : _ref2$view;

            var onItemsFetch = this.props.onItemsFetch;

            var pageSize = view === VIEW_ROW ? 40 : 10;

            this.setState({
                view: view,
                page: page,
                pageSize: pageSize
            });
            (0, _utils2.safeInvoke)(onItemsFetch, { page: page, pageSize: pageSize });
        }
    }, {
        key: 'loadMore',
        value: function loadMore() {
            var onItemsFetch = this.props.onItemsFetch;
            var page = this.state.page;

            var nextPage = page + 1;

            this.setState({
                page: nextPage,
                pageSize: 10
            });
            (0, _utils2.safeInvoke)(onItemsFetch, { page: nextPage, pageSize: 10 });
        }
    }, {
        key: 'isTile',
        value: function isTile() {
            var view = this.state.view;


            return view === VIEW_TILE || view === VIEW_RESPONSIVE;
        }
    }, {
        key: 'renderPagination',
        value: function renderPagination() {
            var _this2 = this;

            var baseClassName = this.props.baseClassName;
            var _state2 = this.state,
                page = _state2.page,
                view = _state2.view;

            var totalPages = this.totalPages();

            if (totalPages < 2) {
                return null;
            }

            if (view === VIEW_RESPONSIVE && page < totalPages) {
                return (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__pagination' },
                    (0, _utils.createElement)(
                        _Button2.default,
                        { onClick: function onClick() {
                                return _this2.loadMore();
                            } },
                        (0, _utils.createElement)(_Translate2.default, { content: 'CardList.loadMore', fallback: 'Load more' })
                    )
                );
            }

            return (0, _utils.createElement)(_Pagination2.default, {
                className: baseClassName + '__pagination',
                total: totalPages,
                current: page,
                onSelect: function onSelect(page) {
                    return _this2.fetchItems({ page: page });
                }
            });
        }
    }, {
        key: 'changeView',
        value: function changeView(view) {
            var onViewChange = this.props.onViewChange;


            this.fetchItems({ page: 1, view: view });
            (0, _utils2.safeInvoke)(onViewChange, view);
        }
    }, {
        key: 'select',
        value: function select(keys) {
            var onSelectionChange = this.props.onSelectionChange;

            onSelectionChange(keys);
        }
    }, {
        key: 'itemSelection',
        value: function itemSelection(item) {
            var _this3 = this;

            var key = this.getItemKey(item);
            var selection = this.props.selection;


            return {
                isSelected: selection.indexOf(key) > -1,
                onSelectionChange: function onSelectionChange(_ref3) {
                    var isSelected = _ref3.isSelected;

                    var keys = isSelected ? [].concat(_toConsumableArray(selection), [key]) : selection.filter(function (k) {
                        return k !== key;
                    });
                    _this3.select(keys);
                }
            };
        }
    }, {
        key: 'renderLoader',
        value: function renderLoader() {
            var _props = this.props,
                baseClassName = _props.baseClassName,
                loading = _props.loading;


            if (!loading) {
                return null;
            }

            return (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__content-blocker' },
                (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__loader' },
                    (0, _utils.createElement)(_Spinner2.default, { className: baseClassName + '__loader-spinner' })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props2 = this.props,
                baseClassName = _props2.baseClassName,
                className = _props2.className,
                items = _props2.items,
                onItemsFetch = _props2.onItemsFetch,
                view = _props2.view,
                itemKey = _props2.itemKey,
                itemRender = _props2.itemRender,
                onViewChange = _props2.onViewChange,
                selection = _props2.selection,
                onSelectionChange = _props2.onSelectionChange,
                selectionButton = _props2.selectionButton,
                viewSwitcher = _props2.viewSwitcher,
                toolbarGroups = _props2.toolbarGroups,
                totalItems = _props2.totalItems,
                defaultPage = _props2.defaultPage,
                loading = _props2.loading,
                props = _objectWithoutProperties(_props2, ['baseClassName', 'className', 'items', 'onItemsFetch', 'view', 'itemKey', 'itemRender', 'onViewChange', 'selection', 'onSelectionChange', 'selectionButton', 'viewSwitcher', 'toolbarGroups', 'totalItems', 'defaultPage', 'loading']);

            var content = this.state.items.map(this.renderItem);

            if (this.isTile()) {
                content = (0, _utils.createElement)(
                    _Grid2.default,
                    { minColumnWidth: 400, gap: 'md' },
                    _utils.Children.map(content, function (child) {
                        return (0, _utils.createElement)(
                            _GridCol2.default,
                            { key: child.props.key },
                            child
                        );
                    })
                );
            }

            return (0, _utils.createElement)(
                _reactMeasure2.default,
                { onResize: this.handleResize },
                function (_ref4) {
                    var measureRef = _ref4.measureRef;
                    return (0, _utils.createElement)(
                        'div',
                        _extends({
                            ref: measureRef,
                            className: (0, _classnames2.default)(baseClassName, className)
                        }, props),
                        (0, _utils.createElement)(_CardListToolbar2.default, {
                            selection: onSelectionChange && _this4.state.totalItems > 1 ? _extends({}, selectionButton, {
                                total: _this4.state.totalItems,
                                onSelectAll: _this4.selectAll,
                                onSelectNone: _this4.selectNone,
                                checked: _this4.state.items.length === selection.length
                            }) : null,
                            onViewChange: viewSwitcher ? function (view) {
                                return _this4.changeView(view);
                            } : null,
                            currentView: _this4.state.view,
                            groups: toolbarGroups
                        }),
                        _this4.state.items.length > 0 && (0, _utils.createElement)(
                            'div',
                            { className: baseClassName + '__list ' + baseClassName + '__list--' + _this4.state.view },
                            content
                        ),
                        _this4.state.items.length === 0 && !loading && (0, _utils.createElement)(_Translate2.default, { content: 'CardList.notFound', fallback: 'No items found.' }),
                        _this4.renderPagination(),
                        _this4.renderLoader()
                    );
                }
            );
        }
    }]);

    return CardList;
}(_utils.Component);

CardList.propTypes = {
    /**
     * Array of data items for rendering.
     */
    items: _propTypes2.default.array.isRequired,
    /**
     * Callback for fetching items.
     */
    onItemsFetch: _propTypes2.default.func,
    /**
     * Total items. Equal items.length by default.
     */
    totalItems: _propTypes2.default.number,
    /**
     * Default page number.
     */
    defaultPage: _propTypes2.default.number,
    /**
     * View mode.
     */
    view: _propTypes2.default.oneOf([VIEW_EXTENDED, VIEW_TILE, VIEW_ROW, VIEW_RESPONSIVE]),
    /**
     * View change callback.
     */
    onViewChange: _propTypes2.default.func,
    /**
     * View switcher config.
     */
    viewSwitcher: _propTypes2.default.bool,
    /**
     * Array of keys of selected cards.
     */
    selection: _propTypes2.default.array,
    /**
     * Selection change handler for list. Checkboxes will only be rendered if this prop is defined.
     */
    onSelectionChange: _propTypes2.default.func,
    /**
     * Config for selection button in the toolbar.
     */
    selectionButton: _propTypes2.default.shape({
        /**
         * See [Badge](#!/Badge) for all props.
         */
        badge: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
        /**
         * Array of additional [MenuItems](#!/MenuItem).
         */
        menuItems: _propTypes2.default.arrayOf(_propTypes2.default.element)
    }),
    /**
     * Toolbar groups for the toolbar.
     */
    toolbarGroups: _propTypes2.default.arrayOf(_propTypes2.default.element),
    /**
     * Unique key.
     */
    itemKey: _propTypes2.default.string.isRequired,
    /**
     * Render function for item.
     */
    itemRender: _propTypes2.default.func.isRequired,
    /**
     * Indicate the loading state of the list.
     */
    loading: _propTypes2.default.bool,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

CardList.defaultProps = {
    onItemsFetch: null,
    totalItems: null,
    defaultPage: 1,
    view: VIEW_EXTENDED,
    onViewChange: null,
    viewSwitcher: false,
    selection: [],
    onSelectionChange: null,
    selectionButton: {
        badge: null,
        menuItems: []
    },
    toolbarGroups: [],
    loading: false,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'card-list'
};

exports.default = CardList;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _Spinner = __webpack_require__(10);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

__webpack_require__(187);

__webpack_require__(251);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `PreviewPanel` component.
 */
var PreviewPanel = function (_Component) {
    _inherits(PreviewPanel, _Component);

    function PreviewPanel() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PreviewPanel);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PreviewPanel.__proto__ || Object.getPrototypeOf(PreviewPanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            loaded: false
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PreviewPanel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var html = this.props.html;


            if (html && this.iframeRef) {
                this.updateIFrame(html);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var html = this.props.html;
            var nextHtml = nextProps.html;


            if (nextHtml !== html && nextHtml && this.iframeRef) {
                this.updateIFrame(nextHtml);
            }
        }
    }, {
        key: 'updateIFrame',
        value: function updateIFrame(content) {
            var doc = this.iframeRef.contentDocument || this.iframeRef.contentWindow.document;

            doc.open();
            doc.write(content);
            doc.close();
        }
    }, {
        key: 'renderIFrame',
        value: function renderIFrame() {
            var _this2 = this;

            return (0, _utils.createElement)('iframe', {
                sandbox: 'allow-same-origin',
                scrolling: 'no',
                ref: function ref(_ref2) {
                    return _this2.iframeRef = _ref2;
                },
                onLoad: function onLoad(e) {
                    if (!e || !e.target) {
                        return;
                    }

                    var iframe = e.target;
                    var win = iframe.contentWindow;
                    var doc = iframe.contentDocument || win.document;

                    _this2.setState({ loaded: true }, function () {
                        doc.body.style.display = 'inline-block';
                        doc.body.style.transformOrigin = 'top left';
                        doc.body.style.transform = 'scale(' + Math.min(win.innerWidth / doc.body.offsetWidth, 1) + ')';
                        doc.querySelector('html').scrollTop = 0;
                    });
                }
            });
        }
    }, {
        key: 'renderLoader',
        value: function renderLoader() {
            var baseClassName = this.props.baseClassName;
            var loaded = this.state.loaded;


            if (loaded) {
                return null;
            }

            return (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__content-blocker' },
                (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__loader' },
                    (0, _utils.createElement)(_Spinner2.default, { className: baseClassName + '__loader-spinner' })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                html = _props.html,
                background = _props.background,
                image = _props.image,
                padding = _props.padding,
                alt = _props.alt,
                children = _props.children,
                className = _props.className,
                baseClassName = _props.baseClassName,
                props = _objectWithoutProperties(_props, ['html', 'background', 'image', 'padding', 'alt', 'children', 'className', 'baseClassName']);

            var loaded = this.state.loaded;


            var el = null;
            var imageSrc = image;
            var backgroundObj = {};

            if (!image && !background && !html) {
                imageSrc = './images/fail.png';
            }

            if (imageSrc) {
                var paddings = {};
                if (padding) {
                    paddings.style = {
                        padding: (padding instanceof Array ? padding.join('px ') : padding) + 'px'
                    };
                }

                el = (0, _utils.createElement)('img', _extends({ className: baseClassName + '__image', src: image, alt: alt }, paddings));
            } else if (background) {
                backgroundObj.style = {
                    backgroundImage: 'url("' + background + '")'
                };
            } else if (html) {
                el = (0, _utils.createElement)(
                    'div',
                    {
                        className: (0, _classnames2.default)(baseClassName + '__html', _defineProperty({}, baseClassName + '__html--loading', !loaded))
                    },
                    this.renderIFrame(),
                    this.renderLoader()
                );
            }

            return (0, _utils.createElement)(
                'div',
                _extends({
                    className: (0, _classnames2.default)(baseClassName, _defineProperty({}, baseClassName + '--background', background), className)
                }, backgroundObj, props),
                el,
                (0, _utils.createElement)(
                    'div',
                    {
                        className: (0, _classnames2.default)(baseClassName + '__content', _defineProperty({}, baseClassName + '__content--empty', !children))
                    },
                    (0, _utils.createElement)(
                        'div',
                        { className: baseClassName + '__content-inner' },
                        children
                    )
                )
            );
        }
    }]);

    return PreviewPanel;
}(_utils.Component);

PreviewPanel.propTypes = {
    /**
     * HTML content. Width of content will be adjusted to fit preview panel.
     */
    html: _propTypes2.default.string,
    /**
     * Background image content.
     */
    background: _propTypes2.default.string,
    /**
     * Image content.
     */
    image: _propTypes2.default.string,
    /**
     * Padding of image content (in pixels). Could be a number or an array of numbers. Behavior as in CSS property `padding`.
     */
    padding: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
    /**
     * Alt property for an image.
     */
    alt: _propTypes2.default.string,
    /**
     * Custom content for hover over preview panel. Hidden in card for the row view.
     */
    children: _propTypes2.default.any,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

PreviewPanel.defaultProps = {
    html: null,
    background: null,
    image: null,
    padding: 0,
    alt: null,
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'preview-panel'
};

exports.default = PreviewPanel;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LocaleProvider = __webpack_require__(121);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LocaleProvider).default;
  }
});
Object.keys(_LocaleProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _LocaleProvider[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _MenuItem = __webpack_require__(30);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `MenuSelectableItem` component.
 */
var MenuSelectableItem = function MenuSelectableItem(_ref) {
  var baseClassName = _ref.baseClassName,
      className = _ref.className,
      children = _ref.children,
      selected = _ref.selected,
      props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'children', 'selected']);

  return (0, _utils.createElement)(
    _MenuItem2.default,
    _extends({
      className: (0, _classnames2.default)(baseClassName, className),
      icon: selected ? 'check-mark' : null
    }, props),
    children
  );
};

MenuSelectableItem.propTypes = {
  /**
   * Whether item is selected.
   */
  selected: _propTypes2.default.bool,
  /**
   * Content of the `MenuSelectableItem`.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  baseClassName: _propTypes2.default.string
};

MenuSelectableItem.defaultProps = {
  selected: false,
  children: null,
  className: null,
  baseClassName: _constants.CLS_PREFIX + 'menu__item'
};

exports.default = MenuSelectableItem;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Pagination = __webpack_require__(134);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Pagination).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Popper = __webpack_require__(142);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Popper).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Switch = __webpack_require__(157);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Switch).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * `Tab` is an individual element of the [Tabs](#!/Tabs) component. A single `Tab` element displays its own unique content when activated.
 * Each `Tab` can display an icon near the tab name for easier identification.
 * `Tab` can also display a [Label](#!/Label) next to the tab name for showing additional information about `Tab` contents.
 * You can make `Tabs` closeable, for example, if you are using `Tabs` for opening and displaying files.
 */
// Copyright 1999-2018. Plesk International GmbH. All rights reserved.
/* eslint-disable react/no-unused-prop-types */

var Tab = function Tab(_ref) {
  var children = _ref.children;
  return (0, _utils.createElement)(
    'div',
    null,
    children
  );
};
Tab.propTypes = {
  /**
   * Tab title
   */
  title: _propTypes2.default.node.isRequired,
  /**
   * Label in tab title
   */
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  /**
   * Name of icon or Icon component for tab
   */
  icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.element]),
  /**
   * Activate callback.
   */
  onActivate: _propTypes2.default.func,
  /**
   * Close callback
   */
  onClose: _propTypes2.default.func,
  /**
   * Tab content
   */
  children: _propTypes2.default.node
};
Tab.defaultProps = {
  label: null,
  icon: null,
  onActivate: null,
  onClose: null,
  children: null
};

exports.default = Tab;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Toolbar = __webpack_require__(171);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Toolbar).default;
  }
});

var _ToolbarGroup = __webpack_require__(173);

Object.defineProperty(exports, 'ToolbarGroup', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ToolbarGroup).default;
  }
});

var _ToolbarExpander = __webpack_require__(172);

Object.defineProperty(exports, 'ToolbarExpander', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ToolbarExpander).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.version = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _package = __webpack_require__(56);

Object.defineProperty(exports, 'version', {
    enumerable: true,
    get: function get() {
        return _package.version;
    }
});

var _utils = __webpack_require__(1);

Object.keys(_utils).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _utils[key];
        }
    });
});

var _components = __webpack_require__(55);

Object.keys(_components).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _components[key];
        }
    });
});

var _svg4everybody = __webpack_require__(57);

var _svg4everybody2 = _interopRequireDefault(_svg4everybody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _svg4everybody2.default)();

var baseUrl = '';

if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && typeof window.require === 'function' && typeof window.require.toUrl === 'function') {
    baseUrl = window.require.toUrl('plesk-ui-library');
    baseUrl = baseUrl.substr(0, baseUrl.lastIndexOf('/') + 1);
}

/* eslint-disable no-undef, camelcase */
if (true) {
    __webpack_require__.p = baseUrl;
}
/* eslint-enable no-undef, camelcase */

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _resizeObserverPolyfill = __webpack_require__(267);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

var _getTypes = __webpack_require__(262);

var _getTypes2 = _interopRequireDefault(_getTypes);

var _getContentRect = __webpack_require__(261);

var _getContentRect2 = _interopRequireDefault(_getContentRect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withContentRect(types) {
  return function (WrappedComponent) {
    var _class, _temp2;

    return _temp2 = _class = function (_Component) {
      _inherits(_class, _Component);

      function _class() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, _class);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          contentRect: {
            entry: {},
            client: {},
            offset: {},
            scroll: {},
            bounds: {},
            margin: {}
          }
        }, _this.measure = function (entries) {
          var contentRect = (0, _getContentRect2.default)(_this._node, types || (0, _getTypes2.default)(_this.props));

          if (entries) {
            contentRect.entry = entries[0].contentRect;
          }

          _this.setState({ contentRect: contentRect });

          if (typeof _this.props.onResize === 'function') {
            _this.props.onResize(contentRect);
          }
        }, _this._handleRef = function (node) {
          if (_this._resizeObserver) {
            if (node) {
              _this._resizeObserver.observe(node);
            } else {
              _this._resizeObserver.disconnect(_this._node);
            }
          }
          _this._node = node;

          if (typeof _this.props.innerRef === 'function') {
            _this.props.innerRef(node);
          }
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(_class, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          this._resizeObserver = new _resizeObserverPolyfill2.default(this.measure);
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props,
              innerRef = _props.innerRef,
              onResize = _props.onResize,
              props = _objectWithoutProperties(_props, ['innerRef', 'onResize']);

          return (0, _react.createElement)(WrappedComponent, _extends({}, props, {
            measureRef: this._handleRef,
            measure: this.measure,
            contentRect: this.state.contentRect
          }));
        }
      }]);

      return _class;
    }(_react.Component), _class.propTypes = {
      client: _propTypes2.default.bool,
      offset: _propTypes2.default.bool,
      scroll: _propTypes2.default.bool,
      bounds: _propTypes2.default.bool,
      margin: _propTypes2.default.bool,
      innerRef: _propTypes2.default.func,
      onResize: _propTypes2.default.func,
      children: _propTypes2.default.func
    }, _temp2;
  };
}

exports.default = withContentRect;
module.exports = exports['default'];

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(0);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(22);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _PropTypes = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm A fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `ENTERING`
 *  - `ENTERED`
 *  - `EXITING`
 *  - `EXITED`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state= { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;
    _this.nextStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.nextStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null }; // allows for nested Transitions
  };

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true);
  };

  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _ref = this.pendingState || this.state,
        status = _ref.status;

    if (nextProps.in) {
      if (status === UNMOUNTED) {
        this.setState({ status: EXITED });
      }
      if (status !== ENTERING && status !== ENTERED) {
        this.nextStatus = ENTERING;
      }
    } else {
      if (status === ENTERING || status === ENTERED) {
        this.nextStatus = EXITING;
      }
    }
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateStatus();
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var nextStatus = this.nextStatus;

    if (nextStatus !== null) {
      this.nextStatus = null;
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    var _this4 = this;

    // We need to track pending updates for instances where a cWRP fires quickly
    // after cDM and before the state flushes, which would double trigger a
    // transition
    this.pendingState = nextState;

    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, function () {
      _this4.pendingState = null;
      callback();
    });
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this5 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this5.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEventListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};

// Name the function so it is clearer in the documentation
function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = Transition;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Action = __webpack_require__(36);

Object.defineProperty(exports, 'Action', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Action).default;
  }
});

var _Alert = __webpack_require__(60);

Object.defineProperty(exports, 'Alert', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alert).default;
  }
});

var _AutoClosable = __webpack_require__(37);

Object.defineProperty(exports, 'AutoClosable', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AutoClosable).default;
  }
});

var _AuxiliaryActions = __webpack_require__(63);

Object.defineProperty(exports, 'AuxiliaryActions', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AuxiliaryActions).default;
  }
});

var _Badge = __webpack_require__(38);

Object.defineProperty(exports, 'Badge', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Badge).default;
  }
});

var _Button = __webpack_require__(5);

Object.defineProperty(exports, 'Button', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Button).default;
  }
});

var _ButtonGroup = __webpack_require__(15);

Object.defineProperty(exports, 'ButtonGroup', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ButtonGroup).default;
  }
});

var _Card = __webpack_require__(71);

Object.defineProperty(exports, 'Card', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Card).default;
  }
});
Object.keys(_Card).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Card[key];
    }
  });
});

var _CardList = __webpack_require__(68);

Object.defineProperty(exports, 'CardList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CardList).default;
  }
});

var _Carousel = __webpack_require__(73);

Object.defineProperty(exports, 'Carousel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Carousel).default;
  }
});

var _Checkbox = __webpack_require__(17);

Object.defineProperty(exports, 'Checkbox', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Checkbox).default;
  }
});

var _CodeEditor = __webpack_require__(76);

Object.defineProperty(exports, 'CodeEditor', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CodeEditor).default;
  }
});

var _ConsoleOutput = __webpack_require__(78);

Object.defineProperty(exports, 'ConsoleOutput', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ConsoleOutput).default;
  }
});

var _ContentLoader = __webpack_require__(80);

Object.defineProperty(exports, 'ContentLoader', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ContentLoader).default;
  }
});

var _Cuttable = __webpack_require__(82);

Object.defineProperty(exports, 'Cuttable', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Cuttable).default;
  }
});

var _Dialog = __webpack_require__(84);

Object.defineProperty(exports, 'Dialog', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Dialog).default;
  }
});

var _Drawer = __webpack_require__(88);

Object.defineProperty(exports, 'Drawer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Drawer).default;
  }
});

var _Dropdown = __webpack_require__(12);

Object.defineProperty(exports, 'Dropdown', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Dropdown).default;
  }
});

var _ExtendedStatusMessage = __webpack_require__(91);

Object.defineProperty(exports, 'ExtendedStatusMessage', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExtendedStatusMessage).default;
  }
});
Object.keys(_ExtendedStatusMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ExtendedStatusMessage[key];
    }
  });
});

var _Figure = __webpack_require__(93);

Object.defineProperty(exports, 'Figure', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Figure).default;
  }
});

var _Form = __webpack_require__(23);

Object.defineProperty(exports, 'Form', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Form).default;
  }
});

var _FormField = __webpack_require__(13);

Object.defineProperty(exports, 'FormField', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormField).default;
  }
});

var _FormFieldCheckbox = __webpack_require__(95);

Object.defineProperty(exports, 'FormFieldCheckbox', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormFieldCheckbox).default;
  }
});

var _FormFieldPassword = __webpack_require__(97);

Object.defineProperty(exports, 'FormFieldPassword', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormFieldPassword).default;
  }
});

var _FormFieldRadioButtons = __webpack_require__(101);

Object.defineProperty(exports, 'FormFieldRadioButtons', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormFieldRadioButtons).default;
  }
});

var _FormFieldText = __webpack_require__(103);

Object.defineProperty(exports, 'FormFieldText', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormFieldText).default;
  }
});

var _Grid = __webpack_require__(25);

Object.defineProperty(exports, 'Grid', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Grid).default;
  }
});

var _GridCol = __webpack_require__(24);

Object.defineProperty(exports, 'GridCol', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GridCol).default;
  }
});

var _Hint = __webpack_require__(26);

Object.defineProperty(exports, 'Hint', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Hint).default;
  }
});

var _Icon = __webpack_require__(6);

Object.defineProperty(exports, 'Icon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Icon).default;
  }
});

var _Input = __webpack_require__(18);

Object.defineProperty(exports, 'Input', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Input).default;
  }
});

var _Item = __webpack_require__(116);

Object.defineProperty(exports, 'Item', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Item).default;
  }
});

var _ItemList = __webpack_require__(114);

Object.defineProperty(exports, 'ItemList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ItemList).default;
  }
});

var _Label = __webpack_require__(27);

Object.defineProperty(exports, 'Label', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Label).default;
  }
});

var _List = __webpack_require__(120);

Object.defineProperty(exports, 'List', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_List).default;
  }
});

var _LocaleProvider = __webpack_require__(41);

Object.defineProperty(exports, 'LocaleProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LocaleProvider).default;
  }
});

var _Markdown = __webpack_require__(123);

Object.defineProperty(exports, 'Markdown', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Markdown).default;
  }
});

var _Media = __webpack_require__(126);

Object.defineProperty(exports, 'Media', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Media).default;
  }
});
Object.keys(_Media).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Media[key];
    }
  });
});

var _Menu = __webpack_require__(16);

Object.defineProperty(exports, 'Menu', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Menu).default;
  }
});
Object.keys(_Menu).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Menu[key];
    }
  });
});

var _Modal = __webpack_require__(131);

Object.defineProperty(exports, 'Modal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Modal).default;
  }
});

var _Overlay = __webpack_require__(31);

Object.defineProperty(exports, 'Overlay', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Overlay).default;
  }
});

var _Pagination = __webpack_require__(43);

Object.defineProperty(exports, 'Pagination', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Pagination).default;
  }
});

var _Panel = __webpack_require__(136);

Object.defineProperty(exports, 'Panel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Panel).default;
  }
});

var _Paragraph = __webpack_require__(138);

Object.defineProperty(exports, 'Paragraph', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Paragraph).default;
  }
});

var _Plaintext = __webpack_require__(140);

Object.defineProperty(exports, 'Plaintext', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Plaintext).default;
  }
});

var _Popover = __webpack_require__(32);

Object.defineProperty(exports, 'Popover', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Popover).default;
  }
});

var _Rating = __webpack_require__(146);

Object.defineProperty(exports, 'Rating', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Rating).default;
  }
});

var _Section = __webpack_require__(19);

Object.defineProperty(exports, 'Section', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Section).default;
  }
});
Object.keys(_Section).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Section[key];
    }
  });
});

var _SegmentedControl = __webpack_require__(33);

Object.defineProperty(exports, 'SegmentedControl', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SegmentedControl).default;
  }
});

var _SplitButton = __webpack_require__(152);

Object.defineProperty(exports, 'SplitButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SplitButton).default;
  }
});

var _Status = __webpack_require__(154);

Object.defineProperty(exports, 'Status', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Status).default;
  }
});

var _Subnav = __webpack_require__(156);

Object.defineProperty(exports, 'Subnav', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Subnav).default;
  }
});
Object.keys(_Subnav).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Subnav[key];
    }
  });
});

var _Switch = __webpack_require__(45);

Object.defineProperty(exports, 'Switch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Switch).default;
  }
});

var _SwitchesPanel = __webpack_require__(161);

Object.defineProperty(exports, 'SwitchesPanel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SwitchesPanel).default;
  }
});

var _SwitchesPanelItem = __webpack_require__(159);

Object.defineProperty(exports, 'SwitchesPanelItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SwitchesPanelItem).default;
  }
});

var _Tabs = __webpack_require__(164);

Object.defineProperty(exports, 'Tabs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tabs).default;
  }
});
Object.keys(_Tabs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Tabs[key];
    }
  });
});

var _Text = __webpack_require__(166);

Object.defineProperty(exports, 'Text', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Text).default;
  }
});

var _Toaster = __webpack_require__(170);

Object.defineProperty(exports, 'Toaster', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Toaster).default;
  }
});

var _Toolbar = __webpack_require__(47);

Object.defineProperty(exports, 'Toolbar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Toolbar).default;
  }
});
Object.keys(_Toolbar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Toolbar[key];
    }
  });
});

var _Tooltip = __webpack_require__(20);

Object.defineProperty(exports, 'Tooltip', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tooltip).default;
  }
});

var _Translate = __webpack_require__(7);

Object.defineProperty(exports, 'Translate', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Translate).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = {"name":"@plesk/ui-library","version":"1.1.5","description":"Plesk UI Library","main":"dist/plesk-ui-library.js","scripts":{"pretest":"yarn lint","test":"jest","build":"webpack --config ./configs/build.config.js","lint":"yarn lint:es && yarn lint:style","lint:es":"eslint --ext js,md src configs scripts","lint:style":"stylelint \"src/**/*.less\"","styleguide":"styleguidist server --config ./configs/styleguide.config.js","styleguide:build":"styleguidist build --config ./configs/styleguide.config.js","create-component":"node scripts/create-component.js","prepublishOnly":"yarn install && yarn test && yarn build && yarn styleguide:build","postversion":"git push && git push --tags"},"files":["dist","styleguide"],"dependencies":{"classnames":"^2.2.5","codemirror":"^5.34.0","marked":"^0.3.6","popper.js":"^1.12.6","prop-types":"^15.6.0","react":"^16.0.0","react-dom":"^16.0.0","react-measure":"^2.0.2","react-sortable-hoc":"^0.6.8","react-transition-group":"^2.2.1","svg4everybody":"^2.1.9"},"devDependencies":{"@plesk/eslint-config":"0.0.7","@plesk/stylelint-config":"0.0.5","babel-core":"^6.26.0","babel-loader":"^7.1.2","babel-plugin-dynamic-import-node":"^1.1.0","babel-preset-env":"^1.6.0","babel-preset-react":"^6.24.1","babel-preset-stage-0":"^6.24.1","clean-webpack-plugin":"^0.1.18","css-loader":"^0.28.0","enzyme":"^3.0.0","enzyme-adapter-react-16":"^1.0.0","eslint-plugin-markdown":"^1.0.0-beta.6","extract-text-webpack-plugin":"^2.1.2","file-loader":"^1.1.4","inquirer":"^3.2.1","jest":"^20.0.4","json-loader":"^0.5.7","less":"^2.7.2","less-loader":"^4.0.5","postcss-loader":"^2.0.6","react-styleguidist":"^6.5.3","react-test-renderer":"^16.0.0","rtlcss":"^2.2.0","style-loader":"^0.18.2","webpack":"^2.7.0"},"browserslist":["last 2 versions",">1%"],"jest":{"rootDir":"src","setupFiles":["<rootDir>/test/shim.js","<rootDir>/test/setup.js"],"moduleNameMapper":{"\\.(png|jpg|gif|svg|woff|woff2)$":"<rootDir>/test/fileMock.js","\\.(css|less)$":"<rootDir>/test/styleMock.js"}},"author":"Plesk Developers <plesk-dev-leads@plesk.com> (https://www.plesk.com/)","license":"Apache-2.0"}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(root, factory) {
     true ? // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
        return root.svg4everybody = factory();
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == typeof module && module.exports ? // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory() : root.svg4everybody = factory();
}(this, function() {
    /*! svg4everybody v2.1.9 | github.com/jonathantneal/svg4everybody */
    function embed(parent, svg, target) {
        // if the target exists
        if (target) {
            // create a document fragment to hold the contents of the target
            var fragment = document.createDocumentFragment(), viewBox = !svg.hasAttribute("viewBox") && target.getAttribute("viewBox");
            // conditionally set the viewBox on the svg
            viewBox && svg.setAttribute("viewBox", viewBox);
            // copy the contents of the clone into the fragment
            for (// clone the target
            var clone = target.cloneNode(!0); clone.childNodes.length; ) {
                fragment.appendChild(clone.firstChild);
            }
            // append the fragment into the svg
            parent.appendChild(fragment);
        }
    }
    function loadreadystatechange(xhr) {
        // listen to changes in the request
        xhr.onreadystatechange = function() {
            // if the request is ready
            if (4 === xhr.readyState) {
                // get the cached html document
                var cachedDocument = xhr._cachedDocument;
                // ensure the cached html document based on the xhr response
                cachedDocument || (cachedDocument = xhr._cachedDocument = document.implementation.createHTMLDocument(""), 
                cachedDocument.body.innerHTML = xhr.responseText, xhr._cachedTarget = {}), // clear the xhr embeds list and embed each item
                xhr._embeds.splice(0).map(function(item) {
                    // get the cached target
                    var target = xhr._cachedTarget[item.id];
                    // ensure the cached target
                    target || (target = xhr._cachedTarget[item.id] = cachedDocument.getElementById(item.id)), 
                    // embed the target into the svg
                    embed(item.parent, item.svg, target);
                });
            }
        }, // test the ready state change immediately
        xhr.onreadystatechange();
    }
    function svg4everybody(rawopts) {
        function oninterval() {
            // while the index exists in the live <use> collection
            for (// get the cached <use> index
            var index = 0; index < uses.length; ) {
                // get the current <use>
                var use = uses[index], parent = use.parentNode, svg = getSVGAncestor(parent), src = use.getAttribute("xlink:href") || use.getAttribute("href");
                if (!src && opts.attributeName && (src = use.getAttribute(opts.attributeName)), 
                svg && src) {
                    if (polyfill) {
                        if (!opts.validate || opts.validate(src, svg, use)) {
                            // remove the <use> element
                            parent.removeChild(use);
                            // parse the src and get the url and id
                            var srcSplit = src.split("#"), url = srcSplit.shift(), id = srcSplit.join("#");
                            // if the link is external
                            if (url.length) {
                                // get the cached xhr request
                                var xhr = requests[url];
                                // ensure the xhr request exists
                                xhr || (xhr = requests[url] = new XMLHttpRequest(), xhr.open("GET", url), xhr.send(), 
                                xhr._embeds = []), // add the svg and id as an item to the xhr embeds list
                                xhr._embeds.push({
                                    parent: parent,
                                    svg: svg,
                                    id: id
                                }), // prepare the xhr ready state change event
                                loadreadystatechange(xhr);
                            } else {
                                // embed the local id into the svg
                                embed(parent, svg, document.getElementById(id));
                            }
                        } else {
                            // increase the index when the previous value was not "valid"
                            ++index, ++numberOfSvgUseElementsToBypass;
                        }
                    }
                } else {
                    // increase the index when the previous value was not "valid"
                    ++index;
                }
            }
            // continue the interval
            (!uses.length || uses.length - numberOfSvgUseElementsToBypass > 0) && requestAnimationFrame(oninterval, 67);
        }
        var polyfill, opts = Object(rawopts), newerIEUA = /\bTrident\/[567]\b|\bMSIE (?:9|10)\.0\b/, webkitUA = /\bAppleWebKit\/(\d+)\b/, olderEdgeUA = /\bEdge\/12\.(\d+)\b/, edgeUA = /\bEdge\/.(\d+)\b/, inIframe = window.top !== window.self;
        polyfill = "polyfill" in opts ? opts.polyfill : newerIEUA.test(navigator.userAgent) || (navigator.userAgent.match(olderEdgeUA) || [])[1] < 10547 || (navigator.userAgent.match(webkitUA) || [])[1] < 537 || edgeUA.test(navigator.userAgent) && inIframe;
        // create xhr requests object
        var requests = {}, requestAnimationFrame = window.requestAnimationFrame || setTimeout, uses = document.getElementsByTagName("use"), numberOfSvgUseElementsToBypass = 0;
        // conditionally start the interval if the polyfill is active
        polyfill && oninterval();
    }
    function getSVGAncestor(node) {
        for (var svg = node; "svg" !== svg.nodeName.toLowerCase() && (svg = svg.parentNode); ) {}
        return svg;
    }
    return svg4everybody;
});

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Icon = __webpack_require__(6);

var _Icon2 = _interopRequireDefault(_Icon);

var _Spinner = __webpack_require__(10);

var _Spinner2 = _interopRequireDefault(_Spinner);

__webpack_require__(4);

__webpack_require__(179);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `Action` component.
 */
var Action = function Action(_ref) {
    var _classNames;

    var baseClassName = _ref.baseClassName,
        Tag = _ref.component,
        icon = _ref.icon,
        rightAddon = _ref.rightAddon,
        bottomAddon = _ref.bottomAddon,
        children = _ref.children,
        progress = _ref.progress,
        nowrap = _ref.nowrap,
        outerProps = _ref.outerProps,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'component', 'icon', 'rightAddon', 'bottomAddon', 'children', 'progress', 'nowrap', 'outerProps']);

    var className = outerProps.className,
        restOuterProps = _objectWithoutProperties(outerProps, ['className']);

    icon = _Icon2.default.create(icon, {
        className: baseClassName + '__icon',
        size: _Icon.ICON_SIZE_16
    });
    var size = icon && icon.props.size ? icon.props.size : _Icon.ICON_SIZE_16;
    if (progress) {
        icon = (0, _utils.createElement)(
            _Icon2.default,
            { size: size, className: baseClassName + '__icon' },
            (0, _utils.createElement)(_Spinner2.default, null)
        );
    }

    return (0, _utils.createElement)(
        'div',
        _extends({
            className: (0, _classnames2.default)(baseClassName, (_classNames = {}, _defineProperty(_classNames, baseClassName + '--size-' + size, icon || progress), _defineProperty(_classNames, baseClassName + '--progress', progress), _defineProperty(_classNames, baseClassName + '--nowrap', nowrap), _defineProperty(_classNames, baseClassName + '--icon', !children && !rightAddon && !bottomAddon), _classNames), className)
        }, restOuterProps),
        (0, _utils.createElement)(
            Tag,
            props,
            icon,
            children
        ),
        rightAddon ? (0, _utils.createElement)(
            'div',
            { className: baseClassName + '__right-addon' },
            rightAddon
        ) : null,
        bottomAddon ? (0, _utils.createElement)(
            'div',
            { className: baseClassName + '__bottom-addon' },
            bottomAddon
        ) : null
    );
};

Action.propTypes = {
    /**
     * Content of the `Action`.
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string,
    /**
     * Useful when rendering an `Action` as `<Link>` instead `<a>`.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    /**
     * Icon of the Action.
     */
    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.element]),
    /**
     * Right additional content.
     */
    rightAddon: _propTypes2.default.node,
    /**
     * Bottom additional content.
     */
    bottomAddon: _propTypes2.default.node,
    /**
     * Indicate the progress state of the `Action`.
     */
    progress: _propTypes2.default.bool,
    /**
     * Suppresses line breaks (text wrapping) within the source.
     */
    nowrap: _propTypes2.default.bool,
    /**
     * Props for the outer element.
     */
    outerProps: _propTypes2.default.object
};

Action.defaultProps = {
    children: null,
    baseClassName: _constants.CLS_PREFIX + 'action',
    component: 'a',
    icon: null,
    rightAddon: null,
    bottomAddon: null,
    progress: false,
    nowrap: false,
    outerProps: {}
};

exports.default = Action;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

__webpack_require__(4);

__webpack_require__(180);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `Alert` component.
 */
var Alert = function Alert(_ref) {
    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        intent = _ref.intent,
        children = _ref.children,
        onClose = _ref.onClose,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'intent', 'children', 'onClose']);

    return (0, _utils.createElement)(
        'div',
        _extends({
            className: (0, _classnames2.default)(baseClassName, _defineProperty({}, baseClassName + '--' + intent, intent), className)
        }, props),
        onClose && (0, _utils.createElement)('span', { className: 'close', onClick: onClose }),
        children
    );
};

Alert.propTypes = {
    /**
     * Visual intent color to apply to component.
     */
    intent: _propTypes2.default.oneOf(['info', 'success', 'warning', 'danger']),
    /**
     * Content of the `Alert`
     */
    children: _propTypes2.default.node,
    /**
     * Click handler for close button. Button will only be rendered if this prop is defined.
     */
    onClose: _propTypes2.default.func,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};
Alert.defaultProps = {
    intent: null,
    children: null,
    onClose: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'alert'
};

exports.default = Alert;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Alert = __webpack_require__(59);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alert).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * AutoClosable component.
 */
var AutoClosable = function (_Component) {
    _inherits(AutoClosable, _Component);

    function AutoClosable(props) {
        _classCallCheck(this, AutoClosable);

        var _this = _possibleConstructorReturn(this, (AutoClosable.__proto__ || Object.getPrototypeOf(AutoClosable)).call(this, props));

        _this.onOutsideClick = _this.onOutsideClick.bind(_this);
        return _this;
    }

    _createClass(AutoClosable, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.body.addEventListener('click', this.onOutsideClick);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.body.removeEventListener('click', this.onOutsideClick);
        }
    }, {
        key: 'onOutsideClick',
        value: function onOutsideClick(event) {
            var ignoreNodes = this.props.ignoreNodes;

            var nodes = typeof ignoreNodes === 'function' ? ignoreNodes() : [];
            nodes.push(this);

            if (nodes.map(_utils.findDOMNode).some(function (node) {
                return node && node.contains(event.target);
            })) {
                return;
            }

            if (this.props.onClose) {
                this.props.onClose();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _utils.Children.only(this.props.children);
        }
    }]);

    return AutoClosable;
}(_utils.Component);

AutoClosable.propTypes = {
    /**
     * onClose handler
     */
    onClose: _propTypes2.default.func,
    /**
     * Content of the AutoClosable
     */
    children: _propTypes2.default.element.isRequired,
    /**
     * Optional function that returns an array of DOM nodes clicks on which should be ignored.
     * @ignore
     */
    ignoreNodes: _propTypes2.default.func
};
AutoClosable.defaultProps = {
    onClose: null,
    ignoreNodes: null
};

exports.default = AutoClosable;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

__webpack_require__(181);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2018. Plesk International GmbH. All rights reserved.

/**
 * Auxiliary Actions component is used for executing additional (not primary) actions.
 * You should not use the actions for submitting data in Form.
 */
var AuxiliaryActions = function AuxiliaryActions(_ref) {
    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        separator = _ref.separator,
        children = _ref.children,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'separator', 'children']);

    var separatorElement = separator === null ? (0, _utils.createElement)(
        'span',
        { className: baseClassName + '__separator' },
        ' | '
    ) : separator;

    return (0, _utils.createElement)(
        'span',
        _extends({ className: (0, _classnames2.default)(baseClassName, className) }, props),
        _utils.Children.toArray(children).reduce(function (accu, elem, index) {
            return accu === null ? [elem] : [].concat(_toConsumableArray(accu), [(0, _utils.isValidElement)(separatorElement) ? (0, _utils.cloneElement)(separatorElement, { key: index }) : separator, elem]);
        }, null)
    );
};

AuxiliaryActions.propTypes = {
    /**
     * Actions
     */
    children: _propTypes2.default.node,
    /**
     * Custom separator between actions
     */
    separator: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

AuxiliaryActions.defaultProps = {
    baseClassName: _constants.CLS_PREFIX + 'auxiliary-actions',
    className: null,
    separator: null,
    children: null
};

exports.default = AuxiliaryActions;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AuxiliaryActions = __webpack_require__(62);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AuxiliaryActions).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Label = __webpack_require__(27);

var _Label2 = _interopRequireDefault(_Label);

__webpack_require__(4);

__webpack_require__(182);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `Badge` component.
 */
var Badge = function Badge(_ref) {
    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        children = _ref.children,
        label = _ref.label,
        hidden = _ref.hidden,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'children', 'label', 'hidden']);

    if (children && !hidden) {
        if (!(0, _utils.isValidElement)(label)) {
            label = (0, _utils.createElement)(
                _Label2.default,
                { intent: 'danger' },
                label
            );
        }
        label = (0, _utils.cloneElement)(label, {
            className: (0, _classnames2.default)(baseClassName + '__value', label.props.className)
        });
    } else {
        label = null;
    }

    return (0, _utils.createElement)(
        'div',
        _extends({ className: (0, _classnames2.default)(baseClassName, className) }, props),
        children,
        label
    );
};

Badge.propTypes = {
    /**
     * Display value. See [Label](#!/Label) for all props.
     */
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]).isRequired,
    /**
     * Set true for hide the badge.
     */
    hidden: _propTypes2.default.bool,
    /**
     * Content of the `Badge`.
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

Badge.defaultProps = {
    hidden: false,
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'badge'
};

exports.default = Badge;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

__webpack_require__(183);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `ButtonGroup` component is used for visual grouping of several [Buttons](#!/Button) together. Buttons are typically grouped
 * based on the similarity of their actions -- for example, for visually separating buttons that add new elements to the list
 * from buttons that modify existing elements in the list.
 */
var ButtonGroup = function ButtonGroup(_ref) {
  var baseClassName = _ref.baseClassName,
      className = _ref.className,
      children = _ref.children,
      innerRef = _ref.innerRef,
      props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'children', 'innerRef']);

  return (0, _utils.createElement)(
    'div',
    _extends({ className: (0, _classnames2.default)(baseClassName, className), ref: innerRef }, props),
    children
  );
};

ButtonGroup.propTypes = {
  /**
   * @ignore
   */
  baseClassName: _propTypes2.default.string,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Content of the button group
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  innerRef: _propTypes2.default.func
};
ButtonGroup.defaultProps = {
  baseClassName: _constants.CLS_PREFIX + 'button-group',
  className: null,
  children: null,
  innerRef: null
};

exports.default = ButtonGroup;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Icon = __webpack_require__(6);

var _Icon2 = _interopRequireDefault(_Icon);

var _Spinner = __webpack_require__(10);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _Tooltip = __webpack_require__(20);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _oldIconNames = __webpack_require__(253);

var _oldIconNames2 = _interopRequireDefault(_oldIconNames);

__webpack_require__(4);

__webpack_require__(184);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `Button` component is used for executing actions, changing the application state, opening forms or dialog windows, and submitting data.
 * As a rule, you should not use buttons for navigation between individual pages (use links instead).
 */
var Button = function (_Component) {
    _inherits(Button, _Component);

    function Button(props) {
        _classCallCheck(this, Button);

        var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

        _this.handleToggle = function () {
            var selected = _this.state.selected;


            _this.setState({ selected: !selected });

            return !selected;
        };

        var toggle = props.onToggle !== null || props.selected !== null;
        _this.state = {
            toggle: toggle,
            selected: toggle ? props.selected || false : null
        };
        return _this;
    }

    _createClass(Button, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props) {
            var _state = this.state,
                toggle = _state.toggle,
                selected = _state.selected;
            var onToggle = props.onToggle,
                selectedProp = props.selected;

            var newState = {};

            newState.toggle = onToggle !== null || selectedProp !== null;

            if (selectedProp === this.props.selected) {
                newState.selected = selected;
            } else {
                newState.selected = newState.toggle ? selectedProp || false : null;
            }

            if (newState.toggle !== toggle || newState.selected !== selected) {
                this.setState(newState);
            }
        }
    }, {
        key: 'isResponsive',
        value: function isResponsive() {
            return this.context.responsive || false;
        }
    }, {
        key: 'renderIcon',
        value: function renderIcon(_ref) {
            var baseClassName = _ref.baseClassName,
                icon = _ref.icon;

            return _Icon2.default.create(_oldIconNames2.default[icon] || icon, {
                className: baseClassName + '__icon'
            });
        }
    }, {
        key: 'renderCaret',
        value: function renderCaret(_ref2) {
            var baseClassName = _ref2.baseClassName,
                caret = _ref2.caret;

            var caretElement = void 0;
            if (typeof caret === 'boolean' && caret) {
                caretElement = (0, _utils.createElement)('span', null);
            } else {
                caretElement = caret;
            }

            if ((0, _utils.isValidElement)(caretElement)) {
                caretElement = (0, _utils.cloneElement)(caretElement, {
                    className: (0, _classnames2.default)(baseClassName + '__caret', caretElement.props.className)
                });
            }

            return caretElement;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this,
                _classNames;

            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                Tag = _props.component,
                intent = _props.intent,
                selectedProp = _props.selected,
                onToggle = _props.onToggle,
                state = _props.state,
                icon = _props.icon,
                caret = _props.caret,
                tooltip = _props.tooltip,
                children = _props.children,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'component', 'intent', 'selected', 'onToggle', 'state', 'icon', 'caret', 'tooltip', 'children']);

            var _state2 = this.state,
                toggle = _state2.toggle,
                selected = _state2.selected;

            var isCollapsed = this.isResponsive();

            var componentProps = {};
            if (Tag === 'button') {
                componentProps.type = 'button';
            } else if (Tag === 'a') {
                componentProps.role = 'button';
                componentProps.tabIndex = 0;

                if (props.onClick && props.disabled) {
                    props.onClick = function (e) {
                        e.preventDefault();
                    };
                }
            }

            var childrenElement = children;
            var tooltipElement = tooltip;
            if (isCollapsed && icon && children) {
                childrenElement = null;

                if (!tooltip) {
                    tooltipElement = children;
                }
            }

            if (!props.onClick && onToggle) {
                props.onClick = function (e) {
                    e.preventDefault();
                    onToggle(_this2.handleToggle());
                };
            }

            if (toggle) {
                componentProps['aria-pressed'] = String(selected);
            }

            var button = (0, _utils.createElement)(
                Tag,
                _extends({
                    className: (0, _classnames2.default)(baseClassName, (_classNames = {}, _defineProperty(_classNames, baseClassName + '--' + intent, intent), _defineProperty(_classNames, baseClassName + '--' + state, state), _defineProperty(_classNames, baseClassName + '--selected', selected), _defineProperty(_classNames, baseClassName + '--disabled', props.disabled), _defineProperty(_classNames, baseClassName + '--empty', !childrenElement), _classNames), className)
                }, componentProps, props),
                state === 'loading' ? (0, _utils.createElement)(_Spinner2.default, { className: baseClassName + '__spinner' }) : this.renderIcon({ baseClassName: baseClassName, icon: icon }),
                childrenElement,
                this.renderCaret({ baseClassName: baseClassName, caret: caret })
            );

            if (tooltipElement) {
                button = (0, _utils.createElement)(
                    _Tooltip2.default,
                    { title: tooltipElement },
                    button
                );
            }

            return button;
        }
    }]);

    return Button;
}(_utils.Component);

Button.propTypes = {
    /**
     * Visual intent color to apply to component.
     */
    intent: _propTypes2.default.oneOf(['primary', 'secondary', 'success', 'warning', 'danger', 'info']),
    /**
     * Selected state of toggle button. Used in controlled component mode.
     */
    selected: _propTypes2.default.bool,
    /**
     * Toggle button callback. Used in uncontrolled component mode.
     */
    onToggle: _propTypes2.default.func,
    /**
     * State of the button
     */
    state: _propTypes2.default.oneOf(['active', 'loading', 'hovered']),
    /**
     * Is button disabled?
     */
    disabled: _propTypes2.default.bool,
    /**
     * Tooltip for component
     */
    tooltip: _propTypes2.default.node,
    /**
     * Name of icon or [Icon](#!/Icon) component
     */
    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.element]),
    /**
     * Show caret
     */
    caret: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.element]),
    /**
     * Content of the button
     */
    children: _propTypes2.default.node,
    /**
     * Component to render as the root element. Useful when rendering a `Button` as `<a>` or `<Link>`.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};
Button.defaultProps = {
    intent: null,
    selected: null,
    onToggle: null,
    state: null,
    disabled: false,
    tooltip: null,
    icon: null,
    caret: null,
    children: null,
    component: 'button',
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'button'
};

Button.contextTypes = {
    responsive: _propTypes2.default.bool
};

exports.default = Button;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(2);

var _Translate = __webpack_require__(7);

var _Translate2 = _interopRequireDefault(_Translate);

var _Button = __webpack_require__(5);

var _Button2 = _interopRequireDefault(_Button);

var _Toolbar = __webpack_require__(47);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _Dropdown = __webpack_require__(12);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _SegmentedControl = __webpack_require__(33);

var _SegmentedControl2 = _interopRequireDefault(_SegmentedControl);

var _Menu = __webpack_require__(16);

var _Menu2 = _interopRequireDefault(_Menu);

var _Checkbox = __webpack_require__(17);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Badge = __webpack_require__(38);

var _Badge2 = _interopRequireDefault(_Badge);

var _CardList = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 1999-2017. Plesk International GmbH. All rights reserved.
/* eslint-disable react/prop-types */

var renderSelection = function renderSelection(_ref) {
    var onSelectAll = _ref.onSelectAll,
        onSelectNone = _ref.onSelectNone,
        checked = _ref.checked,
        badge = _ref.badge,
        total = _ref.total,
        _ref$menuItems = _ref.menuItems,
        menuItems = _ref$menuItems === undefined ? [] : _ref$menuItems;

    var button = (0, _utils.createElement)(
        _Button2.default,
        { caret: true },
        (0, _utils.createElement)(_Checkbox2.default, {
            checked: checked,
            onChange: function onChange(isChecked) {
                if (isChecked) {
                    onSelectAll();
                } else {
                    onSelectNone();
                }
            },
            onClick: function onClick(e) {
                return e.stopPropagation();
            }
        })
    );

    if (badge) {
        if (typeof badge === 'string') {
            badge = { label: badge };
        }

        button = (0, _utils.createElement)(
            _Badge2.default,
            badge,
            button
        );
    }

    menuItems = [(0, _utils.createElement)(
        _Menu.MenuItem,
        {
            key: 'selectAll'
            // eslint-disable-next-line react/jsx-handler-names
            , onClick: onSelectAll,
            label: total
        },
        (0, _utils.createElement)(_Translate2.default, { content: 'Card.selectAll', fallback: 'Select all' })
    ), (0, _utils.createElement)(
        _Menu.MenuItem,
        {
            key: 'selectNone'
            // eslint-disable-next-line react/jsx-handler-names
            , onClick: onSelectNone
        },
        (0, _utils.createElement)(_Translate2.default, { content: 'Card.selectNone', fallback: 'Select none' })
    )].concat(menuItems);

    return (0, _utils.createElement)(
        _Toolbar.ToolbarGroup,
        { key: 'selection', title: (0, _utils.createElement)(_Translate2.default, { content: 'CardList.toolbarSelect', fallback: 'Select' }) },
        (0, _utils.createElement)(
            _Dropdown2.default,
            { menu: (0, _utils.createElement)(
                    _Menu2.default,
                    null,
                    menuItems
                ) },
            button
        )
    );
};

var renderView = function renderView(onViewChange, currentView) {
    var viewButtons = [{
        value: _CardList.VIEW_EXTENDED,
        title: (0, _utils.createElement)(_Translate2.default, { content: 'CardList.viewCards', fallback: 'Cards' }),
        icon: 'site-page'
    }, {
        value: _CardList.VIEW_TILE,
        title: (0, _utils.createElement)(_Translate2.default, { content: 'CardList.viewTiles', fallback: 'Tiles' }),
        icon: 'four-squares'
    }, {
        value: _CardList.VIEW_ROW,
        title: (0, _utils.createElement)(_Translate2.default, { content: 'CardList.viewList', fallback: 'List' }),
        icon: 'list'
    }];

    return (0, _utils.createElement)(
        _Toolbar.ToolbarGroup,
        { key: 'view', title: (0, _utils.createElement)(_Translate2.default, { content: 'CardList.toolbarView', fallback: 'View' }) },
        (0, _utils.createElement)(_SegmentedControl2.default, {
            buttons: viewButtons,
            selected: currentView,
            onChange: function onChange(view) {
                return onViewChange(view);
            }
        })
    );
};

var isToolbarExpander = function isToolbarExpander(element) {
    return (0, _utils.isValidElement)(element) && element.type === _Toolbar.ToolbarExpander;
};

var CardListToolbar = function CardListToolbar(_ref2) {
    var baseClassName = _ref2.baseClassName,
        selection = _ref2.selection,
        onViewChange = _ref2.onViewChange,
        currentView = _ref2.currentView,
        groups = _ref2.groups;

    var toolbar = [];

    if (selection) {
        toolbar.push(renderSelection(selection));
    }

    toolbar = toolbar.concat(groups);

    if (onViewChange && currentView !== _CardList.VIEW_RESPONSIVE) {
        var hasExpander = groups.filter(isToolbarExpander).length > 0;

        if (!hasExpander) {
            toolbar.push((0, _utils.createElement)(_Toolbar.ToolbarExpander, { key: 'expander' }));
        }

        toolbar.push(renderView(onViewChange, currentView));
    }

    if (toolbar.length === 0) {
        return null;
    }

    return (0, _utils.createElement)(
        _Toolbar2.default,
        { className: baseClassName },
        toolbar
    );
};

CardListToolbar.propTypes = {
    selection: _propTypes2.default.object,
    groups: _propTypes2.default.arrayOf(_propTypes2.default.element).isRequired,
    onViewChange: _propTypes2.default.func,
    currentView: _propTypes2.default.string.isRequired,
    baseClassName: _propTypes2.default.string
};
CardListToolbar.defaultProps = {
    selection: null,
    onViewChange: null,
    baseClassName: _constants.CLS_PREFIX + 'card-list__toolbar'
};

exports.default = CardListToolbar;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CardList = __webpack_require__(39);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CardList).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _reactTransitionGroup = __webpack_require__(34);

var _Checkbox = __webpack_require__(17);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Dropdown = __webpack_require__(12);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _Spinner = __webpack_require__(10);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _Translate = __webpack_require__(7);

var _Translate2 = _interopRequireDefault(_Translate);

var _CardButton = __webpack_require__(70);

var _CardButton2 = _interopRequireDefault(_CardButton);

var _PreviewPanel = __webpack_require__(40);

var _PreviewPanel2 = _interopRequireDefault(_PreviewPanel);

__webpack_require__(186);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var VIEW_TILE = 'tile';
var VIEW_EXTENDED = 'extended';
var VIEW_ROW = 'row';

/**
 * `Card` component.
 */

var Card = function (_Component) {
    _inherits(Card, _Component);

    function Card(props) {
        _classCallCheck(this, Card);

        var _this = _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).call(this, props));

        _this.handleToggleView = function () {
            var view = _this.state.view;


            _this.setState({
                view: view === VIEW_EXTENDED ? VIEW_ROW : VIEW_EXTENDED
            });
        };

        _this.state = {
            view: props.view
        };
        return _this;
    }

    _createClass(Card, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var view = nextProps.view;


            if (view !== this.props.view) {
                this.setState({
                    view: view
                });
            }
        }
    }, {
        key: 'renderSelection',
        value: function renderSelection(_ref) {
            var baseClassName = _ref.baseClassName,
                selection = _ref.selection;

            if (!selection) {
                return null;
            }

            var isSelected = selection.isSelected,
                onSelectionChange = selection.onSelectionChange;


            return (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__selection' },
                (0, _utils.createElement)(
                    _Checkbox2.default,
                    {
                        checked: isSelected,
                        onChange: function onChange(isSelected) {
                            return onSelectionChange({ isSelected: isSelected });
                        }
                    },
                    this.isExtended() ? (0, _utils.createElement)(_Translate2.default, { content: 'Card.select', fallback: 'Select' }) : null
                )
            );
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle(_ref2) {
            var baseClassName = _ref2.baseClassName,
                title = _ref2.title,
                titleLink = _ref2.titleLink;

            var titleLinkProps = typeof titleLink === 'string' ? { href: titleLink } : titleLink;

            return (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__title' },
                (0, _utils.createElement)(
                    'span',
                    { className: baseClassName + '__title-text' },
                    title
                ),
                titleLinkProps && (0, _utils.createElement)(_CardButton2.default, _extends({
                    component: 'a',
                    icon: 'chain',
                    tooltip: (0, _utils.createElement)(_Translate2.default, { content: 'Card.titleLinkTooltip', fallback: 'Go to page' })
                }, titleLinkProps))
            );
        }
    }, {
        key: 'renderLabels',
        value: function renderLabels(_ref3) {
            var baseClassName = _ref3.baseClassName,
                labels = _ref3.labels;

            if (labels.length === 0) {
                return null;
            }

            return (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__labels' },
                _utils.Children.map(labels, function (label) {
                    return (0, _utils.cloneElement)(label, {
                        className: (0, _classnames2.default)(baseClassName + '__label', label.props.className)
                    });
                })
            );
        }
    }, {
        key: 'renderHeader',
        value: function renderHeader(_ref4) {
            var baseClassName = _ref4.baseClassName,
                selection = _ref4.selection,
                title = _ref4.title,
                titleLink = _ref4.titleLink,
                labels = _ref4.labels,
                rowContent = _ref4.rowContent,
                menu = _ref4.menu,
                buttons = _ref4.buttons;

            return (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__header' },
                this.renderSelection({ baseClassName: baseClassName, selection: selection }),
                this.renderTitle({ baseClassName: baseClassName, title: title, titleLink: titleLink }),
                this.isExtended() && this.renderLabels({ baseClassName: baseClassName, labels: labels }),
                this.renderButtons({ baseClassName: baseClassName, rowContent: rowContent, menu: menu, buttons: buttons })
            );
        }
    }, {
        key: 'renderRowHeader',
        value: function renderRowHeader(_ref5) {
            var baseClassName = _ref5.baseClassName,
                subtitle = _ref5.subtitle,
                title = _ref5.title,
                titleLink = _ref5.titleLink;

            return (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__header' },
                subtitle && (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__subtitle' },
                    subtitle
                ),
                this.renderTitle({ baseClassName: baseClassName, title: title, titleLink: titleLink })
            );
        }
    }, {
        key: 'renderContent',
        value: function renderContent(_ref6) {
            var baseClassName = _ref6.baseClassName,
                children = _ref6.children;

            return (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__main' },
                (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__main-content' },
                    children
                )
            );
        }
    }, {
        key: 'isExtended',
        value: function isExtended() {
            var view = this.state.view;


            return !this.isTile() && view === VIEW_EXTENDED;
        }
    }, {
        key: 'isTile',
        value: function isTile() {
            var view = this.state.view;


            return view === VIEW_TILE;
        }
    }, {
        key: 'isRow',
        value: function isRow() {
            var view = this.state.view;


            return !this.isTile() && view === VIEW_ROW;
        }
    }, {
        key: 'renderButtons',
        value: function renderButtons(_ref7) {
            var baseClassName = _ref7.baseClassName,
                rowContent = _ref7.rowContent,
                menu = _ref7.menu,
                buttons = _ref7.buttons;

            var result = [];

            if (!this.isRow()) {
                buttons.forEach(function (btn, index) {
                    result.push((0, _utils.createElement)(_CardButton2.default, _extends({ key: btn.key || index }, btn)));
                });
            }

            if (menu) {
                result.push((0, _utils.createElement)(
                    _Dropdown2.default,
                    { key: 'menu', menu: menu, menuPlacement: 'bottom-end' },
                    (0, _utils.createElement)(_CardButton2.default, { icon: 'menu' })
                ));
            }

            if (rowContent && !this.isTile()) {
                result.push((0, _utils.createElement)(_CardButton2.default, {
                    key: 'toggleView',
                    icon: { name: 'chevron-down', flipVertical: this.isExtended() },
                    onClick: this.handleToggleView,
                    tooltip: this.isExtended() ? (0, _utils.createElement)(_Translate2.default, { content: 'Card.collapseCardTooltip', fallback: 'Collapse the card' }) : (0, _utils.createElement)(_Translate2.default, { content: 'Card.expandCardTooltip', fallback: 'Expand the card' })
                }));
            }

            if (result.length === 0) {
                return null;
            }

            return (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__buttons' },
                result
            );
        }
    }, {
        key: 'renderSideHeader',
        value: function renderSideHeader(_ref8) {
            var sideHeader = _ref8.sideHeader,
                baseClassName = _ref8.baseClassName;

            if (!sideHeader) {
                return null;
            }

            var sideHeaderElement = sideHeader;
            if (sideHeader.type === _PreviewPanel2.default && this.isRow()) {
                sideHeaderElement = (0, _utils.cloneElement)(sideHeader, { children: null });
            }

            return (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__side-header' },
                sideHeaderElement
            );
        }
    }, {
        key: 'renderSideContent',
        value: function renderSideContent(_ref9) {
            var sideContent = _ref9.sideContent,
                baseClassName = _ref9.baseClassName;

            if (!sideContent) {
                return null;
            }

            return (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__side-content' },
                sideContent
            );
        }
    }, {
        key: 'renderRow',
        value: function renderRow(_ref10) {
            var baseClassName = _ref10.baseClassName,
                selection = _ref10.selection,
                rowContent = _ref10.rowContent,
                subtitle = _ref10.subtitle,
                title = _ref10.title,
                titleLink = _ref10.titleLink,
                menu = _ref10.menu,
                sideHeader = _ref10.sideHeader,
                buttons = _ref10.buttons;

            return (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__inner' },
                (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__body' },
                    this.renderSelection({ baseClassName: baseClassName, selection: selection }),
                    this.renderSideHeader({ sideHeader: sideHeader, baseClassName: baseClassName }),
                    this.renderRowHeader({ baseClassName: baseClassName, subtitle: subtitle, title: title, titleLink: titleLink }),
                    (0, _utils.createElement)(
                        'div',
                        { className: baseClassName + '__main' },
                        (0, _utils.createElement)(
                            'div',
                            { className: baseClassName + '__main-content' },
                            rowContent
                        )
                    ),
                    this.renderButtons({ baseClassName: baseClassName, rowContent: rowContent, menu: menu, buttons: buttons })
                )
            );
        }
    }, {
        key: 'renderTile',
        value: function renderTile(_ref11) {
            var baseClassName = _ref11.baseClassName,
                selection = _ref11.selection,
                title = _ref11.title,
                titleLink = _ref11.titleLink,
                labels = _ref11.labels,
                children = _ref11.children,
                rowContent = _ref11.rowContent,
                menu = _ref11.menu,
                sideHeader = _ref11.sideHeader,
                sideContent = _ref11.sideContent,
                buttons = _ref11.buttons;

            return (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__inner' },
                this.renderHeader({ baseClassName: baseClassName, selection: selection, title: title, titleLink: titleLink, labels: labels, rowContent: rowContent, menu: menu, buttons: buttons }),
                (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__body' },
                    this.renderSideHeader({ sideHeader: sideHeader, baseClassName: baseClassName }),
                    this.renderContent({ baseClassName: baseClassName, children: children })
                ),
                this.renderSideContent({ sideContent: sideContent, baseClassName: baseClassName })
            );
        }
    }, {
        key: 'renderExtended',
        value: function renderExtended(_ref12) {
            var baseClassName = _ref12.baseClassName,
                selection = _ref12.selection,
                title = _ref12.title,
                titleLink = _ref12.titleLink,
                labels = _ref12.labels,
                children = _ref12.children,
                rowContent = _ref12.rowContent,
                menu = _ref12.menu,
                sideHeader = _ref12.sideHeader,
                sideContent = _ref12.sideContent,
                buttons = _ref12.buttons;

            var sideHeaderElement = this.renderSideHeader({ sideHeader: sideHeader, baseClassName: baseClassName });
            var sideContentElement = this.renderSideContent({ sideContent: sideContent, baseClassName: baseClassName });

            return (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__inner' },
                this.renderHeader({ baseClassName: baseClassName, selection: selection, title: title, titleLink: titleLink, labels: labels, rowContent: rowContent, menu: menu, buttons: buttons }),
                (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__body' },
                    sideHeaderElement || sideContentElement ? (0, _utils.createElement)(
                        'div',
                        { className: baseClassName + '__side' },
                        sideHeaderElement,
                        sideContentElement
                    ) : null,
                    this.renderContent({ baseClassName: baseClassName, children: children })
                )
            );
        }
    }, {
        key: 'renderLoader',
        value: function renderLoader(_ref13) {
            var baseClassName = _ref13.baseClassName,
                progress = _ref13.progress;

            if (!progress) {
                return null;
            }

            return (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__content-blocker' },
                (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__loader' },
                    (0, _utils.createElement)(_Spinner2.default, { className: baseClassName + '__loader-spinner' }),
                    progress === true ? null : (0, _utils.createElement)(
                        'div',
                        { className: baseClassName + '__loader-text' },
                        progress
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                children = _props.children,
                view = _props.view,
                intent = _props.intent,
                title = _props.title,
                subtitle = _props.subtitle,
                titleLink = _props.titleLink,
                selection = _props.selection,
                rowContent = _props.rowContent,
                sideHeader = _props.sideHeader,
                sideContent = _props.sideContent,
                buttons = _props.buttons,
                menu = _props.menu,
                labels = _props.labels,
                progress = _props.progress,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'children', 'view', 'intent', 'title', 'subtitle', 'titleLink', 'selection', 'rowContent', 'sideHeader', 'sideContent', 'buttons', 'menu', 'labels', 'progress']);

            return (0, _utils.createElement)(
                _reactTransitionGroup.CSSTransition,
                {
                    classNames: baseClassName + '-',
                    'in': this.isExtended(),
                    timeout: 300
                },
                (0, _utils.createElement)(
                    'div',
                    _extends({
                        className: (0, _classnames2.default)(baseClassName, (_classNames = {}, _defineProperty(_classNames, baseClassName + '--extended', this.isExtended()), _defineProperty(_classNames, baseClassName + '--tile', this.isTile()), _defineProperty(_classNames, baseClassName + '--row', this.isRow()), _defineProperty(_classNames, baseClassName + '--' + intent, intent), _defineProperty(_classNames, baseClassName + '--progress', progress), _classNames), className)
                    }, props),
                    this.isExtended() && this.renderExtended({ baseClassName: baseClassName, selection: selection, title: title, titleLink: titleLink, labels: labels, children: children, rowContent: rowContent, menu: menu, sideHeader: sideHeader, sideContent: sideContent, buttons: buttons }),
                    this.isTile() && this.renderTile({ baseClassName: baseClassName, selection: selection, title: title, titleLink: titleLink, labels: labels, children: children, rowContent: rowContent, menu: menu, sideHeader: sideHeader, sideContent: sideContent, buttons: buttons }),
                    this.isRow() && this.renderRow({ baseClassName: baseClassName, selection: selection, rowContent: rowContent, subtitle: subtitle, title: title, titleLink: titleLink, menu: menu, sideHeader: sideHeader, buttons: buttons }),
                    this.renderLoader({ baseClassName: baseClassName, progress: progress })
                )
            );
        }
    }]);

    return Card;
}(_utils.Component);

Card.propTypes = {
    /**
     * Content of the `Card`.
     */
    children: _propTypes2.default.node,
    /**
     * View mode.
     */
    view: _propTypes2.default.oneOf([VIEW_EXTENDED, VIEW_TILE, VIEW_ROW]),
    /**
     * Visual intent color to apply to component.
     */
    intent: _propTypes2.default.oneOf(['warning', 'danger', 'inactive']),
    /**
     * Text of title.
     */
    title: _propTypes2.default.node.isRequired,
    /**
     * Link for title.
     */
    titleLink: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    /**
     * Text of subtitle.
     */
    subtitle: _propTypes2.default.node,
    /**
     * List of labels in header. See [Label](#!/Label) component for details.
     */
    labels: _propTypes2.default.arrayOf(_propTypes2.default.element),
    /**
     * List of additional buttons in header.
     */
    buttons: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.element]).isRequired,
        onClick: _propTypes2.default.func.isRequired,
        tooltip: _propTypes2.default.node
    })),
    /**
     * See [Menu](#!/Menu).
     */
    menu: _propTypes2.default.element,
    /**
     * Selection control.
     */
    selection: _propTypes2.default.shape({
        isSelected: _propTypes2.default.bool.isRequired,
        onSelectionChange: _propTypes2.default.func.isRequired
    }),
    /**
     * Side header section. Recommended to use [PreviewPanel](#!/PreviewPanel) component.
     */
    sideHeader: _propTypes2.default.element,
    /**
     * Side content section.
     */
    sideContent: _propTypes2.default.element,
    /**
     * Content for row view.
     */
    rowContent: _propTypes2.default.any,
    /**
     * Indicate the progress state of the card.
     */
    progress: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};
Card.defaultProps = {
    children: null,
    view: VIEW_EXTENDED,
    intent: null,
    subtitle: '',
    titleLink: null,
    labels: [],
    buttons: [],
    menu: null,
    selection: null,
    sideHeader: null,
    sideContent: null,
    rowContent: null,
    progress: false,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'card'
};

exports.default = Card;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(2);

var _Button = __webpack_require__(5);

var _Button2 = _interopRequireDefault(_Button);

var _Icon = __webpack_require__(6);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var CardButton = function CardButton(_ref) {
    var icon = _ref.icon,
        props = _objectWithoutProperties(_ref, ['icon']);

    return (0, _utils.createElement)(_Button2.default, _extends({ icon: _Icon2.default.create(icon) }, props));
};

CardButton.propTypes = {
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string,
    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.element]).isRequired
};

CardButton.defaultProps = {
    baseClassName: _constants.CLS_PREFIX + 'card-button'
};

exports.default = CardButton;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Card = __webpack_require__(69);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Card).default;
  }
});

var _PreviewPanel = __webpack_require__(40);

Object.defineProperty(exports, 'PreviewPanel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PreviewPanel).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactMeasure = __webpack_require__(8);

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _constants = __webpack_require__(2);

var _Icon = __webpack_require__(6);

var _Icon2 = _interopRequireDefault(_Icon);

__webpack_require__(188);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * Carousel component.
 */
var Carousel = function (_Component) {
    _inherits(Carousel, _Component);

    function Carousel(props) {
        _classCallCheck(this, Carousel);

        var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

        _this.state = {
            width: null,
            current: 0,
            next: 0,
            moving: false
        };

        _this.width = 0;
        _this.totalWidth = 0;
        _this.slideWidths = [];
        _this.speed = 500;
        _this.movingCallback = null;

        _this.playSpeed = 5000;
        _this.playTimer = null;

        _this.handlePrevClick = _this.handlePrevClick.bind(_this);
        _this.handleNextClick = _this.handleNextClick.bind(_this);
        _this.stop = _this.stop.bind(_this);
        _this.play = _this.play.bind(_this);
        _this.handleResize = _this.handleResize.bind(_this);
        return _this;
    }

    _createClass(Carousel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.isRtl = (0, _utils.isRtl)();
            var node = (0, _utils.findDOMNode)(this);
            this.slideWidths = [].map.call(node.firstChild.childNodes, function (el) {
                return el.clientWidth;
            });
            this.totalWidth = this.slideWidths.reduce(function (prev, curr) {
                return prev + curr;
            }, 0);
            this.play();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.stop();
            clearTimeout(this.movingCallback);
        }
    }, {
        key: 'handlePrevClick',
        value: function handlePrevClick() {
            this.stop();
            this.setCurrentSlide(this.state.current - 1);
        }
    }, {
        key: 'handleNextClick',
        value: function handleNextClick() {
            this.stop();
            this.setCurrentSlide(this.state.current + 1);
        }
    }, {
        key: 'play',
        value: function play() {
            var _this2 = this;

            this.playTimer = setTimeout(function () {
                _this2.setCurrentSlide(_this2.state.current + 1);
                _this2.play();
            }, this.playSpeed);
        }
    }, {
        key: 'stop',
        value: function stop() {
            if (this.playTimer) {
                clearTimeout(this.playTimer);
                this.playTimer = null;
            }
        }
    }, {
        key: 'setCurrentSlide',
        value: function setCurrentSlide(next) {
            var _this3 = this;

            if (this.state.moving) {
                return;
            }

            var current = next;
            if (current < 0) {
                current = this.slideWidths.length - 1;
            }
            if (current >= this.slideWidths.length) {
                current = 0;
            }

            this.setState({
                current: current,
                next: next,
                moving: true
            });
            this.movingCallback = setTimeout(function () {
                _this3.movingCallback = null;
                _this3.setState({
                    moving: false
                });
            }, this.speed);
        }
    }, {
        key: 'handleResize',
        value: function handleResize(contentRect) {
            this.setState({
                width: contentRect.bounds.width
            });
        }
    }, {
        key: 'listStyle',
        value: function listStyle() {
            var _state = this.state,
                current = _state.current,
                next = _state.next,
                moving = _state.moving;

            var moveTo = moving ? next : current;
            var x = -this.totalWidth + 26;

            if (moveTo < 0) {
                for (var i = moveTo; i < 0; i++) {
                    x += this.slideWidths[i + this.slideWidths.length];
                }
            } else {
                for (var _i = 0; _i < moveTo; _i++) {
                    x -= this.slideWidths[_i % this.slideWidths.length];
                }
            }

            if (this.isRtl) {
                x = -x;
            }

            return {
                WebkitTransform: 'translateX(' + (x ? x + 'px' : 0) + ')',
                transform: 'translateX(' + (x ? x + 'px' : 0) + ')',
                WebkitTransition: moving ? '-webkit-transform ' + this.speed + 'ms ease' : null,
                transition: moving ? 'transform ' + this.speed + 'ms ease' : null
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var width = this.state.width;

            var showControls = width < this.totalWidth;

            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                children = _props.children,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'children']);

            return (0, _utils.createElement)(
                _reactMeasure2.default,
                { onResize: this.handleResize, bounds: true },
                function (_ref) {
                    var measureRef = _ref.measureRef;
                    return (0, _utils.createElement)(
                        'section',
                        _extends({ ref: measureRef, className: (0, _classnames2.default)(baseClassName, className) }, props),
                        (0, _utils.createElement)(
                            'div',
                            { className: baseClassName + '__slides', style: showControls ? _this4.listStyle() : null },
                            showControls && children,
                            children,
                            showControls && children
                        ),
                        showControls && (0, _utils.createElement)(
                            'div',
                            { className: baseClassName + '__controls' },
                            (0, _utils.createElement)(
                                'button',
                                { type: 'button', className: (0, _classnames2.default)(baseClassName + '__control', baseClassName + '__control--previous'), onClick: _this4.handlePrevClick },
                                (0, _utils.createElement)(_Icon2.default, { name: 'chevron-left', flipHorizontal: _this4.isRtl, className: baseClassName + '__control-icon' })
                            ),
                            (0, _utils.createElement)(
                                'button',
                                { type: 'button', className: (0, _classnames2.default)(baseClassName + '__control', baseClassName + '__control--next'), onClick: _this4.handleNextClick },
                                (0, _utils.createElement)(_Icon2.default, { name: 'chevron-right', flipHorizontal: _this4.isRtl, className: baseClassName + '__control-icon' })
                            )
                        )
                    );
                }
            );
        }
    }]);

    return Carousel;
}(_utils.Component);

Carousel.propTypes = {
    /**
     * Slides
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

Carousel.defaultProps = {
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'carousel'
};

exports.default = Carousel;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Carousel = __webpack_require__(72);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Carousel).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Tooltip = __webpack_require__(20);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

__webpack_require__(189);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `Checkbox` component.
 */
var Checkbox = function (_Component) {
    _inherits(Checkbox, _Component);

    function Checkbox() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Checkbox);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (event) {
            var _this$props = _this.props,
                disabled = _this$props.disabled,
                onChange = _this$props.onChange;

            if (!disabled && onChange) {
                onChange(event.target.checked);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Checkbox, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                children = _props.children,
                onChange = _props.onChange,
                tooltip = _props.tooltip,
                checked = _props.checked,
                defaultChecked = _props.defaultChecked,
                disabled = _props.disabled,
                inputProps = _props.inputProps,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'children', 'onChange', 'tooltip', 'checked', 'defaultChecked', 'disabled', 'inputProps']);

            var result = (0, _utils.createElement)(
                'label',
                _extends({
                    className: (0, _classnames2.default)(baseClassName, className)
                }, props),
                (0, _utils.createElement)('input', _extends({
                    className: baseClassName + '__input',
                    type: 'checkbox',
                    onChange: this.handleChange,
                    checked: checked,
                    defaultChecked: defaultChecked,
                    disabled: disabled
                }, inputProps)),
                (0, _utils.createElement)('span', { className: baseClassName + '__indicator' }),
                children ? (0, _utils.createElement)(
                    'span',
                    { className: baseClassName + '__text' },
                    children
                ) : null
            );

            if (tooltip) {
                result = (0, _utils.createElement)(
                    _Tooltip2.default,
                    { title: tooltip },
                    result
                );
            }

            return result;
        }
    }]);

    return Checkbox;
}(_utils.Component);

Checkbox.propTypes = {
    /**
     * Determine whether the `Checkbox` is checked.
     */
    checked: _propTypes2.default.bool,
    /**
     * @ignore
     */
    defaultChecked: _propTypes2.default.bool,
    /**
     * A callback function, can be executed when the checked state is changing.
     */
    onChange: _propTypes2.default.func,
    /**
     * Tooltip for component
     */
    tooltip: _propTypes2.default.node,
    disabled: _propTypes2.default.bool,
    /**
     * Label of the `Checkbox`
     */
    children: _propTypes2.default.any,
    /**
     * Additional props for input element
     */
    inputProps: _propTypes2.default.object,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

Checkbox.defaultProps = {
    checked: undefined,
    defaultChecked: undefined,
    onChange: undefined,
    tooltip: undefined,
    disabled: false,
    children: undefined,
    inputProps: {},
    className: undefined,
    baseClassName: _constants.CLS_PREFIX + 'checkbox'
};

exports.default = Checkbox;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _utils2 = __webpack_require__(11);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

__webpack_require__(190);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `CodeEditor` component.
 */
var CodeEditor = function (_Component) {
    _inherits(CodeEditor, _Component);

    function CodeEditor(props) {
        _classCallCheck(this, CodeEditor);

        var _this = _possibleConstructorReturn(this, (CodeEditor.__proto__ || Object.getPrototypeOf(CodeEditor)).call(this, props));

        _this.handleChange = function (doc, changes) {
            if (_this.props.readOnly || changes.origin === 'setValue') {
                return;
            }

            var lineSeparator = _this.state.lineSeparator;
            var onChange = _this.props.onChange;

            var content = doc.getValue(lineSeparator);
            _this.setState({ content: content }, function () {
                (0, _utils2.safeInvoke)(onChange, content);
            });
        };

        _this.state = {
            content: _this.props.children,
            lineSeparator: _this.getLineSeparator(_this.props.children),
            options: _extends({
                lineNumbers: true,
                lineWrapping: true,
                matchBrackets: true,
                matchTags: { bothTags: true },
                indentUnit: 4,
                indentWithTabs: true,
                enterMode: 'keep',
                tabMode: 'shift'
            }, props.options, {
                extraKeys: { 'Ctrl-S': 'save' },
                autofocus: props.autofocus,
                readOnly: props.readOnly
            })
        };
        return _this;
    }

    _createClass(CodeEditor, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 268)).then(function (_ref) {
                var CodeMirror = _ref.CodeMirror;

                _this2.CodeMirror = CodeMirror;
                var onInit = _this2.props.onInit;
                var options = _this2.state.options;


                _this2.codeMirror = CodeMirror.fromTextArea(_this2.textareaNode, options);
                _this2.updateMode(_this2.props);
                CodeMirror.commands.save = _this2.props.onSave;
                CodeMirror.commands.find = CodeMirror.commands.findPersistent;
                CodeMirror.commands.findNext = CodeMirror.commands.findPersistentNext;
                CodeMirror.commands.findPrev = CodeMirror.commands.findPersistentPrev;
                (0, _utils2.safeInvoke)(onInit, _this2.codeMirror.display.wrapper);
                _this2.codeMirror.on('change', _this2.handleChange);
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref2) {
            var mode = _ref2.mode,
                fileName = _ref2.fileName,
                children = _ref2.children,
                autofocus = _ref2.autofocus;

            this.updateMode({ mode: mode, fileName: fileName });
            var newContent = children || '';

            if (newContent !== this.state.content) {
                var newState = {
                    content: newContent,
                    lineSeparator: this.getLineSeparator(newContent)
                };

                var prevScrollPosition = this.codeMirror.getScrollInfo();
                this.codeMirror.setValue(newContent);
                this.codeMirror.scrollTo(prevScrollPosition.left, prevScrollPosition.top);

                if (autofocus) {
                    this.codeMirror.focus();
                }

                this.setState(newState);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.codeMirror) {
                this.codeMirror.toTextArea();
            }
        }
    }, {
        key: 'findModeByFileName',
        value: function findModeByFileName(fileName) {
            var modeInfo = this.CodeMirror.findModeByFileName(fileName);

            if (modeInfo) {
                return modeInfo.mode;
            }

            return null;
        }
    }, {
        key: 'updateMode',
        value: function updateMode(_ref3) {
            var mode = _ref3.mode,
                fileName = _ref3.fileName;

            if (!mode && fileName) {
                mode = this.findModeByFileName(fileName);
            }

            if (!mode) {
                return;
            }

            this.CodeMirror.loadMode(this.codeMirror, mode);
        }
    }, {
        key: 'getLineSeparator',
        value: function getLineSeparator() {
            var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            var sep = /^.*?(\r\n?|\n)/.exec(content);

            return sep && sep[1] ? sep[1] : '\n';
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                mode = _props.mode,
                fileName = _props.fileName,
                readOnly = _props.readOnly,
                autofocus = _props.autofocus,
                children = _props.children,
                onInit = _props.onInit,
                onChange = _props.onChange,
                onSave = _props.onSave,
                options = _props.options,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'mode', 'fileName', 'readOnly', 'autofocus', 'children', 'onInit', 'onChange', 'onSave', 'options']);

            var content = this.state.content;


            return (0, _utils.createElement)('textarea', _extends({
                style: { display: 'none' },
                ref: function ref(_ref4) {
                    return _this3.textareaNode = _ref4;
                },
                className: (0, _classnames2.default)(baseClassName, className),
                defaultValue: content
            }, props));
        }
    }]);

    return CodeEditor;
}(_utils.Component);

CodeEditor.propTypes = {
    /**
     * The mode to use. When not given, this will default to the first mode that was loaded.
     */
    mode: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    /**
     * CodeEditor can detect mode by file name. Will be ignored if you set mode property.
     */
    fileName: _propTypes2.default.string,
    /**
     * Content of the `CodeEditor`.
     */
    children: _propTypes2.default.string,
    /**
     * Set read only.
     */
    readOnly: _propTypes2.default.bool,
    /**
     * Set auto focus.
     */
    autofocus: _propTypes2.default.bool,
    /**
     * onInit event handler.
     */
    onInit: _propTypes2.default.func,
    /**
     * onChange event handler.
     */
    onChange: _propTypes2.default.func,
    /**
     * onSave event handler.
     */
    onSave: _propTypes2.default.func,
    /**
     * See all supported options in [CodeMirror](https://codemirror.net/doc/manual.html#config) documentation.
     */
    options: _propTypes2.default.object,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};
CodeEditor.defaultProps = {
    mode: '',
    fileName: '',
    children: '',
    readOnly: false,
    autofocus: false,
    onInit: null,
    onChange: null,
    onSave: null,
    options: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'code-editor'
};

exports.default = CodeEditor;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CodeEditor = __webpack_require__(75);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CodeEditor).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

__webpack_require__(191);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * ConsoleOutput component.
 */
var ConsoleOutput = function ConsoleOutput(_ref) {
    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        wide = _ref.wide,
        cursor = _ref.cursor,
        children = _ref.children,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'wide', 'cursor', 'children']);

    return (0, _utils.createElement)(
        'pre',
        _extends({
            className: (0, _classnames2.default)(baseClassName, _defineProperty({}, baseClassName + '--wide', wide), className)
        }, props),
        children,
        cursor ? (0, _utils.createElement)('span', { className: (0, _classnames2.default)(baseClassName + '__cursor', 'animation-blink') }) : null
    );
};
ConsoleOutput.propTypes = {
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * Console output content
     */
    children: _propTypes2.default.node,
    /**
     * Enable wide mode
     */
    wide: _propTypes2.default.bool,
    /**
     * Enable cursor
     */
    cursor: _propTypes2.default.bool
};
ConsoleOutput.defaultProps = {
    baseClassName: _constants.CLS_PREFIX + 'console-output',
    className: null,
    children: null,
    wide: false,
    cursor: false
};

exports.default = ConsoleOutput;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ConsoleOutput = __webpack_require__(77);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ConsoleOutput).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _Spinner = __webpack_require__(10);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _constants = __webpack_require__(2);

__webpack_require__(4);

__webpack_require__(192);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2018. Plesk International GmbH. All rights reserved.

/**
 * `ContentLoader` component indicates that the system is performing a certain operation and alerts users that they need
 * to wait for the operation to complete. `ContentLoader` is an indeterminate indicator: in other words, it does not tell
 * the user how long it will take for the operation to complete, so it should be used when the operation takes a relatively
 * short amount of time (from 2 to 10 seconds). If the operation takes longer than 10 seconds to complete on average,
 * use a progress bar instead.
 */
var ContentLoader = function ContentLoader(_ref) {
    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        text = _ref.text,
        overlay = _ref.overlay,
        children = _ref.children,
        backdrop = _ref.backdrop,
        blur = _ref.blur,
        loading = _ref.loading,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'text', 'overlay', 'children', 'backdrop', 'blur', 'loading']);

    if (!loading) {
        return children;
    }

    if (children && overlay) {
        children = (0, _utils.createElement)(
            'div',
            { className: (0, _classnames2.default)(baseClassName + '__content', blur && baseClassName + '__content--blur') },
            children
        );
    }

    return (0, _utils.createElement)(
        'div',
        _extends({ className: (0, _classnames2.default)(baseClassName, !children && overlay && baseClassName + '--overlay', className) }, props),
        children,
        (0, _utils.createElement)(
            'div',
            { className: (0, _classnames2.default)(baseClassName + '__container', overlay && baseClassName + '__overlay', backdrop && baseClassName + '__backdrop') },
            (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__loader' },
                (0, _utils.createElement)(_Spinner2.default, { className: baseClassName + '__indicator' }),
                text && (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__text' },
                    text
                )
            )
        )
    );
};

ContentLoader.propTypes = {
    /**
     * Allows to set the text near the indicator.
     */
    text: _propTypes2.default.node,
    /**
     * @ignore
     */
    overlay: _propTypes2.default.bool,
    /**
     * @ignore
     */
    backdrop: _propTypes2.default.bool,
    /**
     * @ignore
     */
    blur: _propTypes2.default.bool,
    /**
     * @ignore
     */
    loading: _propTypes2.default.bool,
    /**
     * @ignore
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

ContentLoader.defaultProps = {
    text: null,
    overlay: false,
    backdrop: false,
    blur: false,
    loading: true,
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'content-loader'
};

exports.default = ContentLoader;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ContentLoader = __webpack_require__(79);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ContentLoader).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Translate = __webpack_require__(7);

var _Translate2 = _interopRequireDefault(_Translate);

__webpack_require__(193);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.
/* eslint-disable react/no-did-mount-set-state */

/**
 * The `Collapse` component shows and hides part of content.
 */
var Cuttable = function (_Component) {
    _inherits(Cuttable, _Component);

    function Cuttable(props) {
        _classCallCheck(this, Cuttable);

        var _this = _possibleConstructorReturn(this, (Cuttable.__proto__ || Object.getPrototypeOf(Cuttable)).call(this, props));

        _this.state = {
            collapsed: null
        };

        _this.handleToggle = _this.handleToggle.bind(_this);
        return _this;
    }

    _createClass(Cuttable, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var node = (0, _utils.findDOMNode)(this).firstElementChild;
            if (node.scrollHeight > node.clientHeight) {
                this.setState({
                    collapsed: this.props.collapsed
                });
            }
        }
    }, {
        key: 'handleToggle',
        value: function handleToggle() {
            this.setState(function (_ref) {
                var collapsed = _ref.collapsed;
                return {
                    collapsed: !collapsed
                };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                children = _props.children,
                collapsed = _props.collapsed,
                maxHeight = _props.maxHeight,
                locale = _props.locale,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'children', 'collapsed', 'maxHeight', 'locale']);

            var showMoreLessKey = this.state.collapsed ? 'showMore' : 'showLess';

            return (0, _utils.createElement)(
                'div',
                _extends({
                    className: (0, _classnames2.default)(baseClassName, (_classNames = {}, _defineProperty(_classNames, baseClassName + '--collapse', this.state.collapsed === true), _defineProperty(_classNames, baseClassName + '--expand', this.state.collapsed === false), _classNames), className)
                }, props),
                (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__content', style: { maxHeight: maxHeight } },
                    children
                ),
                this.state.collapsed !== null && (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__action' },
                    (0, _utils.createElement)(
                        'a',
                        { onClick: this.handleToggle },
                        (0, _utils.createElement)(_Translate2.default, { content: 'Cuttable.' + showMoreLessKey, fallback: locale[showMoreLessKey] })
                    )
                )
            );
        }
    }]);

    return Cuttable;
}(_utils.Component);

Cuttable.propTypes = {
    /**
     * Content of the component.
     */
    children: _propTypes2.default.node,
    /**
     * Whether the component is open or closed.
     */
    collapsed: _propTypes2.default.bool,
    /**
     * Max height of content
     */
    maxHeight: _propTypes2.default.string,
    /**
     * Localization messages
     */
    locale: _propTypes2.default.shape({
        showMore: _propTypes2.default.any,
        showLess: _propTypes2.default.any
    }),
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};
Cuttable.defaultProps = {
    children: null,
    collapsed: true,
    maxHeight: '7rem',
    locale: {
        showMore: 'Show more',
        showLess: 'Show less'
    },
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'cuttable'
};

exports.default = Cuttable;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Cuttable = __webpack_require__(81);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Cuttable).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _utils2 = __webpack_require__(11);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Overlay = __webpack_require__(31);

var _Overlay2 = _interopRequireDefault(_Overlay);

var _Form = __webpack_require__(23);

var _Form2 = _interopRequireDefault(_Form);

var _Button = __webpack_require__(5);

var _Button2 = _interopRequireDefault(_Button);

var _Translate = __webpack_require__(7);

var _Translate2 = _interopRequireDefault(_Translate);

__webpack_require__(4);

__webpack_require__(194);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `Dialog` component.
 */
var Dialog = function (_Component) {
    _inherits(Dialog, _Component);

    function Dialog(props) {
        _classCallCheck(this, Dialog);

        var _this = _possibleConstructorReturn(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call(this, props));

        _this.handleClose = function () {
            _this.setState({ show: false });
            (0, _utils2.safeInvoke)(_this.props.onClose);
        };

        _this.state = {
            show: props.isOpen
        };
        return _this;
    }

    _createClass(Dialog, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props) {
            var newState = {
                show: props.isOpen
            };

            this.setState(newState);
        }
    }, {
        key: 'renderImage',
        value: function renderImage(image, block) {
            var baseClassName = this.props.baseClassName;

            var classPrefix = baseClassName + '__' + block;

            if ((0, _utils.isValidElement)(image)) {
                return (0, _utils.createElement)(
                    'div',
                    { className: classPrefix },
                    image
                );
            }

            if (typeof image === 'string') {
                return (0, _utils.createElement)(
                    'div',
                    { className: classPrefix },
                    (0, _utils.createElement)('img', { className: classPrefix + '-inner', src: image })
                );
            }

            return (0, _utils.createElement)(
                'div',
                { className: classPrefix },
                (0, _utils.createElement)('img', _extends({ className: classPrefix + '-inner' }, image))
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                children = _props.children,
                isOpen = _props.isOpen,
                banner = _props.banner,
                image = _props.image,
                title = _props.title,
                cancelTitle = _props.cancelTitle,
                buttons = _props.buttons,
                form = _props.form,
                size = _props.size,
                onClose = _props.onClose,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'children', 'isOpen', 'banner', 'image', 'title', 'cancelTitle', 'buttons', 'form', 'size', 'onClose']);

            var show = this.state.show;


            var cancelTitleElement = cancelTitle || (0, _utils.createElement)(_Translate2.default, { content: 'Dialog.cancelButton', fallback: 'Cancel' });

            var childrenElement = void 0;
            if (form) {
                form.cancelButton = _extends({
                    onClick: this.handleClose
                }, form.cancelButton);
                form.footerClassName = (0, _classnames2.default)(form.footerClassName, baseClassName + '__form-footer');
                form.applyButton = form.applyButton || false;

                if (!form.cancelButton.children && cancelTitleElement) {
                    form.cancelButton.children = cancelTitleElement;
                }

                childrenElement = (0, _utils.createElement)(
                    _Form2.default,
                    form,
                    children
                );
            } else {
                childrenElement = children;
            }

            return (0, _utils.createElement)(
                _Overlay2.default,
                _extends({
                    className: (0, _classnames2.default)(baseClassName, className),
                    isOpen: show,
                    onClose: this.handleClose,
                    canCloseOnBackdropClick: false,
                    size: size
                }, props),
                title && (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__heading' },
                    (0, _utils.createElement)(
                        'h2',
                        { className: baseClassName + '__heading-title' },
                        title
                    )
                ),
                banner && this.renderImage(banner, 'banner'),
                (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__content' },
                    image && this.renderImage(image, 'image'),
                    childrenElement,
                    !form && (0, _utils.createElement)(
                        'div',
                        { className: baseClassName + '__buttons' },
                        buttons,
                        (0, _utils.createElement)(
                            _Button2.default,
                            { onClick: this.handleClose },
                            cancelTitleElement
                        )
                    )
                )
            );
        }
    }]);

    return Dialog;
}(_utils.Component);

Dialog.propTypes = {
    /**
     * Toggles visibility.
     */
    isOpen: _propTypes2.default.bool,
    /**
     * Banner. Renders in front of content as wide as dialog.
     */
    banner: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.element]),
    /**
     * Image. Renders into content.
     */
    image: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.element]),
    /**
     * Title
     */
    title: _propTypes2.default.node,
    /**
     * Title of "cancel" button
     */
    cancelTitle: _propTypes2.default.node,
    /**
     * Buttons except "cancel" button
     */
    buttons: _propTypes2.default.node,
    /**
     * Wraps children into [Form](#!/Form) if not empty.
     */
    form: _propTypes2.default.object,
    /**
     * Dialog width
     */
    size: _propTypes2.default.oneOf(['sm', 'md', 'lg']),
    /**
     * On close event handler. Called immediately after dialog closed by "cancel" button or "Esc" key.
     */
    onClose: _propTypes2.default.func,
    /**
     * Content of the `DialogWindow`.
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

Dialog.defaultProps = {
    isOpen: false,
    banner: null,
    image: null,
    title: null,
    cancelTitle: null,
    buttons: null,
    form: null,
    size: 'md',
    onClose: null,
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'dialog'
};

exports.default = Dialog;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dialog = __webpack_require__(83);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Dialog).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Overlay = __webpack_require__(31);

var _Overlay2 = _interopRequireDefault(_Overlay);

var _Form = __webpack_require__(23);

var _Form2 = _interopRequireDefault(_Form);

var _Header = __webpack_require__(86);

var _Header2 = _interopRequireDefault(_Header);

var _ScrollDirection = __webpack_require__(87);

var _ScrollDirection2 = _interopRequireDefault(_ScrollDirection);

__webpack_require__(4);

__webpack_require__(195);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `Drawer` component.
 */
var Drawer = function Drawer(_ref) {
    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        children = _ref.children,
        title = _ref.title,
        subtitle = _ref.subtitle,
        backButton = _ref.backButton,
        onClose = _ref.onClose,
        form = _ref.form,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'children', 'title', 'subtitle', 'backButton', 'onClose', 'form']);

    if (form) {
        form.footerClassName = (0, _classnames2.default)(form.footerClassName, baseClassName + '__form-footer');
        form.className = (0, _classnames2.default)(baseClassName + '__form', form.className);
        form.cancelButton = _extends({
            onClick: onClose
        }, form.cancelButton);
        children = (0, _utils.createElement)(
            _Form2.default,
            form,
            children
        );
    } else {
        children = (0, _utils.createElement)(
            'div',
            { className: baseClassName + '__inner-body' },
            children
        );
    }

    return (0, _utils.createElement)(
        _Overlay2.default,
        _extends({
            className: (0, _classnames2.default)(baseClassName, _defineProperty({}, baseClassName + '--form', form), className),
            onClose: onClose,
            canCloseOnBackdropClick: false
        }, props),
        (0, _utils.createElement)(
            _Header2.default,
            { backButton: backButton, onClose: onClose },
            title
        ),
        (0, _utils.createElement)(
            _ScrollDirection2.default,
            null,
            function (_ref2) {
                var direction = _ref2.direction,
                    handleScroll = _ref2.handleScroll;
                return (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__body', onScroll: handleScroll },
                    (0, _utils.createElement)(
                        'div',
                        null,
                        subtitle && (0, _utils.createElement)(
                            'div',
                            {
                                className: (0, _classnames2.default)(baseClassName + '__subheader', _defineProperty({}, baseClassName + '__subheader--hidden', direction === 'down'))
                            },
                            (0, _utils.createElement)(
                                'h4',
                                { className: baseClassName + '__subheader-title' },
                                subtitle
                            )
                        ),
                        children
                    )
                );
            }
        )
    );
};

Drawer.propTypes = {
    /**
     * Toggles visibility.
     */
    isOpen: _propTypes2.default.bool,
    /**
     * The title of the `Drawer`.
     */
    title: _propTypes2.default.node.isRequired,
    /**
     * The subtitle of the `Drawer`.
     */
    subtitle: _propTypes2.default.node,
    /**
     * Show back button in the header. If true the close button is not show.
     */
    backButton: _propTypes2.default.bool,
    /**
     * Overlay placement.
     */
    placement: _propTypes2.default.oneOf(['left', 'right']),
    /**
     * Overlay size.
     */
    size: _propTypes2.default.oneOf(['sm', 'md', 'lg']),
    /**
     * onClose handler.
     */
    onClose: _propTypes2.default.func,
    /**
     * Wraps children into [Form](#!/Form) if not empty.
     */
    form: _propTypes2.default.object,
    /**
     * Content of the `Drawer`.
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

Drawer.defaultProps = {
    isOpen: false,
    subtitle: '',
    backButton: false,
    placement: 'left',
    size: 'md',
    onClose: null,
    form: null,
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'drawer'
};

exports.default = Drawer;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(2);

var _IconButton = __webpack_require__(14);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Icon = __webpack_require__(6);

var _Icon2 = _interopRequireDefault(_Icon);

__webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var Header = function Header(_ref) {
    var baseClassName = _ref.baseClassName,
        onClose = _ref.onClose,
        children = _ref.children,
        backButton = _ref.backButton,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'onClose', 'children', 'backButton']);

    return (0, _utils.createElement)(
        'div',
        _extends({ className: baseClassName }, props),
        backButton && onClose && (0, _utils.createElement)(_IconButton2.default, {
            className: baseClassName + '__icon ' + baseClassName + '__back-button',
            icon: (0, _utils.createElement)(_Icon2.default, { name: 'chevron-left', className: baseClassName + '__icon' }),
            onClick: onClose
        }),
        (0, _utils.createElement)(
            'h4',
            { className: baseClassName + '__title' },
            children
        ),
        onClose && !backButton && (0, _utils.createElement)(_IconButton2.default, {
            icon: (0, _utils.createElement)(_Icon2.default, { name: 'cross-mark', className: baseClassName + '__icon' }),
            onClick: onClose
        })
    );
};
Header.propTypes = {
    baseClassName: _propTypes2.default.string,
    onClose: _propTypes2.default.func,
    children: _propTypes2.default.node.isRequired,
    backButton: _propTypes2.default.bool
};
Header.defaultProps = {
    onClose: null,
    baseClassName: _constants.CLS_PREFIX + 'drawer-header',
    backButton: false
};

exports.default = Header;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var ScrollDirection = function (_Component) {
    _inherits(ScrollDirection, _Component);

    function ScrollDirection() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ScrollDirection);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScrollDirection.__proto__ || Object.getPrototypeOf(ScrollDirection)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            direction: 'up'
        }, _this.prevScrollTop = 0, _this.handleScroll = function (e) {
            var scrollTop = e.target.scrollTop;

            var direction = scrollTop > _this.prevScrollTop ? 'down' : 'up';

            _this.prevScrollTop = scrollTop;
            _this.setState({
                direction: direction
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ScrollDirection, [{
        key: 'render',
        value: function render() {
            var children = this.props.children;


            return children({
                direction: this.state.direction,
                handleScroll: this.handleScroll
            });
        }
    }]);

    return ScrollDirection;
}(_utils.Component);

ScrollDirection.propTypes = {
    children: _propTypes2.default.func.isRequired
};

exports.default = ScrollDirection;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Drawer = __webpack_require__(85);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Drawer).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _utils2 = __webpack_require__(11);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Button = __webpack_require__(5);

var _Button2 = _interopRequireDefault(_Button);

var _AutoClosable = __webpack_require__(37);

var _AutoClosable2 = _interopRequireDefault(_AutoClosable);

var _Popper = __webpack_require__(44);

var _Popper2 = _interopRequireDefault(_Popper);

var _Translate = __webpack_require__(7);

var _Translate2 = _interopRequireDefault(_Translate);

__webpack_require__(4);

__webpack_require__(49);

__webpack_require__(197);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `Dropdown` component is a [Button](#!/Button) that opens a drop-down (nested) [Menu](#!/Menu).
 * Use dropdown for grouping actions that are not used often or are less important than others -- in other words,
 * for stuff that you don't want to show users all the time, especially if you have limited screen space.
 */
var Dropdown = function (_Component) {
    _inherits(Dropdown, _Component);

    function Dropdown() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Dropdown);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            opened: false
        }, _this.handleOpen = function () {
            _this.setState({
                opened: true
            });
        }, _this.handleClose = function () {
            setTimeout(function () {
                _this.setState({
                    opened: false
                });
            }, 0);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Dropdown, [{
        key: 'computePlacement',
        value: function computePlacement(placement) {
            var _placement$split = placement.split('-'),
                _placement$split2 = _slicedToArray(_placement$split, 2),
                side = _placement$split2[0],
                align = _placement$split2[1];

            if (align && (0, _utils.isRtl)() && ['top', 'bottom'].indexOf(side) !== -1) {
                return side + '-' + (align === 'start' ? 'end' : 'start');
            }

            return placement;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                children = _props.children,
                menu = _props.menu,
                menuPlacement = _props.menuPlacement,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'children', 'menu', 'menuPlacement']);

            var opened = this.state.opened;

            var target = null;
            var clonedMenu = (0, _utils.cloneElement)(menu, {
                onItemClick: (0, _utils2.wrapFunction)(menu.props.onItemClick, this.handleClose),
                className: (0, _classnames2.default)(baseClassName + '__menu', menu.props.className)
            });

            if (!children || typeof children === 'string' || (0, _utils.isValidElement)(children) && children.type === _Translate2.default) {
                target = (0, _utils.createElement)(
                    _Button2.default,
                    { caret: true, onClick: this.handleOpen },
                    children
                );
            } else {
                target = (0, _utils.cloneElement)(children, {
                    onClick: this.handleOpen
                });
            }

            return (0, _utils.createElement)(
                'div',
                _extends({
                    className: (0, _classnames2.default)(baseClassName, _defineProperty({}, baseClassName + '--opened', opened), className)
                }, props),
                (0, _utils.createElement)(
                    _Popper2.default,
                    {
                        target: target,
                        placement: this.computePlacement(menuPlacement),
                        show: opened,
                        className: baseClassName + '__popper',
                        zIndex: _constants.Z_INDEX_DROPDOWN
                    },
                    (0, _utils.createElement)(
                        _AutoClosable2.default,
                        { onClose: this.handleClose },
                        clonedMenu
                    )
                )
            );
        }
    }]);

    return Dropdown;
}(_utils.Component);

Dropdown.propTypes = {
    /**
     * Dropdown [menu](#!/Menu).
     */
    menu: _propTypes2.default.element.isRequired,
    /**
     * Menu placement.
     */
    menuPlacement: _propTypes2.default.string,
    /**
     * Content of the `Dropdown`.
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

Dropdown.defaultProps = {
    menuPlacement: 'bottom-start',
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'dropdown'
};

exports.default = Dropdown;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ExtendedStatusMessageSeparator = exports.ExtendedStatusMessageActions = exports.ExtendedStatusMessageDescription = exports.ExtendedStatusMessageTitle = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _Spinner = __webpack_require__(10);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _constants = __webpack_require__(2);

__webpack_require__(198);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var ExtendedStatusMessage = function ExtendedStatusMessage(_ref) {
    var _classNames;

    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        intent = _ref.intent,
        image = _ref.image,
        children = _ref.children,
        loading = _ref.loading,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'intent', 'image', 'children', 'loading']);

    return (0, _utils.createElement)(
        'div',
        { className: baseClassName + '__container' },
        (0, _utils.createElement)(
            'div',
            _extends({
                className: (0, _classnames2.default)(baseClassName, (_classNames = {}, _defineProperty(_classNames, baseClassName + '--' + intent, intent), _defineProperty(_classNames, baseClassName + '--loading', loading), _classNames), className)
            }, props),
            image ? (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__image' },
                image
            ) : null,
            (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__body' },
                children
            ),
            loading && (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__content-blocker' },
                (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__loader' },
                    (0, _utils.createElement)(_Spinner2.default, { className: baseClassName + '__loader-spinner' })
                )
            )
        )
    );
};
ExtendedStatusMessage.propTypes = {
    image: _propTypes2.default.any,
    /**
     * Visual intent color to apply to component.
     */
    intent: _propTypes2.default.oneOf(['info', 'success', 'warning', 'danger']),
    children: _propTypes2.default.node,
    /**
     * Indicate the loading state of the component.
     */
    loading: _propTypes2.default.bool,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};
ExtendedStatusMessage.defaultProps = {
    image: null,
    intent: null,
    children: null,
    loading: false,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'extended-status-message'
};

var ExtendedStatusMessageTitle = function ExtendedStatusMessageTitle(_ref2) {
    var baseClassName = _ref2.baseClassName,
        className = _ref2.className,
        children = _ref2.children,
        props = _objectWithoutProperties(_ref2, ['baseClassName', 'className', 'children']);

    return (0, _utils.createElement)(
        'div',
        _extends({ className: (0, _classnames2.default)(baseClassName + '__title', className) }, props),
        children
    );
};
ExtendedStatusMessageTitle.propTypes = {
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};
ExtendedStatusMessageTitle.defaultProps = {
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'extended-status-message'
};

var ExtendedStatusMessageDescription = function ExtendedStatusMessageDescription(_ref3) {
    var baseClassName = _ref3.baseClassName,
        className = _ref3.className,
        children = _ref3.children,
        props = _objectWithoutProperties(_ref3, ['baseClassName', 'className', 'children']);

    return (0, _utils.createElement)(
        'div',
        _extends({ className: (0, _classnames2.default)(baseClassName + '__description', className) }, props),
        children
    );
};
ExtendedStatusMessageDescription.propTypes = {
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};
ExtendedStatusMessageDescription.defaultProps = {
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'extended-status-message'
};

var ExtendedStatusMessageActions = function ExtendedStatusMessageActions(_ref4) {
    var baseClassName = _ref4.baseClassName,
        className = _ref4.className,
        children = _ref4.children,
        props = _objectWithoutProperties(_ref4, ['baseClassName', 'className', 'children']);

    return (0, _utils.createElement)(
        'div',
        _extends({ className: (0, _classnames2.default)(baseClassName + '__actions', className) }, props),
        children
    );
};
ExtendedStatusMessageActions.propTypes = {
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};
ExtendedStatusMessageActions.defaultProps = {
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'extended-status-message'
};

var ExtendedStatusMessageSeparator = function ExtendedStatusMessageSeparator(_ref5) {
    var className = _ref5.className,
        props = _objectWithoutProperties(_ref5, ['className']);

    return (0, _utils.createElement)('hr', _extends({ className: (0, _classnames2.default)(className) }, props));
};
ExtendedStatusMessageSeparator.propTypes = {
    /**
     * @ignore
     */
    className: _propTypes2.default.string
};
ExtendedStatusMessageSeparator.defaultProps = {
    className: null
};

exports.default = ExtendedStatusMessage;
exports.ExtendedStatusMessageTitle = ExtendedStatusMessageTitle;
exports.ExtendedStatusMessageDescription = ExtendedStatusMessageDescription;
exports.ExtendedStatusMessageActions = ExtendedStatusMessageActions;
exports.ExtendedStatusMessageSeparator = ExtendedStatusMessageSeparator;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ExtendedStatusMessage = __webpack_require__(90);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExtendedStatusMessage).default;
  }
});
Object.keys(_ExtendedStatusMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ExtendedStatusMessage[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

__webpack_require__(199);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * Figure component.
 */
var Figure = function Figure(_ref) {
    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        href = _ref.href,
        caption = _ref.caption,
        children = _ref.children,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'href', 'caption', 'children']);

    return (0, _utils.createElement)(
        'figure',
        _extends({ className: (0, _classnames2.default)(baseClassName, className) }, props),
        children,
        href && (0, _utils.createElement)('a', { href: href, className: (0, _classnames2.default)(baseClassName + '__overlay', baseClassName + '__overlay--cover', baseClassName + '__action') }),
        caption && (0, _utils.createElement)(
            'figcaption',
            { className: (0, _classnames2.default)(baseClassName + '__overlay', baseClassName + '__overlay--bottom') },
            caption
        )
    );
};
Figure.propTypes = {
    href: _propTypes2.default.string,
    caption: _propTypes2.default.any,
    /**
     * Content of the figure
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};
Figure.defaultProps = {
    href: null,
    caption: null,
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'figure'
};

exports.default = Figure;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Figure = __webpack_require__(92);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Figure).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Checkbox = __webpack_require__(17);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _FormField = __webpack_require__(13);

var _FormField2 = _interopRequireDefault(_FormField);

__webpack_require__(4);

__webpack_require__(200);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `FormFieldCheckbox` component.
 */
var FormFieldCheckbox = function FormFieldCheckbox(_ref) {
    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        disabled = _ref.disabled,
        label = _ref.label,
        required = _ref.required,
        checkedValue = _ref.checkedValue,
        uncheckedValue = _ref.uncheckedValue,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'disabled', 'label', 'required', 'checkedValue', 'uncheckedValue']);

    return (0, _utils.createElement)(
        _FormField2.default,
        _extends({ className: (0, _classnames2.default)(baseClassName, className), label: null }, props),
        function (_ref2) {
            var getId = _ref2.getId,
                getName = _ref2.getName,
                getValue = _ref2.getValue,
                setValue = _ref2.setValue,
                getRequiredMark = _ref2.getRequiredMark;
            return (0, _utils.createElement)(
                _utils.Fragment,
                null,
                (0, _utils.createElement)('input', { type: 'hidden', name: getName(), value: uncheckedValue }),
                (0, _utils.createElement)(
                    _Checkbox2.default,
                    {
                        checked: getValue() === checkedValue,
                        onChange: function onChange(checked) {
                            return setValue(checked ? checkedValue : uncheckedValue);
                        },
                        inputProps: { id: getId(), name: getName(), value: checkedValue },
                        disabled: disabled
                    },
                    label,
                    ' ',
                    required ? getRequiredMark() : null
                )
            );
        }
    );
};

FormFieldCheckbox.propTypes = {
    /**
     * Disabled state of field.
     */
    disabled: _propTypes2.default.bool,
    /**
     * Custom checked value. Default is boolean true.
     */
    checkedValue: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
    /**
     * Custom unchecked value. Default is boolean false.
     */
    uncheckedValue: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
    /**
     * @ignore
     */
    label: _propTypes2.default.any,
    /**
     * @ignore
     */
    required: _propTypes2.default.bool,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

FormFieldCheckbox.defaultProps = {
    disabled: false,
    checkedValue: true,
    uncheckedValue: false,
    label: undefined,
    required: false,
    className: undefined,
    baseClassName: _constants.CLS_PREFIX + 'form-field-checkbox'
};

exports.default = FormFieldCheckbox;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormFieldCheckbox = __webpack_require__(94);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormFieldCheckbox).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Button = __webpack_require__(5);

var _Button2 = _interopRequireDefault(_Button);

var _FormField = __webpack_require__(13);

var _FormField2 = _interopRequireDefault(_FormField);

var _Input = __webpack_require__(18);

var _Input2 = _interopRequireDefault(_Input);

var _Popover = __webpack_require__(32);

var _Popover2 = _interopRequireDefault(_Popover);

var _Translate = __webpack_require__(7);

var _Translate2 = _interopRequireDefault(_Translate);

var _passwordScore4 = __webpack_require__(99);

var _passwordScore5 = _interopRequireDefault(_passwordScore4);

var _enUS = __webpack_require__(98);

var _enUS2 = _interopRequireDefault(_enUS);

__webpack_require__(201);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var symbolClasses = {
    upper: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    lower: 'abcdefghijklmnopqrstuvwxyz',
    number: '0123456789',
    special: '!@#$%^&*?_~'
};

/**
 * `FormFieldPassword` component.
 */

var FormFieldPassword = function (_Component) {
    _inherits(FormFieldPassword, _Component);

    function FormFieldPassword(props) {
        _classCallCheck(this, FormFieldPassword);

        var _this = _possibleConstructorReturn(this, (FormFieldPassword.__proto__ || Object.getPrototypeOf(FormFieldPassword)).call(this, props));

        _this.handleToggleClick = function () {
            _this.setState(function (_ref) {
                var visible = _ref.visible;
                return {
                    visible: !visible
                };
            });
        };

        _this.handleBlur = function () {
            _this.setState({
                passwordMeterVisible: false
            });
        };

        _this.state = {
            visible: false,
            passwordMeterVisible: false
        };
        return _this;
    }

    _createClass(FormFieldPassword, [{
        key: 'generatePassword',
        value: function generatePassword() {
            var password = ['upper', 'lower', 'lower', 'lower', 'number', 'number', 'special', 'number', 'upper', 'upper', 'lower', 'lower', 'lower', 'lower', 'lower', 'lower'];

            return password.sort(function (a, b) {
                return Math.floor(b.length * Math.random()) - Math.floor(a.length * Math.random());
            }).map(function (symbolClass) {
                return symbolClasses[symbolClass][Math.floor(symbolClasses[symbolClass].length * Math.random())];
            }).join('');
        }
    }, {
        key: 'passwordScore',
        value: function passwordScore(value) {
            if (!value) {
                return { intent: null, strength: null, unusedRules: [] };
            }

            var _passwordScore2 = (0, _passwordScore5.default)(value),
                score = _passwordScore2.score,
                unusedRules = _passwordScore2.unusedRules;

            var intent = 'success';
            var strength = (0, _utils.createElement)(_Translate2.default, { content: 'FormFieldPassword.strengthStrong', fallback: _enUS2.default.strengthStrong });
            if (score < 25) {
                intent = 'danger';
                strength = (0, _utils.createElement)(_Translate2.default, { content: 'FormFieldPassword.strengthWeak', fallback: _enUS2.default.strengthWeak });
            } else if (score < 35) {
                intent = 'warning';
                strength = (0, _utils.createElement)(_Translate2.default, { content: 'FormFieldPassword.strengthMedium', fallback: _enUS2.default.strengthMedium });
            }

            return { intent: intent, strength: strength, unusedRules: unusedRules };
        }
    }, {
        key: 'renderPasswordMeter',
        value: function renderPasswordMeter(value, target) {
            var passwordMeterVisible = this.state.passwordMeterVisible;

            var _passwordScore3 = this.passwordScore(value),
                intent = _passwordScore3.intent,
                strength = _passwordScore3.strength,
                unusedRules = _passwordScore3.unusedRules;

            return (0, _utils.createElement)(
                _Popover2.default,
                {
                    visible: passwordMeterVisible && !!value,
                    target: target,
                    placement: 'bottom-right',
                    intent: intent,
                    canCloseOnOutsideClick: false,
                    canCloseOnEscapePress: false
                },
                (0, _utils.createElement)(_Translate2.default, {
                    content: 'FormFieldPassword.passwordStrength',
                    fallback: _enUS2.default.passwordStrength,
                    params: {
                        strength: (0, _utils.createElement)(
                            'b',
                            null,
                            strength
                        )
                    }
                }),
                (0, _utils.createElement)('br', null),
                unusedRules.length ? (0, _utils.createElement)(
                    _utils.Fragment,
                    null,
                    (0, _utils.createElement)(_Translate2.default, { content: 'FormFieldPassword.improvePassword', fallback: _enUS2.default.improvePassword }),
                    (0, _utils.createElement)('br', null),
                    (0, _utils.createElement)(
                        'ul',
                        null,
                        unusedRules.slice(0, 3).map(function (_ref2) {
                            var rule = _ref2.rule;
                            return (0, _utils.createElement)(
                                'li',
                                { key: rule },
                                (0, _utils.createElement)(_Translate2.default, { content: 'FormFieldPassword.' + rule, fallback: _enUS2.default[rule] })
                            );
                        })
                    )
                ) : (0, _utils.createElement)(_Translate2.default, { content: 'FormFieldPassword.yourPasswordIsStrong', fallback: _enUS2.default.yourPasswordIsStrong })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                hideShowButton = _props.hideShowButton,
                hideGenerateButton = _props.hideGenerateButton,
                hidePasswordMeter = _props.hidePasswordMeter,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'hideShowButton', 'hideGenerateButton', 'hidePasswordMeter']);

            return (0, _utils.createElement)(
                _FormField2.default,
                _extends({ className: (0, _classnames2.default)(baseClassName, className) }, props),
                function (_ref3) {
                    var getId = _ref3.getId,
                        getName = _ref3.getName,
                        getValue = _ref3.getValue,
                        setValue = _ref3.setValue;

                    var input = (0, _utils.createElement)(_Input2.default, {
                        id: getId(),
                        name: getName(),
                        type: _this2.state.visible ? 'text' : 'password',
                        value: getValue(''),
                        onChange: function onChange(e) {
                            setValue(e.target.value);
                            _this2.setState({
                                passwordMeterVisible: true
                            });
                        },
                        onFocus: _this2.handleFocus,
                        onBlur: _this2.handleBlur
                    });

                    return (0, _utils.createElement)(
                        _utils.Fragment,
                        null,
                        hidePasswordMeter ? input : _this2.renderPasswordMeter(getValue(), input),
                        hideShowButton ? null : (0, _utils.createElement)(_Button2.default, {
                            onClick: _this2.handleToggleClick,
                            icon: _this2.state.visible ? 'visible' : 'invisible',
                            tooltip: _this2.state.visible ? (0, _utils.createElement)(_Translate2.default, { content: 'FormFieldPassword.hidePassword', fallback: _enUS2.default.hidePassword }) : (0, _utils.createElement)(_Translate2.default, { content: 'FormFieldPassword.showPassword', fallback: _enUS2.default.showPassword })
                        }),
                        hideGenerateButton ? null : (0, _utils.createElement)(
                            _utils.Fragment,
                            null,
                            ' ',
                            (0, _utils.createElement)(
                                _Button2.default,
                                {
                                    onClick: function onClick() {
                                        return setValue(_this2.generatePassword());
                                    },
                                    tooltip: (0, _utils.createElement)(_Translate2.default, { content: 'FormFieldPassword.generateButtonHint', fallback: _enUS2.default.generateButtonHint })
                                },
                                (0, _utils.createElement)(_Translate2.default, { content: 'FormFieldPassword.generateButton', fallback: _enUS2.default.generateButton })
                            )
                        )
                    );
                }
            );
        }
    }]);

    return FormFieldPassword;
}(_utils.Component);

FormFieldPassword.propTypes = {
    /**
     * Is show button hidden?
     */
    hideShowButton: _propTypes2.default.bool,
    /**
     * Is generate button hidden?
     */
    hideGenerateButton: _propTypes2.default.bool,
    /**
     * Is password meter hidden?
     */
    hidePasswordMeter: _propTypes2.default.bool,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};
FormFieldPassword.defaultProps = {
    hideShowButton: false,
    hideGenerateButton: false,
    hidePasswordMeter: false,
    className: undefined,
    baseClassName: _constants.CLS_PREFIX + 'form-field-password'
};

exports.default = FormFieldPassword;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormFieldPassword = __webpack_require__(96);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormFieldPassword).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

exports.default = {
    improvePassword: 'To improve your password:',
    passwordTooShort: 'Make the password longer.',
    lettersLowerCase: 'Use at least one lower-case character.',
    lettersUpperCase: 'Use at least one upper-case character.',
    numbers1: 'Use at least one number.',
    numbers3: 'Use at least three numbers.',
    specialChar1: 'Use at least one special character (for example: !, @, #, $, % ,^, &, *, ?, _, ~).',
    specialChar2: 'Use at least two special characters (for example: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Use both upper and lower-case characters.',
    comboLettersAndNumbers: 'Use both numbers and characters.',
    comboLettersNumbersSpecial: 'Use numbers, characters and special characters.',
    yourPasswordIsStrong: 'You can make it even stronger by increasing its length.',
    passwordStrength: 'The password strength is %%strength%%.',
    strengthStrong: 'STRONG',
    strengthWeak: 'WEAK',
    strengthMedium: 'MEDIUM',
    hidePassword: 'Hide password',
    showPassword: 'Show password',
    generateButton: 'Generate',
    generateButtonHint: 'Generate strength password'
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var passwordScore = function passwordScore(password) {
    var unusedRules = [];
    var score = 0;
    Object.keys(rules).forEach(function (rule) {
        var mark = rules[rule](password);
        if (mark < 0) {
            unusedRules.push({ rule: rule, value: -mark });
        } else {
            score += mark;
        }
    });

    return {
        score: score,
        unusedRules: unusedRules
    };
};

var rules = {
    passwordTooShort: function passwordTooShort(passwd) {
        return passwd.length < 5 ? -1 : 0;
    },
    passwordLength: function passwordLength(passwd) {
        if (passwd.length < 5) {
            return 3;
        }
        if (passwd.length > 4 && passwd.length < 8) {
            return 6;
        }
        if (passwd.length > 7 && passwd.length < 16) {
            return 12;
        }
        return 18;
    },
    lettersLowerCase: function lettersLowerCase(passwd) {
        // [verified] at least one lower case letter
        return passwd.match(/[a-z]/) ? 1 : -1;
    },
    lettersUpperCase: function lettersUpperCase(passwd) {
        // [verified] at least one upper case letter
        return passwd.match(/[A-Z]/) ? 5 : -1;
    },
    numbers1: function numbers1(passwd) {
        // [verified] at least one number
        return passwd.match(/\d+/) ? 5 : -1;
    },
    numbers3: function numbers3(passwd) {
        // [verified] at least three numbers
        return passwd.match(/(.*[0-9].*[0-9].*[0-9])/) ? 5 : -1;
    },
    specialChar1: function specialChar1(passwd) {
        // [verified] at least one special character
        return passwd.match(/[!@#$%^&*?_~]/) ? 5 : -1;
    },
    specialChar2: function specialChar2(passwd) {
        // [verified] at least two special characters
        return passwd.match(/(.*[!@#$%^&*?_~].*[!@#$%^&*?_~])/) ? 5 : -1;
    },
    comboUpperAndLower: function comboUpperAndLower(passwd) {
        // [verified] both upper and lower case
        return passwd.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/) ? 2 : -1;
    },
    comboLettersAndNumbers: function comboLettersAndNumbers(passwd) {
        // [verified] both letters and numbers
        return passwd.match(/([a-zA-Z])/) && passwd.match(/([0-9])/) ? 2 : -1;
    },
    comboLettersNumbersSpecial: function comboLettersNumbersSpecial(passwd) {
        // [verified] letters, numbers, and special characters
        return passwd.match(/([a-zA-Z0-9].*[!@#$%^&*?_~])|([!@#$%^&*?_~].*[a-zA-Z0-9])/) ? 2 : -1;
    }
};

exports.default = passwordScore;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _FormField = __webpack_require__(13);

var _FormField2 = _interopRequireDefault(_FormField);

var _Hint = __webpack_require__(26);

var _Hint2 = _interopRequireDefault(_Hint);

var _Radio = __webpack_require__(144);

var _Radio2 = _interopRequireDefault(_Radio);

__webpack_require__(202);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.
/* eslint-disable react/prefer-stateless-function */

/**
 * `FormFieldRadioGroup` are used for making a choice among a set of mutually exclusive, related options. Only one option can be chosen.
 */
var FormFieldRadioButtons = function (_Component) {
    _inherits(FormFieldRadioButtons, _Component);

    function FormFieldRadioButtons() {
        _classCallCheck(this, FormFieldRadioButtons);

        return _possibleConstructorReturn(this, (FormFieldRadioButtons.__proto__ || Object.getPrototypeOf(FormFieldRadioButtons)).apply(this, arguments));
    }

    _createClass(FormFieldRadioButtons, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                options = _props.options,
                fieldDisabled = _props.disabled,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'options', 'disabled']);

            return (0, _utils.createElement)(
                _FormField2.default,
                _extends({ className: (0, _classnames2.default)(baseClassName, className) }, props),
                function (_ref) {
                    var getId = _ref.getId,
                        getName = _ref.getName,
                        getValue = _ref.getValue,
                        setValue = _ref.setValue;
                    return options.map(function (_ref2) {
                        var value = _ref2.value,
                            label = _ref2.label,
                            description = _ref2.description,
                            disabled = _ref2.disabled,
                            _ref2$indentFields = _ref2.indentFields,
                            indentFields = _ref2$indentFields === undefined ? [] : _ref2$indentFields;
                        return (0, _utils.createElement)(
                            _Radio2.default,
                            {
                                key: value,
                                name: getName(),
                                label: label || value,
                                checked: getValue() === value,
                                onChange: function onChange(isChecked) {
                                    if (isChecked) {
                                        setValue(value);
                                    }
                                },
                                disabled: fieldDisabled || disabled,
                                inputProps: { id: getId() ? getId() + '-' + value : null, name: getName(), value: value }
                            },
                            description ? (0, _utils.createElement)(
                                _Hint2.default,
                                { className: _FormField2.default.defaultProps.baseClassName + '__description' },
                                description
                            ) : null,
                            indentFields.map(function (field) {
                                return fieldDisabled || disabled || getValue() !== value ? (0, _utils.cloneElement)(field, { disabled: true }) : field;
                            })
                        );
                    });
                }
            );
        }
    }]);

    return FormFieldRadioButtons;
}(_utils.Component);

FormFieldRadioButtons.propTypes = {
    /**
     * Options definition.
     */
    options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        /**
         * Option value.
         */
        value: _propTypes2.default.string.isRequired,
        /**
         * Option label.
         */
        label: _propTypes2.default.node.isRequired,
        /**
         * Text hint located below option for providing additional information.
         */
        description: _propTypes2.default.node,
        /**
         * Set true if option is not available to choice.
         */
        disabled: _propTypes2.default.bool,
        /**
         * Optional array of `FormField` components under this option.
         */
        indentFields: _propTypes2.default.array
    })).isRequired,
    /**
     * Value of current chosen option.
     */
    value: _propTypes2.default.string.isRequired,
    /**
     * Disabled state of field.
     */
    disabled: _propTypes2.default.bool,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};
FormFieldRadioButtons.defaultProps = {
    disabled: false,
    className: undefined,
    baseClassName: _constants.CLS_PREFIX + 'form-field-radio-buttons'
};

exports.default = FormFieldRadioButtons;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormFieldRadioButtons = __webpack_require__(100);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormFieldRadioButtons).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _FormField = __webpack_require__(13);

var _FormField2 = _interopRequireDefault(_FormField);

var _Input = __webpack_require__(18);

var _Input2 = _interopRequireDefault(_Input);

__webpack_require__(203);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.
/* eslint-disable react/prefer-stateless-function */

/**
 * `FormFieldText` component.
 */
var FormFieldText = function (_Component) {
    _inherits(FormFieldText, _Component);

    function FormFieldText() {
        _classCallCheck(this, FormFieldText);

        return _possibleConstructorReturn(this, (FormFieldText.__proto__ || Object.getPrototypeOf(FormFieldText)).apply(this, arguments));
    }

    _createClass(FormFieldText, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                size = _props.size,
                placeholder = _props.placeholder,
                disabled = _props.disabled,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'size', 'placeholder', 'disabled']);

            return (0, _utils.createElement)(
                _FormField2.default,
                _extends({ className: (0, _classnames2.default)(baseClassName, className) }, props),
                function (_ref) {
                    var getId = _ref.getId,
                        getName = _ref.getName,
                        getValue = _ref.getValue,
                        setValue = _ref.setValue;
                    return (0, _utils.createElement)(_Input2.default, {
                        id: getId(),
                        name: getName(),
                        className: baseClassName + '__input',
                        value: getValue(''),
                        onChange: function onChange(e) {
                            return setValue(e.target.value);
                        },
                        disabled: disabled,
                        size: size,
                        placeholder: placeholder
                    });
                }
            );
        }
    }]);

    return FormFieldText;
}(_utils.Component);

FormFieldText.propTypes = {
    /**
     * Size of the input
     */
    size: _propTypes2.default.oneOf(['sm', 'md', 'lg', 'xl', 'fill']),
    /**
     * Placeholder of the input
     */
    placeholder: _propTypes2.default.string,
    /**
     * Disabled state of field.
     */
    disabled: _propTypes2.default.bool,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};
FormFieldText.defaultProps = {
    size: undefined,
    placeholder: undefined,
    disabled: false,
    className: undefined,
    baseClassName: _constants.CLS_PREFIX + 'form-field-text'
};

exports.default = FormFieldText;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormFieldText = __webpack_require__(102);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormFieldText).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Section = __webpack_require__(19);

var _Hint = __webpack_require__(26);

var _Hint2 = _interopRequireDefault(_Hint);

__webpack_require__(204);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `FormField` component.
 */
var FormField = function (_Component) {
    _inherits(FormField, _Component);

    function FormField(props) {
        _classCallCheck(this, FormField);

        var _this = _possibleConstructorReturn(this, (FormField.__proto__ || Object.getPrototypeOf(FormField)).call(this, props));

        _this.state = {
            value: _this.props.value
        };

        _this.fieldApi = {
            getId: function getId() {
                if (_this.props.id) {
                    return _this.props.id;
                }
                if (_this.props.name) {
                    return _this.props.name.replace(/[[\]]+/g, '-').replace(/-+$/, '');
                }
                return null;
            },
            getName: function getName() {
                return _this.props.name;
            },
            getValue: function getValue(def) {
                if (_this.context.form && _this.props.name) {
                    return _this.context.form.getValue(_this.props.name, def);
                }
                return _this.state.value || def;
            },
            setValue: function setValue(value) {
                _this.setState({ value: value });
                if (_this.context.form && _this.props.name) {
                    _this.context.form.setValue(_this.props.name, value);
                }
                if (_this.props.onChange) {
                    _this.props.onChange(value);
                }
            },
            getErrors: function getErrors() {
                if (_this.context.form && _this.props.name) {
                    return _this.context.form.getErrors(_this.props.name);
                }
                return _this.props.errors;
            },
            getRequiredMark: function getRequiredMark() {
                if (_this.context.form) {
                    return _this.context.form.getRequiredMark();
                }
                return null;
            }
        };
        return _this;
    }

    _createClass(FormField, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var value = _ref.value;

            if (this.isControlled()) {
                this.setState({ value: value });
            }
        }
    }, {
        key: 'isControlled',
        value: function isControlled() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
                value = _ref2.value;

            return value !== undefined;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                id = _props.id,
                name = _props.name,
                value = _props.value,
                onChange = _props.onChange,
                label = _props.label,
                description = _props.description,
                errors = _props.errors,
                required = _props.required,
                children = _props.children,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'id', 'name', 'value', 'onChange', 'label', 'description', 'errors', 'required', 'children']);

            var fieldErrors = this.fieldApi.getErrors();

            return (0, _utils.createElement)(
                _Section.SectionItem,
                _extends({
                    className: (0, _classnames2.default)(baseClassName, _defineProperty({}, baseClassName + '--error', Object.keys(this.fieldApi.getErrors()).length), className),
                    title: label === null ? null : (0, _utils.createElement)(
                        'label',
                        { htmlFor: this.fieldApi.getId() },
                        label,
                        ' ',
                        required ? this.fieldApi.getRequiredMark() : null
                    )
                }, props),
                typeof children === 'function' ? children(this.fieldApi) : children,
                Object.keys(fieldErrors).map(function (key) {
                    return (0, _utils.createElement)(
                        'span',
                        { key: key, className: baseClassName + '__error' },
                        fieldErrors[key]
                    );
                }),
                description ? (0, _utils.createElement)(
                    _Hint2.default,
                    { className: baseClassName + '__description' },
                    description
                ) : null
            );
        }
    }]);

    return FormField;
}(_utils.Component);

FormField.propTypes = {
    /**
     * Field ID.
     */
    id: _propTypes2.default.string,
    /**
     * Field name.
     */
    name: _propTypes2.default.string,
    /**
     * Field value.
     */
    value: _propTypes2.default.any,
    /**
     * A callback function, can be executed when the value is changing.
     */
    onChange: _propTypes2.default.func,
    /**
     * Field label.
     */
    label: _propTypes2.default.any,
    /**
     * Field description.
     */
    description: _propTypes2.default.any,
    /**
     * Field errors.
     */
    errors: _propTypes2.default.object,
    /**
     * Indicates whether field is required.
     */
    required: _propTypes2.default.bool,
    /**
     * Content of the `FormField`.
     */
    children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};
FormField.defaultProps = {
    id: undefined,
    name: undefined,
    value: undefined,
    onChange: null,
    label: undefined,
    description: undefined,
    errors: {},
    required: false,
    children: undefined,
    className: undefined,
    baseClassName: _constants.CLS_PREFIX + 'form-field'
};
FormField.contextTypes = {
    form: _propTypes2.default.object
};

exports.default = FormField;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _utils2 = __webpack_require__(106);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactMeasure = __webpack_require__(8);

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _constants = __webpack_require__(2);

var _Button = __webpack_require__(5);

var _Button2 = _interopRequireDefault(_Button);

var _FormField = __webpack_require__(13);

var _FormField2 = _interopRequireDefault(_FormField);

var _Section = __webpack_require__(19);

var _Section2 = _interopRequireDefault(_Section);

var _Translate = __webpack_require__(7);

var _Translate2 = _interopRequireDefault(_Translate);

__webpack_require__(205);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `Form` component.
 */
var Form = function (_Component) {
    _inherits(Form, _Component);

    function Form(props) {
        _classCallCheck(this, Form);

        var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

        _this.handleSubmit = function (e) {
            e.preventDefault();
            if (_this.props.onSubmit) {
                _this.props.onSubmit(_this.state.values, false);
            }
        };

        _this.handleSubmitClick = function () {
            if (_this.props.onSubmit) {
                _this.props.onSubmit(_this.state.values, false);
            }
        };

        _this.handleApplyClick = function () {
            if (_this.props.onSubmit) {
                _this.props.onSubmit(_this.state.values, true);
            }
        };

        _this.handleResize = function (_ref) {
            var bounds = _ref.bounds;
            var vertical = _this.props.vertical;

            if (vertical !== null) {
                _this.setState({ vertical: vertical });
                return;
            }

            _this.setState({ vertical: bounds.width < 450 });
        };

        _this.state = {
            values: _this.props.values,
            vertical: _this.props.vertical || false
        };

        _this.form = {
            getValue: function getValue(name, def) {
                return (0, _utils2.get)(_this.state.values, name, def);
            },
            setValue: function setValue(name, value) {
                _this.setState(function (_ref2) {
                    var values = _ref2.values;
                    return (0, _utils2.set)(values, name, value);
                });
            },
            getErrors: function getErrors(name) {
                return (0, _utils2.get)(_this.props.errors, name, {});
            },
            getRequiredMark: function getRequiredMark() {
                return _this.props.requiredMark;
            }
        };
        return _this;
    }

    _createClass(Form, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                form: this.form,
                verticalSection: this.state.vertical
            };
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref3) {
            var values = _ref3.values;

            if (values !== this.state.values) {
                this.setState({ values: values });
            }
        }
    }, {
        key: 'renderRequiredLegend',
        value: function renderRequiredLegend(_ref4) {
            var hideRequiredLegend = _ref4.hideRequiredLegend,
                requiredMark = _ref4.requiredMark;

            if (hideRequiredLegend || !requiredMark) {
                return '';
            }
            return (0, _utils.createElement)(
                'span',
                null,
                requiredMark,
                ' ',
                (0, _utils.createElement)(_Translate2.default, { content: 'Form.requiredLegend', fallback: 'Required fields' })
            );
        }
    }, {
        key: 'renderSubmitButton',
        value: function renderSubmitButton(_ref5) {
            var submitButton = _ref5.submitButton,
                state = _ref5.state;

            if (!submitButton) {
                return null;
            }
            return (0, _utils.createElement)(_Button2.default, _extends({
                intent: 'primary',
                state: state === 'submit' ? 'loading' : null,
                disabled: !!state,
                onClick: this.handleSubmitClick,
                children: (0, _utils.createElement)(_Translate2.default, { content: 'Form.submitButton', fallback: 'OK' })
            }, submitButton));
        }
    }, {
        key: 'renderApplyButton',
        value: function renderApplyButton(_ref6) {
            var applyButton = _ref6.applyButton,
                state = _ref6.state;

            if (!applyButton) {
                return null;
            }
            return (0, _utils.createElement)(_Button2.default, _extends({
                intent: 'primary',
                state: state === 'apply' ? 'loading' : null,
                disabled: !!state,
                onClick: this.handleApplyClick,
                children: (0, _utils.createElement)(_Translate2.default, { content: 'Form.applyButton', fallback: 'Apply' })
            }, applyButton));
        }
    }, {
        key: 'renderCancelButton',
        value: function renderCancelButton(_ref7) {
            var cancelButton = _ref7.cancelButton,
                state = _ref7.state;

            if (!cancelButton) {
                return null;
            }
            return (0, _utils.createElement)(_Button2.default, _extends({
                state: state === 'cancel' ? 'loading' : null,
                disabled: !!state,
                children: (0, _utils.createElement)(_Translate2.default, { content: 'Form.cancelButton', fallback: 'Cancel' })
            }, cancelButton));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                children = _props.children,
                requiredMark = _props.requiredMark,
                hideRequiredLegend = _props.hideRequiredLegend,
                values = _props.values,
                errors = _props.errors,
                submitButton = _props.submitButton,
                applyButton = _props.applyButton,
                cancelButton = _props.cancelButton,
                onSubmit = _props.onSubmit,
                additionalButtons = _props.additionalButtons,
                footerClassName = _props.footerClassName,
                state = _props.state,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'children', 'requiredMark', 'hideRequiredLegend', 'values', 'errors', 'submitButton', 'applyButton', 'cancelButton', 'onSubmit', 'additionalButtons', 'footerClassName', 'state']);

            return (0, _utils.createElement)(
                _reactMeasure2.default,
                { onResize: this.handleResize, bounds: true },
                function (_ref8) {
                    var measureRef = _ref8.measureRef;
                    return (0, _utils.createElement)(
                        'form',
                        _extends({
                            ref: measureRef,
                            className: (0, _classnames2.default)(baseClassName, className),
                            onSubmit: _this2.handleSubmit
                        }, props),
                        children,
                        (0, _utils.createElement)(
                            _Section2.default,
                            { className: (0, _classnames2.default)(baseClassName + '__footer', footerClassName), title: ' ' },
                            (0, _utils.createElement)(
                                _FormField2.default,
                                { label: _this2.renderRequiredLegend({ hideRequiredLegend: hideRequiredLegend, requiredMark: requiredMark }) },
                                _this2.renderSubmitButton({ submitButton: submitButton, state: state }),
                                _this2.renderApplyButton({ applyButton: applyButton, state: state }),
                                additionalButtons,
                                _this2.renderCancelButton({ cancelButton: cancelButton, state: state })
                            )
                        )
                    );
                }
            );
        }
    }]);

    return Form;
}(_utils.Component);

Form.propTypes = {
    /**
     * Required mark.
     */
    requiredMark: _propTypes2.default.any,
    /**
     * Hide required legend.
     */
    hideRequiredLegend: _propTypes2.default.bool,
    /**
     * Form values.
     */
    values: _propTypes2.default.object,
    /**
     * Form errors.
     */
    errors: _propTypes2.default.object,
    /**
     * Current active state
     */
    state: _propTypes2.default.oneOf(['submit', 'apply', 'cancel']),
    /**
     * Content of the `Form`.
     */
    children: _propTypes2.default.node,
    /**
     * Submit button visibility or custom configuration
     */
    submitButton: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
    /**
     * Apply button visibility or custom configuration
     */
    applyButton: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
    /**
     * Cancel button visibility or custom configuration
     */
    cancelButton: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
    /**
     * Additional buttons
     */
    additionalButtons: _propTypes2.default.array,
    /**
     * Submit handler
     */
    onSubmit: _propTypes2.default.func,
    /**
     * Additional class name for the buttons container.
     */
    footerClassName: _propTypes2.default.string,
    /**
     * Form responsive view will be switched automatically.
     * Specify this parameter explicitly if you want disable this behaviour and choice vertical or horizontal form view.
     */
    vertical: _propTypes2.default.bool,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};
Form.defaultProps = {
    children: null,
    requiredMark: (0, _utils.createElement)(
        'span',
        { className: _constants.CLS_PREFIX + 'form__required' },
        '*'
    ),
    hideRequiredLegend: false,
    values: {},
    errors: {},
    state: null,
    submitButton: true,
    applyButton: true,
    cancelButton: true,
    additionalButtons: [],
    onSubmit: null,
    className: null,
    footerClassName: null,
    vertical: null,
    baseClassName: _constants.CLS_PREFIX + 'form'
};
Form.childContextTypes = {
    form: _propTypes2.default.object,
    verticalSection: _propTypes2.default.bool
};

exports.default = Form;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var nameToPath = function nameToPath(name) {
    return name.replace(/]/g, '').split('[');
};

var fixObj = function fixObj(obj, key) {
    if (isNaN(key) && (Array.isArray(obj) || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null)) {
        return {};
    }
    if (!isNaN(key) && !Array.isArray(obj)) {
        return [];
    }
    return obj;
};

var get = function get(obj, name, def) {
    var path = nameToPath(name);
    var val = void 0;
    try {
        val = path.reduce(function (curr, key) {
            return curr[key];
        }, obj);
    } catch (e) {}
    return val === undefined ? def : val;
};

var set = function set(obj, name, val) {
    var path = nameToPath(name);

    obj = fixObj(obj, path[0]);

    var key = void 0;
    var curr = obj;

    while ((key = path.shift()) && path.length) {
        curr[key] = fixObj(curr[key], path[0]);
        curr = curr[key];
    }
    curr[key] = val;

    return obj;
};

exports.get = get;
exports.set = set;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `GridCol` component.
 */

var GridCol = function GridCol(_ref) {
  var _classNames;

  var baseClassName = _ref.baseClassName,
      className = _ref.className,
      children = _ref.children,
      xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl,
      props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'children', 'xs', 'sm', 'md', 'lg', 'xl']);

  var computedClassName = (0, _classnames2.default)(baseClassName, (_classNames = {}, _defineProperty(_classNames, baseClassName + '--xs-' + xs, xs), _defineProperty(_classNames, baseClassName + '--sm-' + sm, sm), _defineProperty(_classNames, baseClassName + '--md-' + md, md), _defineProperty(_classNames, baseClassName + '--lg-' + lg, lg), _defineProperty(_classNames, baseClassName + '--xl-' + xl, xl), _classNames), className);
  return (0, _utils.createElement)(
    'div',
    _extends({ className: computedClassName }, props),
    children
  );
};

GridCol.propTypes = {
  /**
   * Content of the `GridCol`.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  baseClassName: _propTypes2.default.string,
  /**
   * Column size for `xs` breakpoint (from 1 to 12)
   */
  xs: _propTypes2.default.number,
  /**
   * Column size for `sm` breakpoint (from 1 to 12)
   */
  sm: _propTypes2.default.number,
  /**
   * Column size for `sm` breakpoint (from 1 to 12)
   */
  md: _propTypes2.default.number,
  /**
   * Column size for `md` breakpoint (from 1 to 12)
   */
  lg: _propTypes2.default.number,
  /**
   * Column size for `lg` breakpoint (from 1 to 12)
   */
  xl: _propTypes2.default.number
};
GridCol.defaultProps = {
  children: null,
  className: null,
  baseClassName: _constants.CLS_PREFIX + 'grid__col',
  xs: null,
  sm: null,
  md: null,
  lg: null,
  xl: null
};

exports.default = GridCol;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactMeasure = __webpack_require__(8);

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _constants = __webpack_require__(2);

__webpack_require__(206);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `Grid` component.
 */
var Grid = function (_Component) {
    _inherits(Grid, _Component);

    function Grid(props) {
        _classCallCheck(this, Grid);

        var _this = _possibleConstructorReturn(this, (Grid.__proto__ || Object.getPrototypeOf(Grid)).call(this, props));

        _this.handleResize = function (_ref) {
            var width = _ref.entry.width;
            var maxColumnsNumber = _this.props.maxColumnsNumber;


            if (typeof maxColumnsNumber === 'function') {
                maxColumnsNumber = maxColumnsNumber({ width: width });
            }

            var xs = Math.max(Math.floor((width + _this.getGapSize()) / (_this.props.minColumnWidth + _this.getGapSize())), 1);
            _this.setState({ xs: Math.min(xs, maxColumnsNumber) });
            if (_this.props.onColumnsChange) {
                _this.props.onColumnsChange(xs);
            }
        };

        _this.state = {
            xs: _this.props.xs
        };
        return _this;
    }

    _createClass(Grid, [{
        key: 'getGapSize',
        value: function getGapSize() {
            switch (this.props.gap) {
                case 'xs':
                    return 8;
                case 'sm':
                    return 12;
                case 'md':
                    return 16;
                case 'lg':
                    return 24;
                case 'xl':
                    return 32;
                default:
                    return 0;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                minColumnWidth = _props.minColumnWidth,
                onColumnsChange = _props.onColumnsChange,
                maxColumnsNumber = _props.maxColumnsNumber,
                xs = _props.xs,
                sm = _props.sm,
                md = _props.md,
                lg = _props.lg,
                xl = _props.xl,
                gap = _props.gap,
                children = _props.children,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'minColumnWidth', 'onColumnsChange', 'maxColumnsNumber', 'xs', 'sm', 'md', 'lg', 'xl', 'gap', 'children']);

            var computedClassName = (0, _classnames2.default)(baseClassName, (_classNames = {}, _defineProperty(_classNames, baseClassName + '--xs-' + this.state.xs, this.state.xs), _defineProperty(_classNames, baseClassName + '--sm-' + sm, sm), _defineProperty(_classNames, baseClassName + '--md-' + md, md), _defineProperty(_classNames, baseClassName + '--lg-' + lg, lg), _defineProperty(_classNames, baseClassName + '--xl-' + xl, xl), _defineProperty(_classNames, baseClassName + '--gap-xs', gap === 'xs'), _defineProperty(_classNames, baseClassName + '--gap-sm', gap === 'sm'), _defineProperty(_classNames, baseClassName + '--gap-md', gap === 'md'), _defineProperty(_classNames, baseClassName + '--gap-lg', gap === 'lg'), _defineProperty(_classNames, baseClassName + '--gap-xl', gap === 'xl'), _classNames), className);

            var result = (0, _utils.createElement)(
                'div',
                _extends({ className: computedClassName }, props),
                minColumnWidth > 0 && !this.state.xs ? null : children
            );

            if (minColumnWidth > 0) {
                return (0, _utils.createElement)(
                    _reactMeasure2.default,
                    { onResize: this.handleResize },
                    function (_ref2) {
                        var measureRef = _ref2.measureRef;
                        return (0, _utils.cloneElement)(result, { ref: measureRef });
                    }
                );
            }

            return result;
        }
    }]);

    return Grid;
}(_utils.Component);

Grid.propTypes = {
    /**
     * Content of the `Grid`.
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string,
    /**
     * Minimal column width
     */
    minColumnWidth: _propTypes2.default.number,
    /**
     * Maximum columns number
     */
    maxColumnsNumber: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
    /**
     * Number of columns for `xs` breakpoint
     */
    xs: _propTypes2.default.PropTypes.oneOf([1, 2, 3, 4, 5, 6, 'auto']),
    /**
     * Number of columns for `sm` breakpoint
     */
    sm: _propTypes2.default.oneOf([1, 2, 3, 4, 5, 6, 'auto']),
    /**
     * Number of columns for `md` breakpoint
     */
    md: _propTypes2.default.oneOf([1, 2, 3, 4, 5, 6, 'auto']),
    /**
     * Number of columns for `lg` breakpoint
     */
    lg: _propTypes2.default.oneOf([1, 2, 3, 4, 5, 6, 'auto']),
    /**
     * Number of columns for `xl` breakpoint
     */
    xl: _propTypes2.default.oneOf([1, 2, 3, 4, 5, 6, 'auto']),
    /**
     * Specifying the gutters between grid items
     */
    gap: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    /**
     * Columns number change notifier
     */
    onColumnsChange: _propTypes2.default.func
};
Grid.defaultProps = {
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'grid',
    minColumnWidth: null,
    maxColumnsNumber: 6,
    xs: null,
    sm: null,
    md: null,
    lg: null,
    xl: null,
    gap: null,
    onColumnsChange: null
};

exports.default = Grid;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

__webpack_require__(4);

__webpack_require__(207);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `Hint` component.
 */
var Hint = function Hint(_ref) {
  var baseClassName = _ref.baseClassName,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'children']);

  return (0, _utils.createElement)(
    'span',
    _extends({ className: (0, _classnames2.default)(baseClassName, className) }, props),
    children
  );
};

Hint.propTypes = {
  /**
   * Content of the `Hint`.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  baseClassName: _propTypes2.default.string
};

Hint.defaultProps = {
  children: null,
  className: null,
  baseClassName: _constants.CLS_PREFIX + 'hint'
};

exports.default = Hint;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Icon = __webpack_require__(6);

var _Icon2 = _interopRequireDefault(_Icon);

__webpack_require__(4);

__webpack_require__(208);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `IconButton` component.
 */
var IconButton = function IconButton(_ref) {
    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        icon = _ref.icon,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'icon']);

    return (0, _utils.createElement)(
        'button',
        _extends({
            className: (0, _classnames2.default)(baseClassName, className),
            type: 'button'
        }, props),
        _Icon2.default.create(icon)
    );
};

IconButton.propTypes = {
    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.element]).isRequired,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

IconButton.defaultProps = {
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'icon-button'
};

exports.default = IconButton;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NAMES = exports.ICON_SIZE_192 = exports.ICON_SIZE_128 = exports.ICON_SIZE_96 = exports.ICON_SIZE_64 = exports.ICON_SIZE_48 = exports.ICON_SIZE_32 = exports.ICON_SIZE_24 = exports.ICON_SIZE_16 = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _oldIconNames = __webpack_require__(254);

var _oldIconNames2 = _interopRequireDefault(_oldIconNames);

__webpack_require__(4);

__webpack_require__(209);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var ICON_SIZE_16 = exports.ICON_SIZE_16 = '16';
var ICON_SIZE_24 = exports.ICON_SIZE_24 = '24';
var ICON_SIZE_32 = exports.ICON_SIZE_32 = '32';
var ICON_SIZE_48 = exports.ICON_SIZE_48 = '48';
var ICON_SIZE_64 = exports.ICON_SIZE_64 = '64';
var ICON_SIZE_96 = exports.ICON_SIZE_96 = '96';
var ICON_SIZE_128 = exports.ICON_SIZE_128 = '128';
var ICON_SIZE_192 = exports.ICON_SIZE_192 = '192';

var oldIconSizes = {
    sm: ICON_SIZE_16,
    md: ICON_SIZE_32,
    lg: ICON_SIZE_48,
    xl: ICON_SIZE_64,
    xxl: ICON_SIZE_96
};

var NAMES = exports.NAMES = ['arrow-right', 'arrow-left', 'arrow-down', 'arrow-up', 'arrow-down-in', 'arrow-up-in', 'arrow-down-out', 'arrow-up-out', 'arrow-down-tray', 'arrow-up-tray', 'archive', 'unarchive', 'arrows-four-directions', 'arrows-loop', 'refresh', 'reload', 'chevron-right', 'chevron-left', 'chevron-down', 'chevron-up', 'circle-check-mark', 'circle-check-mark-filled', 'circle-info', 'circle-info-filled', 'circle-question-mark', 'circle-question-mark-filled', 'circle-exclamation-mark', 'circle-exclamation-mark-filled', 'triangle-exclamation-mark', 'triangle-exclamation-mark-filled', 'lock-open', 'lock-closed', 'eye', 'eye-closed', 'chain', 'chain-broken', 'folder-open', 'folder-closed', 'filter', 'filter-check-mark', 'stop', 'start', 'sleep', 'power', 'check-mark', 'cross-mark', 'plus', 'circle-minus', 'clean', 'remove', 'search', 'pencil', 'backup', 'copy', 'world', 'globe', 'plugins', 'themes', 'four-squares', 'list', 'menu', 'three-dots-horizontal', 'sliders', 'gear', 'clock', 'shield', 'share', 'shopping-cart', 'user', 'site-page', 'arrow-diagonal-out'];

/**
 * `Icons` are small symbolic images used for two things: to help quickly find the right control on the screen and to
 * bring user attention to something that requires consideration. In the former case, `Icon` typically acts as a part
 * of a [Button](#!/Button) and helps differentiate this particular [Button](#!/Button) from others. `Icons` come in several
 * standard sizes.
 */
var Icon = function Icon(_ref) {
    var _classNames;

    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        name = _ref.name,
        src = _ref.src,
        size = _ref.size,
        animation = _ref.animation,
        rotate = _ref.rotate,
        flipHorizontal = _ref.flipHorizontal,
        flipVertical = _ref.flipVertical,
        thin = _ref.thin,
        children = _ref.children,
        alt = _ref.alt,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'name', 'src', 'size', 'animation', 'rotate', 'flipHorizontal', 'flipVertical', 'thin', 'children', 'alt']);

    size = oldIconSizes[size] || size;

    return (0, _utils.createElement)(
        'span',
        _extends({
            className: (0, _classnames2.default)(baseClassName, (_classNames = {}, _defineProperty(_classNames, baseClassName + '--size-' + size, size), _defineProperty(_classNames, baseClassName + '--animation-' + animation, animation), _defineProperty(_classNames, baseClassName + '--rotate-' + rotate, rotate), _defineProperty(_classNames, baseClassName + '--flip-horizontal', flipHorizontal), _defineProperty(_classNames, baseClassName + '--flip-vertical', flipVertical), _classNames), className)
        }, props),
        name ? (0, _utils.createElement)(
            'svg',
            { focusable: 'false' },
            (0, _utils.createElement)('use', { xlinkHref: __webpack_require__(252) + '#' + (_oldIconNames2.default[name] || name) })
        ) : src && (0, _utils.createElement)('img', { src: src, alt: alt }) || children
    );
};

Icon.propTypes = {
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * Name of the icon
     */
    name: _propTypes2.default.oneOf(NAMES),
    /**
     * Url to custom image
     */
    src: _propTypes2.default.string,
    /**
     * Size of the icon
     */
    size: _propTypes2.default.oneOf([ICON_SIZE_16, ICON_SIZE_24, ICON_SIZE_32, ICON_SIZE_48, ICON_SIZE_64, ICON_SIZE_96, ICON_SIZE_128, ICON_SIZE_192]),
    /**
     * Animation for icon
     */
    animation: _propTypes2.default.oneOf(['spin']),
    /**
     * Rotate by degree
     */
    rotate: _propTypes2.default.oneOf(['90', '180', '270']),
    /**
     * Flip icon horizontal
     */
    flipHorizontal: _propTypes2.default.bool,
    /**
     * Flip icon vertical
     */
    flipVertical: _propTypes2.default.bool,
    /**
     * @ignore
     */
    thin: _propTypes2.default.bool,
    /**
     * Alternative text for image
     */
    alt: _propTypes2.default.string,
    /**
     * Content of the icon
     */
    children: _propTypes2.default.node
};
Icon.defaultProps = {
    baseClassName: _constants.CLS_PREFIX + 'icon',
    className: null,
    name: null,
    src: null,
    size: null,
    animation: null,
    rotate: null,
    flipHorizontal: false,
    flipVertical: false,
    thin: false,
    alt: '',
    children: null
};

var create = function create(icon) {
    var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!icon) {
        return icon;
    }

    if ((0, _utils.isValidElement)(icon)) {
        var _icon$props = icon.props,
            className = _icon$props.className,
            props = _objectWithoutProperties(_icon$props, ['className']);

        var newProps = _extends({}, defaults);

        Object.keys(props).forEach(function (name) {
            if (props[name] !== null && props[name] !== undefined) {
                newProps[name] = props[name];
            }
        });

        if (defaults.className || className) {
            newProps.className = (0, _classnames2.default)(defaults.className, className);
        }

        return (0, _utils.cloneElement)(icon, newProps);
    }

    if ((typeof icon === 'undefined' ? 'undefined' : _typeof(icon)) === 'object') {
        var _className = icon.className,
            _props = _objectWithoutProperties(icon, ['className']);

        return (0, _utils.createElement)(Icon, _extends({}, defaults, {
            className: defaults.className || _className ? (0, _classnames2.default)(defaults.className, _className) : null
        }, _props));
    }

    return (0, _utils.createElement)(Icon, _extends({}, defaults, { name: icon }));
};

Icon.create = create;

exports.default = Icon;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

__webpack_require__(4);

__webpack_require__(210);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `Input` component.
 */
var Input = function Input(_ref) {
    var size = _ref.size,
        className = _ref.className,
        baseClassName = _ref.baseClassName,
        innerRef = _ref.innerRef,
        props = _objectWithoutProperties(_ref, ['size', 'className', 'baseClassName', 'innerRef']);

    var useSizeModifier = ['sm', 'md', 'lg', 'xl', 'fill'].indexOf(size) !== -1;
    return (0, _utils.createElement)('input', _extends({
        ref: innerRef,
        className: (0, _classnames2.default)(baseClassName, _defineProperty({}, baseClassName + '--size-' + size, useSizeModifier), className),
        size: useSizeModifier ? null : size
    }, props));
};

Input.propTypes = {
    /**
     * The HTML input type.
     */
    type: _propTypes2.default.string,
    /**
     * Size of the input
     */
    size: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['sm', 'md', 'lg', 'xl', 'fill'])]),
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string,
    /**
     * @ignore
     */
    innerRef: _propTypes2.default.func
};

Input.defaultProps = {
    type: 'text',
    size: 'md',
    className: undefined,
    baseClassName: _constants.CLS_PREFIX + 'input',
    innerRef: null
};

exports.default = Input;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Grid = __webpack_require__(25);

var _Grid2 = _interopRequireDefault(_Grid);

var _GridCol = __webpack_require__(24);

var _GridCol2 = _interopRequireDefault(_GridCol);

__webpack_require__(211);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `ItemList` component.
 */
var ItemList = function (_Component) {
    _inherits(ItemList, _Component);

    function ItemList(props) {
        _classCallCheck(this, ItemList);

        var _this = _possibleConstructorReturn(this, (ItemList.__proto__ || Object.getPrototypeOf(ItemList)).call(this, props));

        _this.state = {
            ReorderableGrid: null,
            ReorderableGridCol: null
        };
        return _this;
    }

    _createClass(ItemList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var reorderable = this.props.reorderable;


            if (reorderable) {
                __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 269)).then(function (_ref) {
                    var sortableContainer = _ref.sortableContainer,
                        sortableElement = _ref.sortableElement;

                    _this2.setState({
                        ReorderableGrid: sortableContainer(_Grid2.default),
                        ReorderableGridCol: sortableElement(_GridCol2.default)
                    });
                });
            }
        }
    }, {
        key: 'renderNormal',
        value: function renderNormal(_ref2) {
            var baseClassName = _ref2.baseClassName,
                children = _ref2.children,
                props = _objectWithoutProperties(_ref2, ['baseClassName', 'children']);

            return (0, _utils.createElement)(
                _Grid2.default,
                props,
                _utils.Children.map(children, function (child) {
                    return (0, _utils.createElement)(
                        _GridCol2.default,
                        null,
                        (0, _utils.cloneElement)(child, {
                            className: (0, _classnames2.default)(baseClassName + '__item', child.props.className)
                        })
                    );
                })
            );
        }
    }, {
        key: 'renderReorderable',
        value: function renderReorderable(_ref3) {
            var _classNames;

            var baseClassName = _ref3.baseClassName,
                onReorderEnd = _ref3.onReorderEnd,
                children = _ref3.children,
                props = _objectWithoutProperties(_ref3, ['baseClassName', 'onReorderEnd', 'children']);

            var _state = this.state,
                ReorderableGrid = _state.ReorderableGrid,
                ReorderableGridCol = _state.ReorderableGridCol;


            if (!ReorderableGrid) {
                return null;
            }

            var helperClass = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, baseClassName + '__col--gap-xs', props.gap === 'xs'), _defineProperty(_classNames, baseClassName + '__col--gap-sm', props.gap === 'sm'), _defineProperty(_classNames, baseClassName + '__col--gap-md', props.gap === 'md'), _defineProperty(_classNames, baseClassName + '__col--gap-lg', props.gap === 'lg'), _defineProperty(_classNames, baseClassName + '__col--gap-xl', props.gap === 'xl'), _classNames));

            return (0, _utils.createElement)(
                ReorderableGrid,
                _extends({
                    axis: 'xy',
                    helperClass: helperClass,
                    onSortEnd: onReorderEnd
                }, props),
                _utils.Children.map(children, function (child, index) {
                    return (0, _utils.createElement)(
                        ReorderableGridCol,
                        { index: index },
                        (0, _utils.cloneElement)(child, {
                            className: (0, _classnames2.default)(baseClassName + '__item', baseClassName + '__item--reorderable', child.props.className)
                        })
                    );
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                reorderable = _props.reorderable,
                onReorderEnd = _props.onReorderEnd,
                props = _objectWithoutProperties(_props, ['className', 'reorderable', 'onReorderEnd']);

            return (0, _utils.createElement)(
                'div',
                { className: (0, _classnames2.default)(this.props.baseClassName, className) },
                reorderable ? this.renderReorderable(_extends({ onReorderEnd: onReorderEnd }, props)) : this.renderNormal(props)
            );
        }
    }]);

    return ItemList;
}(_utils.Component);

ItemList.propTypes = {
    /**
     * Enable reorderable view.
     */
    reorderable: _propTypes2.default.bool,
    /**
     * Reorder end handler.
     */
    onReorderEnd: _propTypes2.default.func,
    /**
     * Content of the `ItemList`.
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

ItemList.defaultProps = {
    reorderable: false,
    onReorderEnd: null,
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'item-list'
};

exports.default = ItemList;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ItemList = __webpack_require__(113);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ItemList).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Icon = __webpack_require__(6);

var _Icon2 = _interopRequireDefault(_Icon);

__webpack_require__(212);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `Item` component.
 */
var Item = function (_Component) {
    _inherits(Item, _Component);

    function Item() {
        _classCallCheck(this, Item);

        return _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));
    }

    _createClass(Item, [{
        key: 'renderTitle',
        value: function renderTitle(title) {
            var baseClassName = this.props.baseClassName;


            if (typeof title === 'string') {
                title = (0, _utils.createElement)(
                    'span',
                    null,
                    title
                );
            } else if ((typeof title === 'undefined' ? 'undefined' : _typeof(title)) === 'object' && !(0, _utils.isValidElement)(title)) {
                title = (0, _utils.createElement)('a', title);
            }

            if ((0, _utils.isValidElement)(title)) {
                title = (0, _utils.cloneElement)(title, {
                    className: (0, _classnames2.default)(baseClassName + '__title', title.props.className)
                });
            }

            return title;
        }
    }, {
        key: 'renderIcon',
        value: function renderIcon(icon) {
            if (typeof icon === 'string') {
                return _Icon2.default.create({}, {
                    size: _Icon.ICON_SIZE_32,
                    src: icon
                });
            }

            return _Icon2.default.create(icon, { size: _Icon.ICON_SIZE_32 });
        }
    }, {
        key: 'render',
        value: function render() {
            var _map;

            var _props = this.props,
                children = _props.children,
                baseClassName = _props.baseClassName,
                Tag = _props.component,
                className = _props.className,
                icon = _props.icon,
                title = _props.title,
                props = _objectWithoutProperties(_props, ['children', 'baseClassName', 'component', 'className', 'icon', 'title']);

            var iconElement = this.renderIcon(icon);
            var map = (_map = {}, _defineProperty(_map, _Icon.ICON_SIZE_16, 'sm'), _defineProperty(_map, _Icon.ICON_SIZE_24, 'md'), _defineProperty(_map, _Icon.ICON_SIZE_32, 'md'), _defineProperty(_map, _Icon.ICON_SIZE_48, 'lg'), _defineProperty(_map, _Icon.ICON_SIZE_64, 'lg'), _defineProperty(_map, _Icon.ICON_SIZE_96, 'lg'), _defineProperty(_map, _Icon.ICON_SIZE_128, 'lg'), _defineProperty(_map, _Icon.ICON_SIZE_192, 'lg'), _map);
            var size = map[iconElement.props.size] || _Icon.ICON_SIZE_32;

            return (0, _utils.createElement)(
                Tag,
                _extends({
                    className: (0, _classnames2.default)(baseClassName, baseClassName + '--size-' + size, className)
                }, props),
                (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__icon' },
                    iconElement
                ),
                (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__content' },
                    this.renderTitle(title),
                    children && (0, _utils.createElement)(
                        'div',
                        { className: baseClassName + '__body' },
                        children
                    )
                )
            );
        }
    }]);

    return Item;
}(_utils.Component);

Item.propTypes = {
    /**
     * Component to render as the root element. Useful when rendering a `Item` as `<a>` or `<Link>`.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    /**
     * Icon
     */
    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.element]).isRequired,
    /**
     * Title
     */
    title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.element]),
    /**
     * Content of the `Item`.
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};
Item.defaultProps = {
    component: 'div',
    title: null,
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'item'
};

exports.default = Item;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Item = __webpack_require__(115);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Item).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

__webpack_require__(213);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * Label component.
 */
var Label = function Label(_ref) {
  var baseClassName = _ref.baseClassName,
      className = _ref.className,
      intent = _ref.intent,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'intent', 'children']);

  return (0, _utils.createElement)(
    'span',
    _extends({ className: (0, _classnames2.default)(baseClassName, intent && baseClassName + '--' + intent, className) }, props),
    children
  );
};

Label.propTypes = {
  /**
   * Content of the Label
   */
  children: _propTypes2.default.any,
  /**
   * Intent of the Label
   */
  intent: _propTypes2.default.oneOf(['inactive', 'success', 'warning', 'danger', 'info']),
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  baseClassName: _propTypes2.default.string
};
Label.defaultProps = {
  children: null,
  intent: null,
  className: null,
  baseClassName: _constants.CLS_PREFIX + 'label'
};

exports.default = Label;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2018. Plesk International GmbH. All rights reserved.

/**
 * `Layer` component.
 */
var Layer = function (_Component) {
    _inherits(Layer, _Component);

    function Layer() {
        _classCallCheck(this, Layer);

        return _possibleConstructorReturn(this, (Layer.__proto__ || Object.getPrototypeOf(Layer)).apply(this, arguments));
    }

    _createClass(Layer, [{
        key: 'getChildContext',
        value: function getChildContext() {
            var parentLayer = this.context.parentLayer;
            var level = this.props.level;

            var parentLevel = parentLayer ? parentLayer.level : 0;

            return {
                parentLayer: {
                    level: parentLevel + level
                }
            };
        }
    }, {
        key: 'renderChildren',
        value: function renderChildren(_ref) {
            var children = _ref.children,
                level = _ref.level;
            var parentLayer = this.context.parentLayer;

            var parentLevel = parentLayer ? parentLayer.level : 0;

            if ((0, _utils.isValidElement)(children)) {
                return (0, _utils.cloneElement)(children, {
                    style: _extends({}, children.props.style, { zIndex: parentLevel + level })
                });
            }

            return children;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                children = _props.children,
                innerRef = _props.innerRef,
                level = _props.level,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'children', 'innerRef', 'level']);

            return (0, _utils.createPortal)((0, _utils.createElement)(
                'div',
                _extends({
                    className: (0, _classnames2.default)(baseClassName, className),
                    ref: innerRef
                }, props),
                this.renderChildren({ children: children, level: level })
            ), document.body);
        }
    }]);

    return Layer;
}(_utils.Component);

Layer.propTypes = {
    /**
     * Content of the `Layer`.
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string,
    /**
     * @ignore
     */
    innerRef: _propTypes2.default.func,
    /**
     * Level.
     */
    level: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
};

Layer.defaultProps = {
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'layer',
    innerRef: null,
    level: null
};

Layer.childContextTypes = {
    parentLayer: _propTypes2.default.shape({
        level: _propTypes2.default.number
    })
};

Layer.contextTypes = {
    parentLayer: _propTypes2.default.shape({
        level: _propTypes2.default.number
    })
};

exports.default = Layer;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

__webpack_require__(214);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `List` component.
 */
var List = function (_Component) {
    _inherits(List, _Component);

    function List(props) {
        _classCallCheck(this, List);

        var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

        _this.state = {
            sortColumn: _this.props.sortColumn,
            sortDirection: _this.props.sortDirection,
            selection: _this.props.selection,
            headerChecked: false
        };

        _this.handleRowSelectionChange = _this.handleRowSelectionChange.bind(_this);
        _this.handleGlobalSelectionChange = _this.handleGlobalSelectionChange.bind(_this);
        return _this;
    }

    _createClass(List, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var sortColumn = nextProps.sortColumn,
                sortDirection = nextProps.sortDirection,
                selection = nextProps.selection;

            if (this.state.sortColumn !== sortColumn || this.state.sortDirection !== sortDirection) {
                this.setState({ sortColumn: sortColumn, sortDirection: sortDirection });
            }

            if (selection && this.state.selection !== selection) {
                this.setState({
                    selection: selection,
                    headerChecked: selection.length === this.props.data.filter(function (_ref) {
                        var disabled = _ref.disabled;
                        return !disabled;
                    }).length
                });
            }
        }
    }, {
        key: 'getData',
        value: function getData() {
            var _state = this.state,
                sortColumn = _state.sortColumn,
                sortDirection = _state.sortDirection;

            var _props$columns$filter = this.props.columns.filter(function (_ref2) {
                var key = _ref2.key;
                return key === sortColumn;
            }),
                _props$columns$filter2 = _slicedToArray(_props$columns$filter, 1),
                column = _props$columns$filter2[0];

            var defaultSort = function defaultSort(a, b) {
                if (a > b) {
                    return 1;
                }
                if (a < b) {
                    return -1;
                }
                return 0;
            };

            if (!column) {
                return this.props.data;
            }
            return this.props.data.sort(function (a, b) {
                return (column.sort ? column.sort(a, b) : defaultSort(a[sortColumn], b[sortColumn])) * (sortDirection === 'ASC' ? 1 : -1);
            });
        }
    }, {
        key: 'sort',
        value: function sort(columnKey) {
            var _state2 = this.state,
                sortColumn = _state2.sortColumn,
                sortDirection = _state2.sortDirection;

            sortDirection = sortColumn === columnKey && sortDirection === 'ASC' ? 'DESC' : 'ASC';
            sortColumn = columnKey;

            this.setState({ sortColumn: sortColumn, sortDirection: sortDirection });
            if (this.props.onSortChange) {
                this.props.onSortChange({ sortColumn: sortColumn, sortDirection: sortDirection });
            }
        }
    }, {
        key: 'isRowSelected',
        value: function isRowSelected(row) {
            return this.state.selection.indexOf(this.getRowKey(row)) !== -1;
        }
    }, {
        key: 'handleRowSelectionChange',
        value: function handleRowSelectionChange(event) {
            this.setState({ headerChecked: false });

            var selection = void 0;
            if (event.target.checked) {
                selection = this.state.selection.slice();
                selection.push(event.target.value);
            } else {
                selection = this.state.selection.filter(function (value) {
                    return value !== event.target.value;
                });
            }
            this.setSelection(selection);
        }
    }, {
        key: 'handleGlobalSelectionChange',
        value: function handleGlobalSelectionChange(event) {
            var _this2 = this;

            var headerChecked = event.target.checked;
            this.setState({ headerChecked: headerChecked });

            var selection = headerChecked ? this.props.data.filter(function (_ref3) {
                var disabled = _ref3.disabled;
                return !disabled;
            }).map(function (row) {
                return _this2.getRowKey(row);
            }) : [];
            this.setSelection(selection);
        }
    }, {
        key: 'setSelection',
        value: function setSelection(selection) {
            this.setState({ selection: selection });
            if (this.props.onSelectionChange) {
                this.props.onSelectionChange(selection.slice());
            }
        }
    }, {
        key: 'getRowKey',
        value: function getRowKey(row) {
            var rowKey = this.props.rowKey;

            if (typeof rowKey === 'function') {
                return rowKey(row);
            }

            return row[rowKey];
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                data = _props.data,
                columns = _props.columns,
                sortColumn = _props.sortColumn,
                sortDirection = _props.sortDirection,
                onSortChange = _props.onSortChange,
                selection = _props.selection,
                onSelectionChange = _props.onSelectionChange,
                rowKey = _props.rowKey,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'data', 'columns', 'sortColumn', 'sortDirection', 'onSortChange', 'selection', 'onSelectionChange', 'rowKey']);

            var realColumn = [].concat(_toConsumableArray(columns));
            if (onSelectionChange) {
                realColumn.unshift({
                    key: 'selection',
                    className: 'cell-shrink',
                    title: (0, _utils.createElement)('input', {
                        type: 'checkbox',
                        className: 'checkbox',
                        checked: this.state.headerChecked,
                        onChange: this.handleGlobalSelectionChange
                    }),
                    render: function render(row) {
                        return (0, _utils.createElement)('input', {
                            type: 'checkbox',
                            className: 'checkbox',
                            value: _this3.getRowKey(row),
                            checked: _this3.isRowSelected(row),
                            disabled: row.disabled,
                            onChange: _this3.handleRowSelectionChange
                        });
                    }
                });
            }

            return (0, _utils.createElement)(
                'table',
                _extends({ className: (0, _classnames2.default)(baseClassName, className) }, props),
                (0, _utils.createElement)(
                    'thead',
                    null,
                    (0, _utils.createElement)(
                        'tr',
                        null,
                        realColumn.map(function (_ref4) {
                            var key = _ref4.key,
                                title = _ref4.title,
                                sortable = _ref4.sortable,
                                render = _ref4.render,
                                headerProps = _objectWithoutProperties(_ref4, ['key', 'title', 'sortable', 'render']);

                            if (sortable) {
                                title = (0, _utils.createElement)(
                                    'div',
                                    { className: 'th__action' },
                                    title
                                );
                                headerProps.className = (0, _classnames2.default)({
                                    'is-sortable': sortable,
                                    'is-sorted is-sorted--up': _this3.state.sortColumn === key && _this3.state.sortDirection === 'ASC',
                                    'is-sorted is-sorted--down': _this3.state.sortColumn === key && _this3.state.sortDirection === 'DESC'
                                }, headerProps.className);
                                headerProps.onClick = function () {
                                    return _this3.sort(key);
                                };
                            }

                            return (0, _utils.createElement)(
                                'th',
                                _extends({ key: key }, headerProps),
                                title
                            );
                        })
                    )
                ),
                (0, _utils.createElement)(
                    'tbody',
                    null,
                    this.getData().map(function (row) {
                        return (0, _utils.createElement)(
                            'tr',
                            { key: _this3.getRowKey(row), className: _this3.isRowSelected(row) ? 'is-selected' : null },
                            realColumn.map(function (_ref5) {
                                var key = _ref5.key,
                                    render = _ref5.render;
                                return (0, _utils.createElement)(
                                    'td',
                                    { key: key },
                                    render ? render(row) : row[key]
                                );
                            })
                        );
                    })
                )
            );
        }
    }]);

    return List;
}(_utils.Component);

List.propTypes = {
    /**
     * Columns definition.
     *
     * In addition to the properties described below, you can use any native properties
     * supported by the `TH` element like `width`, `className`, `style`, etc.
     */
    columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        /**
         * Unique column key.
         */
        key: _propTypes2.default.string.isRequired,
        /**
         * Column title.
         */
        title: _propTypes2.default.node,
        /**
         * Optional cell renderer function: `row => Component`. By default render value of cell.
         */
        render: _propTypes2.default.func,
        /**
         * Is column sortable.
         * Default is `false`
         */
        sortable: _propTypes2.default.bool,
        /**
         * Optional function for row comparison: `(row1, row2) => -1 | 0 | 1`
         */
        sort: _propTypes2.default.func
    })).isRequired,
    /**
     * Array of row objects.
     *
     * Each row must contains `key` property, all columns keys, and can contain `disabled` property.
     */
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        /**
         * Unique column key. This property can by renamed using `rowKey` property of List.
         */
        key: _propTypes2.default.string,
        /**
         * Optional property for disabling ability to select this row.
         */
        disabled: _propTypes2.default.bool
    })),
    /**
     * Current sort column key
     */
    sortColumn: _propTypes2.default.string,
    /**
     * Sort direction of the column being sorted.
     */
    sortDirection: _propTypes2.default.oneOf(['ASC', 'DESC']),
    /**
     * Sort change handler
     */
    onSortChange: _propTypes2.default.func,
    /**
     * Array of keys of selected rows
     */
    selection: _propTypes2.default.array,
    /**
     * Selection change handler for list. Checkboxes will only be rendered if this prop is defined.
     */
    onSelectionChange: _propTypes2.default.func,
    /**
     * Row's key getter. Could be a string or function like: `row => <unique_string>`
     */
    rowKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};
List.defaultProps = {
    data: [],
    sortColumn: null,
    sortDirection: 'ASC',
    onSortChange: null,
    onSelectionChange: null,
    selection: [],
    rowKey: 'key',
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'list'
};

exports.default = List;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _List = __webpack_require__(119);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_List).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.applyParams = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var applyParams = function applyParams(message) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var result = [];
    var hasElements = false;
    var m = void 0;
    while (m = message.match(/%%(\w+)%%/)) {
        if (m.index > 0) {
            result.push(message.substr(0, m.index));
        }
        if (params[m[1]] === undefined) {
            result.push(m[0]);
        } else if ((0, _utils.isValidElement)(params[m[1]])) {
            result.push((0, _utils.cloneElement)(params[m[1]], { key: m[1] }));
            hasElements = true;
        } else {
            result.push(params[m[1]]);
        }
        message = message.substr(m.index + m[0].length);
    }
    if (message !== '') {
        result.push(message);
    }
    return hasElements ? result : result.join('');
};

/**
 * LocaleProvider provides a uniform localization support for built-in text of components.
 */

var LocaleProvider = function (_Component) {
    _inherits(LocaleProvider, _Component);

    function LocaleProvider(props) {
        _classCallCheck(this, LocaleProvider);

        var _this = _possibleConstructorReturn(this, (LocaleProvider.__proto__ || Object.getPrototypeOf(LocaleProvider)).call(this, props));

        _this.lmsg = _this.lmsg.bind(_this);
        return _this;
    }

    _createClass(LocaleProvider, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                locale: {
                    lmsg: this.lmsg
                }
            };
        }
    }, {
        key: 'lmsg',
        value: function lmsg(key) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            if (typeof key !== 'string') {
                return '';
            }

            var message = this.getMessage(key, this.props.messages);

            if (typeof message !== 'string') {
                message = fallback === null ? '[' + key + ']' : fallback;
            }

            return applyParams(message, params);
        }
    }, {
        key: 'getMessage',
        value: function getMessage(fullKey, messages) {
            var _fullKey$split = fullKey.split('.'),
                _fullKey$split2 = _toArray(_fullKey$split),
                key = _fullKey$split2[0],
                rest = _fullKey$split2.slice(1);

            if (_typeof(messages[key]) === 'object' && rest.length) {
                return this.getMessage(rest.join('.'), messages[key]);
            }

            return messages[fullKey];
        }
    }, {
        key: 'render',
        value: function render() {
            return this.props.children;
        }
    }]);

    return LocaleProvider;
}(_utils.Component);

LocaleProvider.propTypes = {
    /**
     * Localization messages
     */
    messages: _propTypes2.default.object.isRequired,
    children: _propTypes2.default.node
};
LocaleProvider.defaultProps = {
    children: null
};

LocaleProvider.childContextTypes = {
    locale: _propTypes2.default.object
};

exports.default = LocaleProvider;
exports.applyParams = applyParams;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _marked = __webpack_require__(255);

var _marked2 = _interopRequireDefault(_marked);

var _constants = __webpack_require__(2);

__webpack_require__(215);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.
/* eslint-disable react/no-danger */

/**
 * Markdown component.
 */
var Markdown = function Markdown(_ref) {
    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        _ref$compact = _ref.compact,
        compact = _ref$compact === undefined ? false : _ref$compact,
        children = _ref.children;
    return (0, _utils.createElement)('div', {
        className: (0, _classnames2.default)(baseClassName, _defineProperty({}, baseClassName + '--compact', compact), className),
        dangerouslySetInnerHTML: { __html: (0, _marked2.default)(children, { sanitize: true }) }
    });
};

Markdown.propTypes = {
    /**
     * Content of the Markdown
     */
    children: _propTypes2.default.string.isRequired,
    /**
     * Compact mode
     */
    compact: _propTypes2.default.bool,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

Markdown.defaultProps = {
    compact: false,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'markdown'
};

exports.default = Markdown;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Markdown = __webpack_require__(122);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Markdown).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Icon = __webpack_require__(6);

var _Icon2 = _interopRequireDefault(_Icon);

__webpack_require__(216);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `Media` component.
 */
var Media = function Media(_ref) {
    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        children = _ref.children,
        title = _ref.title,
        titleAddon = _ref.titleAddon,
        titleSize = _ref.titleSize,
        image = _ref.image,
        imageSpacing = _ref.imageSpacing,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'children', 'title', 'titleAddon', 'titleSize', 'image', 'imageSpacing']);

    if (!imageSpacing && (0, _utils.isValidElement)(image) && image.type === _Icon2.default) {
        var _map;

        var map = (_map = {}, _defineProperty(_map, _Icon.ICON_SIZE_16, 'sm'), _defineProperty(_map, _Icon.ICON_SIZE_24, 'md'), _defineProperty(_map, _Icon.ICON_SIZE_32, 'md'), _defineProperty(_map, _Icon.ICON_SIZE_48, 'lg'), _defineProperty(_map, _Icon.ICON_SIZE_64, 'xl'), _defineProperty(_map, _Icon.ICON_SIZE_96, 'xxl'), _defineProperty(_map, _Icon.ICON_SIZE_128, 'xxl'), _defineProperty(_map, _Icon.ICON_SIZE_192, 'xxl'), _map);
        imageSpacing = map[image.props.size];
    }

    return (0, _utils.createElement)(
        'div',
        _extends({ className: (0, _classnames2.default)(baseClassName, className) }, props),
        image && (0, _utils.createElement)(
            'figure',
            {
                className: (0, _classnames2.default)(baseClassName + '__figure', _defineProperty({}, baseClassName + '__figure--' + imageSpacing, imageSpacing))
            },
            image
        ),
        (0, _utils.createElement)(
            'div',
            { className: baseClassName + '__body' },
            title || titleAddon ? (0, _utils.createElement)(
                'div',
                {
                    className: (0, _classnames2.default)(baseClassName + '__header', _defineProperty({}, baseClassName + '__header--' + titleSize, titleSize))
                },
                title && (0, _utils.createElement)(
                    'h4',
                    { className: baseClassName + '__title' },
                    title
                ),
                titleAddon && (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__title-addon' },
                    titleAddon
                )
            ) : null,
            (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__content' },
                children
            )
        )
    );
};

Media.propTypes = {
    /**
     * Title
     */
    title: _propTypes2.default.node,
    /**
     * Title addon
     */
    titleAddon: _propTypes2.default.node,
    /**
     * Title size
     */
    titleSize: _propTypes2.default.oneOf(['md', 'lg', 'xl']),
    /**
     * Image
     */
    image: _propTypes2.default.any,
    /**
     * Spacings between image and content
     */
    imageSpacing: _propTypes2.default.oneOf(['sm', 'md', 'lg', 'xl', 'xxl']),
    /**
     * Content of the `Media`.
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};
Media.defaultProps = {
    title: null,
    titleAddon: null,
    titleSize: null,
    image: null,
    imageSpacing: null,
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'media'
};

exports.default = Media;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `MediaSection` component.
 */
var MediaSection = function MediaSection(_ref) {
  var baseClassName = _ref.baseClassName,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'children']);

  return (0, _utils.createElement)(
    'div',
    _extends({ className: (0, _classnames2.default)(baseClassName, className) }, props),
    children
  );
};

MediaSection.propTypes = {
  /**
   * Content of the `MediaSection`.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  baseClassName: _propTypes2.default.string
};
MediaSection.defaultProps = {
  children: null,
  className: null,
  baseClassName: _constants.CLS_PREFIX + 'media-section'
};

exports.default = MediaSection;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Media = __webpack_require__(124);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Media).default;
  }
});

var _MediaSection = __webpack_require__(125);

Object.defineProperty(exports, 'MediaSection', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MediaSection).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _utils2 = __webpack_require__(11);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _MenuItem = __webpack_require__(30);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _MenuSelectableItem = __webpack_require__(42);

var _MenuSelectableItem2 = _interopRequireDefault(_MenuSelectableItem);

__webpack_require__(4);

__webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var hasIconItem = function hasIconItem(children) {
    var result = false;
    _utils.Children.forEach(children, function (child) {
        if (child.type === _MenuItem2.default && child.props.icon || child.type === _MenuSelectableItem2.default) {
            result = true;
        }
    });

    return result;
};

/**
 * `Menu` component displays grouped controls for navigating the UI, performing actions on objects, or showing
 * options for [Lists](#!/List) (for example, sorting and filtering settings). `Menu` is most typically used in a
 * [Dropdown](#!/Dropdown). `Menu` consists of several [Menu Items](#!/MenuItem) or [Selectable Menu
 * Items](#!/MenuSelectableItem).
 */
var Menu = function Menu(_ref) {
    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        children = _ref.children,
        onItemClick = _ref.onItemClick,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'children', 'onItemClick']);

    return (0, _utils.createElement)(
        'ul',
        _extends({
            className: (0, _classnames2.default)(baseClassName, className, _defineProperty({}, baseClassName + '--icons', hasIconItem(children)))
        }, props),
        _utils.Children.map(children, function (child, index) {
            if (onItemClick && child && (child.type === _MenuItem2.default || child.type === _MenuSelectableItem2.default)) {
                return (0, _utils.cloneElement)(child, {
                    onClick: (0, _utils2.wrapFunction)(child.props.onClick, onItemClick.bind(null, child, index))
                });
            }

            return child;
        })
    );
};

Menu.propTypes = {
    /**
     * Triggered when menu item was clicked.
     */
    onItemClick: _propTypes2.default.func,
    /**
     * Content of the `Menu`.
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

Menu.defaultProps = {
    onItemClick: null,
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'menu'
};

exports.default = Menu;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `MenuDivider` component.
 */
var MenuDivider = function MenuDivider(_ref) {
  var baseClassName = _ref.baseClassName,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ['baseClassName', 'className']);

  return (0, _utils.createElement)('li', _extends({ className: (0, _classnames2.default)(baseClassName, className) }, props));
};

MenuDivider.propTypes = {
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  baseClassName: _propTypes2.default.string
};

MenuDivider.defaultProps = {
  className: null,
  baseClassName: _constants.CLS_PREFIX + 'menu__divider'
};

exports.default = MenuDivider;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _MenuBaseItem = __webpack_require__(29);

var _MenuBaseItem2 = _interopRequireDefault(_MenuBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `MenuHeader` component.
 */
var MenuHeader = function MenuHeader(_ref) {
  var baseClassName = _ref.baseClassName,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'children']);

  return (0, _utils.createElement)(
    _MenuBaseItem2.default,
    _extends({ className: (0, _classnames2.default)(baseClassName, className) }, props),
    children
  );
};

MenuHeader.propTypes = {
  /**
   * Content of the `MenuHeader`.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  baseClassName: _propTypes2.default.string
};

MenuHeader.defaultProps = {
  children: null,
  className: null,
  baseClassName: _constants.CLS_PREFIX + 'menu__header'
};

exports.default = MenuHeader;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var scrollbarSpacerStyle = void 0;

var initScrollbarSpacer = function initScrollbarSpacer() {
    if (scrollbarSpacerStyle) {
        return;
    }

    var scrollDiv = document.createElement('div');
    scrollDiv.style.width = '50px';
    scrollDiv.style.height = '50px';
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    document.body.appendChild(scrollDiv);

    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);

    scrollbarSpacerStyle = document.createElement('style');
    document.head.appendChild(scrollbarSpacerStyle);
    scrollbarSpacerStyle.sheet.insertRule('.modal-open { margin-right: ' + scrollbarWidth + 'px; }', 0);
    scrollbarSpacerStyle.sheet.insertRule('.modal-open .js-scrollbar-spacer { margin-right: ' + scrollbarWidth + 'px; }', 1);
};

var Modal = function (_Component) {
    _inherits(Modal, _Component);

    function Modal() {
        _classCallCheck(this, Modal);

        return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
    }

    _createClass(Modal, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            initScrollbarSpacer();
            document.documentElement.classList.add('modal-open');
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.documentElement.classList.remove('modal-open');
        }
    }, {
        key: 'render',
        value: function render() {
            return (0, _utils.createElement)(
                'div',
                null,
                (0, _utils.createElement)('div', { className: 'main-disabled-block' }),
                this.props.children
            );
        }
    }]);

    return Modal;
}(_utils.Component);

Modal.propTypes = {
    children: _utils.PropTypes.node
};
Modal.defaultProps = {
    children: null
};

exports.default = Modal;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(130);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Modal).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var Backdrop = function Backdrop(_ref) {
    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        innerRef = _ref.innerRef,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'innerRef']);

    return (0, _utils.createElement)('div', _extends({
        ref: innerRef,
        className: (0, _classnames2.default)(baseClassName, className)
    }, props));
};
Backdrop.propTypes = {
    /**
     * Inner ref handler.
     */
    innerRef: _propTypes2.default.func,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};
Backdrop.defaultProps = {
    innerRef: null,
    baseClassName: _constants.CLS_PREFIX + 'overlay__backdrop',
    className: null
};

exports.default = Backdrop;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _utils2 = __webpack_require__(11);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _reactTransitionGroup = __webpack_require__(34);

var _Backdrop = __webpack_require__(132);

var _Backdrop2 = _interopRequireDefault(_Backdrop);

var _Layer = __webpack_require__(28);

var _Layer2 = _interopRequireDefault(_Layer);

__webpack_require__(4);

__webpack_require__(217);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `Overlay` component.
 */
var Overlay = function (_Component) {
    _inherits(Overlay, _Component);

    function Overlay() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Overlay);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isOpened: false
        }, _this.containerElement = null, _this.prevFocusElement = null, _this.backdropElement = null, _this.handleBackdropClick = function () {
            var _this$props = _this.props,
                onClose = _this$props.onClose,
                canCloseOnBackdropClick = _this$props.canCloseOnBackdropClick;


            if (canCloseOnBackdropClick) {
                (0, _utils2.safeInvoke)(onClose);
            } else {
                _this.focus();
            }
        }, _this.handleContentKeyUp = function (e) {
            var onClose = _this.props.onClose;


            if (!e.isDefaultPrevented() && e.key === 'Escape') {
                (0, _utils2.safeInvoke)(onClose);
                e.preventDefault();
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Overlay, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.isOpen) {
                this.overlayWillOpen();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (!this.props.isOpen && prevProps.isOpen) {
                this.overlayWillClose();
            } else if (this.props.isOpen && !prevProps.isOpen) {
                this.overlayWillOpen();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.isOpen) {
                this.overlayWillClose();
            }
        }
    }, {
        key: 'overlayWillOpen',
        value: function overlayWillOpen() {
            var _this2 = this;

            (0, _utils.disableDocumentScroll)();
            this.setState({ isOpened: true }, function () {
                _this2.prevFocusElement = document.activeElement;
                _this2.focus();
            });
        }
    }, {
        key: 'overlayWillClose',
        value: function overlayWillClose() {
            var _this3 = this;

            (0, _utils.enableDocumentScroll)();

            this.setState({ isOpened: false }, function () {
                if (_this3.prevFocusElement) {
                    _this3.prevFocusElement.focus();
                    _this3.prevFocusElement = null;
                }
            });
        }
    }, {
        key: 'focus',
        value: function focus() {
            if (this.containerElement === null || document.activeElement === null || !this.props.isOpen) {
                return;
            }

            var isFocusOutside = !this.containerElement.contains(document.activeElement);
            if (isFocusOutside) {
                var autofocusElement = this.containerElement.querySelector('[autofocus]');
                var wrapperElement = this.containerElement.querySelector('[tabindex]');
                if (autofocusElement !== null) {
                    autofocusElement.focus();
                } else if (wrapperElement !== null) {
                    wrapperElement.focus();
                }
            }
        }
    }, {
        key: 'renderContent',
        value: function renderContent(_ref2) {
            var baseClassName = _ref2.baseClassName,
                children = _ref2.children,
                canCloseOnEscapePress = _ref2.canCloseOnEscapePress;

            return (0, _utils.createElement)(
                _reactTransitionGroup.CSSTransition,
                {
                    classNames: baseClassName + '-',
                    timeout: 300
                },
                (0, _utils.createElement)(
                    'div',
                    {
                        className: baseClassName + '__content',
                        tabIndex: 0,
                        onKeyUp: canCloseOnEscapePress ? this.handleContentKeyUp : null
                    },
                    children
                )
            );
        }
    }, {
        key: 'renderBackdrop',
        value: function renderBackdrop(_ref3) {
            var _this4 = this;

            var baseClassName = _ref3.baseClassName;

            return (0, _utils.createElement)(
                _reactTransitionGroup.CSSTransition,
                {
                    classNames: baseClassName + '-',
                    timeout: 200
                },
                (0, _utils.createElement)(_Backdrop2.default, {
                    innerRef: function innerRef(ref) {
                        _this4.backdropElement = ref;
                    },
                    onClick: function onClick() {
                        return _this4.handleBackdropClick();
                    }
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                children = _props.children,
                isOpen = _props.isOpen,
                placement = _props.placement,
                size = _props.size,
                onClose = _props.onClose,
                canCloseOnBackdropClick = _props.canCloseOnBackdropClick,
                canCloseOnEscapePress = _props.canCloseOnEscapePress,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'children', 'isOpen', 'placement', 'size', 'onClose', 'canCloseOnBackdropClick', 'canCloseOnEscapePress']);

            if (!isOpen) {
                return null;
            }

            var isOpened = this.state.isOpened;


            return (0, _utils.createElement)(
                _Layer2.default,
                {
                    innerRef: function innerRef(ref) {
                        return _this5.containerElement = ref;
                    },
                    level: _constants.Z_INDEX_OVERLAY
                },
                (0, _utils.createElement)(
                    _reactTransitionGroup.TransitionGroup,
                    _extends({
                        className: (0, _classnames2.default)(baseClassName, baseClassName + '--' + placement, baseClassName + '--' + size, className),
                        role: 'dialog',
                        'aria-modal': 'true'
                    }, props),
                    isOpened ? this.renderBackdrop({ baseClassName: baseClassName }) : null,
                    isOpened ? this.renderContent({ baseClassName: baseClassName, children: children, canCloseOnEscapePress: canCloseOnEscapePress }) : null
                )
            );
        }
    }]);

    return Overlay;
}(_utils.Component);

Overlay.propTypes = {
    /**
     * Toggles visibility.
     */
    isOpen: _propTypes2.default.bool,
    /**
     * Overlay placement.
     */
    placement: _propTypes2.default.oneOf(['center', 'left', 'right']),
    /**
     * Overlay size.
     */
    size: _propTypes2.default.oneOf(['sm', 'md', 'lg']),
    /**
     * onClose handler.
     */
    onClose: _propTypes2.default.func,
    /**
     * Indicating if clicking the backdrop should close the overlay.
     */
    canCloseOnBackdropClick: _propTypes2.default.bool,
    /**
     * Indicating if pressing the escape key should close the overlay.
     */
    canCloseOnEscapePress: _propTypes2.default.bool,
    /**
     * Content of the `Overlay`.
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

Overlay.defaultProps = {
    isOpen: false,
    placement: 'center',
    size: 'md',
    onClose: null,
    canCloseOnBackdropClick: true,
    canCloseOnEscapePress: true,
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'overlay'
};

exports.default = Overlay;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Button = __webpack_require__(5);

var _Button2 = _interopRequireDefault(_Button);

var _SegmentedControl = __webpack_require__(33);

var _SegmentedControl2 = _interopRequireDefault(_SegmentedControl);

var _ButtonGroup = __webpack_require__(15);

var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);

var _Translate = __webpack_require__(7);

var _Translate2 = _interopRequireDefault(_Translate);

__webpack_require__(218);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var range = function range(start, length) {
    return [].concat(_toConsumableArray(Array(length))).map(function (_, i) {
        return start + i;
    });
};

var getButton = function getButton(value) {
    return { value: value, title: value };
};

var getEllipsis = function getEllipsis(key) {
    return { value: key, title: '...', tabIndex: -1, style: { pointerEvents: 'none' } };
};

var pageRange = function pageRange(visible, current, total) {
    var needEllipsis = total > visible;
    var hasStartEllipsis = needEllipsis && visible - 3 < current;
    var hasEndEllipsis = needEllipsis && current < total - visible + 4;

    if (!needEllipsis) {
        return range(1, total).map(getButton);
    } else if (hasStartEllipsis && !hasEndEllipsis) {
        var _pageCount = visible - 2;
        return [getButton(1), getEllipsis('startEllipsis')].concat(_toConsumableArray(range(total - _pageCount + 1, _pageCount).map(getButton)));
    } else if (!hasStartEllipsis && hasEndEllipsis) {
        var _pageCount2 = visible - 2;
        return [].concat(_toConsumableArray(range(1, _pageCount2).map(getButton)), [getEllipsis('endEllipsis'), getButton(total)]);
    }

    var pageCount = visible - 4;
    return [getButton(1), getEllipsis('startEllipsis')].concat(_toConsumableArray(range(current - Math.floor(pageCount / 2), pageCount).map(getButton)), [getEllipsis('endEllipsis'), getButton(total)]);
};

/**
 * `Pagination` component.
 */
var Pagination = function Pagination(_ref) {
    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        current = _ref.current,
        total = _ref.total,
        onSelect = _ref.onSelect,
        maxPageButtons = _ref.maxPageButtons,
        isShowPageButtons = _ref.isShowPageButtons,
        isShowNavigationButtons = _ref.isShowNavigationButtons,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'current', 'total', 'onSelect', 'maxPageButtons', 'isShowPageButtons', 'isShowNavigationButtons']);

    // we should hide page buttons if isShowPageButtons and isShowNavigationButtons is not defined and only two pages
    isShowPageButtons = isShowPageButtons === null ? !(isShowNavigationButtons && total < 3) : isShowPageButtons;

    return (0, _utils.createElement)(
        'div',
        _extends({ className: (0, _classnames2.default)(baseClassName, className) }, props),
        isShowPageButtons && (0, _utils.createElement)(_SegmentedControl2.default, {
            className: baseClassName + '__page-buttons',
            buttons: pageRange(maxPageButtons, current, total),
            monospaced: true,
            selected: current,
            onChange: function onChange(item) {
                return onSelect(item);
            }
        }),
        isShowNavigationButtons && (0, _utils.createElement)(
            _ButtonGroup2.default,
            { className: baseClassName + '__navigation-buttons' },
            (0, _utils.createElement)(
                _Button2.default,
                {
                    disabled: current === 1,
                    onClick: function onClick() {
                        return onSelect(current - 1);
                    }
                },
                (0, _utils.createElement)(_Translate2.default, { content: 'Pagination.previous', fallback: 'Previous' })
            ),
            (0, _utils.createElement)(
                _Button2.default,
                {
                    disabled: current === total,
                    onClick: function onClick() {
                        return onSelect(current + 1);
                    }
                },
                (0, _utils.createElement)(_Translate2.default, { content: 'Pagination.next', fallback: 'Next' })
            )
        ),
        !isShowPageButtons && (0, _utils.createElement)(
            'div',
            { className: baseClassName + '__total' },
            (0, _utils.createElement)(_Translate2.default, {
                content: 'Pagination.total',
                fallback: '%%current%% of %%total%%',
                params: {
                    current: current,
                    total: total
                }
            })
        )
    );
};
Pagination.propTypes = {
    /**
     * Number of pages in pagination.
     */
    total: _propTypes2.default.number.isRequired,
    /**
     * Current page number.
     */
    current: _propTypes2.default.number,
    /**
     * On select callback.
     */
    onSelect: _propTypes2.default.func.isRequired,
    /**
     * Max page buttons.
     */
    maxPageButtons: _propTypes2.default.number,
    /**
     * Set false if want to hide page buttons.
     */
    isShowPageButtons: _propTypes2.default.bool,
    /**
     * Set false if want to hide navigation buttons.
     */
    isShowNavigationButtons: _propTypes2.default.bool,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};
Pagination.defaultProps = {
    current: 1,
    maxPageButtons: 11,
    isShowPageButtons: null,
    isShowNavigationButtons: true,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'pagination'
};

exports.default = Pagination;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _IconButton = __webpack_require__(14);

var _IconButton2 = _interopRequireDefault(_IconButton);

__webpack_require__(219);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * Panel component.
 */
var Panel = function (_Component) {
    _inherits(Panel, _Component);

    function Panel(props) {
        _classCallCheck(this, Panel);

        var _this = _possibleConstructorReturn(this, (Panel.__proto__ || Object.getPrototypeOf(Panel)).call(this, props));

        _this.handleToggle = function () {
            _this.setState(function (_ref) {
                var collapsed = _ref.collapsed;
                return {
                    collapsed: !collapsed
                };
            }, function () {
                if (_this.props.onToggle) {
                    _this.props.onToggle(_this.state.collapsed);
                }
            });
        };

        _this.state = {
            collapsed: _this.props.collapsible && _this.props.collapsed
        };
        return _this;
    }

    _createClass(Panel, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var collapsed = nextProps.collapsed;

            if (this.state.collapsed !== collapsed) {
                this.setState({ collapsed: collapsed });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                title = _props.title,
                collapsible = _props.collapsible,
                children = _props.children;
            var collapsed = this.state.collapsed;


            return (0, _utils.createElement)(
                'div',
                {
                    className: (0, _classnames2.default)(baseClassName, (_classNames = {}, _defineProperty(_classNames, baseClassName + '--collapsible', collapsible), _defineProperty(_classNames, baseClassName + '--collapsed', collapsed), _defineProperty(_classNames, baseClassName + '--expanded', !collapsed), _classNames), className)
                },
                title && (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__header', onClick: this.props.collapsible ? this.handleToggle : null },
                    (0, _utils.createElement)(
                        'h4',
                        { className: baseClassName + '__title' },
                        title
                    ),
                    this.props.collapsible && (0, _utils.createElement)(_IconButton2.default, {
                        className: (0, _classnames2.default)(baseClassName + '__control-button', baseClassName + '__control-button--collapse'),
                        icon: { name: 'chevron-down', flipVertical: collapsed }
                    })
                ),
                (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__content' },
                    children
                )
            );
        }
    }]);

    return Panel;
}(_utils.Component);

Panel.propTypes = {
    /**
     * Panel title.
     */
    title: _propTypes2.default.node,
    /**
     * Is panel collapsible.
     */
    collapsible: _propTypes2.default.bool,
    collapsed: _propTypes2.default.bool,
    onToggle: _propTypes2.default.func,
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};
Panel.defaultProps = {
    title: null,
    collapsible: false,
    collapsed: false,
    onToggle: null,
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'panel'
};

exports.default = Panel;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Panel = __webpack_require__(135);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Panel).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

__webpack_require__(4);

__webpack_require__(220);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2018. Plesk International GmbH. All rights reserved.

/**
 * `Paragraph` is a block containing a single paragraph of [Text](#!/Text) with a bottom margin.
 */
var Paragraph = function Paragraph(_ref) {
  var baseClassName = _ref.baseClassName,
      className = _ref.className,
      children = _ref.children,
      Tag = _ref.component,
      props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'children', 'component']);

  return (0, _utils.createElement)(
    Tag,
    _extends({ className: (0, _classnames2.default)(baseClassName, className) }, props),
    children
  );
};

Paragraph.propTypes = {
  /**
   * Content of the `Paragraph`.
   */
  children: _propTypes2.default.node,
  /**
   * Component to render as the root element.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  baseClassName: _propTypes2.default.string
};

Paragraph.defaultProps = {
  children: null,
  component: 'p',
  className: null,
  baseClassName: _constants.CLS_PREFIX + 'paragraph'
};

exports.default = Paragraph;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Paragraph = __webpack_require__(137);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Paragraph).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

__webpack_require__(221);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Plaintext component.
 */
var Plaintext = function Plaintext(_ref) {
  var baseClassName = _ref.baseClassName,
      className = _ref.className,
      children = _ref.children;
  return (0, _utils.createElement)(
    'pre',
    { className: (0, _classnames2.default)(baseClassName, className) },
    children
  );
}; // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

Plaintext.propTypes = {
  /**
   * Content of the Plaintext
   */
  children: _propTypes2.default.string.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  baseClassName: _propTypes2.default.string
};
Plaintext.defaultProps = {
  className: null,
  baseClassName: _constants.CLS_PREFIX + 'plaintext'
};

exports.default = Plaintext;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Plaintext = __webpack_require__(139);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Plaintext).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ = __webpack_require__(48);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactMeasure = __webpack_require__(8);

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _constants = __webpack_require__(2);

var _Popper = __webpack_require__(44);

var _Popper2 = _interopRequireDefault(_Popper);

var _IconButton = __webpack_require__(14);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _utils = __webpack_require__(11);

__webpack_require__(222);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var PLACEMENT_MAP = {
    'top-left': 'top-end',
    'top-right': 'top-start',
    'right-top': 'right-end',
    'right-bottom': 'right-start',
    'bottom-left': 'bottom-end',
    'bottom-right': 'bottom-start',
    'left-top': 'left-end',
    'left-bottom': 'left-start'
};
var ARROW_HEIGHT = 26;

/**
 * Popover component.
 */

var Popover = function (_Component) {
    _inherits(Popover, _Component);

    function Popover(props) {
        _classCallCheck(this, Popover);

        var _this = _possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).call(this, props));

        _this.checkArrowPosition = function () {
            var title = _this.props.title;
            var _this$state = _this.state,
                show = _this$state.show,
                arrowInHeader = _this$state.arrowInHeader;


            if (!show || !_this.popperData) {
                return;
            }

            var _this$popperData = _this.popperData,
                actualPlacement = _this$popperData.actualPlacement,
                arrowStyle = _this$popperData.arrowStyle;
            var top = arrowStyle.top;

            var _actualPlacement$spli = actualPlacement.split('-'),
                _actualPlacement$spli2 = _slicedToArray(_actualPlacement$spli, 1),
                direction = _actualPlacement$spli2[0];

            var newArrowInHeader = false;

            var directionBottomOrPopoverLowEnough = direction === 'bottom' || top !== null && _this.headerBounds && top < _this.headerBounds.height - ARROW_HEIGHT / 2;
            var rightDirection = direction !== 'top' && directionBottomOrPopoverLowEnough;
            if (title && _this.headerBounds && rightDirection) {
                newArrowInHeader = true;
            }

            if (arrowInHeader !== newArrowInHeader) {
                _this.setState({ arrowInHeader: newArrowInHeader });
            }
        };

        _this.hotkeyHandler = function (e) {
            if (!e.isDefaultPrevented() && e.key === 'Escape') {
                _this.handleClose();
                e.preventDefault();
            }
        };

        _this.handleTargetClick = function () {
            var show = _this.state.show;
            var _this$props = _this.props,
                canCloseOnOutsideClick = _this$props.canCloseOnOutsideClick,
                canCloseOnEscapePress = _this$props.canCloseOnEscapePress;

            if (show && !canCloseOnOutsideClick) {
                return;
            }

            _this.setState({ show: !show }, function () {
                if (!show && canCloseOnEscapePress) {
                    setTimeout(function () {
                        return _this.focus();
                    }, 0);
                }
            });
        };

        _this.handleClose = function () {
            var show = _this.state.show;

            if (!show) {
                return;
            }

            var _this$props2 = _this.props,
                onClose = _this$props2.onClose,
                canCloseOnEscapePress = _this$props2.canCloseOnEscapePress;

            var isNeedFocus = canCloseOnEscapePress && _this.prevFocusElement && (!document.activeElement || _this.popover.contains(document.activeElement));

            if (onClose) {
                onClose();
            } else {
                _this.setState({ show: false });
            }

            if (isNeedFocus) {
                _this.prevFocusElement.focus();
            }
        };

        _this.handleHeaderResize = function (contentRect) {
            _this.headerBounds = contentRect.bounds;
            _this.checkArrowPosition();
        };

        _this.handlePopperUpdate = function (popperData) {
            _this.popperData = popperData;
            _this.checkArrowPosition();
        };

        var controlled = props.visible !== null;
        _this.state = {
            controlled: controlled,
            show: controlled ? props.visible : props.defaultVisible || false,
            arrowInHeader: false
        };
        return _this;
    }

    _createClass(Popover, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.node = (0, _.findDOMNode)(this);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            var _this2 = this;

            var controlled = newProps.visible !== null;
            var newState = {
                controlled: controlled,
                show: controlled ? newProps.visible : newProps.defaultVisible || false
            };

            this.setState(newState, function () {
                if (newProps.canCloseOnEscapePress && newState.show) {
                    setTimeout(function () {
                        return _this2.focus();
                    }, 0);
                }
            });
        }
    }, {
        key: 'focus',
        value: function focus() {
            if (this.popover === null || document.activeElement === null || !this.state.show) {
                return;
            }

            this.prevFocusElement = document.activeElement;

            var isFocusOutside = !this.popover.contains(document.activeElement);
            if (isFocusOutside) {
                var autofocusElement = this.popover.querySelector('[autofocus]');
                var wrapperElement = this.popover;

                if (autofocusElement !== null) {
                    autofocusElement.focus();
                } else if (wrapperElement !== null) {
                    wrapperElement.focus();
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this,
                _classNames;

            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                visible = _props.visible,
                defaultVisible = _props.defaultVisible,
                title = _props.title,
                placement = _props.placement,
                canCloseOnOutsideClick = _props.canCloseOnOutsideClick,
                canCloseOnEscapePress = _props.canCloseOnEscapePress,
                target = _props.target,
                intent = _props.intent,
                onClose = _props.onClose,
                children = _props.children,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'visible', 'defaultVisible', 'title', 'placement', 'canCloseOnOutsideClick', 'canCloseOnEscapePress', 'target', 'intent', 'onClose', 'children']);

            var _state = this.state,
                controlled = _state.controlled,
                show = _state.show,
                arrowInHeader = _state.arrowInHeader;

            var behavior = void 0;

            if (placement !== 'auto') {
                var _placement$split = placement.split('-'),
                    _placement$split2 = _slicedToArray(_placement$split, 1),
                    direction = _placement$split2[0];

                if (direction === 'top') {
                    behavior = ['top', 'bottom', 'right', 'left'];
                } else if (direction === 'right') {
                    behavior = ['right', 'left', 'bottom', 'top'];
                } else if (direction === 'bottom') {
                    behavior = ['bottom', 'top', 'left', 'right'];
                } else if (direction === 'left') {
                    behavior = ['left', 'right', 'top', 'bottom'];
                }
            }

            var close = (0, _.createElement)(_IconButton2.default, {
                className: (0, _classnames2.default)(baseClassName + '__close', title && baseClassName + '__close--heading'),
                onClick: this.handleClose,
                icon: 'cross-mark'
            });

            var heading = title && (0, _.createElement)(
                _reactMeasure2.default,
                { onResize: this.handleHeaderResize, bounds: true },
                function (_ref) {
                    var measureRef = _ref.measureRef;
                    return (0, _.createElement)(
                        'div',
                        { ref: measureRef, className: baseClassName + '__heading' },
                        close,
                        (0, _.createElement)(
                            'h4',
                            { className: baseClassName + '__title' },
                            title
                        )
                    );
                }
            );

            var trigger = controlled ? target : (0, _.cloneElement)(target, {
                className: (0, _classnames2.default)(target.props.className, baseClassName + '__target'),
                onClick: (0, _utils.wrapFunction)(target.props.onClick, this.handleTargetClick)
            });

            var popperPlacement = PLACEMENT_MAP[placement] || placement;
            var content = (0, _.createElement)(
                'div',
                {
                    ref: function ref(_ref2) {
                        return _this3.popover = _ref2;
                    },
                    onKeyUp: canCloseOnEscapePress && show ? this.hotkeyHandler : null,
                    tabIndex: canCloseOnEscapePress ? 0 : null,
                    className: baseClassName + '__inner'
                },
                heading || close,
                (0, _.createElement)(
                    'div',
                    { className: baseClassName + '__content' },
                    children
                )
            );

            return (0, _.createElement)(
                _Popper2.default,
                _extends({
                    target: trigger,
                    arrow: (0, _.createElement)('span', {
                        className: (0, _classnames2.default)(baseClassName + '__arrow', arrowInHeader && baseClassName + '__arrow--heading')
                    }),
                    placement: popperPlacement,
                    onUpdate: this.handlePopperUpdate,
                    className: (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, baseClassName + '--heading', title), _defineProperty(_classNames, baseClassName + '--intent-' + intent, intent), _classNames), className),
                    baseClassName: baseClassName,
                    behavior: behavior,
                    zIndex: _constants.Z_INDEX_POPOVER,
                    show: show
                }, props),
                canCloseOnOutsideClick ? (0, _.createElement)(
                    _.AutoClosable,
                    { onClose: this.handleClose, ignoreNodes: function ignoreNodes() {
                            return [_this3.node];
                        } },
                    content
                ) : content
            );
        }
    }]);

    return Popover;
}(_.Component);

Popover.propTypes = {
    /**
     * The reference element used to position the popover.
     */
    target: _propTypes2.default.element.isRequired,
    /**
     * Popover visibility. For controlled component only.
     */
    visible: _propTypes2.default.bool,
    /**
     * Popover default (on init) visibility. For uncontrolled component only.
     */
    defaultVisible: _propTypes2.default.bool,
    /**
     * Popover title. Header will only be rendered if this prop is defined.
     */
    title: _propTypes2.default.node,
    /**
     * Click handler for close button. If it is not defined then default behavior (hide popover) will be used.
     */
    onClose: _propTypes2.default.func,
    /**
     * Popover placement
     */
    placement: _propTypes2.default.oneOf(['auto', 'top-left', 'top', 'top-right', 'right-top', 'right', 'right-bottom', 'bottom-right', 'bottom', 'bottom-left', 'left-bottom', 'left', 'left-top']),
    /**
     * Indicating if clicking outside the popover should close it.
     */
    canCloseOnOutsideClick: _propTypes2.default.bool,
    /**
     * Indicating if pressing the escape key should close the popover.
     */
    canCloseOnEscapePress: _propTypes2.default.bool,
    /**
     * Content of the Popover
     */
    children: _propTypes2.default.node,
    /**
     * Visual intent color to apply to component.
     */
    intent: _propTypes2.default.oneOf(['info', 'success', 'warning', 'danger']),
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

Popover.defaultProps = {
    visible: null,
    defaultVisible: false,
    title: null,
    onClose: null,
    placement: 'auto',
    canCloseOnOutsideClick: true,
    canCloseOnEscapePress: true,
    children: null,
    intent: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'popover'
};

exports.default = Popover;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _popper = __webpack_require__(256);

var _popper2 = _interopRequireDefault(_popper);

var _Layer = __webpack_require__(28);

var _Layer2 = _interopRequireDefault(_Layer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `Popper` component.
 */
var Popper = function (_Component) {
    _inherits(Popper, _Component);

    function Popper(props) {
        _classCallCheck(this, Popper);

        var _this = _possibleConstructorReturn(this, (Popper.__proto__ || Object.getPrototypeOf(Popper)).call(this, props));

        _this.popper = null;
        _this.contentRef = null;

        _this.extractStyles = function (state) {
            if (!state) {
                return;
            }

            var _this$props = _this.props,
                arrow = _this$props.arrow,
                onUpdate = _this$props.onUpdate;
            var _state$offsets$popper = state.offsets.popper,
                left = _state$offsets$popper.left,
                top = _state$offsets$popper.top;

            var data = {
                popperStyle: {
                    position: state.offsets.popper.position || null,
                    left: left || null,
                    top: top || null
                },
                actualPlacement: state.placement,
                arrowStyle: arrow && {
                    position: state.offsets.arrow.position || null,
                    left: state.offsets.arrow.left || null,
                    top: state.offsets.arrow.top || null
                }
            };

            if (arrow && data.arrowStyle.left === null && data.arrowStyle.top === null) {
                data.arrowStyle.top = 0;
            }

            _this.setState(data);

            if (onUpdate) {
                onUpdate(data);
            }
        };

        _this.state = {
            popperStyle: null,
            arrowStyle: null,
            actualPlacement: props.placement
        };
        return _this;
    }

    _createClass(Popper, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.updatePopper(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            setTimeout(function () {
                _this2.updatePopper(nextProps);
            }, 0);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.popper) {
                this.popper.destroy();
            }
        }
    }, {
        key: 'updatePopper',
        value: function updatePopper(props) {
            if (this.popper) {
                this.popper.destroy();
            }

            if (!this.contentRef || !props.show) {
                return;
            }

            var popperOpts = {
                placement: props.placement,
                modifiers: {
                    applyStyle: {
                        enabled: false
                    },
                    applyReactStyle: {
                        enabled: true,
                        fn: this.extractStyles,
                        order: 900
                    },
                    hide: {
                        enabled: false
                    },
                    offset: {
                        enabled: true,
                        offset: props.offset
                    },
                    flip: {
                        enabled: true,
                        padding: 0,
                        behavior: props.behavior
                    },
                    preventOverflow: {
                        enabled: true,
                        boundariesElement: 'viewport'
                    },
                    arrow: props.arrow && {
                        enabled: true,
                        element: this.arrowRef
                    }
                }
            };

            this.popper = new _popper2.default((0, _utils.findDOMNode)(this), this.contentRef, popperOpts);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                children = _props.children,
                target = _props.target,
                arrow = _props.arrow,
                placement = _props.placement,
                behavior = _props.behavior,
                offset = _props.offset,
                onUpdate = _props.onUpdate,
                zIndex = _props.zIndex,
                show = _props.show,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'children', 'target', 'arrow', 'placement', 'behavior', 'offset', 'onUpdate', 'zIndex', 'show']);

            var _state = this.state,
                popperStyle = _state.popperStyle,
                arrowStyle = _state.arrowStyle,
                actualPlacement = _state.actualPlacement;


            var arrowElement = arrow && (0, _utils.cloneElement)(arrow, {
                ref: function ref(_ref) {
                    return _this3.arrowRef = _ref;
                },
                style: arrowStyle
            });

            return (0, _utils.createElement)(
                _utils.Fragment,
                null,
                target,
                show ? (0, _utils.createElement)(
                    _Layer2.default,
                    { level: zIndex },
                    (0, _utils.createElement)(
                        'div',
                        _extends({
                            ref: function ref(_ref2) {
                                return _this3.contentRef = _ref2;
                            },
                            className: (0, _classnames2.default)(baseClassName, className, baseClassName + '--placement-' + actualPlacement),
                            style: _extends({
                                position: 'absolute'
                            }, popperStyle)
                        }, props),
                        children,
                        arrowElement
                    )
                ) : null
            );
        }
    }]);

    return Popper;
}(_utils.Component);

Popper.propTypes = {
    /**
     * Whether show popper content.
     */
    show: _propTypes2.default.bool,
    /**
     * Content of the `Popper`.
     */
    children: _propTypes2.default.node,
    /**
     * Target for popper.
     */
    target: _propTypes2.default.any.isRequired,
    /**
     * Arrow element of popper
     */
    arrow: _propTypes2.default.element,
    /**
     * Placement for popper.
     */
    placement: _propTypes2.default.oneOf(['auto', 'auto-start', 'auto-end', 'auto-top', 'auto-right', 'auto-bottom', 'auto-left', 'top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end']),
    /**
     * The behavior used to change the popper's placement.
     */
    behavior: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['flip', 'clockwise', 'counterclockwise']), _propTypes2.default.arrayOf(_propTypes2.default.string)]),
    /**
     * Shift your popper on both axis.
     */
    offset: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    /**
     * Update callback function
     */
    onUpdate: _propTypes2.default.func,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string,
    /**
     * zIndex value.
     */
    zIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
};

Popper.defaultProps = {
    show: true,
    children: null,
    arrow: null,
    placement: 'bottom-start',
    behavior: 'flip',
    offset: '0, 0',
    onUpdate: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'popper',
    zIndex: null
};

exports.default = Popper;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

__webpack_require__(223);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var radioId = 0;

/**
 * Helper component for `FormFieldRadioButtons` component.
 */

var Radio = function (_Component) {
    _inherits(Radio, _Component);

    function Radio() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Radio);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Radio.__proto__ || Object.getPrototypeOf(Radio)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (event) {
            var _this$props = _this.props,
                disabled = _this$props.disabled,
                onChange = _this$props.onChange;

            if (!disabled && onChange) {
                onChange(event.target.checked);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Radio, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                children = _props.children,
                onChange = _props.onChange,
                checked = _props.checked,
                defaultChecked = _props.defaultChecked,
                disabled = _props.disabled,
                inputProps = _props.inputProps,
                label = _props.label,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'children', 'onChange', 'checked', 'defaultChecked', 'disabled', 'inputProps', 'label']);

            if (!inputProps.id) {
                inputProps.id = 'radio-' + radioId++;
            }

            return (0, _utils.createElement)(
                'div',
                _extends({
                    className: (0, _classnames2.default)(baseClassName, className)
                }, props),
                (0, _utils.createElement)('input', _extends({
                    className: baseClassName + '__input',
                    type: 'radio',
                    onChange: this.handleChange,
                    checked: checked,
                    defaultChecked: defaultChecked,
                    disabled: disabled
                }, inputProps)),
                label ? (0, _utils.createElement)(
                    'label',
                    { htmlFor: inputProps.id },
                    label
                ) : null,
                children
            );
        }
    }]);

    return Radio;
}(_utils.Component);

Radio.propTypes = {
    /**
     * Determine whether the `Radio` is checked.
     */
    checked: _propTypes2.default.bool,
    /**
     * @ignore
     */
    defaultChecked: _propTypes2.default.bool,
    /**
     * A callback function, can be executed when the checked state is changing.
     */
    onChange: _propTypes2.default.func,
    disabled: _propTypes2.default.bool,
    /**
     * Label of the `Radio`
     */
    label: _propTypes2.default.node,
    /**
     * Additional content
     */
    children: _propTypes2.default.node,
    /**
     * Additional props for input element
     */
    inputProps: _propTypes2.default.object,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

Radio.defaultProps = {
    checked: undefined,
    defaultChecked: undefined,
    onChange: undefined,
    disabled: false,
    label: undefined,
    children: undefined,
    inputProps: {},
    className: undefined,
    baseClassName: _constants.CLS_PREFIX + 'radio'
};

exports.default = Radio;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Radio = __webpack_require__(143);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Radio).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

__webpack_require__(224);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var width = function width(value) {
    var result = Math.ceil(value * 20 / 5) * 5;
    if (result % 20 === 5) {
        result += 2;
    } else if (result % 20 === 15) {
        result -= 2;
    }

    return result;
};

/**
 * Rating component.
 */
var Rating = function Rating(_ref) {
    var _classNames;

    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        value = _ref.value,
        small = _ref.small,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'value', 'small']);

    return (0, _utils.createElement)(
        'div',
        _extends({
            className: (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, baseClassName, true), _defineProperty(_classNames, baseClassName + '--static', true), _defineProperty(_classNames, baseClassName + '--small', small), _defineProperty(_classNames, className, true), _classNames))
        }, props),
        (0, _utils.createElement)('div', { className: baseClassName + '__rates', style: { width: width(value) + '%' } })
    );
};

Rating.propTypes = {
    /**
     * Rating value from 0 to 5.
     */
    value: _propTypes2.default.number,
    /**
     * Small variant.
     */
    small: _propTypes2.default.bool,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

Rating.defaultProps = {
    value: 0,
    small: false,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'rating'
};

exports.default = Rating;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Rating = __webpack_require__(145);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Rating).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactMeasure = __webpack_require__(8);

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _constants = __webpack_require__(2);

var _Button = __webpack_require__(5);

var _Button2 = _interopRequireDefault(_Button);

var _IconButton = __webpack_require__(14);

var _IconButton2 = _interopRequireDefault(_IconButton);

__webpack_require__(225);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `Section` component.
 */
var Section = function (_Component) {
    _inherits(Section, _Component);

    function Section(props) {
        _classCallCheck(this, Section);

        var _this = _possibleConstructorReturn(this, (Section.__proto__ || Object.getPrototypeOf(Section)).call(this, props));

        _this.handleResize = function (_ref) {
            var bounds = _ref.bounds;
            var vertical = _this.props.vertical;

            if (vertical !== null) {
                _this.setState({ vertical: vertical });
                return;
            }

            var verticalSection = _this.context.verticalSection;

            if (verticalSection !== undefined) {
                _this.setState({ vertical: verticalSection });
                return;
            }

            _this.setState({ vertical: bounds.width < 450 });
        };

        _this.handleCollapse = function () {
            _this.setState(function (_ref2) {
                var collapsed = _ref2.collapsed;
                return {
                    collapsed: !collapsed
                };
            });
        };

        _this.handleEdit = function () {
            _this.setState(function (_ref3, _ref4) {
                var editing = _ref3.editing;
                var title = _ref4.title;
                return {
                    editing: !editing,
                    title: title
                };
            });
        };

        _this.handleEditKey = function (event) {
            if (event.key === 'Escape') {
                _this.handleEdit();
            } else if (event.key === 'Enter') {
                _this.handleEditOk();
            }
        };

        _this.handleTitleChange = function (event) {
            _this.setState({ title: event.target.value });
        };

        _this.handleEditOk = function () {
            _this.props.onTitleChange(_this.state.title);
            _this.handleEdit();
        };

        _this.state = {
            collapsed: props.collapsed,
            editing: false,
            title: props.title,
            vertical: props.vertical || false
        };
        return _this;
    }

    _createClass(Section, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                verticalSection: this.state.vertical
            };
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref5) {
            var title = _ref5.title,
                collapsed = _ref5.collapsed;

            var newState = { title: title };

            if (collapsed !== this.props.collapsed) {
                newState.collapsed = collapsed;
            }

            this.setState(newState);
        }
    }, {
        key: 'renderCollapseButton',
        value: function renderCollapseButton(_ref6) {
            var baseClassName = _ref6.baseClassName,
                collapsible = _ref6.collapsible;
            var collapsed = this.state.collapsed;


            return collapsible && (0, _utils.createElement)(_IconButton2.default, {
                className: (0, _classnames2.default)(baseClassName + '__control-button', baseClassName + '__control-button--collapse'),
                icon: { name: 'chevron-down', flipVertical: collapsed },
                onClick: this.handleCollapse
            });
        }
    }, {
        key: 'renderCloseButton',
        value: function renderCloseButton(_ref7) {
            var baseClassName = _ref7.baseClassName,
                onClose = _ref7.onClose,
                buttons = _ref7.buttons;

            return (onClose || buttons) && (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__header-buttons' },
                buttons,
                onClose && (0, _utils.createElement)(_IconButton2.default, {
                    className: (0, _classnames2.default)(baseClassName + '__control-button', baseClassName + '__control-button--close'),
                    onClick: onClose,
                    icon: 'cross-mark'
                })
            );
        }
    }, {
        key: 'renderTitleEditing',
        value: function renderTitleEditing(_ref8) {
            var baseClassName = _ref8.baseClassName;
            var _state = this.state,
                title = _state.title,
                editing = _state.editing;


            return editing ? (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__title-edit' },
                (0, _utils.createElement)('input', {
                    type: 'text',
                    value: title,
                    onChange: this.handleTitleChange,
                    onKeyDown: this.handleEditKey,
                    autoFocus: true
                }),
                (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__title-edit-actions' },
                    (0, _utils.createElement)(_Button2.default, { icon: 'check-mark', onClick: this.handleEditOk }),
                    (0, _utils.createElement)(_Button2.default, { icon: 'cross-mark', onClick: this.handleEdit })
                )
            ) : title;
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle(_ref9) {
            var baseClassName = _ref9.baseClassName,
                onTitleChange = _ref9.onTitleChange;
            var _state2 = this.state,
                title = _state2.title,
                editing = _state2.editing;


            return title && (0, _utils.createElement)(
                'div',
                { className: baseClassName + '__title' },
                this.renderTitleEditing({ baseClassName: baseClassName }),
                onTitleChange && !editing && (0, _utils.createElement)(_IconButton2.default, {
                    className: (0, _classnames2.default)(baseClassName + '__control-button', baseClassName + '__control-button--edit'),
                    onClick: this.handleEdit,
                    icon: { name: 'pencil', className: baseClassName + '__control-button-icon' }
                })
            );
        }
    }, {
        key: 'renderContent',
        value: function renderContent(_ref10) {
            var collapsible = _ref10.collapsible,
                children = _ref10.children;
            var collapsed = this.state.collapsed;


            if (collapsible && collapsed) {
                return null;
            }

            return children;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                intent = _props.intent,
                collapsible = _props.collapsible,
                title = _props.title,
                collapsed = _props.collapsed,
                onTitleChange = _props.onTitleChange,
                onClose = _props.onClose,
                buttons = _props.buttons,
                vertical = _props.vertical,
                children = _props.children,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'intent', 'collapsible', 'title', 'collapsed', 'onTitleChange', 'onClose', 'buttons', 'vertical', 'children']);

            return (0, _utils.createElement)(
                _reactMeasure2.default,
                { onResize: this.handleResize, bounds: true },
                function (_ref11) {
                    var _classNames;

                    var measureRef = _ref11.measureRef;
                    return (0, _utils.createElement)(
                        'div',
                        _extends({
                            ref: measureRef,
                            className: (0, _classnames2.default)(baseClassName, (_classNames = {}, _defineProperty(_classNames, baseClassName + '--' + intent, intent), _defineProperty(_classNames, baseClassName + '--collapsible', collapsible), _defineProperty(_classNames, baseClassName + '--vertical', _this2.state.vertical), _classNames), className)
                        }, props),
                        title && (0, _utils.createElement)(
                            'div',
                            { className: baseClassName + '__header' },
                            _this2.renderCollapseButton({ baseClassName: baseClassName, collapsible: collapsible }),
                            _this2.renderTitle({ baseClassName: baseClassName, onTitleChange: onTitleChange }),
                            _this2.renderCloseButton({ baseClassName: baseClassName, onClose: onClose, buttons: buttons })
                        ),
                        _this2.renderContent({ collapsible: collapsible, children: children })
                    );
                }
            );
        }
    }]);

    return Section;
}(_utils.Component);

Section.propTypes = {
    /**
     * Title of the section.
     */
    title: _propTypes2.default.node,
    /**
     * Visual intent color to apply to component.
     */
    intent: _propTypes2.default.oneOf(['danger', 'warning', 'success', 'inactive']),
    /**
     * Is section collapsible.
     */
    collapsible: _propTypes2.default.bool,
    /**
     * Is section collapsed now.
     */
    collapsed: _propTypes2.default.bool,
    /**
     * Event handler of title change with inline editing form.
     */
    onTitleChange: _propTypes2.default.func,
    /**
     * Event handler of closing section with X-sign at the right.
     */
    onClose: _propTypes2.default.func,
    /**
     * Array of custom section action button at the right.
     */
    buttons: _propTypes2.default.arrayOf(_propTypes2.default.element),
    /**
     * Vertical or horizontal section view.
     * Section view will be automatically switched if this parameter is not specified explicitly.
     */
    vertical: _propTypes2.default.bool,
    /**
     * Content of the `Section`.
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

Section.defaultProps = {
    title: null,
    intent: null,
    collapsible: false,
    collapsed: false,
    onTitleChange: null,
    onClose: null,
    buttons: null,
    vertical: null,
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'section'
};

Section.childContextTypes = {
    verticalSection: _propTypes2.default.bool
};

Section.contextTypes = {
    verticalSection: _propTypes2.default.bool
};

exports.default = Section;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

__webpack_require__(226);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `SectionItem` component. Used as row in `Section` component.
 */
var SectionItem = function SectionItem(_ref, _ref2) {
    var _classNames;

    var verticalSection = _ref2.verticalSection;

    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        children = _ref.children,
        title = _ref.title,
        actions = _ref.actions,
        vertical = _ref.vertical,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'children', 'title', 'actions', 'vertical']);

    return (0, _utils.createElement)(
        'div',
        _extends({
            className: (0, _classnames2.default)(baseClassName, (_classNames = {}, _defineProperty(_classNames, baseClassName + '--actions', actions), _defineProperty(_classNames, baseClassName + '--vertical', vertical === null ? verticalSection : vertical), _classNames), className)
        }, props),
        title === null ? null : (0, _utils.createElement)(
            'div',
            { className: baseClassName + '__title' },
            title
        ),
        (0, _utils.createElement)(
            'div',
            { className: baseClassName + '__value' },
            children
        )
    );
};

SectionItem.propTypes = {
    /**
     * Content of the `SectionItem`.
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string,
    /**
     * Title of the section item.
     */
    title: _propTypes2.default.node,
    /**
     * Is this section item contains actions? If it so than there should be extra whitespaces.
     */
    actions: _propTypes2.default.bool,
    /**
     * @ignore
     */
    vertical: _propTypes2.default.bool
};

SectionItem.defaultProps = {
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'section-item',
    title: null,
    actions: false,
    vertical: null
};

SectionItem.contextTypes = {
    verticalSection: _propTypes2.default.bool
};

exports.default = SectionItem;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactMeasure = __webpack_require__(8);

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _constants = __webpack_require__(2);

var _ButtonGroup = __webpack_require__(15);

var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);

var _Button = __webpack_require__(5);

var _Button2 = _interopRequireDefault(_Button);

__webpack_require__(4);

__webpack_require__(227);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var alphaSort = function alphaSort(a, b) {
    return a > b ? 1 : -1;
};

/**
 *  `Segmented Control` is a group of several [Buttons](#!/Button) typically used for switching between
 * different content views (list, tiles, and so on). Since there can only be one current content view for a
 * particular content, one of the buttons in a group is always active, and only one button should be active at a time.
 * The buttons are displayed in-line and can contain text, images or both.
 */

var SegmentedControl = function (_Component) {
    _inherits(SegmentedControl, _Component);

    function SegmentedControl(props) {
        _classCallCheck(this, SegmentedControl);

        var _this = _possibleConstructorReturn(this, (SegmentedControl.__proto__ || Object.getPrototypeOf(SegmentedControl)).call(this, props));

        _initialiseProps.call(_this);

        var selected = props.selected;

        _this.state = { selected: selected, collapsed: false, monoWidth: 0, monoWidthButton: null };

        _this.items = {};
        _this.maxWidth = null;
        _this.minWidth = null;
        return _this;
    }

    _createClass(SegmentedControl, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                responsive: this.isResponsive()
            };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadItems();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props) {
            var selected = props.selected,
                multiple = props.multiple;

            var newState = {};

            newState.selected = this.state.selected;
            if (selected !== this.props.selected) {
                newState.selected = selected;
            }

            if (multiple && newState.selected && !(newState.selected instanceof Array)) {
                newState.selected = [newState.selected];
            }

            if (newState.selected !== this.state.selected) {
                this.setState(newState);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.loadItems();
        }
    }, {
        key: 'isResponsive',
        value: function isResponsive() {
            return typeof this.context.responsive === 'undefined' ? this.state.collapsed : this.context.responsive;
        }
    }, {
        key: 'loadItems',
        value: function loadItems() {
            var _this2 = this;

            setTimeout(function () {
                if (!_this2.groupRef) {
                    return;
                }

                var _props = _this2.props,
                    baseClassName = _props.baseClassName,
                    buttons = _props.buttons;

                var items = Array.prototype.map.call(_this2.groupRef.querySelectorAll('.' + baseClassName + '__button'), function (el) {
                    return el.getBoundingClientRect().width;
                });

                _this2.items = items.reduce(function (res, width, ind) {
                    res[buttons[ind].value] = width;
                    return res;
                }, {});
                _this2.itemsWidth = items.reduce(function (res, el) {
                    return res + el;
                }, 0);

                _this2.checkAdaptive();
            }, 0);
        }
    }, {
        key: 'renderButtonGroup',
        value: function renderButtonGroup(_ref) {
            var _this3 = this;

            var buttons = _ref.buttons,
                monospaced = _ref.monospaced,
                multiple = _ref.multiple,
                onChange = _ref.onChange,
                baseClassName = _ref.baseClassName;
            var _state = this.state,
                selected = _state.selected,
                monoWidth = _state.monoWidth,
                monoWidthButton = _state.monoWidthButton;

            var isCollapsed = this.isResponsive();

            return (0, _utils.createElement)(
                _ButtonGroup2.default,
                {
                    innerRef: function innerRef(ref) {
                        return _this3.groupRef = ref;
                    },
                    className: baseClassName + '__button-group'
                },
                buttons.map(function (_ref2) {
                    var value = _ref2.value,
                        title = _ref2.title,
                        buttonProps = _objectWithoutProperties(_ref2, ['value', 'title']);

                    // uncontrolled
                    var handler = {};
                    if (onChange !== null) {
                        handler.onClick = _this3.handleChange(value);
                    }

                    var buttonSelected = false;
                    if (multiple && selected && selected instanceof Array && selected.indexOf(value) !== -1) {
                        buttonSelected = true;
                    } else if (!multiple && selected === value) {
                        buttonSelected = true;
                    }

                    buttonProps.className = (0, _classnames2.default)(buttonProps.className, baseClassName + '__button');

                    if (!isCollapsed && monospaced && monoWidth && monoWidthButton !== value) {
                        buttonProps.style = _extends({
                            width: monoWidth
                        }, buttonProps.style);
                    }

                    return (0, _utils.createElement)(
                        _Button2.default,
                        _extends({
                            key: value,
                            selected: buttonSelected
                        }, handler, buttonProps),
                        title
                    );
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props2 = this.props,
                label = _props2.label,
                labelPlacement = _props2.labelPlacement,
                buttons = _props2.buttons,
                monospaced = _props2.monospaced,
                multiple = _props2.multiple,
                selectedProp = _props2.selected,
                onChange = _props2.onChange,
                inline = _props2.inline,
                className = _props2.className,
                baseClassName = _props2.baseClassName,
                props = _objectWithoutProperties(_props2, ['label', 'labelPlacement', 'buttons', 'monospaced', 'multiple', 'selected', 'onChange', 'inline', 'className', 'baseClassName']);

            var isCollapsed = this.isResponsive();

            return (0, _utils.createElement)(
                _reactMeasure2.default,
                { onResize: this.handleResize, bounds: true },
                function (_ref3) {
                    var _classNames;

                    var measureRef = _ref3.measureRef;
                    return (0, _utils.createElement)(
                        'div',
                        _extends({
                            ref: measureRef,
                            className: (0, _classnames2.default)(baseClassName, (_classNames = {}, _defineProperty(_classNames, baseClassName + '--inline', inline), _defineProperty(_classNames, baseClassName + '--collapsed', isCollapsed), _defineProperty(_classNames, baseClassName + '--vertical', label && labelPlacement === 'top'), _classNames), className)
                        }, props),
                        label && (0, _utils.createElement)(
                            'div',
                            { className: baseClassName + '__label' },
                            label
                        ),
                        _this4.renderButtonGroup({ buttons: buttons, monospaced: monospaced, multiple: multiple, onChange: onChange, baseClassName: baseClassName })
                    );
                }
            );
        }
    }]);

    return SegmentedControl;
}(_utils.Component);

var _initialiseProps = function _initialiseProps() {
    var _this5 = this;

    this.checkAdaptive = function () {
        if (!_this5.group || !_this5.items || Object.keys(_this5.items).length !== _this5.props.buttons.length) {
            return;
        }

        var _props3 = _this5.props,
            buttons = _props3.buttons,
            monospaced = _props3.monospaced;
        var _state2 = _this5.state,
            collapsed = _state2.collapsed,
            monoWidth = _state2.monoWidth,
            monoWidthButton = _state2.monoWidthButton;

        var newState = {};

        if (!_this5.maxWidth || _this5.itemsWidth > _this5.maxWidth) {
            _this5.maxWidth = _this5.itemsWidth;
        }
        if (!_this5.minWidth || _this5.itemsWidth < _this5.minWidth) {
            _this5.minWidth = _this5.itemsWidth;
        }

        if (!collapsed && monospaced) {
            var width = 0;
            var widthButton = null;
            for (var i = 0; i < buttons.length; i++) {
                var button = buttons[i].value;
                var size = _this5.items[button];

                if (size > monoWidth && size > width) {
                    width = size;
                    widthButton = button;
                }
            }

            if (width && width !== monoWidth) {
                newState.monoWidth = width;
            }
            if (widthButton && widthButton !== monoWidthButton) {
                newState.monoWidthButton = widthButton;
            }
        }

        var offset = _this5.groupRef.getBoundingClientRect().left - _this5.group.left;
        if (!collapsed && _this5.group.width < _this5.itemsWidth + offset) {
            newState.collapsed = true;
        } else if (collapsed && _this5.group.width >= _this5.maxWidth + offset) {
            newState.collapsed = false;
        }

        if (Object.keys(newState).length) {
            _this5.setState(newState, function () {
                setTimeout(_this5.checkAdaptive, 0);
            });
        }
    };

    this.handleChange = function (value) {
        return function () {
            var _props4 = _this5.props,
                multiple = _props4.multiple,
                onChange = _props4.onChange;
            var selected = _this5.state.selected;


            var newSelected = void 0;
            if (multiple) {
                newSelected = selected ? selected.slice() : [];
                if (!selected || !(selected instanceof Array) || selected.indexOf(value) === -1) {
                    newSelected.push(value);
                } else {
                    newSelected.splice(selected.indexOf(value), 1);
                }

                newSelected.sort(alphaSort);
            } else {
                newSelected = value;
            }

            if (selected instanceof Array) {
                selected.sort(alphaSort);
            }

            if (JSON.stringify(newSelected) !== JSON.stringify(selected)) {
                _this5.setState({ selected: newSelected });

                onChange(newSelected);
            }
        };
    };

    this.handleResize = function (contentRect) {
        _this5.group = contentRect.bounds;
        _this5.checkAdaptive();
    };
};

SegmentedControl.propTypes = {
    /**
     * Label
     */
    label: _propTypes2.default.node,
    /**
     * Where to place label
     */
    labelPlacement: _propTypes2.default.oneOf(['top', 'left']),
    /**
     * Array of buttons to display (every array item must contain an unique "value" property)
     */
    buttons: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.any.isRequired,
        title: _propTypes2.default.node
    })).isRequired,
    /**
     * Monospaced version of buttons (all button would have the same width).
     * Attention: using it with buttons dynamic update may cause to wrong behavior!
     */
    monospaced: _propTypes2.default.bool,
    /**
     * Multiple selected options version (any number of buttons can be selected)
     */
    multiple: _propTypes2.default.bool,
    /**
     * Selected value or an array of values (for multiple version).
     * Used in controlled version or as default value in uncontrolled version (with onChange property)
     */
    selected: _propTypes2.default.oneOfType([_propTypes2.default.any, _propTypes2.default.arrayOf(_propTypes2.default.any)]).isRequired,
    /**
     * On change selection callback for uncontrolled mode.
     */
    onChange: _propTypes2.default.func,
    /**
     * Should component displays as inline element?
     */
    inline: _propTypes2.default.bool,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

SegmentedControl.defaultProps = {
    label: null,
    labelPlacement: 'top',
    monospaced: false,
    multiple: false,
    onChange: null,
    inline: false,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'segmented-control'
};

SegmentedControl.contextTypes = {
    responsive: _propTypes2.default.bool
};

SegmentedControl.childContextTypes = {
    responsive: _propTypes2.default.bool
};

exports.default = SegmentedControl;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

__webpack_require__(4);

__webpack_require__(228);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2018. Plesk International GmbH. All rights reserved.

/**
 * `Spinner` component.
 */
var Spinner = function Spinner(_ref) {
    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className']);

    return (0, _utils.createElement)(
        'svg',
        _extends({
            className: (0, _classnames2.default)(baseClassName, className)
        }, props, {
            viewBox: '0 0 48 48',
            xmlns: 'http://www.w3.org/2000/svg'
        }),
        (0, _utils.createElement)('circle', {
            className: baseClassName + '__path',
            fill: 'none',
            strokeWidth: '6',
            strokeLinecap: 'round',
            cx: '24',
            cy: '24',
            r: '21'
        })
    );
};

Spinner.propTypes = {
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string,
    /**
     * @ignore
     */
    className: _propTypes2.default.string
};

Spinner.defaultProps = {
    baseClassName: _constants.CLS_PREFIX + 'spinner',
    className: null
};

exports.default = Spinner;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Button = __webpack_require__(5);

var _Button2 = _interopRequireDefault(_Button);

var _ButtonGroup = __webpack_require__(15);

var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);

var _Dropdown = __webpack_require__(12);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

__webpack_require__(229);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `Split Button` is a combination of a standard [button](#!/Button) with a [drop-down](#!/Dropdown) menu.
 * It is used for grouping several related actions when one of the actions should be accessible immediately
 * because it is used more often than others.
 */
var SplitButton = function SplitButton(_ref) {
    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        menu = _ref.menu,
        children = _ref.children,
        opened = _ref.opened,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'menu', 'children', 'opened']);

    return (0, _utils.createElement)(
        _ButtonGroup2.default,
        _extends({ className: (0, _classnames2.default)(baseClassName, className) }, props),
        (0, _utils.createElement)(
            _Button2.default,
            null,
            children
        ),
        (0, _utils.createElement)(_Dropdown2.default, { className: baseClassName + '__dropdown-trigger', menu: menu, menuPlacement: 'bottom-end' })
    );
};

SplitButton.propTypes = {
    menu: _propTypes2.default.any,
    opened: _propTypes2.default.bool,
    /**
     * Content of the button group
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

SplitButton.defaultProps = {
    menu: null,
    opened: false,
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'split-button'
};

exports.default = SplitButton;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SplitButton = __webpack_require__(151);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SplitButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Action = __webpack_require__(36);

var _Action2 = _interopRequireDefault(_Action);

var _Icon = __webpack_require__(6);

var _Icon2 = _interopRequireDefault(_Icon);

__webpack_require__(4);

__webpack_require__(230);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var intentIconMap = {
    success: 'circle-check-mark-filled',
    info: 'circle-info-filled',
    warning: 'circle-exclamation-mark-filled',
    danger: 'circle-exclamation-mark-filled'
};

/**
 * `Status` component.
 */
var Status = function Status(_ref) {
    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        children = _ref.children,
        icon = _ref.icon,
        intent = _ref.intent,
        progress = _ref.progress,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'children', 'icon', 'intent', 'progress']);

    if (intent === 'inactive') {
        intent = 'muted';
    }

    return (0, _utils.createElement)(
        _Action2.default,
        _extends({
            component: 'span',
            icon: _Icon2.default.create(icon || intentIconMap[intent], {
                name: intentIconMap[intent]
            }),
            className: (0, _classnames2.default)(baseClassName, _defineProperty({}, baseClassName + '--' + intent, intent && !progress), className),
            progress: progress
        }, props),
        children
    );
};

Status.propTypes = {
    /**
     * Content of the `Status`.
     */
    children: _propTypes2.default.node,
    /**
     * Icon of the Status.
     */
    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.element]),
    /**
     * Visual intent color to apply to component.
     */
    intent: _propTypes2.default.oneOf(['danger', 'warning', 'success', 'info', 'muted']),
    /**
     * Right additional content.
     */
    rightAddon: _propTypes2.default.node,
    /**
     * Bottom additional content.
     */
    bottomAddon: _propTypes2.default.node,
    /**
     * Indicate the progress state of the `Status`.
     */
    progress: _propTypes2.default.bool,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

Status.defaultProps = {
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'status',
    icon: null,
    intent: null,
    rightAddon: null,
    bottomAddon: null,
    progress: null
};

exports.default = Status;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Status = __webpack_require__(153);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Status).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubnavItem = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

__webpack_require__(231);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `Subnav` component is used when you need a second level navigation under [Tabs](#!/Tabs) on the screen.
 */
var Subnav = function Subnav(_ref) {
  var baseClassName = _ref.baseClassName,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'children']);

  return (0, _utils.createElement)(
    'div',
    _extends({ className: (0, _classnames2.default)(baseClassName, className) }, props),
    children
  );
};

Subnav.propTypes = {
  /**
   * Subnav items
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  baseClassName: _propTypes2.default.string
};

Subnav.defaultProps = {
  children: null,
  className: null,
  baseClassName: _constants.CLS_PREFIX + 'subnav'
};

/**
 * SubnavItem component.
 */
var SubnavItem = function SubnavItem(_ref2) {
  var baseClassName = _ref2.baseClassName,
      className = _ref2.className,
      active = _ref2.active,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ['baseClassName', 'className', 'active', 'children']);

  return (0, _utils.cloneElement)(children, _extends({
    className: (0, _classnames2.default)(baseClassName, active && baseClassName + '--active', className)
  }, props));
};

SubnavItem.propTypes = {
  /**
   * Is item active.
   */
  active: _propTypes2.default.bool,
  /**
   * Content of the item
   */
  children: _propTypes2.default.element.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  baseClassName: _propTypes2.default.string
};

SubnavItem.defaultProps = {
  className: null,
  baseClassName: _constants.CLS_PREFIX + 'subnav__item'
};

exports.default = Subnav;
exports.SubnavItem = SubnavItem;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Subnav = __webpack_require__(155);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Subnav).default;
  }
});
Object.keys(_Subnav).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Subnav[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Tooltip = __webpack_require__(20);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

__webpack_require__(232);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `Switch` component.
 */
var Switch = function (_Component) {
    _inherits(Switch, _Component);

    function Switch() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Switch);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Switch.__proto__ || Object.getPrototypeOf(Switch)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (event) {
            var _this$props = _this.props,
                disabled = _this$props.disabled,
                onChange = _this$props.onChange;

            if (!disabled && onChange) {
                onChange(event.target.checked);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Switch, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                children = _props.children,
                onChange = _props.onChange,
                tooltip = _props.tooltip,
                intent = _props.intent,
                checked = _props.checked,
                defaultChecked = _props.defaultChecked,
                disabled = _props.disabled,
                loading = _props.loading,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'children', 'onChange', 'tooltip', 'intent', 'checked', 'defaultChecked', 'disabled', 'loading']);

            var result = (0, _utils.createElement)(
                'label',
                _extends({
                    className: (0, _classnames2.default)(baseClassName, (_classNames = {}, _defineProperty(_classNames, baseClassName + '--' + intent, intent), _defineProperty(_classNames, baseClassName + '--loading', loading), _classNames), className)
                }, props),
                children ? (0, _utils.createElement)(
                    'span',
                    { className: baseClassName + '__label' },
                    children
                ) : null,
                (0, _utils.createElement)('input', {
                    type: 'checkbox',
                    onChange: this.handleChange,
                    checked: checked,
                    defaultChecked: defaultChecked,
                    disabled: disabled || loading
                }),
                (0, _utils.createElement)('span', { className: baseClassName + '__indicator' })
            );

            if (tooltip) {
                result = (0, _utils.createElement)(
                    _Tooltip2.default,
                    { title: tooltip },
                    result
                );
            }

            return result;
        }
    }]);

    return Switch;
}(_utils.Component);

Switch.propTypes = {
    /**
     * Determine whether the `Switch` is checked.
     */
    checked: _propTypes2.default.bool,
    /**
     * @ignore
     */
    defaultChecked: _propTypes2.default.bool,
    /**
     * A callback function, can be executed when the checked state is changing.
     */
    onChange: _propTypes2.default.func,
    /**
     * Tooltip for component
     */
    tooltip: _propTypes2.default.any,
    /**
     * Visual intent color to apply to component.
     */
    intent: _propTypes2.default.oneOf(['warning', 'danger']),
    /**
     * Is `Switch` disabled?
     */
    disabled: _propTypes2.default.bool,
    /**
     * Loading indication
     */
    loading: _propTypes2.default.bool,
    /**
     * Label of the `Switch`
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

Switch.defaultProps = {
    checked: undefined,
    defaultChecked: undefined,
    onChange: undefined,
    tooltip: undefined,
    intent: undefined,
    disabled: false,
    loading: false,
    children: undefined,
    className: undefined,
    baseClassName: _constants.CLS_PREFIX + 'switch'
};

exports.default = Switch;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Switch = __webpack_require__(45);

var _Switch2 = _interopRequireDefault(_Switch);

var _Button = __webpack_require__(5);

var _Button2 = _interopRequireDefault(_Button);

var _IconButton = __webpack_require__(14);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Popover = __webpack_require__(32);

var _Popover2 = _interopRequireDefault(_Popover);

__webpack_require__(4);

__webpack_require__(233);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `SwitchesPanelItem` component.
 */
var SwitchesPanelItem = function (_Component) {
    _inherits(SwitchesPanelItem, _Component);

    function SwitchesPanelItem(props) {
        _classCallCheck(this, SwitchesPanelItem);

        var _this = _possibleConstructorReturn(this, (SwitchesPanelItem.__proto__ || Object.getPrototypeOf(SwitchesPanelItem)).call(this, props));

        _this.handleChange = function (checked) {
            _this.setState({ checked: checked });

            _this.props.onChange(checked);
        };

        _this.state = {
            checked: props.defaultChecked
        };
        return _this;
    }

    _createClass(SwitchesPanelItem, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                onChange = _props.onChange,
                defaultChecked = _props.defaultChecked,
                intent = _props.intent,
                title = _props.title,
                description = _props.description,
                fullDescription = _props.fullDescription,
                baseClassName = _props.baseClassName,
                className = _props.className,
                switchProps = _props.switchProps,
                children = _props.children,
                props = _objectWithoutProperties(_props, ['onChange', 'defaultChecked', 'intent', 'title', 'description', 'fullDescription', 'baseClassName', 'className', 'switchProps', 'children']);

            var checked = this.state.checked;


            return (0, _utils.createElement)(
                'div',
                _extends({
                    className: (0, _classnames2.default)(baseClassName, _defineProperty({}, baseClassName + '--' + intent, intent && checked), className)
                }, props),
                (0, _utils.createElement)(
                    'h5',
                    { className: baseClassName + '__title' },
                    title
                ),
                description && (0, _utils.createElement)(
                    'p',
                    { className: baseClassName + '__description' },
                    description
                ),
                (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__actions' },
                    (0, _utils.createElement)(_Switch2.default, _extends({
                        className: baseClassName + '__switch',
                        intent: intent,
                        onChange: this.handleChange,
                        defaultChecked: defaultChecked
                    }, switchProps)),
                    (fullDescription || children) && (0, _utils.createElement)(
                        'div',
                        { className: baseClassName + '__controls' },
                        children && _utils.Children.map(children, function (child) {
                            if (child.type === _Button2.default) {
                                return (0, _utils.cloneElement)(child, {
                                    className: (0, _classnames2.default)(child.props.className, baseClassName + '__controls-button')
                                });
                            }

                            return child;
                        }),
                        fullDescription && (0, _utils.createElement)(
                            _Popover2.default,
                            {
                                target: (0, _utils.createElement)(_IconButton2.default, {
                                    className: baseClassName + '__controls-button',
                                    icon: 'circle-question-mark'
                                }),
                                placement: 'bottom'
                            },
                            fullDescription
                        )
                    )
                )
            );
        }
    }]);

    return SwitchesPanelItem;
}(_utils.Component);

SwitchesPanelItem.propTypes = {
    /**
     * A callback function, can be executed when the checked state is changing.
     */
    onChange: _propTypes2.default.func.isRequired,
    /**
     * @ignore
     */
    defaultChecked: _propTypes2.default.bool,
    /**
     * Visual intent color to apply to component.
     */
    intent: _propTypes2.default.oneOf(['warning', 'danger']),
    /**
     * Title of the `SwitchesPanelItem`. Must be no longer than two lines.
     */
    title: _propTypes2.default.node.isRequired,
    /**
     * `SwitchesPanelItem` description. Must be no longer than three lines.
     */
    description: _propTypes2.default.node,
    /**
     * Rich full description of the `SwitchesPanelItem`.
     * Adds control button with question mark that shows `Popover` on click.
     */
    fullDescription: _propTypes2.default.node,
    /**
     * Props of underlying [Switch](#!/Switch) component.
     */
    switchProps: _propTypes2.default.object,
    /**
     * Content of the control actions.
     * Don't place here more than three buttons (with the one from 'fullDescription' property) or one link and one button.
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

SwitchesPanelItem.defaultProps = {
    defaultChecked: false,
    intent: null,
    description: null,
    fullDescription: null,
    switchProps: {},
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'switches-panel-item'
};

exports.default = SwitchesPanelItem;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SwitchesPanelItem = __webpack_require__(158);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SwitchesPanelItem).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Section = __webpack_require__(19);

var _Section2 = _interopRequireDefault(_Section);

__webpack_require__(4);

__webpack_require__(234);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `SwitchesPanel` component.
 * Used to organize [SwitchesPanelItem](#!/SwitchesPanelItem) components with responsive section layout.
 * Inherits properties of [Section](#!/Section) component.
 */
var SwitchesPanel = function SwitchesPanel(_ref) {
    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        children = _ref.children,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'children']);

    return (0, _utils.createElement)(
        _Section2.default,
        _extends({ className: (0, _classnames2.default)(baseClassName, className) }, props),
        (0, _utils.createElement)(
            'div',
            { className: baseClassName + '__items' },
            children && _utils.Children.map(children, function (child) {
                return (0, _utils.cloneElement)(child, {
                    className: (0, _classnames2.default)(child.props.className, baseClassName + '__item')
                });
            })
        )
    );
};

SwitchesPanel.propTypes = {
    /**
     * Content of the `SwitchesPanel`. Recommended to use [SwitchesPanelItem](#!/SwitchesPanelItem) components.
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

SwitchesPanel.defaultProps = {
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'switches-panel'
};

exports.default = SwitchesPanel;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SwitchesPanel = __webpack_require__(160);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SwitchesPanel).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _ButtonGroup = __webpack_require__(15);

var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);

var _Input = __webpack_require__(18);

var _Input2 = _interopRequireDefault(_Input);

var _Button = __webpack_require__(5);

var _Button2 = _interopRequireDefault(_Button);

var _IconButton = __webpack_require__(14);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Menu = __webpack_require__(16);

var _Menu2 = _interopRequireDefault(_Menu);

__webpack_require__(235);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * SearchBar component.
 */
var SearchBar = function (_Component) {
    _inherits(SearchBar, _Component);

    function SearchBar() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchBar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            focused: false,
            overMenu: false,
            value: '',
            highlightedValue: null
        }, _this.keyboardNavigation = function (key) {
            var _this$props = _this.props,
                onItemSelect = _this$props.onItemSelect,
                results = _this$props.results;

            var highlightedValue = _this.getHighlightedValue();

            if (!results || !onItemSelect) {
                return;
            }

            var res = _this.getResults();
            var currentIndex = res.indexOf(highlightedValue);
            var nextIndex = void 0;

            if (key === 'ArrowUp') {
                nextIndex = Math.max(currentIndex - 1, 0);
            } else if (key === 'ArrowDown') {
                nextIndex = Math.min(currentIndex + 1, res.length - 1);
            }

            _this.setState({ highlightedValue: currentIndex === -1 ? null : res[nextIndex] });
        }, _this.handleFocus = function () {
            _this.setState({ focused: true });
            _this.search && _this.search.focus();
        }, _this.handleBlur = function () {
            _this.setState({ focused: false });
            _this.search && _this.search.blur();
        }, _this.handleMenuMouseOver = function () {
            _this.setState({ overMenu: true });
        }, _this.handleMenuMouseOut = function () {
            _this.setState({ overMenu: false });
        }, _this.handleKeyDown = function (e) {
            var onTyping = _this.props.onTyping;
            var value = e.target.value;


            if (['Enter', 'Escape', 'ArrowUp', 'ArrowDown'].indexOf(e.key) !== -1) {
                _this.checkKeys(e.key);
                return;
            }

            _this.setState({ value: value });

            if (onTyping) {
                onTyping(value, function () {
                    return _this.clearInput();
                });
            }
        }, _this.handleSearch = function () {
            var _this$props2 = _this.props,
                onSearch = _this$props2.onSearch,
                onTyping = _this$props2.onTyping;
            var value = _this.state.value;


            if (onSearch) {
                onSearch(value, function () {
                    return _this.clearInput();
                });
            } else if (onTyping) {
                onTyping(value, function () {
                    return _this.clearInput();
                });
            }
        }, _this.handleReset = function () {
            _this.clearInput();
            _this.handleFocus();
        }, _this.handleSelect = function (value) {
            return function () {
                var onItemSelect = _this.props.onItemSelect;

                _this.setState({ highlightedValue: null });
                _this.handleBlur();

                if (onItemSelect) {
                    onItemSelect(value, function () {
                        return _this.clearInput();
                    });
                } else {
                    _this.clearInput();
                }
            };
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SearchBar, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps() {
            this.setState({ highlightedValue: null });
        }
    }, {
        key: 'isResponsive',
        value: function isResponsive() {
            return this.props.responsive === null ? this.context.responsiveTabs || false : this.props.responsive;
        }
    }, {
        key: 'getResults',
        value: function getResults() {
            var innerResults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var results = this.props.results;


            if (!results) {
                return [];
            }

            if (results.type === _Menu2.default || innerResults) {
                var res = [];
                var children = innerResults || results.props.children;
                for (var i = 0; i < children.length; i++) {
                    var child = children[i];

                    if (!child) {
                        continue;
                    }

                    if (child instanceof Array) {
                        res = res.concat(this.getResults(child));
                    } else if (child.type === _Menu.MenuItem || child.type === _Menu.MenuSelectableItem) {
                        res.push(child.key);
                    }
                }

                return res;
            }

            return results.map(function (item) {
                return item.value;
            });
        }
    }, {
        key: 'getHighlightedValue',
        value: function getHighlightedValue() {
            return this.state.highlightedValue || this.getResults()[0];
        }
    }, {
        key: 'searchAction',
        value: function searchAction() {
            var _props = this.props,
                onItemSelect = _props.onItemSelect,
                results = _props.results;

            var highlightedValue = this.getHighlightedValue();

            if (onItemSelect && results) {
                var res = this.getResults();
                var currentIndex = res.indexOf(highlightedValue);

                if (currentIndex === -1) {
                    this.handleSearch();
                } else {
                    this.handleSelect(highlightedValue)();
                }
            } else {
                this.handleSearch();
            }
        }
    }, {
        key: 'checkKeys',
        value: function checkKeys(key) {
            if (key === 'Enter') {
                this.searchAction();
            } else if (key === 'Escape') {
                if (this.state.value) {
                    this.handleReset();
                } else {
                    this.handleBlur();
                    this.handleMenuMouseOut();
                }
            } else if (key === 'ArrowUp' || key === 'ArrowDown') {
                this.keyboardNavigation(key);
            }
        }
    }, {
        key: 'clearInput',
        value: function clearInput() {
            this.setState({ value: '' }, this.handleSearch);
        }
    }, {
        key: 'elementsIndexToKeyMapping',
        value: function elementsIndexToKeyMapping(elements) {
            var result = [];
            for (var i = 0; i < elements.length; i++) {
                var element = elements[i];

                if (!element) {
                    continue;
                }

                if (element instanceof Array) {
                    result = result.concat(this.elementsIndexToKeyMapping(element));
                } else {
                    result.push(element.key);
                }
            }

            return result;
        }
    }, {
        key: 'renderResults',
        value: function renderResults() {
            var _this2 = this;

            var _props2 = this.props,
                baseClassName = _props2.baseClassName,
                results = _props2.results;
            var _state = this.state,
                focused = _state.focused,
                overMenu = _state.overMenu;

            var highlightedValue = this.getHighlightedValue();

            if (!results || results.length === 0) {
                return null;
            }

            return (0, _utils.createElement)(
                _Menu2.default,
                {
                    className: (0, _classnames2.default)(baseClassName + '__results', _defineProperty({}, baseClassName + '__results--hidden', !focused && !overMenu)),
                    onMouseOver: this.handleMenuMouseOver,
                    onMouseOut: this.handleMenuMouseOut
                },
                results.map(function (item) {
                    return (0, _utils.createElement)(
                        _Menu.MenuItem,
                        {
                            key: item.value,
                            active: item.value === highlightedValue,
                            onClick: _this2.handleSelect(item.value)
                        },
                        item.title
                    );
                })
            );
        }
    }, {
        key: 'renderResultsMenu',
        value: function renderResultsMenu() {
            var _this3 = this;

            var _props3 = this.props,
                baseClassName = _props3.baseClassName,
                results = _props3.results,
                onItemSelect = _props3.onItemSelect;
            var _state2 = this.state,
                focused = _state2.focused,
                overMenu = _state2.overMenu;

            var highlightedValue = this.getHighlightedValue();

            if (!results) {
                return null;
            }

            return (0, _utils.cloneElement)(results, {
                className: (0, _classnames2.default)(baseClassName + '__results', _defineProperty({}, baseClassName + '__results--hidden', !focused && !overMenu), results.className),
                onMouseOver: this.handleMenuMouseOver,
                onMouseOut: this.handleMenuMouseOut,
                onItemClick: function onItemClick(item, index) {
                    var indexMap = _this3.elementsIndexToKeyMapping(results.props.children);
                    _this3.handleSelect(indexMap[index])();
                },
                children: _utils.Children.map(results.props.children, function (child) {
                    if (onItemSelect && child && (child.type === _Menu.MenuItem || child.type === _Menu.MenuSelectableItem)) {
                        return (0, _utils.cloneElement)(child, { active: child.key === highlightedValue });
                    }

                    return child;
                })
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props4 = this.props,
                baseClassName = _props4.baseClassName,
                className = _props4.className,
                maxWidth = _props4.maxWidth,
                minWidth = _props4.minWidth,
                leftAddon = _props4.leftAddon,
                loading = _props4.loading,
                responsive = _props4.responsive,
                onSearch = _props4.onSearch,
                onTyping = _props4.onTyping,
                onItemSelect = _props4.onItemSelect,
                results = _props4.results,
                inputProps = _props4.inputProps,
                props = _objectWithoutProperties(_props4, ['baseClassName', 'className', 'maxWidth', 'minWidth', 'leftAddon', 'loading', 'responsive', 'onSearch', 'onTyping', 'onItemSelect', 'results', 'inputProps']);

            var _state3 = this.state,
                focused = _state3.focused,
                value = _state3.value;

            var isCollapsed = this.isResponsive();

            return (0, _utils.createElement)(
                'div',
                _extends({
                    className: (0, _classnames2.default)(baseClassName, _defineProperty({}, baseClassName + '--focused', focused), className),
                    style: isCollapsed ? null : { maxWidth: maxWidth, minWidth: minWidth }
                }, props),
                (0, _utils.createElement)(
                    _ButtonGroup2.default,
                    { className: baseClassName + '__group' },
                    leftAddon,
                    !isCollapsed && (0, _utils.createElement)(
                        _utils.Fragment,
                        null,
                        (0, _utils.createElement)(_Input2.default, _extends({
                            innerRef: function innerRef(ref) {
                                return _this4.search = ref;
                            },
                            className: baseClassName + '__input',
                            size: 'fill',
                            value: value,
                            onChange: this.handleKeyDown,
                            onFocus: this.handleFocus,
                            onBlur: this.handleBlur,
                            onKeyDown: this.handleKeyDown
                        }, inputProps)),
                        value && (0, _utils.createElement)(_IconButton2.default, {
                            className: baseClassName + '__reset-button',
                            icon: 'remove',
                            onClick: this.handleReset
                        })
                    ),
                    (0, _utils.createElement)(_Button2.default, {
                        className: baseClassName + '__search-button',
                        intent: focused ? 'primary' : null,
                        icon: 'search',
                        onClick: this.handleSearch,
                        state: loading ? 'loading' : null
                    })
                ),
                results && results.type === _Menu2.default ? this.renderResultsMenu() : this.renderResults()
            );
        }
    }]);

    return SearchBar;
}(_utils.Component);

SearchBar.propTypes = {
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string,
    /**
     * Maximum width of SearchBar
     */
    maxWidth: _propTypes2.default.number,
    /**
     * Minimum width of SearchBar
     */
    minWidth: _propTypes2.default.number,
    /**
     * Addon in the left side or SearchBar.
     */
    leftAddon: _propTypes2.default.element,
    /**
     * Should disable input and show spinner or not.
     */
    loading: _propTypes2.default.bool,
    /**
     * Should collapse input or not. Used for control in independence of context.
     */
    responsive: _propTypes2.default.bool,
    /**
     * Callback for pressing 'Enter' key or 'Search' button.
     *
     * arguments:
     * * value - search value
     * * clearHandler - function that clears input value
     */
    onSearch: _propTypes2.default.func,
    /**
     * Callback for pressing any key in input. Used for a live search.
     *
     * arguments:
     * * value - search value
     * * clearHandler - function that clears input value
     */
    onTyping: _propTypes2.default.func,
    /**
     * Callback for selecting menu item with mouse click or key pressing.
     *
     * arguments:
     * * value - selected value
     * * clearHandler - function that clears input value
     */
    onItemSelect: _propTypes2.default.func,
    /**
     * Results to display.
     * Could be specified by array of objects with "value" and "title" properties or by Menu component.
     * If Menu component is used then key property of MenuItem will be treated as value.
     */
    results: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.string.isRequired,
        title: _propTypes2.default.string.isRequired
    })), _propTypes2.default.element]),
    /**
     * Props of underlying input element.
     */
    inputProps: _propTypes2.default.object
};

SearchBar.defaultProps = {
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'search-bar',
    maxWidth: 500,
    minWidth: 270,
    leftAddon: null,
    loading: false,
    responsive: null,
    onSearch: null,
    onTyping: null,
    onItemSelect: null,
    results: null,
    inputProps: {}
};

SearchBar.contextTypes = {
    responsiveTabs: _propTypes2.default.bool
};

exports.default = SearchBar;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactMeasure = __webpack_require__(8);

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _constants = __webpack_require__(2);

var _Icon = __webpack_require__(6);

var _Icon2 = _interopRequireDefault(_Icon);

var _Label = __webpack_require__(27);

var _Label2 = _interopRequireDefault(_Label);

var _Button = __webpack_require__(5);

var _Button2 = _interopRequireDefault(_Button);

var _Dropdown = __webpack_require__(12);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _Menu = __webpack_require__(16);

var _Menu2 = _interopRequireDefault(_Menu);

var _Tab = __webpack_require__(46);

var _Tab2 = _interopRequireDefault(_Tab);

__webpack_require__(4);

__webpack_require__(236);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var ADDON_LEFT_PADDING = 5;
var MIN_ADDON_WIDTH_DEFAULT = 150;
var COLLAPSED_SEARCH_WIDTH = 60;

/**
 * `Tabs` component is a content area with a group of individual [Tab](#!/Tab) elements, each displaying different content
 * in the same screen area. `Tabs` are used when you have too much content to display in one place at the same time, so
 * the content is broken into logical groups and each group is displayed under its own [Tab](#!/Tab) that serves both as a
 * group name and a navigation button.
 */

var Tabs = function (_Component) {
    _inherits(Tabs, _Component);

    function Tabs(props) {
        _classCallCheck(this, Tabs);

        var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));

        _this.checkAdaptive = function () {
            var _this$state = _this.state,
                compact = _this$state.compact,
                searching = _this$state.searching,
                collapsedLength = _this$state.collapsedLength;
            var _this$props = _this.props,
                addonMinWidthProp = _this$props.addonMinWidth,
                search = _this$props.search,
                monospaced = _this$props.monospaced;
            var widths = _this.widths,
                addon = _this.addon;

            var monospacedWidth = null;

            if (!widths) {
                return;
            }

            var addonMinWidth = ADDON_LEFT_PADDING + (addonMinWidthProp || (search ? search.props.minWidth : MIN_ADDON_WIDTH_DEFAULT));
            var searchWidth = compact && search ? COLLAPSED_SEARCH_WIDTH + ADDON_LEFT_PADDING : 0;
            var more = widths.more,
                container = widths.container,
                margin = widths.margin;

            var tabs = widths.tabs.slice();
            var tabsNumber = tabs.length;
            var lastTabIndex = tabsNumber - 1 - collapsedLength;

            if (monospaced) {
                monospacedWidth = tabs.slice(0, lastTabIndex + 1).reduce(function (max, tab) {
                    return tab > max ? tab : max;
                }, 0);
                tabs = Array(tabsNumber).fill(monospacedWidth);
            }

            var getListWidth = function getListWidth() {
                var listWidth = margin * Math.max(0, tabsNumber - 1 - Math.max(0, collapsedLength - 1));
                for (var i = 0; i <= lastTabIndex; ++i) {
                    listWidth += tabs[i];
                }
                if (collapsedLength) {
                    listWidth += more;
                }

                return listWidth;
            };

            var spaceForAddon = container - getListWidth();
            if (addon && !collapsedLength && !compact && spaceForAddon <= addonMinWidth) {
                compact = true;
            }

            var freeSpace = spaceForAddon - searchWidth;

            if (freeSpace <= 0) {
                // collapse
                for (var i = lastTabIndex; i >= 0; --i) {
                    var width = tabs[i];

                    if (monospaced && widths.tabs[i] === monospacedWidth) {
                        monospacedWidth = widths.tabs.slice(0, lastTabIndex).reduce(function (max, tab) {
                            return tab > max ? tab : max;
                        }, 0);
                        tabs = Array(tabsNumber).fill(monospacedWidth);
                        width += (widths.tabs[i] - monospacedWidth) * lastTabIndex;
                    }

                    if (collapsedLength === 0) {
                        width -= more;
                    }

                    freeSpace += width;
                    ++collapsedLength;
                    --lastTabIndex;

                    if (freeSpace > 0) {
                        break;
                    }
                }
            } else {
                // expand
                for (var _i = lastTabIndex + 1; _i < tabsNumber; ++_i) {
                    var _width = tabs[_i];

                    if (monospaced && widths.tabs[_i] > monospacedWidth) {
                        monospacedWidth = widths.tabs[_i];
                        tabs = Array(tabsNumber).fill(monospacedWidth);
                        _width = monospacedWidth + (monospacedWidth - _width) * (lastTabIndex + 1);
                    }

                    if (collapsedLength === 1) {
                        _width -= more;
                    }

                    if (freeSpace <= _width) {
                        break;
                    }

                    freeSpace -= _width;
                    --collapsedLength;
                    ++lastTabIndex;
                }
            }

            if (collapsedLength || compact) {
                spaceForAddon = container - getListWidth();
                if (collapsedLength) {
                    compact = true;
                } else if (spaceForAddon >= addonMinWidth) {
                    compact = false;
                    searching = false;
                }
            }

            var newState = { compact: compact, searching: searching, collapsedLength: collapsedLength, monospacedWidth: monospacedWidth };

            var keys = Object.keys(newState);
            for (var _i2 = 0; _i2 < keys.length; _i2++) {
                var key = keys[_i2];
                if (JSON.stringify(newState[key]) === JSON.stringify(_this.state[key])) {
                    delete newState[key];
                }
            }

            if (Object.keys(newState).length) {
                _this.setState(newState, function () {
                    if (typeof newState.collapsedLength !== 'undefined' && _this.state.collapsedLength !== newState.collapsedLength) {
                        _this.checkAdaptive();
                    }
                });
            }
        };

        _this.handleStartSearching = function () {
            _this.setState({ searching: true });
        };

        _this.handleCancelSearching = function () {
            _this.setState({ searching: false }, _this.checkAdaptive);
        };

        _this.handleResize = function () {
            var baseClassName = _this.props.baseClassName;


            if (_this.tabsnavRef) {
                var tabElements = _this.tabsnavRef.querySelectorAll('.' + baseClassName + '__tab-list--fake .' + baseClassName + '__tab');
                var more = tabElements[tabElements.length - 1];
                var tabs = Array.prototype.slice.call(tabElements, 0, -1).map(function (el) {
                    return el.offsetWidth;
                });
                _this.widths = {
                    tabs: tabs,
                    more: more.offsetWidth,
                    container: _this.tabsnavRef.offsetWidth,
                    margin: more.offsetWidth - more.querySelector('.' + baseClassName + '__link').offsetWidth
                };
            }

            _this.checkAdaptive();
        };

        _this.handleAddonResize = function (contentRect) {
            _this.addon = contentRect.bounds;
            _this.checkAdaptive();
        };

        _this.state = {
            active: _this.props.active,
            collapsedLength: 0,
            compact: false,
            searching: false,
            monospacedWidth: null
        };
        _this.widths = null;
        return _this;
    }

    _createClass(Tabs, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                responsiveTabs: this.state.compact
            };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.isRtl = (0, _utils.isRtl)();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (nextProps.active !== this.state.active) {
                this.setState({
                    active: nextProps.active
                });
            }

            if (!this.widths || nextProps.children.length !== this.widths.tabs.length) {
                setTimeout(function () {
                    return _this2.handleResize();
                }, 0);
            }
        }
    }, {
        key: 'onClick',
        value: function onClick(active) {
            this.setState({ active: active });
            var tab = this.props.children[active - 1];
            var onActivate = tab.props.onActivate;

            if (onActivate) {
                onActivate();
            }
        }
    }, {
        key: 'renderTabLabel',
        value: function renderTabLabel(tabMode, label) {
            var baseClassName = this.props.baseClassName;

            if (typeof label === 'string') {
                return (0, _utils.createElement)(
                    _Label2.default,
                    { className: baseClassName + '__' + tabMode + '-label', intent: 'danger' },
                    label
                );
            }
            if ((0, _utils.isValidElement)(label)) {
                return (0, _utils.cloneElement)(label, {
                    className: (0, _classnames2.default)(baseClassName + '__' + tabMode + '-label', label.props.className)
                });
            }
            return null;
        }
    }, {
        key: 'renderTabClose',
        value: function renderTabClose(tabMode, onClose) {
            var baseClassName = this.props.baseClassName;

            if (typeof onClose === 'function') {
                return (0, _utils.createElement)(
                    'button',
                    { className: baseClassName + '__' + tabMode + '-close', type: 'button', onClick: onClose },
                    (0, _utils.createElement)(_Icon2.default, { className: baseClassName + '__' + tabMode + '-close-icon', name: 'cross-mark' })
                );
            }
            return null;
        }
    }, {
        key: 'renderFakeTabs',
        value: function renderFakeTabs() {
            var _this3 = this;

            var _props = this.props,
                baseClassName = _props.baseClassName,
                children = _props.children;


            var childrenCount = _utils.Children.count(children);
            if (!childrenCount) {
                return null;
            }

            return (0, _utils.createElement)(
                'ul',
                {
                    className: (0, _classnames2.default)(baseClassName + '__tab-list', baseClassName + '__tab-list--fake')
                },
                _utils.Children.map(children, function (tab) {
                    if (!tab || tab.type !== _Tab2.default) {
                        return null;
                    }

                    var _tab$props = tab.props,
                        title = _tab$props.title,
                        label = _tab$props.label,
                        icon = _tab$props.icon,
                        onActivate = _tab$props.onActivate,
                        onClose = _tab$props.onClose,
                        tabProps = _objectWithoutProperties(_tab$props, ['title', 'label', 'icon', 'onActivate', 'onClose']);

                    var iconBlock = _Icon2.default.create(icon, {
                        size: _Icon.ICON_SIZE_16,
                        className: baseClassName + '__tab-icon'
                    });

                    var closeBlock = _this3.renderTabClose('tab', onClose);

                    return (0, _utils.createElement)(
                        'li',
                        {
                            key: title,
                            className: (0, _classnames2.default)(baseClassName + '__tab', closeBlock && baseClassName + '__tab--closable')
                        },
                        (0, _utils.createElement)(
                            'a',
                            {
                                className: baseClassName + '__link',
                                tabIndex: '-1',
                                style: tabProps.style
                            },
                            iconBlock,
                            (0, _utils.createElement)(
                                'span',
                                { className: baseClassName + '__tab-title' },
                                title
                            ),
                            _this3.renderTabLabel('tab', label)
                        ),
                        closeBlock
                    );
                }),
                (0, _utils.createElement)(
                    'li',
                    {
                        className: (0, _classnames2.default)(baseClassName + '__tab', baseClassName + '__tab--more')
                    },
                    (0, _utils.createElement)(
                        'a',
                        {
                            className: baseClassName + '__link',
                            tabIndex: '-1'
                        },
                        (0, _utils.createElement)(_Icon2.default, { name: 'three-dots-horizontal' })
                    )
                )
            );
        }
    }, {
        key: 'renderTablist',
        value: function renderTablist() {
            var _this4 = this;

            var _props2 = this.props,
                baseClassName = _props2.baseClassName,
                children = _props2.children;
            var _state = this.state,
                collapsedLength = _state.collapsedLength,
                monospacedWidth = _state.monospacedWidth;

            var moreTabs = null;
            var moreSelected = false;

            var childrenCount = _utils.Children.count(children);
            if (!childrenCount) {
                return null;
            }
            var lastTabIndex = childrenCount - 1 - collapsedLength;

            return (0, _utils.createElement)(
                'ul',
                { className: baseClassName + '__tab-list', role: 'tablist' },
                _utils.Children.map(children, function (tab, index) {
                    if (!tab || tab.type !== _Tab2.default) {
                        return null;
                    }

                    var _tab$props2 = tab.props,
                        title = _tab$props2.title,
                        label = _tab$props2.label,
                        icon = _tab$props2.icon,
                        onActivate = _tab$props2.onActivate,
                        onClose = _tab$props2.onClose,
                        tabProps = _objectWithoutProperties(_tab$props2, ['title', 'label', 'icon', 'onActivate', 'onClose']);

                    var selected = index + 1 === _this4.state.active;
                    var iconBlock = _Icon2.default.create(icon, {
                        size: _Icon.ICON_SIZE_16,
                        className: baseClassName + '__tab-icon'
                    });

                    if (index > lastTabIndex) {
                        if (selected) {
                            moreSelected = true;
                        }

                        moreTabs = moreTabs || [];
                        moreTabs.push((0, _utils.createElement)(
                            _Menu.MenuItem,
                            {
                                key: moreTabs.length,
                                icon: iconBlock,
                                label: (0, _utils.createElement)(
                                    _utils.Fragment,
                                    null,
                                    _this4.renderTabLabel('menu-item', label),
                                    _this4.renderTabClose('menu-item', onClose)
                                ),
                                active: selected,
                                onClick: function onClick() {
                                    return _this4.onClick(index + 1);
                                }
                            },
                            title
                        ));

                        return null;
                    }

                    var closeBlock = _this4.renderTabClose('tab', onClose);

                    return (0, _utils.createElement)(
                        'li',
                        {
                            key: title,
                            className: (0, _classnames2.default)(baseClassName + '__tab', selected && baseClassName + '__tab--selected', closeBlock && baseClassName + '__tab--closable'),
                            role: 'presentation'
                        },
                        (0, _utils.createElement)(
                            'a',
                            _extends({
                                className: baseClassName + '__link',
                                onClick: function onClick() {
                                    return _this4.onClick(index + 1);
                                },
                                role: 'tab',
                                tabIndex: '0',
                                'aria-selected': selected || null,
                                style: { width: monospacedWidth }
                            }, tabProps),
                            iconBlock,
                            (0, _utils.createElement)(
                                'span',
                                { className: baseClassName + '__tab-title' },
                                title
                            ),
                            _this4.renderTabLabel('tab', label)
                        ),
                        closeBlock
                    );
                }),
                moreTabs && (0, _utils.createElement)(
                    'li',
                    {
                        ref: function ref(_ref) {
                            return _this4.moreTabsRef = _ref;
                        },
                        className: (0, _classnames2.default)(baseClassName + '__tab', moreSelected && baseClassName + '__tab--selected', baseClassName + '__tab--more'),
                        role: 'presentation',
                        'aria-selected': moreSelected || null
                    },
                    (0, _utils.createElement)(
                        _Dropdown2.default,
                        { className: baseClassName + '__dropdown', menu: (0, _utils.createElement)(
                                _Menu2.default,
                                null,
                                moreTabs
                            ), menuPlacement: 'bottom-end' },
                        (0, _utils.createElement)(
                            'a',
                            {
                                className: baseClassName + '__link',
                                role: 'tab',
                                tabIndex: '0',
                                'aria-selected': moreSelected || null
                            },
                            (0, _utils.createElement)(_Icon2.default, { name: 'three-dots-horizontal' })
                        )
                    )
                )
            );
        }
    }, {
        key: 'getSearchCompactProps',
        value: function getSearchCompactProps(searchProps) {
            var searching = this.state.searching;


            if (searching) {
                searchProps.maxWidth = null;
                searchProps.minWidth = null;
                searchProps.autoFocus = true;
                searchProps.responsive = false;
                searchProps.leftAddon = (0, _utils.createElement)(_Button2.default, {
                    icon: { name: 'chevron-right', flipHorizontal: this.isRtl },
                    onClick: this.handleCancelSearching
                });
            } else {
                searchProps.leftAddon = (0, _utils.createElement)(_Button2.default, {
                    icon: { name: 'chevron-left', flipHorizontal: this.isRtl },
                    onClick: this.handleStartSearching
                });
                searchProps.onSearch = this.handleStartSearching;
            }

            return searchProps;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var _props3 = this.props,
                baseClassName = _props3.baseClassName,
                className = _props3.className,
                addon = _props3.addon,
                placeholder = _props3.placeholder,
                children = _props3.children,
                active = _props3.active,
                addonMinWidth = _props3.addonMinWidth,
                monospaced = _props3.monospaced,
                search = _props3.search,
                props = _objectWithoutProperties(_props3, ['baseClassName', 'className', 'addon', 'placeholder', 'children', 'active', 'addonMinWidth', 'monospaced', 'search']);

            var _state2 = this.state,
                compact = _state2.compact,
                searching = _state2.searching;


            var childrenCount = _utils.Children.count(children);
            if (!childrenCount) {
                return null;
            }

            var addonBlock = addon || placeholder;
            var addonProps = {};
            var searchBlock = null;
            if (search) {
                var searchProps = {
                    className: (0, _classnames2.default)(baseClassName + '__search', search.props.className)
                };

                if (compact) {
                    searchBlock = (0, _utils.cloneElement)(search, this.getSearchCompactProps(searchProps));
                } else if (addonBlock) {
                    searchProps.key = 1;
                    addonBlock = [(0, _utils.cloneElement)(search, searchProps), (0, _utils.cloneElement)(addonBlock, { key: 2 })];
                } else {
                    addonProps.style = { maxWidth: search.props.maxWidth };
                    addonBlock = (0, _utils.cloneElement)(search, searchProps);
                }
            }

            return (0, _utils.createElement)(
                'div',
                _extends({ className: (0, _classnames2.default)(baseClassName, className) }, props),
                (0, _utils.createElement)(
                    _reactMeasure2.default,
                    { onResize: this.handleResize, innerRef: function innerRef(ref) {
                            return _this5.tabsnavRef = ref;
                        } },
                    function (_ref2) {
                        var measureRef = _ref2.measureRef;
                        return (0, _utils.createElement)(
                            'div',
                            {
                                className: (0, _classnames2.default)(baseClassName + '__nav', compact && baseClassName + '__nav--compact', searching && baseClassName + '__nav--searching'),
                                ref: measureRef
                            },
                            _this5.renderTablist(),
                            (0, _utils.createElement)(
                                _reactMeasure2.default,
                                { onResize: _this5.handleResize },
                                function (_ref3) {
                                    var ref = _ref3.measureRef;
                                    return (0, _utils.cloneElement)(_this5.renderFakeTabs(), { ref: ref });
                                }
                            ),
                            searchBlock,
                            addonBlock && (0, _utils.createElement)(
                                _reactMeasure2.default,
                                { onResize: _this5.handleAddonResize, bounds: true },
                                function (_ref4) {
                                    var ref = _ref4.measureRef;
                                    return (0, _utils.createElement)(
                                        'div',
                                        _extends({ className: baseClassName + '__addon', ref: ref }, addonProps),
                                        addonBlock
                                    );
                                }
                            )
                        );
                    }
                ),
                (0, _utils.createElement)(
                    'div',
                    { className: baseClassName + '__tab-panel', role: 'tabpanel' },
                    _utils.Children.map(children, function (tab, index) {
                        return index + 1 === _this5.state.active ? tab : null;
                    })
                )
            );
        }
    }]);

    return Tabs;
}(_utils.Component);

Tabs.propTypes = {
    /**
     * Number of active tab
     */
    active: _propTypes2.default.number,
    /**
     * Addon for search bar, dropdown etc.
     */
    addon: _propTypes2.default.element,
    /**
     * Placeholder for search bar, dropdown etc.
     *
     * @deprecated Do not use! Use `addon` instead!
     */
    placeholder: _propTypes2.default.element,
    /**
     * Minimum add-on width in pixels
     */
    addonMinWidth: _propTypes2.default.number,
    /**
     * Monospaced version of tabs (all visible tabs as wide as widest of them)
     */
    monospaced: _propTypes2.default.bool,
    /**
     * [SearchBar](#!/SearchBar) element
     */
    search: _propTypes2.default.element,
    /**
     * [Tabs](#!/Tab)
     */
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.element), _propTypes2.default.element]),
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

Tabs.defaultProps = {
    active: 1,
    addon: null,
    placeholder: null,
    addonMinWidth: null,
    monospaced: null,
    search: null,
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'tabs'
};

Tabs.childContextTypes = {
    responsiveTabs: _propTypes2.default.bool
};

exports.default = Tabs;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tabs = __webpack_require__(163);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tabs).default;
  }
});

var _Tab = __webpack_require__(46);

Object.defineProperty(exports, 'Tab', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tab).default;
  }
});

var _SearchBar = __webpack_require__(162);

Object.defineProperty(exports, 'SearchBar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SearchBar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

__webpack_require__(4);

__webpack_require__(237);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2018. Plesk International GmbH. All rights reserved.

/**
 * `Text` component is a basic building block for UI. It is used when you need to display inline text on the screen.
 */
var Text = function Text(_ref) {
    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        children = _ref.children,
        Tag = _ref.component,
        intent = _ref.intent,
        bold = _ref.bold,
        italic = _ref.italic,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'children', 'component', 'intent', 'bold', 'italic']);

    if (bold) {
        children = (0, _utils.createElement)(
            'b',
            null,
            children
        );
    }

    if (italic) {
        children = (0, _utils.createElement)(
            'i',
            null,
            children
        );
    }

    return (0, _utils.createElement)(
        Tag,
        _extends({
            className: (0, _classnames2.default)(baseClassName, _defineProperty({}, baseClassName + '--' + intent, intent), className)
        }, props),
        children
    );
};

Text.propTypes = {
    /**
     * Content of the `Text`.
     */
    children: _propTypes2.default.node,
    /**
     * Component to render as the root element.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    /**
     * Visual intent color to apply to component.
     */
    intent: _propTypes2.default.oneOf(['info', 'success', 'warning', 'danger', 'muted']),
    /**
     * Indicates that contents have strong importance.
     */
    bold: _propTypes2.default.bool,
    /**
     * Indicates that contents are set off from the normal text for some reason.
     */
    italic: _propTypes2.default.bool,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

Text.defaultProps = {
    children: null,
    component: 'span',
    intent: null,
    bold: false,
    italic: false,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'text'
};

exports.default = Text;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Text = __webpack_require__(165);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Text).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _icons;

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Icon = __webpack_require__(6);

var _Icon2 = _interopRequireDefault(_Icon);

__webpack_require__(238);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var INFO = 'info';
var SUCCESS = 'success';
var WARNING = 'warning';
var DANGER = 'danger';

var icons = (_icons = {}, _defineProperty(_icons, INFO, 'circle-info-filled'), _defineProperty(_icons, SUCCESS, 'circle-check-mark-filled'), _defineProperty(_icons, WARNING, 'circle-exclamation-mark-filled'), _defineProperty(_icons, DANGER, 'circle-exclamation-mark-filled'), _icons);

var Toast = function Toast(_ref) {
    var baseClassName = _ref.baseClassName,
        className = _ref.className,
        message = _ref.message,
        intent = _ref.intent,
        onClose = _ref.onClose,
        props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'message', 'intent', 'onClose']);

    return (0, _utils.createElement)(
        'div',
        _extends({ tabIndex: '0', className: (0, _classnames2.default)(baseClassName, baseClassName + '--' + intent, className) }, props),
        (0, _utils.createElement)(
            'span',
            { className: baseClassName + '__icon' },
            (0, _utils.createElement)(_Icon2.default, { name: icons[intent] })
        ),
        (0, _utils.createElement)(
            'span',
            { className: baseClassName + '__content' },
            message
        ),
        (0, _utils.createElement)(
            'span',
            { className: baseClassName + '__action' },
            (0, _utils.createElement)(
                'button',
                { className: baseClassName + '__close', type: 'button', onClick: onClose },
                (0, _utils.createElement)(_Icon2.default, { name: 'cross-mark', className: baseClassName + '__close-x' })
            )
        )
    );
};
Toast.propTypes = {
    /**
     * Visual intent color to apply to component.
     */
    intent: _propTypes2.default.oneOf(['info', 'success', 'warning', 'danger']).isRequired,
    message: _propTypes2.default.any,
    onClose: _propTypes2.default.func,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};
Toast.defaultProps = {
    message: null,
    onClose: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'toast'
};

exports.default = Toast;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Toast = __webpack_require__(167);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Toast).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _reactTransitionGroup = __webpack_require__(34);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Toast = __webpack_require__(168);

var _Toast2 = _interopRequireDefault(_Toast);

var _Layer = __webpack_require__(28);

var _Layer2 = _interopRequireDefault(_Layer);

__webpack_require__(239);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var toastId = 0;

/**
 * Toaster component.
 */

var Toaster = function (_Component) {
    _inherits(Toaster, _Component);

    function Toaster(props) {
        _classCallCheck(this, Toaster);

        var _this = _possibleConstructorReturn(this, (Toaster.__proto__ || Object.getPrototypeOf(Toaster)).call(this, props));

        _this.state = {
            toasts: (_this.props.toasts || []).map(function (toast) {
                return _extends({ key: 'toast-' + toastId++ }, toast);
            })
        };
        return _this;
    }

    /**
     * Add a new toast
     *
     * @param {Object} props Toast props { type, message }
     * @returns {string} New toast key
     * @public
     */


    _createClass(Toaster, [{
        key: 'add',
        value: function add(props) {
            var key = 'toast-' + toastId++;
            this.setState(function (_ref) {
                var toasts = _ref.toasts;
                return {
                    toasts: [_extends({}, props, { key: key })].concat(_toConsumableArray(toasts))
                };
            });
            return key;
        }

        /**
         * Update toast by key
         *
         * @param {string} key
         * @param {Object} props New props
         * @returns {string} Updated toast key
         * @public
         */

    }, {
        key: 'update',
        value: function update(key, props) {
            this.setState(function (_ref2) {
                var toasts = _ref2.toasts;
                return {
                    toasts: toasts.map(function (toast) {
                        return toast.key === key ? _extends({}, props, { key: key }) : toast;
                    })
                };
            });
            return key;
        }

        /**
         * Remove toast by key
         *
         * @param {string} key
         * @public
         */

    }, {
        key: 'remove',
        value: function remove(key) {
            this.setState(function (_ref3) {
                var toasts = _ref3.toasts;
                return {
                    toasts: toasts.filter(function (toast) {
                        return toast.key !== key;
                    })
                };
            });
        }

        /**
         * Clear all toasts
         *
         * @public
         */

    }, {
        key: 'clear',
        value: function clear() {
            this.setState({
                toasts: []
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                toasts = _props.toasts,
                position = _props.position,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'toasts', 'position']);

            return (0, _utils.createElement)(
                _Layer2.default,
                { level: _constants.Z_INDEX_TOASTER },
                (0, _utils.createElement)(
                    'div',
                    _extends({
                        className: (0, _classnames2.default)(baseClassName, _defineProperty({}, baseClassName + '--' + position, position), className)
                    }, props),
                    (0, _utils.createElement)(
                        _reactTransitionGroup.TransitionGroup,
                        { component: 'span' },
                        this.state.toasts.map(function (toastProps) {
                            return (0, _utils.createElement)(
                                _reactTransitionGroup.CSSTransition,
                                {
                                    key: toastProps.key,
                                    classNames: _Toast2.default.defaultProps.baseClassName + '-',
                                    timeout: {
                                        enter: 300,
                                        exit: 300
                                    }
                                },
                                (0, _utils.createElement)(_Toast2.default, _extends({}, toastProps, { onClose: function onClose() {
                                        return _this2.remove(toastProps.key);
                                    } }))
                            );
                        })
                    )
                )
            );
        }
    }]);

    return Toaster;
}(_utils.Component);

Toaster.create = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;

    var containerElement = document.createElement('div');
    container.appendChild(containerElement);

    return (0, _utils.render)((0, _utils.createElement)(Toaster, props), containerElement);
};

Toaster.propTypes = {
    /**
     * Toaster position
     */
    position: _propTypes2.default.oneOf(['top']),
    toasts: _propTypes2.default.array,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

Toaster.defaultProps = {
    position: 'top',
    toasts: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'toaster'
};

exports.default = Toaster;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Toaster = __webpack_require__(169);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Toaster).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactMeasure = __webpack_require__(8);

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _constants = __webpack_require__(2);

__webpack_require__(4);

__webpack_require__(240);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `Toolbar` component is a panel containing various instruments used for managing the contents of a large content block.
 * Toolbar is located on top of the managed content block.
 * It typically consists of three main parts: controls that add new elements, controls that work with existing elements,
 * and controls for changing the way the content block looks.
 */
var Toolbar = function (_Component) {
    _inherits(Toolbar, _Component);

    function Toolbar() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Toolbar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            responsive: false
        }, _this.minWidth = 0, _this.handleResize = function (_ref2) {
            var entry = _ref2.entry,
                scroll = _ref2.scroll;

            _this.minWidth = scroll.width > entry.width ? scroll.width : _this.minWidth;

            _this.setState({
                responsive: _this.minWidth > 0 && entry.width < _this.minWidth
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Toolbar, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                responsive: this.state.responsive
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                children = _props.children,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'children']);

            return (0, _utils.createElement)(
                _reactMeasure2.default,
                { onResize: this.handleResize, scroll: true },
                function (_ref3) {
                    var measureRef = _ref3.measureRef;
                    return (0, _utils.createElement)(
                        'div',
                        _extends({
                            ref: measureRef,
                            className: (0, _classnames2.default)(baseClassName, className)
                        }, props),
                        children
                    );
                }
            );
        }
    }]);

    return Toolbar;
}(_utils.Component);

Toolbar.propTypes = {
    /**
     * Content of the `Toolbar`.
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

Toolbar.defaultProps = {
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'toolbar'
};

Toolbar.childContextTypes = {
    responsive: _propTypes2.default.bool
};

exports.default = Toolbar;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `ToolbarExpander` is a part of the [Toolbar](#!/Toolbar) component. It is used to split all toolbar controls into two groups:
 * all controls before ToolbarExpander are  aligned left, and all controls after ToolbarExpander are aligned right.
 *
 * `ToolbarExpander` can also be used to create equal space between several control groups in a toolbar.
 */
var ToolbarExpander = function ToolbarExpander(_ref) {
  var baseClassName = _ref.baseClassName,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['baseClassName', 'className', 'children']);

  return (0, _utils.createElement)(
    'div',
    _extends({ className: (0, _classnames2.default)(baseClassName, className) }, props),
    children
  );
};

ToolbarExpander.propTypes = {
  /**
   * Content of the `ToolbarExpander`.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  baseClassName: _propTypes2.default.string
};

ToolbarExpander.defaultProps = {
  children: null,
  className: null,
  baseClassName: _constants.CLS_PREFIX + 'toolbar__expander'
};

exports.default = ToolbarExpander;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

var _Menu = __webpack_require__(16);

var _Menu2 = _interopRequireDefault(_Menu);

var _Dropdown = __webpack_require__(12);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _Button = __webpack_require__(5);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `ToolbarGroup` is a part of the [Toolbar](#!/Toolbar) component similar to [ButtonGroup](#buttongroup).
 * It is used for grouping several toolbar controls together.
 */
var ToolbarGroup = function (_Component) {
    _inherits(ToolbarGroup, _Component);

    function ToolbarGroup() {
        _classCallCheck(this, ToolbarGroup);

        return _possibleConstructorReturn(this, (ToolbarGroup.__proto__ || Object.getPrototypeOf(ToolbarGroup)).apply(this, arguments));
    }

    _createClass(ToolbarGroup, [{
        key: 'isResponsive',
        value: function isResponsive() {
            return this.context.responsive && _utils.Children.count(this.props.children) > 1;
        }
    }, {
        key: 'convertToMenu',
        value: function convertToMenu(child, isLast) {
            if (child.type === _Button2.default) {
                return (0, _utils.createElement)(
                    _Menu.MenuItem,
                    {
                        disabled: child.props.disabled,
                        icon: child.props.icon
                        // eslint-disable-next-line react/jsx-handler-names
                        , onClick: child.props.onClick
                    },
                    child.props.children
                );
            }

            if (child.type === _Dropdown2.default) {
                return [child.props.children ? (0, _utils.createElement)(
                    _Menu.MenuHeader,
                    null,
                    child.props.children
                ) : null, child.props.menu.props.children, isLast ? null : (0, _utils.createElement)(_Menu.MenuDivider, null)];
            }

            return (0, _utils.createElement)(
                _Menu.MenuBaseItem,
                null,
                child
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                children = _props.children,
                title = _props.title,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'children', 'title']);

            var childrenCount = _utils.Children.count(children);
            var isCollapsed = this.isResponsive();

            var childElement = _utils.Children.map(children, function (child, index) {
                if (!(0, _utils.isValidElement)(child)) {
                    return child;
                }

                if (isCollapsed) {
                    return _this2.convertToMenu(child, index === childrenCount - 1);
                }

                return (0, _utils.cloneElement)(child, {
                    className: (0, _classnames2.default)(baseClassName + '-item', child.props.className)
                });
            });

            if (isCollapsed) {
                childElement = (0, _utils.createElement)(
                    _Dropdown2.default,
                    { menu: (0, _utils.createElement)(
                            _Menu2.default,
                            null,
                            childElement
                        ) },
                    title
                );
            }

            return (0, _utils.createElement)(
                'div',
                _extends({ className: (0, _classnames2.default)(baseClassName, className) }, props),
                childElement
            );
        }
    }]);

    return ToolbarGroup;
}(_utils.Component);

ToolbarGroup.propTypes = {
    /**
     * Title.
     */
    title: _propTypes2.default.node.isRequired,
    /**
     * Content of the `ToolbarGroup`.
     */
    children: _propTypes2.default.node,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

ToolbarGroup.defaultProps = {
    children: null,
    className: null,
    baseClassName: _constants.CLS_PREFIX + 'toolbar__group'
};

ToolbarGroup.contextTypes = {
    responsive: _propTypes2.default.bool
};

exports.default = ToolbarGroup;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(22);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(2);

__webpack_require__(241);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * Tooltip component.
 */
var Tooltip = function (_Component) {
    _inherits(Tooltip, _Component);

    function Tooltip(props) {
        _classCallCheck(this, Tooltip);

        var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

        _this.handleShow = function () {
            if (_this.showTimer) {
                clearTimeout(_this.showTimer);
                _this.showTimer = null;
            }

            _this.node = document.createElement('div');
            document.body.appendChild(_this.node);

            (0, _reactDom.unstable_renderSubtreeIntoContainer)(_this, _this.renderTooltip(), _this.node);
        };

        _this.handleHide = function () {
            if (_this.showTimer) {
                clearTimeout(_this.showTimer);
                _this.showTimer = null;
            }
            if (_this.node) {
                (0, _reactDom.unmountComponentAtNode)(_this.node);
                document.body.removeChild(_this.node);
                _this.node = null;
            }
        };

        _this.handleMouseEnter = function () {
            if (_this.showTimer || _this.node) {
                return;
            }
            _this.showTimer = setTimeout(_this.handleShow, _this.props.delay);
        };

        _this.handleMouseMove = function (e) {
            var tooltipPosition = _this.getTooltipPosition(e);
            var tooltipOffset = _this.getTooltipOffset();

            _this.setState({
                left: tooltipPosition.x + tooltipOffset.x,
                top: tooltipPosition.y + tooltipOffset.y
            });
        };

        _this.handleMouseLeave = function () {
            _this.handleHide();
        };

        _this.state = {
            left: 0,
            top: 0
        };
        return _this;
    }

    _createClass(Tooltip, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.node) {
                (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, this.renderTooltip(), this.node);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.handleHide();
        }
    }, {
        key: 'getTooltipPosition',
        value: function getTooltipPosition(e) {
            var x = e.clientX + (window.scrollX || window.pageXOffset);
            var y = e.clientY + (window.scrollY || window.pageYOffset);

            return { x: x, y: y };
        }
    }, {
        key: 'getTooltipOffset',
        value: function getTooltipOffset() {
            var x = 5;
            var y = 13;

            return { x: x, y: y };
        }
    }, {
        key: 'renderTooltip',
        value: function renderTooltip() {
            var _props = this.props,
                baseClassName = _props.baseClassName,
                className = _props.className,
                children = _props.children,
                title = _props.title,
                style = _props.style,
                props = _objectWithoutProperties(_props, ['baseClassName', 'className', 'children', 'title', 'style']);

            var _state = this.state,
                left = _state.left,
                top = _state.top;


            return (0, _utils.createElement)(
                'span',
                _extends({
                    className: (0, _classnames2.default)(baseClassName, className),
                    style: _extends({}, style, { left: left + 'px', top: top + 'px' }),
                    role: 'tooltip'
                }, props),
                title
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return (0, _utils.cloneElement)(this.props.children, {
                onMouseEnter: this.handleMouseEnter,
                onMouseMove: this.handleMouseMove,
                onMouseLeave: this.handleMouseLeave
            });
        }
    }]);

    return Tooltip;
}(_utils.Component);

Tooltip.propTypes = {
    /**
     * Content of the tooltip
     */
    title: _propTypes2.default.node.isRequired,
    /**
     * Show delay (ms)
     */
    delay: _propTypes2.default.number,
    /**
     * Element with tooltip
     */
    children: _propTypes2.default.element.isRequired,
    /**
     * @ignore
     */
    style: _propTypes2.default.object,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * @ignore
     */
    baseClassName: _propTypes2.default.string
};

Tooltip.defaultProps = {
    delay: 550,
    style: undefined,
    className: undefined,
    baseClassName: _constants.CLS_PREFIX + 'tooltip'
};

exports.default = Tooltip;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LocaleProvider = __webpack_require__(41);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * `Translate` component.
 */
var Translate = function Translate(_ref, _ref2) {
    var locale = _ref2.locale;

    var Tag = _ref.component,
        content = _ref.content,
        children = _ref.children,
        params = _ref.params,
        unsafe = _ref.unsafe,
        _ref$fallback = _ref.fallback,
        fallback = _ref$fallback === undefined ? null : _ref$fallback,
        props = _objectWithoutProperties(_ref, ['component', 'content', 'children', 'params', 'unsafe', 'fallback']);

    var key = content || children;
    var message = locale && locale.lmsg(key, params, fallback);
    if (typeof message === 'undefined') {
        message = fallback === null ? '[' + key + ']' : (0, _LocaleProvider.applyParams)(fallback, params);
    }

    if (unsafe) {
        props.dangerouslySetInnerHTML = { __html: message };
    } else {
        props.children = message;
    }
    return (0, _utils.createElement)(Tag, props);
};

Translate.contextTypes = {
    locale: _propTypes2.default.object
};

Translate.propTypes = {
    /**
     * Translatable content or message key.
     */
    content: _propTypes2.default.string,
    /**
     * Message params
     */
    params: _propTypes2.default.object,
    /**
     * Fallback translation value.
     */
    fallback: _propTypes2.default.string,
    /**
     * Component to render as the root element. Useful when rendering a `Translate` as `<option>`.
     */
    component: _propTypes2.default.string,
    /**
     * @ignore
     */
    unsafe: _propTypes2.default.bool,
    /**
     * @ignore
     */
    children: _propTypes2.default.string
};

Translate.defaultProps = {
    content: null,
    params: null,
    component: 'span',
    unsafe: null,
    fallback: null,
    children: null
};

exports.default = Translate;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(177);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
}
module.exports = exports['default'];

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
};

/***/ }),
/* 179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(21);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(249);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(248);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/fail.png";

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/symbols.svg";

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports = {"customize-order":"arrows-four-directions","download":"arrow-down-tray","edit":"pencil","folder":"folder-closed","globe-alt":"globe","import":"arrow-down-in","invisible":"eye-closed","link":"chain","lock":"lock-closed","ok-circle":"circle-check-mark","question-circle":"circle-question-mark","security-scan":"shield","settings":"sliders","suspend":"sleep","unlock":"lock-open","upload":"arrow-up-tray","visible":"eye"}

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports = {"i-filter-02":"filter","i-filter-check-mark":"filter-check-mark","i-sliders":"sliders","i-two-sheets-blank":"copy","i-server-refresh":"backup","i-two-arrows-refresh-04":"refresh","i-circle-check-mark":"circle-check-mark","i-check-mark":"check-mark","i-three-dots":"three-dots-horizontal","tree-dots-horizontal":"three-dots-horizontal","i-square-arrow-up-04":"arrow-up-in","i-square-arrow-down-04":"arrow-down-in","i-shield-star":"shield","i-menu":"menu","i-folder-blank-closed-02":"folder-closed","i-arrow-refresh-02":"reload","i-eye-03":"eye-closed","i-www-site-picture-text":"site-page","i-broken-chain":"chain-broken","i-eye-02":"eye","i-arrows-looping-06":"arrows-loop","i-circle-question-mark-02":"circle-question-mark-filled","i-circle-check-mark-02":"circle-check-mark-filled","i-circle-info-02":"circle-info-filled","i-circle-exclamation-mark-02":"circle-exclamation-mark-filled","i-magnifying-glass":"search","i-circle-exclamation-mark":"circle-exclamation-mark","i-cross-mark":"cross-mark","i-plus":"plus","i-circle-question-mark":"circle-question-mark","i-arrow-up-07":"chevron-down","i-arrow-down-07":"chevron-up","i-arrow-right-07":"chevron-right","i-arrow-left-07":"chevron-left","i-arrow-up-06":"arrow-up-tray","i-arrow-down-06":"arrow-down-tray","i-trashcan":"remove","i-four-squares":"four-squares","i-shopping-cart-02":"shopping-cart","i-chain":"chain","i-gear":"gear","i-list":"list","i-pencil":"pencil","i-circle-cross-mark":"clean","i-circle-minus":"circle-minus","i-circle-info":"circle-info","i-folder-blank-open":"folder-open"}

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * marked - a markdown parser
 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/chjj/marked
 */

;(function() {

/**
 * Block-Level Grammar
 */

var block = {
  newline: /^\n+/,
  code: /^( {4}[^\n]+\n*)+/,
  fences: noop,
  hr: /^( *[-*_]){3,} *(?:\n+|$)/,
  heading: /^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,
  nptable: noop,
  lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
  blockquote: /^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,
  list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
  html: /^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,
  table: noop,
  paragraph: /^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,
  text: /^[^\n]+/
};

block.bullet = /(?:[*+-]|\d+\.)/;
block.item = /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;
block.item = replace(block.item, 'gm')
  (/bull/g, block.bullet)
  ();

block.list = replace(block.list)
  (/bull/g, block.bullet)
  ('hr', '\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))')
  ('def', '\\n+(?=' + block.def.source + ')')
  ();

block.blockquote = replace(block.blockquote)
  ('def', block.def)
  ();

block._tag = '(?!(?:'
  + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code'
  + '|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo'
  + '|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b';

block.html = replace(block.html)
  ('comment', /<!--[\s\S]*?-->/)
  ('closed', /<(tag)[\s\S]+?<\/\1>/)
  ('closing', /<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)
  (/tag/g, block._tag)
  ();

block.paragraph = replace(block.paragraph)
  ('hr', block.hr)
  ('heading', block.heading)
  ('lheading', block.lheading)
  ('blockquote', block.blockquote)
  ('tag', '<' + block._tag)
  ('def', block.def)
  ();

/**
 * Normal Block Grammar
 */

block.normal = merge({}, block);

/**
 * GFM Block Grammar
 */

block.gfm = merge({}, block.normal, {
  fences: /^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,
  paragraph: /^/,
  heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
});

block.gfm.paragraph = replace(block.paragraph)
  ('(?!', '(?!'
    + block.gfm.fences.source.replace('\\1', '\\2') + '|'
    + block.list.source.replace('\\1', '\\3') + '|')
  ();

/**
 * GFM + Tables Block Grammar
 */

block.tables = merge({}, block.gfm, {
  nptable: /^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,
  table: /^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/
});

/**
 * Block Lexer
 */

function Lexer(options) {
  this.tokens = [];
  this.tokens.links = {};
  this.options = options || marked.defaults;
  this.rules = block.normal;

  if (this.options.gfm) {
    if (this.options.tables) {
      this.rules = block.tables;
    } else {
      this.rules = block.gfm;
    }
  }
}

/**
 * Expose Block Rules
 */

Lexer.rules = block;

/**
 * Static Lex Method
 */

Lexer.lex = function(src, options) {
  var lexer = new Lexer(options);
  return lexer.lex(src);
};

/**
 * Preprocessing
 */

Lexer.prototype.lex = function(src) {
  src = src
    .replace(/\r\n|\r/g, '\n')
    .replace(/\t/g, '    ')
    .replace(/\u00a0/g, ' ')
    .replace(/\u2424/g, '\n');

  return this.token(src, true);
};

/**
 * Lexing
 */

Lexer.prototype.token = function(src, top, bq) {
  var src = src.replace(/^ +$/gm, '')
    , next
    , loose
    , cap
    , bull
    , b
    , item
    , space
    , i
    , l;

  while (src) {
    // newline
    if (cap = this.rules.newline.exec(src)) {
      src = src.substring(cap[0].length);
      if (cap[0].length > 1) {
        this.tokens.push({
          type: 'space'
        });
      }
    }

    // code
    if (cap = this.rules.code.exec(src)) {
      src = src.substring(cap[0].length);
      cap = cap[0].replace(/^ {4}/gm, '');
      this.tokens.push({
        type: 'code',
        text: !this.options.pedantic
          ? cap.replace(/\n+$/, '')
          : cap
      });
      continue;
    }

    // fences (gfm)
    if (cap = this.rules.fences.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'code',
        lang: cap[2],
        text: cap[3] || ''
      });
      continue;
    }

    // heading
    if (cap = this.rules.heading.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'heading',
        depth: cap[1].length,
        text: cap[2]
      });
      continue;
    }

    // table no leading pipe (gfm)
    if (top && (cap = this.rules.nptable.exec(src))) {
      src = src.substring(cap[0].length);

      item = {
        type: 'table',
        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
        cells: cap[3].replace(/\n$/, '').split('\n')
      };

      for (i = 0; i < item.align.length; i++) {
        if (/^ *-+: *$/.test(item.align[i])) {
          item.align[i] = 'right';
        } else if (/^ *:-+: *$/.test(item.align[i])) {
          item.align[i] = 'center';
        } else if (/^ *:-+ *$/.test(item.align[i])) {
          item.align[i] = 'left';
        } else {
          item.align[i] = null;
        }
      }

      for (i = 0; i < item.cells.length; i++) {
        item.cells[i] = item.cells[i].split(/ *\| */);
      }

      this.tokens.push(item);

      continue;
    }

    // lheading
    if (cap = this.rules.lheading.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'heading',
        depth: cap[2] === '=' ? 1 : 2,
        text: cap[1]
      });
      continue;
    }

    // hr
    if (cap = this.rules.hr.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'hr'
      });
      continue;
    }

    // blockquote
    if (cap = this.rules.blockquote.exec(src)) {
      src = src.substring(cap[0].length);

      this.tokens.push({
        type: 'blockquote_start'
      });

      cap = cap[0].replace(/^ *> ?/gm, '');

      // Pass `top` to keep the current
      // "toplevel" state. This is exactly
      // how markdown.pl works.
      this.token(cap, top, true);

      this.tokens.push({
        type: 'blockquote_end'
      });

      continue;
    }

    // list
    if (cap = this.rules.list.exec(src)) {
      src = src.substring(cap[0].length);
      bull = cap[2];

      this.tokens.push({
        type: 'list_start',
        ordered: bull.length > 1
      });

      // Get each top-level item.
      cap = cap[0].match(this.rules.item);

      next = false;
      l = cap.length;
      i = 0;

      for (; i < l; i++) {
        item = cap[i];

        // Remove the list item's bullet
        // so it is seen as the next token.
        space = item.length;
        item = item.replace(/^ *([*+-]|\d+\.) +/, '');

        // Outdent whatever the
        // list item contains. Hacky.
        if (~item.indexOf('\n ')) {
          space -= item.length;
          item = !this.options.pedantic
            ? item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '')
            : item.replace(/^ {1,4}/gm, '');
        }

        // Determine whether the next list item belongs here.
        // Backpedal if it does not belong in this list.
        if (this.options.smartLists && i !== l - 1) {
          b = block.bullet.exec(cap[i + 1])[0];
          if (bull !== b && !(bull.length > 1 && b.length > 1)) {
            src = cap.slice(i + 1).join('\n') + src;
            i = l - 1;
          }
        }

        // Determine whether item is loose or not.
        // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
        // for discount behavior.
        loose = next || /\n\n(?!\s*$)/.test(item);
        if (i !== l - 1) {
          next = item.charAt(item.length - 1) === '\n';
          if (!loose) loose = next;
        }

        this.tokens.push({
          type: loose
            ? 'loose_item_start'
            : 'list_item_start'
        });

        // Recurse.
        this.token(item, false, bq);

        this.tokens.push({
          type: 'list_item_end'
        });
      }

      this.tokens.push({
        type: 'list_end'
      });

      continue;
    }

    // html
    if (cap = this.rules.html.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: this.options.sanitize
          ? 'paragraph'
          : 'html',
        pre: !this.options.sanitizer
          && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
        text: cap[0]
      });
      continue;
    }

    // def
    if ((!bq && top) && (cap = this.rules.def.exec(src))) {
      src = src.substring(cap[0].length);
      this.tokens.links[cap[1].toLowerCase()] = {
        href: cap[2],
        title: cap[3]
      };
      continue;
    }

    // table (gfm)
    if (top && (cap = this.rules.table.exec(src))) {
      src = src.substring(cap[0].length);

      item = {
        type: 'table',
        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
        cells: cap[3].replace(/(?: *\| *)?\n$/, '').split('\n')
      };

      for (i = 0; i < item.align.length; i++) {
        if (/^ *-+: *$/.test(item.align[i])) {
          item.align[i] = 'right';
        } else if (/^ *:-+: *$/.test(item.align[i])) {
          item.align[i] = 'center';
        } else if (/^ *:-+ *$/.test(item.align[i])) {
          item.align[i] = 'left';
        } else {
          item.align[i] = null;
        }
      }

      for (i = 0; i < item.cells.length; i++) {
        item.cells[i] = item.cells[i]
          .replace(/^ *\| *| *\| *$/g, '')
          .split(/ *\| */);
      }

      this.tokens.push(item);

      continue;
    }

    // top-level paragraph
    if (top && (cap = this.rules.paragraph.exec(src))) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'paragraph',
        text: cap[1].charAt(cap[1].length - 1) === '\n'
          ? cap[1].slice(0, -1)
          : cap[1]
      });
      continue;
    }

    // text
    if (cap = this.rules.text.exec(src)) {
      // Top-level should never reach here.
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'text',
        text: cap[0]
      });
      continue;
    }

    if (src) {
      throw new
        Error('Infinite loop on byte: ' + src.charCodeAt(0));
    }
  }

  return this.tokens;
};

/**
 * Inline-Level Grammar
 */

var inline = {
  escape: /^\\([\\`*{}\[\]()#+\-.!_>])/,
  autolink: /^<([^ >]+(@|:\/)[^ >]+)>/,
  url: noop,
  tag: /^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,
  link: /^!?\[(inside)\]\(href\)/,
  reflink: /^!?\[(inside)\]\s*\[([^\]]*)\]/,
  nolink: /^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,
  strong: /^__([\s\S]+?)__(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,
  em: /^\b_((?:[^_]|__)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,
  code: /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,
  br: /^ {2,}\n(?!\s*$)/,
  del: noop,
  text: /^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/
};

inline._inside = /(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/;
inline._href = /\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;

inline.link = replace(inline.link)
  ('inside', inline._inside)
  ('href', inline._href)
  ();

inline.reflink = replace(inline.reflink)
  ('inside', inline._inside)
  ();

/**
 * Normal Inline Grammar
 */

inline.normal = merge({}, inline);

/**
 * Pedantic Inline Grammar
 */

inline.pedantic = merge({}, inline.normal, {
  strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
  em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/
});

/**
 * GFM Inline Grammar
 */

inline.gfm = merge({}, inline.normal, {
  escape: replace(inline.escape)('])', '~|])')(),
  url: /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,
  del: /^~~(?=\S)([\s\S]*?\S)~~/,
  text: replace(inline.text)
    (']|', '~]|')
    ('|', '|https?://|')
    ()
});

/**
 * GFM + Line Breaks Inline Grammar
 */

inline.breaks = merge({}, inline.gfm, {
  br: replace(inline.br)('{2,}', '*')(),
  text: replace(inline.gfm.text)('{2,}', '*')()
});

/**
 * Inline Lexer & Compiler
 */

function InlineLexer(links, options) {
  this.options = options || marked.defaults;
  this.links = links;
  this.rules = inline.normal;
  this.renderer = this.options.renderer || new Renderer;
  this.renderer.options = this.options;

  if (!this.links) {
    throw new
      Error('Tokens array requires a `links` property.');
  }

  if (this.options.gfm) {
    if (this.options.breaks) {
      this.rules = inline.breaks;
    } else {
      this.rules = inline.gfm;
    }
  } else if (this.options.pedantic) {
    this.rules = inline.pedantic;
  }
}

/**
 * Expose Inline Rules
 */

InlineLexer.rules = inline;

/**
 * Static Lexing/Compiling Method
 */

InlineLexer.output = function(src, links, options) {
  var inline = new InlineLexer(links, options);
  return inline.output(src);
};

/**
 * Lexing/Compiling
 */

InlineLexer.prototype.output = function(src) {
  var out = ''
    , link
    , text
    , href
    , cap;

  while (src) {
    // escape
    if (cap = this.rules.escape.exec(src)) {
      src = src.substring(cap[0].length);
      out += cap[1];
      continue;
    }

    // autolink
    if (cap = this.rules.autolink.exec(src)) {
      src = src.substring(cap[0].length);
      if (cap[2] === '@') {
        text = cap[1].charAt(6) === ':'
          ? this.mangle(cap[1].substring(7))
          : this.mangle(cap[1]);
        href = this.mangle('mailto:') + text;
      } else {
        text = escape(cap[1]);
        href = text;
      }
      out += this.renderer.link(href, null, text);
      continue;
    }

    // url (gfm)
    if (!this.inLink && (cap = this.rules.url.exec(src))) {
      src = src.substring(cap[0].length);
      text = escape(cap[1]);
      href = text;
      out += this.renderer.link(href, null, text);
      continue;
    }

    // tag
    if (cap = this.rules.tag.exec(src)) {
      if (!this.inLink && /^<a /i.test(cap[0])) {
        this.inLink = true;
      } else if (this.inLink && /^<\/a>/i.test(cap[0])) {
        this.inLink = false;
      }
      src = src.substring(cap[0].length);
      out += this.options.sanitize
        ? this.options.sanitizer
          ? this.options.sanitizer(cap[0])
          : escape(cap[0])
        : cap[0]
      continue;
    }

    // link
    if (cap = this.rules.link.exec(src)) {
      src = src.substring(cap[0].length);
      this.inLink = true;
      out += this.outputLink(cap, {
        href: cap[2],
        title: cap[3]
      });
      this.inLink = false;
      continue;
    }

    // reflink, nolink
    if ((cap = this.rules.reflink.exec(src))
        || (cap = this.rules.nolink.exec(src))) {
      src = src.substring(cap[0].length);
      link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
      link = this.links[link.toLowerCase()];
      if (!link || !link.href) {
        out += cap[0].charAt(0);
        src = cap[0].substring(1) + src;
        continue;
      }
      this.inLink = true;
      out += this.outputLink(cap, link);
      this.inLink = false;
      continue;
    }

    // strong
    if (cap = this.rules.strong.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.strong(this.output(cap[2] || cap[1]));
      continue;
    }

    // em
    if (cap = this.rules.em.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.em(this.output(cap[2] || cap[1]));
      continue;
    }

    // code
    if (cap = this.rules.code.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.codespan(escape(cap[2], true));
      continue;
    }

    // br
    if (cap = this.rules.br.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.br();
      continue;
    }

    // del (gfm)
    if (cap = this.rules.del.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.del(this.output(cap[1]));
      continue;
    }

    // text
    if (cap = this.rules.text.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.text(escape(this.smartypants(cap[0])));
      continue;
    }

    if (src) {
      throw new
        Error('Infinite loop on byte: ' + src.charCodeAt(0));
    }
  }

  return out;
};

/**
 * Compile Link
 */

InlineLexer.prototype.outputLink = function(cap, link) {
  var href = escape(link.href)
    , title = link.title ? escape(link.title) : null;

  return cap[0].charAt(0) !== '!'
    ? this.renderer.link(href, title, this.output(cap[1]))
    : this.renderer.image(href, title, escape(cap[1]));
};

/**
 * Smartypants Transformations
 */

InlineLexer.prototype.smartypants = function(text) {
  if (!this.options.smartypants) return text;
  return text
    // em-dashes
    .replace(/---/g, '\u2014')
    // en-dashes
    .replace(/--/g, '\u2013')
    // opening singles
    .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
    // closing singles & apostrophes
    .replace(/'/g, '\u2019')
    // opening doubles
    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201c')
    // closing doubles
    .replace(/"/g, '\u201d')
    // ellipses
    .replace(/\.{3}/g, '\u2026');
};

/**
 * Mangle Links
 */

InlineLexer.prototype.mangle = function(text) {
  if (!this.options.mangle) return text;
  var out = ''
    , l = text.length
    , i = 0
    , ch;

  for (; i < l; i++) {
    ch = text.charCodeAt(i);
    if (Math.random() > 0.5) {
      ch = 'x' + ch.toString(16);
    }
    out += '&#' + ch + ';';
  }

  return out;
};

/**
 * Renderer
 */

function Renderer(options) {
  this.options = options || {};
}

Renderer.prototype.code = function(code, lang, escaped) {
  if (this.options.highlight) {
    var out = this.options.highlight(code, lang);
    if (out != null && out !== code) {
      escaped = true;
      code = out;
    }
  }

  if (!lang) {
    return '<pre><code>'
      + (escaped ? code : escape(code, true))
      + '\n</code></pre>';
  }

  return '<pre><code class="'
    + this.options.langPrefix
    + escape(lang, true)
    + '">'
    + (escaped ? code : escape(code, true))
    + '\n</code></pre>\n';
};

Renderer.prototype.blockquote = function(quote) {
  return '<blockquote>\n' + quote + '</blockquote>\n';
};

Renderer.prototype.html = function(html) {
  return html;
};

Renderer.prototype.heading = function(text, level, raw) {
  return '<h'
    + level
    + ' id="'
    + this.options.headerPrefix
    + raw.toLowerCase().replace(/[^\w]+/g, '-')
    + '">'
    + text
    + '</h'
    + level
    + '>\n';
};

Renderer.prototype.hr = function() {
  return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
};

Renderer.prototype.list = function(body, ordered) {
  var type = ordered ? 'ol' : 'ul';
  return '<' + type + '>\n' + body + '</' + type + '>\n';
};

Renderer.prototype.listitem = function(text) {
  return '<li>' + text + '</li>\n';
};

Renderer.prototype.paragraph = function(text) {
  return '<p>' + text + '</p>\n';
};

Renderer.prototype.table = function(header, body) {
  return '<table>\n'
    + '<thead>\n'
    + header
    + '</thead>\n'
    + '<tbody>\n'
    + body
    + '</tbody>\n'
    + '</table>\n';
};

Renderer.prototype.tablerow = function(content) {
  return '<tr>\n' + content + '</tr>\n';
};

Renderer.prototype.tablecell = function(content, flags) {
  var type = flags.header ? 'th' : 'td';
  var tag = flags.align
    ? '<' + type + ' style="text-align:' + flags.align + '">'
    : '<' + type + '>';
  return tag + content + '</' + type + '>\n';
};

// span level renderer
Renderer.prototype.strong = function(text) {
  return '<strong>' + text + '</strong>';
};

Renderer.prototype.em = function(text) {
  return '<em>' + text + '</em>';
};

Renderer.prototype.codespan = function(text) {
  return '<code>' + text + '</code>';
};

Renderer.prototype.br = function() {
  return this.options.xhtml ? '<br/>' : '<br>';
};

Renderer.prototype.del = function(text) {
  return '<del>' + text + '</del>';
};

Renderer.prototype.link = function(href, title, text) {
  if (this.options.sanitize) {
    try {
      var prot = decodeURIComponent(unescape(href))
        .replace(/[^\w:]/g, '')
        .toLowerCase();
    } catch (e) {
      return '';
    }
    if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0) {
      return '';
    }
  }
  var out = '<a href="' + href + '"';
  if (title) {
    out += ' title="' + title + '"';
  }
  out += '>' + text + '</a>';
  return out;
};

Renderer.prototype.image = function(href, title, text) {
  var out = '<img src="' + href + '" alt="' + text + '"';
  if (title) {
    out += ' title="' + title + '"';
  }
  out += this.options.xhtml ? '/>' : '>';
  return out;
};

Renderer.prototype.text = function(text) {
  return text;
};

/**
 * Parsing & Compiling
 */

function Parser(options) {
  this.tokens = [];
  this.token = null;
  this.options = options || marked.defaults;
  this.options.renderer = this.options.renderer || new Renderer;
  this.renderer = this.options.renderer;
  this.renderer.options = this.options;
}

/**
 * Static Parse Method
 */

Parser.parse = function(src, options, renderer) {
  var parser = new Parser(options, renderer);
  return parser.parse(src);
};

/**
 * Parse Loop
 */

Parser.prototype.parse = function(src) {
  this.inline = new InlineLexer(src.links, this.options, this.renderer);
  this.tokens = src.reverse();

  var out = '';
  while (this.next()) {
    out += this.tok();
  }

  return out;
};

/**
 * Next Token
 */

Parser.prototype.next = function() {
  return this.token = this.tokens.pop();
};

/**
 * Preview Next Token
 */

Parser.prototype.peek = function() {
  return this.tokens[this.tokens.length - 1] || 0;
};

/**
 * Parse Text Tokens
 */

Parser.prototype.parseText = function() {
  var body = this.token.text;

  while (this.peek().type === 'text') {
    body += '\n' + this.next().text;
  }

  return this.inline.output(body);
};

/**
 * Parse Current Token
 */

Parser.prototype.tok = function() {
  switch (this.token.type) {
    case 'space': {
      return '';
    }
    case 'hr': {
      return this.renderer.hr();
    }
    case 'heading': {
      return this.renderer.heading(
        this.inline.output(this.token.text),
        this.token.depth,
        this.token.text);
    }
    case 'code': {
      return this.renderer.code(this.token.text,
        this.token.lang,
        this.token.escaped);
    }
    case 'table': {
      var header = ''
        , body = ''
        , i
        , row
        , cell
        , flags
        , j;

      // header
      cell = '';
      for (i = 0; i < this.token.header.length; i++) {
        flags = { header: true, align: this.token.align[i] };
        cell += this.renderer.tablecell(
          this.inline.output(this.token.header[i]),
          { header: true, align: this.token.align[i] }
        );
      }
      header += this.renderer.tablerow(cell);

      for (i = 0; i < this.token.cells.length; i++) {
        row = this.token.cells[i];

        cell = '';
        for (j = 0; j < row.length; j++) {
          cell += this.renderer.tablecell(
            this.inline.output(row[j]),
            { header: false, align: this.token.align[j] }
          );
        }

        body += this.renderer.tablerow(cell);
      }
      return this.renderer.table(header, body);
    }
    case 'blockquote_start': {
      var body = '';

      while (this.next().type !== 'blockquote_end') {
        body += this.tok();
      }

      return this.renderer.blockquote(body);
    }
    case 'list_start': {
      var body = ''
        , ordered = this.token.ordered;

      while (this.next().type !== 'list_end') {
        body += this.tok();
      }

      return this.renderer.list(body, ordered);
    }
    case 'list_item_start': {
      var body = '';

      while (this.next().type !== 'list_item_end') {
        body += this.token.type === 'text'
          ? this.parseText()
          : this.tok();
      }

      return this.renderer.listitem(body);
    }
    case 'loose_item_start': {
      var body = '';

      while (this.next().type !== 'list_item_end') {
        body += this.tok();
      }

      return this.renderer.listitem(body);
    }
    case 'html': {
      var html = !this.token.pre && !this.options.pedantic
        ? this.inline.output(this.token.text)
        : this.token.text;
      return this.renderer.html(html);
    }
    case 'paragraph': {
      return this.renderer.paragraph(this.inline.output(this.token.text));
    }
    case 'text': {
      return this.renderer.paragraph(this.parseText());
    }
  }
};

/**
 * Helpers
 */

function escape(html, encode) {
  return html
    .replace(!encode ? /&(?!#?\w+;)/g : /&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function unescape(html) {
	// explicitly match decimal, hex, and named HTML entities 
  return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g, function(_, n) {
    n = n.toLowerCase();
    if (n === 'colon') return ':';
    if (n.charAt(0) === '#') {
      return n.charAt(1) === 'x'
        ? String.fromCharCode(parseInt(n.substring(2), 16))
        : String.fromCharCode(+n.substring(1));
    }
    return '';
  });
}

function replace(regex, opt) {
  regex = regex.source;
  opt = opt || '';
  return function self(name, val) {
    if (!name) return new RegExp(regex, opt);
    val = val.source || val;
    val = val.replace(/(^|[^\[])\^/g, '$1');
    regex = regex.replace(name, val);
    return self;
  };
}

function noop() {}
noop.exec = noop;

function merge(obj) {
  var i = 1
    , target
    , key;

  for (; i < arguments.length; i++) {
    target = arguments[i];
    for (key in target) {
      if (Object.prototype.hasOwnProperty.call(target, key)) {
        obj[key] = target[key];
      }
    }
  }

  return obj;
}


/**
 * Marked
 */

function marked(src, opt, callback) {
  if (callback || typeof opt === 'function') {
    if (!callback) {
      callback = opt;
      opt = null;
    }

    opt = merge({}, marked.defaults, opt || {});

    var highlight = opt.highlight
      , tokens
      , pending
      , i = 0;

    try {
      tokens = Lexer.lex(src, opt)
    } catch (e) {
      return callback(e);
    }

    pending = tokens.length;

    var done = function(err) {
      if (err) {
        opt.highlight = highlight;
        return callback(err);
      }

      var out;

      try {
        out = Parser.parse(tokens, opt);
      } catch (e) {
        err = e;
      }

      opt.highlight = highlight;

      return err
        ? callback(err)
        : callback(null, out);
    };

    if (!highlight || highlight.length < 3) {
      return done();
    }

    delete opt.highlight;

    if (!pending) return done();

    for (; i < tokens.length; i++) {
      (function(token) {
        if (token.type !== 'code') {
          return --pending || done();
        }
        return highlight(token.text, token.lang, function(err, code) {
          if (err) return done(err);
          if (code == null || code === token.text) {
            return --pending || done();
          }
          token.text = code;
          token.escaped = true;
          --pending || done();
        });
      })(tokens[i]);
    }

    return;
  }
  try {
    if (opt) opt = merge({}, marked.defaults, opt);
    return Parser.parse(Lexer.lex(src, opt), opt);
  } catch (e) {
    e.message += '\nPlease report this to https://github.com/chjj/marked.';
    if ((opt || marked.defaults).silent) {
      return '<p>An error occured:</p><pre>'
        + escape(e.message + '', true)
        + '</pre>';
    }
    throw e;
  }
}

/**
 * Options
 */

marked.options =
marked.setOptions = function(opt) {
  merge(marked.defaults, opt);
  return marked;
};

marked.defaults = {
  gfm: true,
  tables: true,
  breaks: false,
  pedantic: false,
  sanitize: false,
  sanitizer: null,
  mangle: true,
  smartLists: false,
  silent: false,
  highlight: null,
  langPrefix: 'lang-',
  smartypants: false,
  headerPrefix: '',
  renderer: new Renderer,
  xhtml: false
};

/**
 * Expose
 */

marked.Parser = Parser;
marked.parser = Parser.parse;

marked.Renderer = Renderer;

marked.Lexer = Lexer;
marked.lexer = Lexer.lex;

marked.InlineLexer = InlineLexer;
marked.inlineLexer = InlineLexer.output;

marked.parse = marked;

if (true) {
  module.exports = marked;
} else if (typeof define === 'function' && define.amd) {
  define(function() { return marked; });
} else {
  this.marked = marked;
}

}).call(function() {
  return this || (typeof window !== 'undefined' ? window : global);
}());

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.12.9
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  // NOTE: 1 DOM access here
  var offsetParent = element && element.offsetParent;
  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    if (element) {
      return element.ownerDocument.documentElement;
    }

    return document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

/**
 * Tells if you are running Internet Explorer 10
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean} isIE10
 */
var isIE10 = undefined;

var isIE10$1 = function () {
  if (isIE10 === undefined) {
    isIE10 = navigator.appVersion.indexOf('MSIE 10') !== -1;
  }
  return isIE10;
};

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE10$1() ? html['offset' + axis] + computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')] + computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')] : 0);
}

function getWindowSizes() {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE10$1() && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  if (isIE10$1()) {
    try {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } catch (err) {}
  } else {
    rect = element.getBoundingClientRect();
  }

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes() : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var isIE10 = isIE10$1();
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = getScroll(html);
  var scrollLeft = getScroll(html, 'left');

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  // NOTE: 1 DOM access here
  var boundaries = { top: 0, left: 0 };
  var offsetParent = findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  boundaries.left += padding;
  boundaries.top += padding;
  boundaries.right -= padding;
  boundaries.bottom -= padding;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var commonOffsetParent = findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
  data.offsets.popper.position = 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length - 1; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroy the popper
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.left = '';
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger onUpdate callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper.
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // floor sides to avoid blurry text
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.floor(popper.top),
    bottom: Math.floor(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    top = -offsetParentRect.height + offsets.bottom;
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    left = -offsetParentRect.width + offsets.right;
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjuction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-right` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement);
  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unitless, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the height.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > More on this [reading this issue](https://github.com/FezVrasta/popper.js/issues/373)
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * An scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper this makes sure the popper has always a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier, can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near eachothers
   * without leaving any gap between the two. Expecially useful when the arrow is
   * enabled and you want to assure it to point to its reference element.
   * It cares only about the first axis, you can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjuction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations).
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position,
     * the popper will never be placed outside of the defined boundaries
     * (except if keepTogether is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define you own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the informations used by Popper.js
 * this object get passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper.
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements.
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overriden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass as 3rd argument an object with the same
 * structure of this object, example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Whether events (resize, scroll) are initially enabled
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated, this callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Create a new Popper.js instance
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as popper.
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedule an update, it will run on the next UI update available
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(35)))

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(21);
var invariant = __webpack_require__(247);
var ReactPropTypesSecret = __webpack_require__(258);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(9),l=__webpack_require__(243),B=__webpack_require__(51),C=__webpack_require__(21),ba=__webpack_require__(242),da=__webpack_require__(246),ea=__webpack_require__(250),fa=__webpack_require__(244),ia=__webpack_require__(245),D=__webpack_require__(50);
function E(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:E("227");
var oa={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0};function pa(a,b){return(a&b)===b}
var ta={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ta,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){ua.hasOwnProperty(f)?E("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:pa(h,b.MUST_USE_PROPERTY),
hasBooleanValue:pa(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:pa(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:pa(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:pa(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:pa(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:E("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);ua[f]=g}}},ua={};
function va(a,b){if(oa.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return oa.hasOwnProperty(a)?a=!0:(b=wa(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case "undefined":case "number":case "string":case "object":return!0;default:return!1}}function wa(a){return ua.hasOwnProperty(a)?ua[a]:null}
var xa=ta,ya=xa.MUST_USE_PROPERTY,K=xa.HAS_BOOLEAN_VALUE,za=xa.HAS_NUMERIC_VALUE,Aa=xa.HAS_POSITIVE_NUMERIC_VALUE,Ba=xa.HAS_OVERLOADED_BOOLEAN_VALUE,Ca=xa.HAS_STRING_BOOLEAN_VALUE,Da={Properties:{allowFullScreen:K,async:K,autoFocus:K,autoPlay:K,capture:Ba,checked:ya|K,cols:Aa,contentEditable:Ca,controls:K,"default":K,defer:K,disabled:K,download:Ba,draggable:Ca,formNoValidate:K,hidden:K,loop:K,multiple:ya|K,muted:ya|K,noValidate:K,open:K,playsInline:K,readOnly:K,required:K,reversed:K,rows:Aa,rowSpan:za,
scoped:K,seamless:K,selected:ya|K,size:Aa,start:za,span:Aa,spellCheck:Ca,style:0,tabIndex:0,itemScope:K,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ca},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&
a.setAttribute("value",""+b)}}},Ea=xa.HAS_STRING_BOOLEAN_VALUE,M={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Ga={Properties:{autoReverse:Ea,externalResourcesRequired:Ea,preserveAlpha:Ea},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:M.xlink,xlinkArcrole:M.xlink,xlinkHref:M.xlink,xlinkRole:M.xlink,xlinkShow:M.xlink,xlinkTitle:M.xlink,xlinkType:M.xlink,
xmlBase:M.xml,xmlLang:M.xml,xmlSpace:M.xml}},Ha=/[\-\:]([a-z])/g;function Ia(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Ha,
Ia);Ga.Properties[b]=0;Ga.DOMAttributeNames[b]=a});xa.injectDOMPropertyConfig(Da);xa.injectDOMPropertyConfig(Ga);
var P={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?E("197"):void 0;Ja=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){Ja.apply(P,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){P.invokeGuardedCallback.apply(this,arguments);if(P.hasCaughtError()){var q=P.clearCaughtError();P._hasRethrowError||(P._hasRethrowError=!0,P._rethrowError=
q)}},rethrowCaughtError:function(){return Ka.apply(P,arguments)},hasCaughtError:function(){return P._hasCaughtError},clearCaughtError:function(){if(P._hasCaughtError){var a=P._caughtError;P._caughtError=null;P._hasCaughtError=!1;return a}E("198")}};function Ja(a,b,c,d,e,f,g,h,k){P._hasCaughtError=!1;P._caughtError=null;var q=Array.prototype.slice.call(arguments,3);try{b.apply(c,q)}catch(v){P._caughtError=v,P._hasCaughtError=!0}}
function Ka(){if(P._hasRethrowError){var a=P._rethrowError;P._rethrowError=null;P._hasRethrowError=!1;throw a;}}var La=null,Ma={};
function Na(){if(La)for(var a in Ma){var b=Ma[a],c=La.indexOf(a);-1<c?void 0:E("96",a);if(!Oa[c]){b.extractEvents?void 0:E("97",a);Oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;Pa.hasOwnProperty(h)?E("99",h):void 0;Pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Qa(k[e],g,h);e=!0}else f.registrationName?(Qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:E("98",d,a)}}}}
function Qa(a,b,c){Ra[a]?E("100",a):void 0;Ra[a]=b;Sa[a]=b.eventTypes[c].dependencies}var Oa=[],Pa={},Ra={},Sa={};function Ta(a){La?E("101"):void 0;La=Array.prototype.slice.call(a);Na()}function Ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];Ma.hasOwnProperty(c)&&Ma[c]===d||(Ma[c]?E("102",c):void 0,Ma[c]=d,b=!0)}b&&Na()}
var Va=Object.freeze({plugins:Oa,eventNameDispatchConfigs:Pa,registrationNameModules:Ra,registrationNameDependencies:Sa,possibleRegistrationNames:null,injectEventPluginOrder:Ta,injectEventPluginsByName:Ua}),Wa=null,Xa=null,Ya=null;function Za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ya(d);P.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function $a(a,b){null==b?E("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function ab(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var bb=null;
function cb(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Za(a,b,c[e],d[e]);else c&&Za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function db(a){return cb(a,!0)}function gb(a){return cb(a,!1)}var hb={injectEventPluginOrder:Ta,injectEventPluginsByName:Ua};
function ib(a,b){var c=a.stateNode;if(!c)return null;var d=Wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?E("231",b,typeof c):void 0;
return c}function jb(a,b,c,d){for(var e,f=0;f<Oa.length;f++){var g=Oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=$a(e,g))}return e}function kb(a){a&&(bb=$a(bb,a))}function lb(a){var b=bb;bb=null;b&&(a?ab(b,db):ab(b,gb),bb?E("95"):void 0,P.rethrowCaughtError())}var mb=Object.freeze({injection:hb,getListener:ib,extractEvents:jb,enqueueEvents:kb,processEventQueue:lb}),nb=Math.random().toString(36).slice(2),Q="__reactInternalInstance$"+nb,ob="__reactEventHandlers$"+nb;
function pb(a){if(a[Q])return a[Q];for(var b=[];!a[Q];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=void 0,d=a[Q];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[Q]);a=b.pop())c=d;return c}function qb(a){if(5===a.tag||6===a.tag)return a.stateNode;E("33")}function rb(a){return a[ob]||null}
var sb=Object.freeze({precacheFiberNode:function(a,b){b[Q]=a},getClosestInstanceFromNode:pb,getInstanceFromNode:function(a){a=a[Q];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:qb,getFiberCurrentPropsFromNode:rb,updateFiberProps:function(a,b){a[ob]=b}});function tb(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function ub(a,b,c){for(var d=[];a;)d.push(a),a=tb(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}
function vb(a,b,c){if(b=ib(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a)}function wb(a){a&&a.dispatchConfig.phasedRegistrationNames&&ub(a._targetInst,vb,a)}function xb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?tb(b):null;ub(b,vb,a)}}
function yb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=ib(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a))}function zb(a){a&&a.dispatchConfig.registrationName&&yb(a._targetInst,null,a)}function Ab(a){ab(a,wb)}
function Bb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=tb(h))g++;h=0;for(var k=f;k;k=tb(k))h++;for(;0<g-h;)e=tb(e),g--;for(;0<h-g;)f=tb(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=tb(e);f=tb(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=tb(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=tb(d)}for(d=0;d<e.length;d++)yb(e[d],"bubbled",a);for(a=c.length;0<a--;)yb(c[a],"captured",b)}
var Cb=Object.freeze({accumulateTwoPhaseDispatches:Ab,accumulateTwoPhaseDispatchesSkipTarget:function(a){ab(a,xb)},accumulateEnterLeaveDispatches:Bb,accumulateDirectDispatches:function(a){ab(a,zb)}}),Db=null;function Eb(){!Db&&l.canUseDOM&&(Db="textContent"in document.documentElement?"textContent":"innerText");return Db}var S={_root:null,_startText:null,_fallbackText:null};
function Fb(){if(S._fallbackText)return S._fallbackText;var a,b=S._startText,c=b.length,d,e=Gb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);S._fallbackText=e.slice(a,1<d?1-d:void 0);return S._fallbackText}function Gb(){return"value"in S._root?S._root.value:S._root[Eb()]}
var Hb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Ib={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function T(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
B(T.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Hb.length;a++)this[Hb[a]]=null}});T.Interface=Ib;T.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;B(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=B({},this.Interface,b);a.augmentClass=this.augmentClass;Jb(a)};Jb(T);function Kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Lb(a){a instanceof this?void 0:E("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Jb(a){a.eventPool=[];a.getPooled=Kb;a.release=Lb}function Mb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Mb,{data:null});function Nb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Nb,{data:null});var Pb=[9,13,27,32],Vb=l.canUseDOM&&"CompositionEvent"in window,Wb=null;l.canUseDOM&&"documentMode"in document&&(Wb=document.documentMode);var Xb;
if(Xb=l.canUseDOM&&"TextEvent"in window&&!Wb){var Yb=window.opera;Xb=!("object"===typeof Yb&&"function"===typeof Yb.version&&12>=parseInt(Yb.version(),10))}
var Zb=Xb,$b=l.canUseDOM&&(!Vb||Wb&&8<Wb&&11>=Wb),ac=String.fromCharCode(32),bc={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},cc=!1;
function dc(a,b){switch(a){case "topKeyUp":return-1!==Pb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ec(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var fc=!1;function gc(a,b){switch(a){case "topCompositionEnd":return ec(b);case "topKeyPress":if(32!==b.which)return null;cc=!0;return ac;case "topTextInput":return a=b.data,a===ac&&cc?null:a;default:return null}}
function hc(a,b){if(fc)return"topCompositionEnd"===a||!Vb&&dc(a,b)?(a=Fb(),S._root=null,S._startText=null,S._fallbackText=null,fc=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return $b?null:b.data;default:return null}}
var ic={eventTypes:bc,extractEvents:function(a,b,c,d){var e;if(Vb)b:{switch(a){case "topCompositionStart":var f=bc.compositionStart;break b;case "topCompositionEnd":f=bc.compositionEnd;break b;case "topCompositionUpdate":f=bc.compositionUpdate;break b}f=void 0}else fc?dc(a,c)&&(f=bc.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=bc.compositionStart);f?($b&&(fc||f!==bc.compositionStart?f===bc.compositionEnd&&fc&&(e=Fb()):(S._root=d,S._startText=Gb(),fc=!0)),f=Mb.getPooled(f,b,c,d),e?f.data=
e:(e=ec(c),null!==e&&(f.data=e)),Ab(f),e=f):e=null;(a=Zb?gc(a,c):hc(a,c))?(b=Nb.getPooled(bc.beforeInput,b,c,d),b.data=a,Ab(b)):b=null;return[e,b]}},jc=null,kc=null,lc=null;function mc(a){if(a=Xa(a)){jc&&"function"===typeof jc.restoreControlledState?void 0:E("194");var b=Wa(a.stateNode);jc.restoreControlledState(a.stateNode,a.type,b)}}var nc={injectFiberControlledHostComponent:function(a){jc=a}};function oc(a){kc?lc?lc.push(a):lc=[a]:kc=a}
function pc(){if(kc){var a=kc,b=lc;lc=kc=null;mc(a);if(b)for(a=0;a<b.length;a++)mc(b[a])}}var qc=Object.freeze({injection:nc,enqueueStateRestore:oc,restoreStateIfNeeded:pc});function rc(a,b){return a(b)}var sc=!1;function tc(a,b){if(sc)return rc(a,b);sc=!0;try{return rc(a,b)}finally{sc=!1,pc()}}var uc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};
function vc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!uc[a.type]:"textarea"===b?!0:!1}function wc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var xc;l.canUseDOM&&(xc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function yc(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&xc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function Bc(a){a._valueTracker||(a._valueTracker=Ac(a))}function Cc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Dc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};
function Ec(a,b,c){a=T.getPooled(Dc.change,a,b,c);a.type="change";oc(c);Ab(a);return a}var Fc=null,Gc=null;function Hc(a){kb(a);lb(!1)}function Ic(a){var b=qb(a);if(Cc(b))return a}function Jc(a,b){if("topChange"===a)return b}var Kc=!1;l.canUseDOM&&(Kc=yc("input")&&(!document.documentMode||9<document.documentMode));function Lc(){Fc&&(Fc.detachEvent("onpropertychange",Mc),Gc=Fc=null)}function Mc(a){"value"===a.propertyName&&Ic(Gc)&&(a=Ec(Gc,a,wc(a)),tc(Hc,a))}
function Nc(a,b,c){"topFocus"===a?(Lc(),Fc=b,Gc=c,Fc.attachEvent("onpropertychange",Mc)):"topBlur"===a&&Lc()}function Oc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Ic(Gc)}function Pc(a,b){if("topClick"===a)return Ic(b)}function $c(a,b){if("topInput"===a||"topChange"===a)return Ic(b)}
var ad={eventTypes:Dc,_isInputEventSupported:Kc,extractEvents:function(a,b,c,d){var e=b?qb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Jc;else if(vc(e))if(Kc)g=$c;else{g=Oc;var h=Nc}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Pc);if(g&&(g=g(a,b)))return Ec(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==
a&&e.setAttribute("value",a))}};function bd(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(bd,{view:null,detail:null});var cd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}function fd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(fd,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?pb(b):null):a=null;if(a===
b)return null;var f=null==a?e:qb(a);e=null==b?e:qb(b);var g=fd.getPooled(gd.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=fd.getPooled(gd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Bb(g,c,a,b);return[g,c]}},id=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;function jd(a){a=a.type;return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}
function kd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){return(a=a._reactInternalFiber)?2===kd(a):!1}function md(a){2!==kd(a)?E("188"):void 0}
function nd(a){var b=a.alternate;if(!b)return b=kd(a),3===b?E("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return md(e),a;if(g===d)return md(e),b;g=g.sibling}E("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:E("189")}}c.alternate!==d?E("190"):void 0}3!==c.tag?E("188"):void 0;return c.stateNode.current===c?a:b}function od(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function pd(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var qd=[];
function rd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=pb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],sd(a.topLevelType,b,a.nativeEvent,wc(a.nativeEvent))}var td=!0,sd=void 0;function ud(a){td=!!a}function U(a,b,c){return c?ba.listen(c,b,vd.bind(null,a)):null}function wd(a,b,c){return c?ba.capture(c,b,vd.bind(null,a)):null}
function vd(a,b){if(td){var c=wc(b);c=pb(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(qd.length){var d=qd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{tc(rd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>qd.length&&qd.push(a)}}}
var xd=Object.freeze({get _enabled(){return td},get _handleTopLevel(){return sd},setHandleTopLevel:function(a){sd=a},setEnabled:ud,isEnabled:function(){return td},trapBubbledEvent:U,trapCapturedEvent:wd,dispatchEvent:vd});function yd(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var zd={animationend:yd("Animation","AnimationEnd"),animationiteration:yd("Animation","AnimationIteration"),animationstart:yd("Animation","AnimationStart"),transitionend:yd("Transition","TransitionEnd")},Ad={},Bd={};l.canUseDOM&&(Bd=document.createElement("div").style,"AnimationEvent"in window||(delete zd.animationend.animation,delete zd.animationiteration.animation,delete zd.animationstart.animation),"TransitionEvent"in window||delete zd.transitionend.transition);
function Cd(a){if(Ad[a])return Ad[a];if(!zd[a])return a;var b=zd[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Bd)return Ad[a]=b[c];return""}
var Dd={topAbort:"abort",topAnimationEnd:Cd("animationend")||"animationend",topAnimationIteration:Cd("animationiteration")||"animationiteration",topAnimationStart:Cd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Cd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Ed={},Fd=0,Gd="_reactListenersID"+(""+Math.random()).slice(2);function Hd(a){Object.prototype.hasOwnProperty.call(a,Gd)||(a[Gd]=Fd++,Ed[a[Gd]]={});return Ed[a[Gd]]}function Id(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Jd(a,b){var c=Id(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Id(c)}}function Kd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ld=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Md={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Nd=null,Od=null,Pd=null,Qd=!1;
function Rd(a,b){if(Qd||null==Nd||Nd!==da())return null;var c=Nd;"selectionStart"in c&&Kd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Pd&&ea(Pd,c)?null:(Pd=c,a=T.getPooled(Md.select,Od,a,b),a.type="select",a.target=Nd,Ab(a),a)}
var Sd={eventTypes:Md,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Hd(e);f=Sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?qb(b):window;switch(a){case "topFocus":if(vc(e)||"true"===e.contentEditable)Nd=e,Od=b,Pd=null;break;case "topBlur":Pd=Od=Nd=null;break;case "topMouseDown":Qd=!0;break;case "topContextMenu":case "topMouseUp":return Qd=!1,Rd(c,d);case "topSelectionChange":if(Ld)break;
case "topKeyDown":case "topKeyUp":return Rd(c,d)}return null}};function Td(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Td,{animationName:null,elapsedTime:null,pseudoElement:null});function Ud(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Ud,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function Vd(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(Vd,{relatedTarget:null});
function Wd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var Xd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Yd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function Zd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(Zd,{key:function(a){if(a.key){var b=Xd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Wd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Yd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===a.type?Wd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?Wd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function $d(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass($d,{dataTransfer:null});function ae(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(ae,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed});function be(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(be,{propertyName:null,elapsedTime:null,pseudoElement:null});
function ce(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass(ce,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var de={},ee={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};de[a]=c;ee[b]=c});
var fe={eventTypes:de,extractEvents:function(a,b,c,d){var e=ee[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Wd(c))return null;case "topKeyDown":case "topKeyUp":a=Zd;break;case "topBlur":case "topFocus":a=Vd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=fd;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=
$d;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=ae;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Td;break;case "topTransitionEnd":a=be;break;case "topScroll":a=bd;break;case "topWheel":a=ce;break;case "topCopy":case "topCut":case "topPaste":a=Ud;break;default:a=T}b=a.getPooled(e,b,c,d);Ab(b);return b}};sd=function(a,b,c,d){a=jb(a,b,c,d);kb(a);lb(!1)};hb.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
Wa=sb.getFiberCurrentPropsFromNode;Xa=sb.getInstanceFromNode;Ya=sb.getNodeFromInstance;hb.injectEventPluginsByName({SimpleEventPlugin:fe,EnterLeaveEventPlugin:hd,ChangeEventPlugin:ad,SelectEventPlugin:Sd,BeforeInputEventPlugin:ic});var ge=[],he=-1;function V(a){0>he||(a.current=ge[he],ge[he]=null,he--)}function W(a,b){he++;ge[he]=a.current;a.current=b}new Set;var ie={current:D},X={current:!1},je=D;function ke(a){return le(a)?je:ie.current}
function me(a,b){var c=a.type.contextTypes;if(!c)return D;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function le(a){return 2===a.tag&&null!=a.type.childContextTypes}function ne(a){le(a)&&(V(X,a),V(ie,a))}
function oe(a,b,c){null!=ie.cursor?E("168"):void 0;W(ie,b,a);W(X,c,a)}function pe(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:E("108",jd(a)||"Unknown",e);return B({},b,c)}function qe(a){if(!le(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||D;je=ie.current;W(ie,b,a);W(X,X.current,a);return!0}
function re(a,b){var c=a.stateNode;c?void 0:E("169");if(b){var d=pe(a,je);c.__reactInternalMemoizedMergedChildContext=d;V(X,a);V(ie,a);W(ie,d,a)}else V(X,a);W(X,b,a)}
function Y(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function se(a,b,c){var d=a.alternate;null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.pendingProps=b;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function te(a,b,c){var d=void 0,e=a.type,f=a.key;"function"===typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"===typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"===typeof e&&null!==e&&"number"===typeof e.tag?(d=e,d.pendingProps=a.props):E("130",null==e?e:typeof e,"");d.expirationTime=c;return d}function ue(a,b,c,d){b=new Y(10,d,b);b.pendingProps=a;b.expirationTime=c;return b}
function ve(a,b,c){b=new Y(6,null,b);b.pendingProps=a;b.expirationTime=c;return b}function we(a,b,c){b=new Y(7,a.key,b);b.type=a.handler;b.pendingProps=a;b.expirationTime=c;return b}function xe(a,b,c){a=new Y(9,null,b);a.expirationTime=c;return a}function ye(a,b,c){b=new Y(4,a.key,b);b.pendingProps=a.children||[];b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var ze=null,Ae=null;
function Be(a){return function(b){try{return a(b)}catch(c){}}}function Ce(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ze=Be(function(a){return b.onCommitFiberRoot(c,a)});Ae=Be(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function De(a){"function"===typeof ze&&ze(a)}function Ee(a){"function"===typeof Ae&&Ae(a)}
function Fe(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Ge(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}
function He(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Fe(null));null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=Fe(null))):a=null;a=a!==d?a:null;null===a?Ge(d,b):null===d.last||null===a.last?(Ge(d,b),Ge(a,b)):(Ge(d,b),a.last=b)}function Ie(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Je(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,h=c.first,k=!1;null!==h;){var q=h.expirationTime;if(q>f){var v=c.expirationTime;if(0===v||v>q)c.expirationTime=q;k||(k=!0,c.baseState=a)}else{k||(c.first=h.next,null===
c.first&&(c.last=null));if(h.isReplace)a=Ie(h,d,a,e),g=!0;else if(q=Ie(h,d,a,e))a=g?B({},a,q):B(a,q),g=!1;h.isForced&&(c.hasForceUpdate=!0);null!==h.callback&&(q=c.callbackList,null===q&&(q=c.callbackList=[]),q.push(h))}h=h.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null);k||(c.baseState=a);return a}
function Ke(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?E("191",e):void 0;e.call(b)}}
function Le(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;b._reactInternalFiber=a}var f={isMounted:ld,enqueueSetState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null});a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null});
a(c,g)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber;d=void 0===d?null:d;var e=b(c);He(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null});a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=ke(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?me(a,d):D;b=new c(b,g);e(a,b);f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g);return b},mountClassInstance:function(a,
b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:E("158");var h=ke(a);d.props=g;d.state=a.memoizedState=e;d.refs=D;d.context=me(a,h);null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1);"function"===typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),e=a.updateQueue,null!==e&&(d.state=Je(c,a,e,d,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=
4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?E("159"):void 0);var u=g.context,z=ke(b);z=me(b,z);"function"!==typeof g.componentWillReceiveProps||h===k&&u===z||(u=g.state,g.componentWillReceiveProps(k,z),g.state!==u&&f.enqueueReplaceState(g,g.state,null));u=b.memoizedState;e=null!==b.updateQueue?Je(a,b,b.updateQueue,g,k,e):u;if(!(h!==k||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==
typeof g.componentDidUpdate||h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var G=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)G=!0;else{var I=b.stateNode,L=b.type;G="function"===typeof I.shouldComponentUpdate?I.shouldComponentUpdate(G,e,z):L.prototype&&L.prototype.isPureReactComponent?!ea(h,G)||!ea(u,e):!0}G?("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(k,e,z),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,k),d(b,e));g.props=k;g.state=e;g.context=z;return G}}}var Qe="function"===typeof Symbol&&Symbol["for"],Re=Qe?Symbol["for"]("react.element"):60103,Se=Qe?Symbol["for"]("react.call"):60104,Te=Qe?Symbol["for"]("react.return"):60105,Ue=Qe?Symbol["for"]("react.portal"):60106,Ve=Qe?Symbol["for"]("react.fragment"):60107,We="function"===typeof Symbol&&Symbol.iterator;
function Xe(a){if(null===a||"undefined"===typeof a)return null;a=We&&a[We]||a["@@iterator"];return"function"===typeof a?a:null}var Ye=Array.isArray;
function Ze(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag?E("110"):void 0,d=b.stateNode);d?void 0:E("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===D?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?E("148"):void 0;b._owner?void 0:E("149",c)}return c}
function $e(a,b){"textarea"!==a.type&&E("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function af(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=se(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=ve(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ze(b,c),d["return"]=a,d;d=te(c,a.internalContextTag,d);d.ref=Ze(b,c);d["return"]=a;return d}function q(a,b,c,d){if(null===b||7!==b.tag)return b=we(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);
b["return"]=a;return b}function v(a,b,c,d){if(null===b||9!==b.tag)return b=xe(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=e(b,null,d);b.type=c.value;b["return"]=a;return b}function y(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=ye(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function u(a,b,c,d,f){if(null===b||10!==b.tag)return b=ue(c,a.internalContextTag,
d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ve(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Re:if(b.type===Ve)return b=ue(b.props.children,a.internalContextTag,c,b.key),b["return"]=a,b;c=te(b,a.internalContextTag,c);c.ref=Ze(null,b);c["return"]=a;return c;case Se:return b=we(b,a.internalContextTag,c),b["return"]=a,b;case Te:return c=xe(b,a.internalContextTag,
c),c.type=b.value,c["return"]=a,c;case Ue:return b=ye(b,a.internalContextTag,c),b["return"]=a,b}if(Ye(b)||Xe(b))return b=ue(b,a.internalContextTag,c,null),b["return"]=a,b;$e(a,b)}return null}function G(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Re:return c.key===e?c.type===Ve?u(a,b,c.props.children,d,e):k(a,b,c,d):null;case Se:return c.key===e?q(a,b,c,d):null;case Te:return null===
e?v(a,b,c,d):null;case Ue:return c.key===e?y(a,b,c,d):null}if(Ye(c)||Xe(c))return null!==e?null:u(a,b,c,d,null);$e(a,c)}return null}function I(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Re:return a=a.get(null===d.key?c:d.key)||null,d.type===Ve?u(b,a,d.props.children,e,d.key):k(b,a,d,e);case Se:return a=a.get(null===d.key?c:d.key)||null,q(b,a,d,e);case Te:return a=a.get(c)||null,v(b,a,d,e);case Ue:return a=
a.get(null===d.key?c:d.key)||null,y(b,a,d,e)}if(Ye(d)||Xe(d))return a=a.get(c)||null,u(b,a,d,e,null);$e(b,d)}return null}function L(e,g,m,A){for(var h=null,r=null,n=g,w=g=0,k=null;null!==n&&w<m.length;w++){n.index>w?(k=n,n=null):k=n.sibling;var x=G(e,n,m[w],A);if(null===x){null===n&&(n=k);break}a&&n&&null===x.alternate&&b(e,n);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x;n=k}if(w===m.length)return c(e,n),h;if(null===n){for(;w<m.length;w++)if(n=z(e,m[w],A))g=f(n,g,w),null===r?h=n:r.sibling=n,r=n;return h}for(n=
d(e,n);w<m.length;w++)if(k=I(n,e,w,m[w],A)){if(a&&null!==k.alternate)n["delete"](null===k.key?w:k.key);g=f(k,g,w);null===r?h=k:r.sibling=k;r=k}a&&n.forEach(function(a){return b(e,a)});return h}function N(e,g,m,A){var h=Xe(m);"function"!==typeof h?E("150"):void 0;m=h.call(m);null==m?E("151"):void 0;for(var r=h=null,n=g,w=g=0,k=null,x=m.next();null!==n&&!x.done;w++,x=m.next()){n.index>w?(k=n,n=null):k=n.sibling;var J=G(e,n,x.value,A);if(null===J){n||(n=k);break}a&&n&&null===J.alternate&&b(e,n);g=f(J,
g,w);null===r?h=J:r.sibling=J;r=J;n=k}if(x.done)return c(e,n),h;if(null===n){for(;!x.done;w++,x=m.next())x=z(e,x.value,A),null!==x&&(g=f(x,g,w),null===r?h=x:r.sibling=x,r=x);return h}for(n=d(e,n);!x.done;w++,x=m.next())if(x=I(n,e,w,x.value,A),null!==x){if(a&&null!==x.alternate)n["delete"](null===x.key?w:x.key);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x}a&&n.forEach(function(a){return b(e,a)});return h}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===Ve&&null===f.key&&(f=f.props.children);
var m="object"===typeof f&&null!==f;if(m)switch(f.$$typeof){case Re:a:{var r=f.key;for(m=d;null!==m;){if(m.key===r)if(10===m.tag?f.type===Ve:m.type===f.type){c(a,m.sibling);d=e(m,f.type===Ve?f.props.children:f.props,h);d.ref=Ze(m,f);d["return"]=a;a=d;break a}else{c(a,m);break}else b(a,m);m=m.sibling}f.type===Ve?(d=ue(f.props.children,a.internalContextTag,h,f.key),d["return"]=a,a=d):(h=te(f,a.internalContextTag,h),h.ref=Ze(d,f),h["return"]=a,a=h)}return g(a);case Se:a:{for(m=f.key;null!==d;){if(d.key===
m)if(7===d.tag){c(a,d.sibling);d=e(d,f,h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=we(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a);case Te:a:{if(null!==d)if(9===d.tag){c(a,d.sibling);d=e(d,null,h);d.type=f.value;d["return"]=a;a=d;break a}else c(a,d);d=xe(f,a.internalContextTag,h);d.type=f.value;d["return"]=a;a=d}return g(a);case Ue:a:{for(m=f.key;null!==d;){if(d.key===m)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===
f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ye(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h)):(c(a,d),d=ve(f,a.internalContextTag,h)),d["return"]=a,a=d,g(a);if(Ye(f))return L(a,d,f,h);if(Xe(f))return N(a,d,f,h);m&&$e(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,E("152",h.displayName||
h.name||"Component")}return c(a,d)}}var bf=af(!0),cf=af(!1);
function df(a,b,c,d,e){function f(a,b,c){var d=b.expirationTime;b.child=null===a?cf(b,null,c,d):bf(b,a.child,c,d)}function g(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){g(a,b);if(!c)return d&&re(b,!1),q(a,b);c=b.stateNode;id.current=b;var e=c.render();b.effectTag|=1;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&re(b,!0);return b.child}function k(a){var b=a.stateNode;b.pendingContext?oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&oe(a,
b.context,!1);I(a,b.containerInfo)}function q(a,b){null!==a&&b.child!==a.child?E("153"):void 0;if(null!==b.child){a=b.child;var c=se(a,a.pendingProps,a.expirationTime);b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=se(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}function v(a,b){switch(b.tag){case 3:k(b);break;case 2:qe(b);break;case 4:I(b,b.stateNode.containerInfo)}return null}var y=a.shouldSetTextContent,u=a.useSyncScheduling,z=a.shouldDeprioritizeSubtree,
G=b.pushHostContext,I=b.pushHostContainer,L=c.enterHydrationState,N=c.resetHydrationState,J=c.tryToClaimNextHydratableInstance;a=Le(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var w=a.adoptClassInstance,m=a.constructClassInstance,A=a.mountClassInstance,Ob=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return v(a,b);switch(b.tag){case 0:null!==a?E("155"):void 0;var d=b.type,e=b.pendingProps,r=ke(b);r=me(b,r);d=d(e,r);b.effectTag|=
1;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=2,e=qe(b),w(b,d),A(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child);return b;case 1:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(X.current)null===c&&(c=d);else if(null===c||d===c){b=q(a,b);break a}d=ke(b);d=me(b,d);e=e(c,d);b.effectTag|=1;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case 2:return e=qe(b),d=void 0,null===a?b.stateNode?E("153"):(m(b,b.pendingProps),A(b,c),d=!0):d=Ob(a,b,c),h(a,b,d,e);case 3:return k(b),
e=b.updateQueue,null!==e?(d=b.memoizedState,e=Je(a,b,e,null,null,c),d===e?(N(),b=q(a,b)):(d=e.element,r=b.stateNode,(null===a||null===a.child)&&r.hydrate&&L(b)?(b.effectTag|=2,b.child=cf(b,null,d,c)):(N(),f(a,b,d)),b.memoizedState=e,b=b.child)):(N(),b=q(a,b)),b;case 5:G(b);null===a&&J(b);e=b.type;var n=b.memoizedProps;d=b.pendingProps;null===d&&(d=n,null===d?E("154"):void 0);r=null!==a?a.memoizedProps:null;X.current||null!==d&&n!==d?(n=d.children,y(e,d)?n=null:r&&y(e,r)&&(b.effectTag|=16),g(a,b),
2147483647!==c&&!u&&z(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,n),b.memoizedProps=d,b=b.child)):b=q(a,b);return b;case 6:return null===a&&J(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null===e?E("154"):void 0);else if(null===e||b.memoizedProps===e)e=b.memoizedProps;d=e.children;b.stateNode=null===a?cf(b,b.stateNode,d,c):bf(b,b.stateNode,d,c);b.memoizedProps=e;return b.stateNode;
case 9:return null;case 4:a:{I(b,b.stateNode.containerInfo);e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null==e?E("154"):void 0);else if(null===e||b.memoizedProps===e){b=q(a,b);break a}null===a?b.child=bf(b,null,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case 10:a:{c=b.pendingProps;if(X.current)null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=q(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:E("156")}},beginFailedWork:function(a,b,
c){switch(b.tag){case 2:qe(b);break;case 3:k(b);break;default:E("157")}b.effectTag|=64;null===a?b.child=null:b.child!==a.child&&(b.child=a.child);if(0===b.expirationTime||b.expirationTime>c)return v(a,b);b.firstEffect=null;b.lastEffect=null;b.child=null===a?cf(b,null,null,c):bf(b,a.child,null,c);2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
function ef(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,h=a.finalizeInitialChildren,k=a.prepareUpdate,q=a.persistence,v=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,z=b.popHostContainer,G=c.prepareToHydrateHostInstance,I=c.prepareToHydrateHostTextInstance,L=c.popHydrationState,N=void 0,J=void 0,w=void 0;a.mutation?(N=function(){},J=function(a,b,c){(b.updateQueue=c)&&d(b)},w=function(a,b,c,e){c!==e&&d(b)}):q?E("235"):E("236");
return{completeWork:function(a,b,c){var m=b.pendingProps;if(null===m)m=b.memoizedProps;else if(2147483647!==b.expirationTime||2147483647===c)b.pendingProps=null;switch(b.tag){case 1:return null;case 2:return ne(b),null;case 3:z(b);V(X,b);V(ie,b);m=b.stateNode;m.pendingContext&&(m.context=m.pendingContext,m.pendingContext=null);if(null===a||null===a.child)L(b),b.effectTag&=-3;N(b);return null;case 5:y(b);c=v();var A=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,q=b.stateNode,x=u();q=
k(q,A,p,m,c,x);J(a,b,q,A,p,m,c);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!m)return null===b.stateNode?E("166"):void 0,null;a=u();if(L(b))G(b,c,a)&&d(b);else{a=e(A,m,c,a,b);a:for(p=b.child;null!==p;){if(5===p.tag||6===p.tag)g(a,p.stateNode);else if(4!==p.tag&&null!==p.child){p.child["return"]=p;p=p.child;continue}if(p===b)break;for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}h(a,A,m,c)&&d(b);b.stateNode=a}null!==b.ref&&
(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)w(a,b,a.memoizedProps,m);else{if("string"!==typeof m)return null===b.stateNode?E("166"):void 0,null;a=v();c=u();L(b)?I(b)&&d(b):b.stateNode=f(m,a,c,b)}return null;case 7:(m=b.memoizedProps)?void 0:E("165");b.tag=8;A=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==p;){if(5===p.tag||6===p.tag||4===p.tag)E("247");else if(9===p.tag)A.push(p.type);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===
p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=m.handler;m=p(m.props,A);b.child=bf(b,null!==a?a.child:null,m,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 10:return null;case 4:return z(b),N(b),null;case 0:E("167");default:E("156")}}}}
function ff(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(A){b(a,A)}}function d(a){"function"===typeof Ee&&Ee(a);switch(a.tag){case 2:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(A){b(a,A)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:k&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||k&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||
b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?E("160"):void 0;switch(c.tag){case 5:f=c.stateNode;g=!1;break a;case 3:f=c.stateNode.containerInfo;g=!0;break a;case 4:f=c.stateNode.containerInfo;g=!0;break a}c=c["return"]}c=!0}if(5===b.tag||6===b.tag)e(b),g?J(f,b.stateNode):N(f,b.stateNode);
else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var h=a.getPublicInstance,k=a.mutation;a=a.persistence;k||(a?E("235"):E("236"));var q=k.commitMount,v=k.commitUpdate,y=k.resetTextContent,u=k.commitTextUpdate,z=k.appendChild,G=k.appendChildToContainer,I=k.insertBefore,L=k.insertInContainerBefore,
N=k.removeChild,J=k.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(f(b)){var c=b;break a}b=b["return"]}E("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:E("161")}c.effectTag&16&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||f(c["return"])){c=
null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?L(b,e.stateNode,c):I(b,e.stateNode,c):d?G(b,e.stateNode):z(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===
a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){g(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&v(c,f,e,a,d,b)}break;case 6:null===b.stateNode?E("162"):void 0;c=b.memoizedProps;u(b.stateNode,null!==a?a.memoizedProps:
c,c);break;case 3:break;default:E("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(b.effectTag&4)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b=b.updateQueue;null!==b&&Ke(b,c);break;case 3:c=b.updateQueue;null!==c&&Ke(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode;null===a&&b.effectTag&4&&q(c,
b.type,b.memoizedProps,b);break;case 6:break;case 4:break;default:E("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(h(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var gf={};
function hf(a){function b(a){a===gf?E("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:gf},f={current:gf},g={current:gf};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a);V(f,a);V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a);b=d(b);W(f,a,a);W(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);
d=c(h,a.type,d);h!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=gf;g.current=gf}}}
function jf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=g(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];y=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){E("175")},prepareToHydrateHostTextInstance:function(){E("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,q=a.hydrateInstance,v=a.hydrateTextInstance,y=null,u=null,z=!1;return{enterHydrationState:function(a){u=
k(a.stateNode.containerInfo);y=a;return z=!0},resetHydrationState:function(){u=y=null;z=!1},tryToClaimNextHydratableInstance:function(a){if(z){var d=u;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=2;z=!1;y=a;return}b(y,u)}y=a;u=k(d)}else a.effectTag|=2,z=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=q(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return v(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
y)return!1;if(!z)return d(a),z=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=h(c);d(a);u=y?h(a.stateNode):null;return!0}}}
function kf(a){function b(a){Qb=ja=!0;var b=a.stateNode;b.current===a?E("177"):void 0;b.isReadyForCommit=!1;id.current=null;if(1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;yg();for(t=c;null!==t;){var d=!1,e=void 0;try{for(;null!==t;){var f=t.effectTag;f&16&&zg(t);if(f&128){var g=t.alternate;null!==g&&Ag(g)}switch(f&-242){case 2:Ne(t);t.effectTag&=-3;break;case 6:Ne(t);t.effectTag&=-3;Oe(t.alternate,t);break;case 4:Oe(t.alternate,
t);break;case 8:Sc=!0,Bg(t),Sc=!1}t=t.nextEffect}}catch(Tc){d=!0,e=Tc}d&&(null===t?E("178"):void 0,h(t,e),null!==t&&(t=t.nextEffect))}Cg();b.current=a;for(t=c;null!==t;){c=!1;d=void 0;try{for(;null!==t;){var k=t.effectTag;k&36&&Dg(t.alternate,t);k&128&&Eg(t);if(k&64)switch(e=t,f=void 0,null!==R&&(f=R.get(e),R["delete"](e),null==f&&null!==e.alternate&&(e=e.alternate,f=R.get(e),R["delete"](e))),null==f?E("184"):void 0,e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});
break;case 3:null===ca&&(ca=f.error);break;default:E("157")}var Qc=t.nextEffect;t.nextEffect=null;t=Qc}}catch(Tc){c=!0,d=Tc}c&&(null===t?E("178"):void 0,h(t,d),null!==t&&(t=t.nextEffect))}ja=Qb=!1;"function"===typeof De&&De(a.stateNode);ha&&(ha.forEach(G),ha=null);null!==ca&&(a=ca,ca=null,Ob(a));b=b.current.expirationTime;0===b&&(qa=R=null);return b}function c(a){for(;;){var b=Fg(a.alternate,a,H),c=a["return"],d=a.sibling;var e=a;if(2147483647===H||2147483647!==e.expirationTime){if(2!==e.tag&&3!==
e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;
if(null!==c)a=c;else{a.stateNode.isReadyForCommit=!0;break}}return null}function d(a){var b=rg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function e(a){var b=Gg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function f(a){if(null!==R){if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=k(F)?e(F):d(F);else for(;null!==F&&!A();)F=k(F)?e(F):d(F)}else if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=d(F);else for(;null!==F&&!A();)F=d(F)}function g(a,b){ja?E("243"):void 0;ja=!0;a.isReadyForCommit=
!1;if(a!==ra||b!==H||null===F){for(;-1<he;)ge[he]=null,he--;je=D;ie.current=D;X.current=!1;x();ra=a;H=b;F=se(ra.current,null,b)}var c=!1,d=null;try{f(b)}catch(Rc){c=!0,d=Rc}for(;c;){if(eb){ca=d;break}var g=F;if(null===g)eb=!0;else{var k=h(g,d);null===k?E("183"):void 0;if(!eb){try{c=k;d=b;for(k=c;null!==g;){switch(g.tag){case 2:ne(g);break;case 5:qg(g);break;case 3:p(g);break;case 4:p(g)}if(g===k||g.alternate===k)break;g=g["return"]}F=e(c);f(d)}catch(Rc){c=!0;d=Rc;continue}break}}}b=ca;eb=ja=!1;ca=
null;null!==b&&Ob(b);return a.isReadyForCommit?a.current.alternate:null}function h(a,b){var c=id.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,q(a)&&(eb=!0);else for(var g=a["return"];null!==g&&null===c;){2===g.tag?"function"===typeof g.stateNode.componentDidCatch&&(d=!0,f=jd(g),c=g,e=!0):3===g.tag&&(c=g);if(q(g)){if(Sc||null!==ha&&(ha.has(g)||null!==g.alternate&&ha.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===qa&&(qa=new Set);qa.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=
g._debugOwner,Qc=g._debugSource;var m=jd(g);var n=null;k&&(n=jd(k));k=Qc;m="\n    in "+(m||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:m=""}h+=m;g=g["return"]}while(g);g=h;a=jd(a);null===R&&(R=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};R.set(c,b);try{var p=b.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(Vc){Vc&&
Vc.suppressReactErrorLogging||console.error(Vc)}Qb?(null===ha&&(ha=new Set),ha.add(c)):G(c);return c}null===ca&&(ca=b);return null}function k(a){return null!==R&&(R.has(a)||null!==a.alternate&&R.has(a.alternate))}function q(a){return null!==qa&&(qa.has(a)||null!==a.alternate&&qa.has(a.alternate))}function v(){return 20*(((I()+100)/20|0)+1)}function y(a){return 0!==ka?ka:ja?Qb?1:H:!Hg||a.internalContextTag&1?v():1}function u(a,b){return z(a,b,!1)}function z(a,b){for(;null!==a;){if(0===a.expirationTime||
a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a["return"])if(3===a.tag){var c=a.stateNode;!ja&&c===ra&&b<H&&(F=ra=null,H=0);var d=c,e=b;Rb>Ig&&E("185");if(null===d.nextScheduledRoot)d.remainingExpirationTime=e,null===O?(sa=O=d,d.nextScheduledRoot=d):(O=O.nextScheduledRoot=d,O.nextScheduledRoot=sa);else{var f=d.remainingExpirationTime;if(0===f||e<f)d.remainingExpirationTime=e}Fa||(la?
Sb&&(ma=d,na=1,m(ma,na)):1===e?w(1,null):L(e));!ja&&c===ra&&b<H&&(F=ra=null,H=0)}else break;a=a["return"]}}function G(a){z(a,1,!0)}function I(){return Uc=((Wc()-Pe)/10|0)+2}function L(a){if(0!==Tb){if(a>Tb)return;Jg(Xc)}var b=Wc()-Pe;Tb=a;Xc=Kg(J,{timeout:10*(a-2)-b})}function N(){var a=0,b=null;if(null!==O)for(var c=O,d=sa;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===O?E("244"):void 0;if(d===d.nextScheduledRoot){sa=O=d.nextScheduledRoot=null;break}else if(d===sa)sa=e=d.nextScheduledRoot,
O.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===O){O=c;O.nextScheduledRoot=sa;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===O)break;c=d;d=d.nextScheduledRoot}}c=ma;null!==c&&c===b?Rb++:Rb=0;ma=b;na=a}function J(a){w(0,a)}function w(a,b){fb=b;for(N();null!==ma&&0!==na&&(0===a||na<=a)&&!Yc;)m(ma,na),N();null!==fb&&(Tb=0,Xc=-1);0!==na&&L(na);fb=null;Yc=!1;Rb=0;if(Ub)throw a=Zc,Zc=
null,Ub=!1,a;}function m(a,c){Fa?E("245"):void 0;Fa=!0;if(c<=I()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(a.remainingExpirationTime=b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(A()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Fa=!1}function A(){return null===fb||fb.timeRemaining()>Lg?!1:Yc=!0}function Ob(a){null===ma?E("246"):
void 0;ma.remainingExpirationTime=0;Ub||(Ub=!0,Zc=a)}var r=hf(a),n=jf(a),p=r.popHostContainer,qg=r.popHostContext,x=r.resetHostContainer,Me=df(a,r,n,u,y),rg=Me.beginWork,Gg=Me.beginFailedWork,Fg=ef(a,r,n).completeWork;r=ff(a,h);var zg=r.commitResetTextContent,Ne=r.commitPlacement,Bg=r.commitDeletion,Oe=r.commitWork,Dg=r.commitLifeCycles,Eg=r.commitAttachRef,Ag=r.commitDetachRef,Wc=a.now,Kg=a.scheduleDeferredCallback,Jg=a.cancelDeferredCallback,Hg=a.useSyncScheduling,yg=a.prepareForCommit,Cg=a.resetAfterCommit,
Pe=Wc(),Uc=2,ka=0,ja=!1,F=null,ra=null,H=0,t=null,R=null,qa=null,ha=null,ca=null,eb=!1,Qb=!1,Sc=!1,sa=null,O=null,Tb=0,Xc=-1,Fa=!1,ma=null,na=0,Yc=!1,Ub=!1,Zc=null,fb=null,la=!1,Sb=!1,Ig=1E3,Rb=0,Lg=1;return{computeAsyncExpiration:v,computeExpirationForFiber:y,scheduleWork:u,batchedUpdates:function(a,b){var c=la;la=!0;try{return a(b)}finally{(la=c)||Fa||w(1,null)}},unbatchedUpdates:function(a){if(la&&!Sb){Sb=!0;try{return a()}finally{Sb=!1}}return a()},flushSync:function(a){var b=la;la=!0;try{a:{var c=
ka;ka=1;try{var d=a();break a}finally{ka=c}d=void 0}return d}finally{la=b,Fa?E("187"):void 0,w(1,null)}},deferredUpdates:function(a){var b=ka;ka=v();try{return a()}finally{ka=b}}}}
function lf(a){function b(a){a=od(a);return null===a?null:a.stateNode}var c=a.getPublicInstance;a=kf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null};return c.stateNode=a},updateContainer:function(a,b,c,q){var g=b.current;if(c){c=
c._reactInternalFiber;var h;b:{2===kd(c)&&2===c.tag?void 0:E("170");for(h=c;3!==h.tag;){if(le(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h["return"])?void 0:E("171")}h=h.stateNode.context}c=le(c)?pe(c,h):h}else c=D;null===b.context?b.context=c:b.pendingContext=c;b=q;b=void 0===b?null:b;q=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g);He(g,{expirationTime:q,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,
nextCallback:null,next:null});f(g,q)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){a=pd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return Ce(B({},
a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ue,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};
var sf=void 0,tf=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==wf&&wf<=
a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity}})})},
tf=function(a){clearTimeout(a)};var Ef=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Ff={},Gf={};
function Hf(a){if(Gf.hasOwnProperty(a))return!0;if(Ff.hasOwnProperty(a))return!1;if(Ef.test(a))return Gf[a]=!0;Ff[a]=!0;return!1}
function If(a,b,c){var d=wa(b);if(d&&va(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Jf(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Kf(a,b,va(b,c)?c:null)}
function Kf(a,b,c){Hf(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Jf(a,b){var c=wa(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}
function Lf(a,b){var c=b.value,d=b.checked;return B({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function Mf(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}
function Nf(a,b){b=b.checked;null!=b&&If(a,"checked",b)}function Of(a,b){Nf(a,b);var c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Pf(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Qf(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function Rf(a,b){a=B({children:void 0},b);if(b=Qf(b.children))a.children=b;return a}function Sf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Tf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Uf(a,b){null!=b.dangerouslySetInnerHTML?E("91"):void 0;return B({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Vf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?E("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:E("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Wf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Xf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Yf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Zf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function $f(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Zf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ag=void 0,bg=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Yf.svg||"innerHTML"in a)a.innerHTML=b;else{ag=ag||document.createElement("div");ag.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=ag.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function cg(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var dg={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},eg=["Webkit","ms","Moz","O"];Object.keys(dg).forEach(function(a){eg.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);dg[b]=dg[a]})});
function fg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||dg.hasOwnProperty(e)&&dg[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var gg=B({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function hg(a,b,c){b&&(gg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?E("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?E("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:E("61")),null!=b.style&&"object"!==typeof b.style?E("62",c()):void 0)}
function ig(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var jg=Yf.html,kg=C.thatReturns("");
function lg(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Hd(a);b=Sa[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?wd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(wd("topFocus","focus",a),wd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(yc("cancel",!0)&&wd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(yc("close",!0)&&wd("topClose","close",a),c.topClose=!0):Dd.hasOwnProperty(e)&&U(e,Dd[e],a),c[e]=!0)}}
var mg={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"};function ng(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===jg&&(d=Zf(a));d===jg?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function og(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function pg(a,b,c,d){var e=ig(b,c);switch(b){case "iframe":case "object":U("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);f=c;break;case "source":U("topError","error",a);f=c;break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);f=c;break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);f=c;break;case "details":U("topToggle","toggle",a);f=c;break;case "input":Mf(a,c);f=Lf(a,c);U("topInvalid","invalid",a);
lg(d,"onChange");break;case "option":f=Rf(a,c);break;case "select":Tf(a,c);f=B({},c,{value:void 0});U("topInvalid","invalid",a);lg(d,"onChange");break;case "textarea":Vf(a,c);f=Uf(a,c);U("topInvalid","invalid",a);lg(d,"onChange");break;default:f=c}hg(b,f,kg);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?fg(a,k,kg):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&bg(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&cg(a,k):"number"===typeof k&&cg(a,
""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Ra.hasOwnProperty(h)?null!=k&&lg(d,h):e?Kf(a,h,k):null!=k&&If(a,h,k))}switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Sf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Sf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=
C)}}
function sg(a,b,c,d,e){var f=null;switch(b){case "input":c=Lf(a,c);d=Lf(a,d);f=[];break;case "option":c=Rf(a,c);d=Rf(a,d);f=[];break;case "select":c=B({},c,{value:void 0});d=B({},d,{value:void 0});f=[];break;case "textarea":c=Uf(a,c);d=Uf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}hg(b,d,kg);var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]=
"");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Ra.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===
g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Ra.hasOwnProperty(g)?(null!=k&&lg(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f}
function tg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Nf(a,e);ig(c,d);d=ig(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?fg(a,h,kg):"dangerouslySetInnerHTML"===g?bg(a,h):"children"===g?cg(a,h):d?null!=h?Kf(a,g,h):a.removeAttribute(g):null!=h?If(a,g,h):Jf(a,g)}switch(c){case "input":Of(a,e);break;case "textarea":Wf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Sf(a,
!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?Sf(a,!!e.multiple,e.defaultValue,!0):Sf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function ug(a,b,c,d,e){switch(b){case "iframe":case "object":U("topLoad","load",a);break;case "video":case "audio":for(var f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);break;case "source":U("topError","error",a);break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);break;case "details":U("topToggle","toggle",a);break;case "input":Mf(a,c);U("topInvalid","invalid",a);lg(e,"onChange");break;case "select":Tf(a,c);
U("topInvalid","invalid",a);lg(e,"onChange");break;case "textarea":Vf(a,c),U("topInvalid","invalid",a),lg(e,"onChange")}hg(b,c,kg);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Ra.hasOwnProperty(g)&&null!=f&&lg(e,g));switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function vg(a,b){return a.nodeValue!==b}
var wg=Object.freeze({createElement:ng,createTextNode:og,setInitialProperties:pg,diffProperties:sg,updateProperties:tg,diffHydratedProperties:ug,diffHydratedText:vg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Of(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=rb(d);e?void 0:E("90");Cc(d);Of(d,e)}}}break;case "textarea":Wf(a,c);break;case "select":b=c.value,null!=b&&Sf(a,!!c.multiple,b,!1)}}});nc.injectFiberControlledHostComponent(wg);var xg=null,Mg=null;function Ng(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function Og(a){a=a?9===a.nodeType?a.documentElement:a.firstChild:null;return!(!a||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}
var Z=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:$f(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=$f(a,b)}return a},getChildHostContext:function(a,b){return $f(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){xg=td;var a=da();if(Kd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(z){b=null;break a}var f=0,g=-1,h=-1,k=0,q=0,v=a,y=null;b:for(;;){for(var u;;){v!==b||0!==d&&3!==v.nodeType||(g=f+d);v!==e||0!==c&&3!==v.nodeType||(h=f+c);3===v.nodeType&&(f+=v.nodeValue.length);if(null===(u=v.firstChild))break;y=v;v=u}for(;;){if(v===a)break b;y===b&&++k===d&&(g=f);y===e&&++q===c&&(h=f);if(null!==(u=v.nextSibling))break;v=y;y=v.parentNode}v=u}b=-1===g||-1===h?null:
{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;Mg={focusedElem:a,selectionRange:b};ud(!1)},resetAfterCommit:function(){var a=Mg,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){if(Kd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Eb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=Jd(c,a);var f=Jd(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ia(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=
a.top}Mg=null;ud(xg);xg=null},createInstance:function(a,b,c,d,e){a=ng(a,b,c,d);a[Q]=e;a[ob]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){pg(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return sg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===
typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=og(a,b);a[Q]=d;return a},now:rf,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[ob]=e;tg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,
b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,
b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[Q]=f;a[ob]=c;return ug(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[Q]=c;return vg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},
didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf,useSyncScheduling:!0});rc=Z.batchedUpdates;
function Pg(a,b,c,d,e){Ng(c)?void 0:E("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{d=d||Og(c);if(!d)for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g;Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Qg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ng(b)?void 0:E("200");return pf(a,b,null,c)}
function Rg(a,b){this._reactRootContainer=Z.createContainer(a,b)}Rg.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)};Rg.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};
var Sg={createPortal:Qg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"===typeof a.render?E("188"):E("213",Object.keys(a))},hydrate:function(a,b,c){return Pg(null,a,b,!0,c)},render:function(a,b,c){return Pg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?E("38"):void 0;return Pg(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ng(a)?void 0:
E("40");return a._reactRootContainer?(Z.unbatchedUpdates(function(){Pg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:Qg,unstable_batchedUpdates:tc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:mb,EventPluginRegistry:Va,EventPropagators:Cb,ReactControlledComponent:qc,ReactDOMComponentTree:sb,ReactDOMEventListener:xd}};
Z.injectIntoDevTools({findFiberByHostInstance:pb,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var Tg=Object.freeze({default:Sg}),Ug=Tg&&Sg||Tg;module.exports=Ug["default"]?Ug["default"]:Ug;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _withContentRect = __webpack_require__(52);

var _withContentRect2 = _interopRequireDefault(_withContentRect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Measure(_ref) {
  var measure = _ref.measure,
      measureRef = _ref.measureRef,
      contentRect = _ref.contentRect,
      children = _ref.children;

  return children({ measure: measure, measureRef: measureRef, contentRect: contentRect });
}

exports.default = (0, _withContentRect2.default)()(Measure);
module.exports = exports['default'];

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function getContentRect(node, types) {
  var calculations = {};

  if (types.indexOf('client') > -1) {
    calculations.client = {
      top: node.clientTop,
      left: node.clientLeft,
      width: node.clientWidth,
      height: node.clientHeight
    };
  }

  if (types.indexOf('offset') > -1) {
    calculations.offset = {
      top: node.offsetTop,
      left: node.offsetLeft,
      width: node.offsetWidth,
      height: node.offsetHeight
    };
  }

  if (types.indexOf('scroll') > -1) {
    calculations.scroll = {
      top: node.scrollTop,
      left: node.scrollLeft,
      width: node.scrollWidth,
      height: node.scrollHeight
    };
  }

  if (types.indexOf('bounds') > -1) {
    var rect = node.getBoundingClientRect();
    calculations.bounds = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.width,
      height: rect.height
    };
  }

  if (types.indexOf('margin') > -1) {
    var styles = getComputedStyle(node);
    calculations.margin = {
      top: parseInt(styles.marginTop),
      right: parseInt(styles.marginRight),
      bottom: parseInt(styles.marginBottom),
      left: parseInt(styles.marginLeft)
    };
  }

  return calculations;
}

exports.default = getContentRect;
module.exports = exports['default'];

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getTypes;
var types = ['client', 'offset', 'scroll', 'bounds', 'margin'];

function getTypes(props) {
  var allowedTypes = [];
  types.forEach(function (type) {
    if (props[type]) {
      allowedTypes.push(type);
    }
  });
  return allowedTypes;
}
module.exports = exports['default'];

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(0);

var PropTypes = _interopRequireWildcard(_propTypes);

var _addClass = __webpack_require__(176);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(178);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__(53);

var _Transition2 = _interopRequireDefault(_Transition);

var _PropTypes = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass2.default)(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass2.default)(node, c);
  });
};

var propTypes = _extends({}, _Transition2.default.propTypes, {

  /**
   * The animation classNames applied to the component as it enters or exits.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-exit`, `fade-exit-active`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   * }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  exit?: string,
   *  exitActive?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** from the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** from the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
});

/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 *
 * ```js
 * import CSSTransition from 'react-transition-group/CSSTransition';
 *
 * const Fade = ({ children, ...props }) => (
 *  <CSSTransition
 *    {...props}
 *    timeout={500}
 *    classNames="fade"
 *  >
 *   {children}
 *  </CSSTransition>
 * );
 *
 * class FadeInAndOut extends React.Component {
 *   constructor(...args) {
 *     super(...args);
 *     this.state= { show: false }
 *
 *     setInterval(() => {
 *       this.setState({ show: !this.state.show })
 *     }, 5000)
 *   }
 *   render() {
 *     return (
 *       <Fade in={this.state.show}>
 *         <div>Hello world</div>
 *       </Fade>
 *     )
 *   }
 * }
 * ```
 *
 * And the coorresponding CSS for the `<Fade>` component:
 *
 * ```css
 * .fade-enter {
 *   opacity: 0.01;
 * }
 *
 * .fade-enter.fade-enter-active {
 *   opacity: 1;
 *   transition: opacity 500ms ease-in;
 * }
 *
 * .fade-exit {
 *   opacity: 1;
 * }
 *
 * .fade-exit.fade-exit-active {
 *   opacity: 0.01;
 *   transition: opacity 300ms ease-in;
 * }
 * ```
 */

var CSSTransition = function (_React$Component) {
  _inherits(CSSTransition, _React$Component);

  function CSSTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');
      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.onEntered = function (node, appearing) {
      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.onExited = function (node) {
      _this.removeClasses(node, 'exit');

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;


      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;

      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';

      return { className: className, activeClassName: activeClassName };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
    var _getClassNames = this.getClassNames(type),
        className = _getClassNames.className,
        activeClassName = _getClassNames.activeClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
  };

  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    /* eslint-disable no-unused-expressions */
    node.scrollTop;
    /* eslint-enable no-unused-expressions */
    addClass(node, className);
  };

  CSSTransition.prototype.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;

    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react2.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};

exports.default = CSSTransition;
module.exports = exports['default'];

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _ChildMapping = __webpack_require__(265);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disabled appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disabled enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
    * A convenience prop that enables or disabled exit animations
    * for all children. Note that specifying this will override any defaults set
    * on individual children Transitions.
    */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};

/**
 * The `<TransitionGroup>` component manages a set of `<Transition>` components
 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
 * state machine for managing the mounting and unmounting of components over
 * time.
 *
 * Consider the example below using the `Fade` CSS transition from before.
 * As items are removed or added to the TodoList the `in` prop is toggled
 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
 * component in a `<TransitionGroup>`, not just css.
 *
 * ```jsx
 * import TransitionGroup from 'react-transition-group/TransitionGroup';
 *
 * class TodoList extends React.Component {
 *   constructor(props) {
 *     super(props)
 *     this.state = {items: ['hello', 'world', 'click', 'me']}
 *   }
 *   handleAdd() {
 *     const newItems = this.state.items.concat([
 *       prompt('Enter some text')
 *     ]);
 *     this.setState({ items: newItems });
 *   }
 *   handleRemove(i) {
 *     let newItems = this.state.items.slice();
 *     newItems.splice(i, 1);
 *     this.setState({items: newItems});
 *   }
 *   render() {
 *     return (
 *       <div>
 *         <button onClick={() => this.handleAdd()}>Add Item</button>
 *         <TransitionGroup>
 *           {this.state.items.map((item, i) => (
 *             <FadeTransition key={item}>
 *               <div>
 *                 {item}{' '}
 *                 <button onClick={() => this.handleRemove(i)}>
 *                   remove
 *                 </button>
 *               </div>
 *             </FadeTransition>
 *           ))}
 *         </TransitionGroup>
 *       </div>
 *     );
 *   }
 * }
 * ```
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual `<Transition>`
 * components. This means you can mix and match animations across different
 * list items.
 */

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    // Initial children should all be entering, dependent on appear
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleExited = function (key, node, originalHandler) {
      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (key in currentChildMapping) return;

      if (originalHandler) originalHandler(node);

      _this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[key];
        return { children: children };
      });
    };

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
        var onExited = function onExited(node) {
          _this.handleExited(child.key, node, child.props.onExited);
        };

        return (0, _react.cloneElement)(child, {
          onExited: onExited,
          in: true,
          appear: _this.getProp(child, 'appear'),
          enter: _this.getProp(child, 'enter'),
          exit: _this.getProp(child, 'exit')
        });
      })
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };
  // use child config unless explictly set by the Group


  TransitionGroup.prototype.getProp = function getProp(child, prop) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;

    return props[prop] != null ? props[prop] : child.props[prop];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var prevChildMapping = this.state.children;
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);

    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);

    Object.keys(children).forEach(function (key) {
      var child = children[key];

      if (!(0, _react.isValidElement)(child)) return;

      var onExited = function onExited(node) {
        _this2.handleExited(child.key, node, child.props.onExited);
      };

      var hasPrev = key in prevChildMapping;
      var hasNext = key in nextChildMapping;

      var prevChild = prevChildMapping[key];
      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;

      // item is new (entering)
      if (hasNext && (!hasPrev || isLeaving)) {
        // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
          onExited: onExited,
          in: true,
          exit: _this2.getProp(child, 'exit', nextProps),
          enter: _this2.getProp(child, 'enter', nextProps)
        });
      }
      // item is old (exiting)
      else if (!hasNext && hasPrev && !isLeaving) {
          // console.log('leaving', key)
          children[key] = (0, _react.cloneElement)(child, { in: false });
        }
        // item hasn't changed transition states
        // copy over the last transition props;
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
            // console.log('unchanged', key)
            children[key] = (0, _react.cloneElement)(child, {
              onExited: onExited,
              in: prevChild.props.in,
              exit: _this2.getProp(child, 'exit', nextProps),
              enter: _this2.getProp(child, 'enter', nextProps)
            });
          }
    });

    this.setState({ children: children });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = this.state.children;


    delete props.appear;
    delete props.enter;
    delete props.exit;

    return _react2.default.createElement(
      Component,
      props,
      values(children).map(childFactory)
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(9);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(51),n=__webpack_require__(50),p=__webpack_require__(21),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map != 'undefined') {
        return Map;
    }

    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;

        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;

                return true;
            }

            return false;
        });

        return result;
    }

    return (function () {
        function anonymous() {
            this.__entries__ = [];
        }

        var prototypeAccessors = { size: {} };

        /**
         * @returns {boolean}
         */
        prototypeAccessors.size.get = function () {
            return this.__entries__.length;
        };

        /**
         * @param {*} key
         * @returns {*}
         */
        anonymous.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];

            return entry && entry[1];
        };

        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        anonymous.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);

            if (~index) {
                this.__entries__[index][1] = value;
            } else {
                this.__entries__.push([key, value]);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);

            if (~index) {
                entries.splice(index, 1);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };

        /**
         * @returns {void}
         */
        anonymous.prototype.clear = function () {
            this.__entries__.splice(0);
        };

        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        anonymous.prototype.forEach = function (callback, ctx) {
            if ( ctx === void 0 ) ctx = null;

            for (var i = 0, list = this.__entries__; i < list.length; i += 1) {
                var entry = list[i];

                callback.call(ctx, entry[1], entry[0]);
            }
        };

        Object.defineProperties( anonymous.prototype, prototypeAccessors );

        return anonymous;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window != 'undefined' && typeof document != 'undefined' && window.document === document;

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        return requestAnimationFrame;
    }

    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;

/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
var throttle = function (callback, delay) {
    var leadingCall = false,
        trailingCall = false,
        lastCallTime = 0;

    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;

            callback();
        }

        if (trailingCall) {
            proxy();
        }
    }

    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }

    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();

        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }

            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;

            setTimeout(timeoutCallback, delay);
        }

        lastCallTime = timeStamp;
    }

    return proxy;
};

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;

// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];

// Detect whether running in IE 11 (facepalm).
var isIE11 = typeof navigator != 'undefined' && /Trident\/.*rv:11/.test(navigator.userAgent);

// MutationObserver should not be used if running in Internet Explorer 11 as it's
// implementation is unreliable. Example: https://jsfiddle.net/x2r3jpuz/2/
//
// It's a real bummer that there is no other way to check for this issue but to
// use the UA information.
var mutationObserverSupported = typeof MutationObserver != 'undefined' && !isIE11;

/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = function() {
    /**
     * Indicates whether DOM listeners have been added.
     *
     * @private {boolean}
     */
    this.connected_ = false;

    /**
     * Tells that controller has subscribed for Mutation Events.
     *
     * @private {boolean}
     */
    this.mutationEventsAdded_ = false;

    /**
     * Keeps reference to the instance of MutationObserver.
     *
     * @private {MutationObserver}
     */
    this.mutationsObserver_ = null;

    /**
     * A list of connected observers.
     *
     * @private {Array<ResizeObserverSPI>}
     */
    this.observers_ = [];

    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
};

/**
 * Adds observer to observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be added.
 * @returns {void}
 */
ResizeObserverController.prototype.addObserver = function (observer) {
    if (!~this.observers_.indexOf(observer)) {
        this.observers_.push(observer);
    }

    // Add listeners if they haven't been added yet.
    if (!this.connected_) {
        this.connect_();
    }
};

/**
 * Removes observer from observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be removed.
 * @returns {void}
 */
ResizeObserverController.prototype.removeObserver = function (observer) {
    var observers = this.observers_;
    var index = observers.indexOf(observer);

    // Remove observer if it's present in registry.
    if (~index) {
        observers.splice(index, 1);
    }

    // Remove listeners if controller has no connected observers.
    if (!observers.length && this.connected_) {
        this.disconnect_();
    }
};

/**
 * Invokes the update of observers. It will continue running updates insofar
 * it detects changes.
 *
 * @returns {void}
 */
ResizeObserverController.prototype.refresh = function () {
    var changesDetected = this.updateObservers_();

    // Continue running updates if changes have been detected as there might
    // be future ones caused by CSS transitions.
    if (changesDetected) {
        this.refresh();
    }
};

/**
 * Updates every observer from observers list and notifies them of queued
 * entries.
 *
 * @private
 * @returns {boolean} Returns "true" if any observer has detected changes in
 *  dimensions of it's elements.
 */
ResizeObserverController.prototype.updateObservers_ = function () {
    // Collect observers that have active observations.
    var activeObservers = this.observers_.filter(function (observer) {
        return observer.gatherActive(), observer.hasActive();
    });

    // Deliver notifications in a separate cycle in order to avoid any
    // collisions between observers, e.g. when multiple instances of
    // ResizeObserver are tracking the same element and the callback of one
    // of them changes content dimensions of the observed target. Sometimes
    // this may result in notifications being blocked for the rest of observers.
    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });

    return activeObservers.length > 0;
};

/**
 * Initializes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.connect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already added.
    if (!isBrowser || this.connected_) {
        return;
    }

    // Subscription to the "Transitionend" event is used as a workaround for
    // delayed transitions. This way it's possible to capture at least the
    // final state of an element.
    document.addEventListener('transitionend', this.onTransitionEnd_);

    window.addEventListener('resize', this.refresh);

    if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);

        this.mutationsObserver_.observe(document, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
        });
    } else {
        document.addEventListener('DOMSubtreeModified', this.refresh);

        this.mutationEventsAdded_ = true;
    }

    this.connected_ = true;
};

/**
 * Removes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.disconnect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already removed.
    if (!isBrowser || !this.connected_) {
        return;
    }

    document.removeEventListener('transitionend', this.onTransitionEnd_);
    window.removeEventListener('resize', this.refresh);

    if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
    }

    if (this.mutationEventsAdded_) {
        document.removeEventListener('DOMSubtreeModified', this.refresh);
    }

    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
};

/**
 * "Transitionend" event handler.
 *
 * @private
 * @param {TransitionEvent} event
 * @returns {void}
 */
ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
        var propertyName = ref.propertyName;

    // Detect whether transition may affect dimensions of an element.
    var isReflowProperty = transitionKeys.some(function (key) {
        return !!~propertyName.indexOf(key);
    });

    if (isReflowProperty) {
        this.refresh();
    }
};

/**
 * Returns instance of the ResizeObserverController.
 *
 * @returns {ResizeObserverController}
 */
ResizeObserverController.getInstance = function () {
    if (!this.instance_) {
        this.instance_ = new ResizeObserverController();
    }

    return this.instance_;
};

/**
 * Holds reference to the controller's instance.
 *
 * @private {ResizeObserverController}
 */
ResizeObserverController.instance_ = null;

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
        var key = list[i];

        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }

    return target;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);

/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}

/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = Array.prototype.slice.call(arguments, 1);

    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];

        return size + toFloat(value);
    }, 0);
}

/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};

    for (var i = 0, list = positions; i < list.length; i += 1) {
        var position = list[i];

        var value = styles['padding-' + position];

        paddings[position] = toFloat(value);
    }

    return paddings;
}

/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();

    return createRectInit(0, 0, bbox.width, bbox.height);
}

/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth;
    var clientHeight = target.clientHeight;

    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }

    var styles = getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;

    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width),
        height = toFloat(styles.height);

    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }

        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }

    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;

        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }

        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }

    return createRectInit(paddings.left, paddings.top, width, height);
}

/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement != 'undefined') {
        return function (target) { return target instanceof SVGGraphicsElement; };
    }

    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return target instanceof SVGElement && typeof target.getBBox === 'function'; };
})();

/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === document.documentElement;
}

/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }

    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }

    return getHTMLElementContentRect(target);
}

/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(ref) {
    var x = ref.x;
    var y = ref.y;
    var width = ref.width;
    var height = ref.height;

    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly != 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);

    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });

    return rect;
}

/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = function(target) {
    /**
     * Broadcasted width of content rectangle.
     *
     * @type {number}
     */
    this.broadcastWidth = 0;

    /**
     * Broadcasted height of content rectangle.
     *
     * @type {number}
     */
    this.broadcastHeight = 0;

    /**
     * Reference to the last observed content rectangle.
     *
     * @private {DOMRectInit}
     */
    this.contentRect_ = createRectInit(0, 0, 0, 0);

    /**
     * Reference to the observed element.
     *
     * @type {Element}
     */
    this.target = target;
};

/**
 * Updates content rectangle and tells whether it's width or height properties
 * have changed since the last broadcast.
 *
 * @returns {boolean}
 */
ResizeObservation.prototype.isActive = function () {
    var rect = getContentRect(this.target);

    this.contentRect_ = rect;

    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
};

/**
 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
 * from the corresponding properties of the last observed content rectangle.
 *
 * @returns {DOMRectInit} Last observed content rectangle.
 */
ResizeObservation.prototype.broadcastRect = function () {
    var rect = this.contentRect_;

    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;

    return rect;
};

var ResizeObserverEntry = function(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);

    // According to the specification following properties are not writable
    // and are also not enumerable in the native implementation.
    //
    // Property accessors are not being used as they'd require to define a
    // private WeakMap storage which may cause memory leaks in browsers that
    // don't support this type of collections.
    defineConfigurable(this, { target: target, contentRect: contentRect });
};

var ResizeObserverSPI = function(callback, controller, callbackCtx) {
    if (typeof callback !== 'function') {
        throw new TypeError('The callback provided as parameter 1 is not a function.');
    }

    /**
     * Collection of resize observations that have detected changes in dimensions
     * of elements.
     *
     * @private {Array<ResizeObservation>}
     */
    this.activeObservations_ = [];

    /**
     * Registry of the ResizeObservation instances.
     *
     * @private {Map<Element, ResizeObservation>}
     */
    this.observations_ = new MapShim();

    /**
     * Reference to the callback function.
     *
     * @private {ResizeObserverCallback}
     */
    this.callback_ = callback;

    /**
     * Reference to the associated ResizeObserverController.
     *
     * @private {ResizeObserverController}
     */
    this.controller_ = controller;

    /**
     * Public ResizeObserver instance which will be passed to the callback
     * function and used as a value of it's "this" binding.
     *
     * @private {ResizeObserver}
     */
    this.callbackCtx_ = callbackCtx;
};

/**
 * Starts observing provided element.
 *
 * @param {Element} target - Element to be observed.
 * @returns {void}
 */
ResizeObserverSPI.prototype.observe = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is already being observed.
    if (observations.has(target)) {
        return;
    }

    observations.set(target, new ResizeObservation(target));

    this.controller_.addObserver(this);

    // Force the update of observations.
    this.controller_.refresh();
};

/**
 * Stops observing provided element.
 *
 * @param {Element} target - Element to stop observing.
 * @returns {void}
 */
ResizeObserverSPI.prototype.unobserve = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is not being observed.
    if (!observations.has(target)) {
        return;
    }

    observations.delete(target);

    if (!observations.size) {
        this.controller_.removeObserver(this);
    }
};

/**
 * Stops observing all elements.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.disconnect = function () {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
};

/**
 * Collects observation instances the associated element of which has changed
 * it's content rectangle.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.gatherActive = function () {
        var this$1 = this;

    this.clearActive();

    this.observations_.forEach(function (observation) {
        if (observation.isActive()) {
            this$1.activeObservations_.push(observation);
        }
    });
};

/**
 * Invokes initial callback function with a list of ResizeObserverEntry
 * instances collected from active resize observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.broadcastActive = function () {
    // Do nothing if observer doesn't have active observations.
    if (!this.hasActive()) {
        return;
    }

    var ctx = this.callbackCtx_;

    // Create ResizeObserverEntry instance for every active observation.
    var entries = this.activeObservations_.map(function (observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });

    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
};

/**
 * Clears the collection of active observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.clearActive = function () {
    this.activeObservations_.splice(0);
};

/**
 * Tells whether observer has active observations.
 *
 * @returns {boolean}
 */
ResizeObserverSPI.prototype.hasActive = function () {
    return this.activeObservations_.length > 0;
};

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap != 'undefined' ? new WeakMap() : new MapShim();

/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver$1 = function(callback) {
    if (!(this instanceof ResizeObserver$1)) {
        throw new TypeError('Cannot call a class as a function');
    }

    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);

    observers.set(this, observer);
};

// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
    ResizeObserver$1.prototype[method] = function () {
        return (ref = observers.get(this))[method].apply(ref, arguments);
        var ref;
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof ResizeObserver != 'undefined') {
        // eslint-disable-next-line no-undef
        return ResizeObserver;
    }

    return ResizeObserver$1;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// plesk-ui-library.min.js